/* eslint-disable */
const urls = {"wagtailapi:pages:listing":{"route":"/api/cms/v2/^pages/","args":{}},"wagtailapi:pages:detail":{"route":"/api/cms/v2/^pages/<int:pk>/","args":{"pk":"number"}},"wagtailapi:pages:find":{"route":"/api/cms/v2/^pages/find/","args":{}},"wagtailapi:images:listing":{"route":"/api/cms/v2/^images/","args":{}},"wagtailapi:images:detail":{"route":"/api/cms/v2/^images/<int:pk>/","args":{"pk":"number"}},"wagtailapi:images:find":{"route":"/api/cms/v2/^images/find/","args":{}},"wagtailapi:documents:listing":{"route":"/api/cms/v2/^documents/","args":{}},"wagtailapi:documents:detail":{"route":"/api/cms/v2/^documents/<int:pk>/","args":{"pk":"number"}},"wagtailapi:documents:find":{"route":"/api/cms/v2/^documents/find/","args":{}},"wagtailapi:flagship-pages:listing":{"route":"/api/cms/v2/^flagship-pages/","args":{}},"wagtailapi:flagship-pages:detail":{"route":"/api/cms/v2/^flagship-pages/<int:pk>/","args":{"pk":"number"}},"wagtailapi:flagship-pages:find":{"route":"/api/cms/v2/^flagship-pages/find/","args":{}},"wagtailapi:social:listing":{"route":"/api/cms/v2/^social/","args":{}},"wagtailapi:social:detail":{"route":"/api/cms/v2/^social/<int:pk>/","args":{"pk":"number"}},"wagtailapi:social:find":{"route":"/api/cms/v2/^social/find/","args":{}},"oidc_authentication_callback":{"route":"/oidc/callback/","args":{}},"oidc_authentication_init":{"route":"/oidc/authenticate/","args":{}},"oidc_logout":{"route":"/oidc/logout/","args":{}},"health_check:health_check_home":{"route":"/admin/ht/","args":{}},"health_check:health_check_subset":{"route":"/admin/ht/<str:subset>/","args":{"subset":"string"}},"download-periodic-report":{"route":"/admin/periodic-reports/download/<str:key>/<path:filename>","args":{"key":"string","filename":"string"}},"wagtailadmin_home":{"route":"/admin/cms/","args":{}},"wagtailadmin_api:pages:listing":{"route":"/admin/cms/api/main/^pages/","args":{}},"wagtailadmin_api:pages:detail":{"route":"/admin/cms/api/main/^pages/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_api:pages:find":{"route":"/admin/cms/api/main/^pages/find/","args":{}},"wagtailadmin_api:pages:action":{"route":"/admin/cms/api/main/^pages/<int:pk>/action/<str:action_name>/","args":{"pk":"number","action_name":"string"}},"wagtailadmin_api:documents:listing":{"route":"/admin/cms/api/main/^documents/","args":{}},"wagtailadmin_api:documents:detail":{"route":"/admin/cms/api/main/^documents/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_api:documents:find":{"route":"/admin/cms/api/main/^documents/find/","args":{}},"wagtailadmin_api:images:listing":{"route":"/admin/cms/api/main/^images/","args":{}},"wagtailadmin_api:images:detail":{"route":"/admin/cms/api/main/^images/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_api:images:find":{"route":"/admin/cms/api/main/^images/find/","args":{}},"wagtailadmin_error_test":{"route":"/admin/cms/failwhale/","args":{}},"wagtailadmin_explore_root":{"route":"/admin/cms/pages/","args":{}},"wagtailadmin_explore":{"route":"/admin/cms/pages/<int:parent_page_id>/","args":{"parent_page_id":"number"}},"wagtailadmin_explore_results":{"route":"/admin/cms/pages/<int:parent_page_id>/results/","args":{"parent_page_id":"number"}},"wagtail_bulk_action":{"route":"/admin/cms/bulk/<str:app_label>/<str:model_name>/<str:action>/","args":{"app_label":"string","model_name":"string","action":"string"}},"wagtailadmin_pages:add":{"route":"/admin/cms/pages/add/<slug:content_type_app_name>/<slug:content_type_model_name>/<int:parent_page_id>/","args":{"content_type_app_name":"string","content_type_model_name":"string","parent_page_id":"number"}},"wagtailadmin_pages:preview_on_add":{"route":"/admin/cms/pages/add/<slug:content_type_app_name>/<slug:content_type_model_name>/<int:parent_page_id>/preview/","args":{"content_type_app_name":"string","content_type_model_name":"string","parent_page_id":"number"}},"wagtailadmin_pages:type_use":{"route":"/admin/cms/pages/usage/<slug:content_type_app_name>/<slug:content_type_model_name>/","args":{"content_type_app_name":"string","content_type_model_name":"string"}},"wagtailadmin_pages:type_use_results":{"route":"/admin/cms/pages/usage/<slug:content_type_app_name>/<slug:content_type_model_name>/results/","args":{"content_type_app_name":"string","content_type_model_name":"string"}},"wagtailadmin_pages:usage":{"route":"/admin/cms/pages/<int:page_id>/usage/","args":{"page_id":"number"}},"wagtailadmin_pages:edit":{"route":"/admin/cms/pages/<int:page_id>/edit/","args":{"page_id":"number"}},"wagtailadmin_pages:preview_on_edit":{"route":"/admin/cms/pages/<int:page_id>/edit/preview/","args":{"page_id":"number"}},"wagtailadmin_pages:view_draft":{"route":"/admin/cms/pages/<int:page_id>/view_draft/","args":{"page_id":"number"}},"wagtailadmin_pages:add_subpage":{"route":"/admin/cms/pages/<int:parent_page_id>/add_subpage/","args":{"parent_page_id":"number"}},"wagtailadmin_pages:delete":{"route":"/admin/cms/pages/<int:page_id>/delete/","args":{"page_id":"number"}},"wagtailadmin_pages:unpublish":{"route":"/admin/cms/pages/<int:page_id>/unpublish/","args":{"page_id":"number"}},"wagtailadmin_pages:convert_alias":{"route":"/admin/cms/pages/<int:page_id>/convert_alias/","args":{"page_id":"number"}},"wagtailadmin_pages:search":{"route":"/admin/cms/pages/search/","args":{}},"wagtailadmin_pages:search_results":{"route":"/admin/cms/pages/search/results/","args":{}},"wagtailadmin_pages:move":{"route":"/admin/cms/pages/<int:page_to_move_id>/move/","args":{"page_to_move_id":"number"}},"wagtailadmin_pages:move_confirm":{"route":"/admin/cms/pages/<int:page_to_move_id>/move/<int:destination_id>/confirm/","args":{"page_to_move_id":"number","destination_id":"number"}},"wagtailadmin_pages:set_page_position":{"route":"/admin/cms/pages/<int:page_to_move_id>/set_position/","args":{"page_to_move_id":"number"}},"wagtailadmin_pages:copy":{"route":"/admin/cms/pages/<int:page_id>/copy/","args":{"page_id":"number"}},"wagtailadmin_pages:workflow_action":{"route":"/admin/cms/pages/workflow/action/<int:page_id>/<slug:action_name>/<int:task_state_id>/","args":{"page_id":"number","action_name":"string","task_state_id":"number"}},"wagtailadmin_pages:collect_workflow_action_data":{"route":"/admin/cms/pages/workflow/collect_action_data/<int:page_id>/<slug:action_name>/<int:task_state_id>/","args":{"page_id":"number","action_name":"string","task_state_id":"number"}},"wagtailadmin_pages:confirm_workflow_cancellation":{"route":"/admin/cms/pages/workflow/confirm_cancellation/<int:page_id>/","args":{"page_id":"number"}},"wagtailadmin_pages:workflow_preview":{"route":"/admin/cms/pages/workflow/preview/<int:page_id>/<int:task_id>/","args":{"page_id":"number","task_id":"number"}},"wagtailadmin_pages:set_privacy":{"route":"/admin/cms/pages/<int:page_id>/privacy/","args":{"page_id":"number"}},"wagtailadmin_pages:lock":{"route":"/admin/cms/pages/<int:page_id>/lock/","args":{"page_id":"number"}},"wagtailadmin_pages:unlock":{"route":"/admin/cms/pages/<int:page_id>/unlock/","args":{"page_id":"number"}},"wagtailadmin_pages:revisions_index":{"route":"/admin/cms/pages/<int:page_id>/revisions/","args":{"page_id":"number"}},"wagtailadmin_pages:revisions_view":{"route":"/admin/cms/pages/<int:page_id>/revisions/<int:revision_id>/view/","args":{"page_id":"number","revision_id":"number"}},"wagtailadmin_pages:revisions_revert":{"route":"/admin/cms/pages/<int:page_id>/revisions/<int:revision_id>/revert/","args":{"page_id":"number","revision_id":"number"}},"wagtailadmin_pages:revisions_unschedule":{"route":"/admin/cms/pages/<int:page_id>/revisions/<int:revision_id>/unschedule/","args":{"page_id":"number","revision_id":"number"}},"wagtailadmin_pages:workflow_history":{"route":"/admin/cms/pages/<int:page_id>/workflow_history/","args":{"page_id":"number"}},"wagtailadmin_pages:workflow_history_detail":{"route":"/admin/cms/pages/<int:page_id>/workflow_history/detail/<int:workflow_state_id>/","args":{"page_id":"number","workflow_state_id":"number"}},"wagtailadmin_pages:history":{"route":"/admin/cms/pages/<int:page_id>/history/","args":{"page_id":"number"}},"wagtailadmin_pages:history_results":{"route":"/admin/cms/pages/<int:page_id>/history/results/","args":{"page_id":"number"}},"wagtailadmin_choose_page":{"route":"/admin/cms/choose-page/","args":{}},"wagtailadmin_choose_page_child":{"route":"/admin/cms/choose-page/<int:parent_page_id>/","args":{"parent_page_id":"number"}},"wagtailadmin_choose_page_search":{"route":"/admin/cms/choose-page/search/","args":{}},"wagtailadmin_choose_page_chosen_multiple":{"route":"/admin/cms/choose-page/chosen-multiple/","args":{}},"wagtailadmin_choose_page_external_link":{"route":"/admin/cms/choose-external-link/","args":{}},"wagtailadmin_choose_page_email_link":{"route":"/admin/cms/choose-email-link/","args":{}},"wagtailadmin_choose_page_phone_link":{"route":"/admin/cms/choose-phone-link/","args":{}},"wagtailadmin_choose_page_anchor_link":{"route":"/admin/cms/choose-anchor-link/","args":{}},"wagtailadmin_tag_autocomplete":{"route":"/admin/cms/tag-autocomplete/","args":{}},"wagtailadmin_tag_model_autocomplete":{"route":"/admin/cms/tag-autocomplete/<slug:app_name>/<slug:model_name>/","args":{"app_name":"string","model_name":"string"}},"wagtailadmin_collections:index":{"route":"/admin/cms/collections/","args":{}},"wagtailadmin_collections:add":{"route":"/admin/cms/collections/add/","args":{}},"wagtailadmin_collections:edit":{"route":"/admin/cms/collections/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_collections:delete":{"route":"/admin/cms/collections/<int:pk>/delete/","args":{"pk":"number"}},"wagtailadmin_collections:set_privacy":{"route":"/admin/cms/collections/<int:collection_id>/privacy/","args":{"collection_id":"number"}},"wagtailadmin_workflows:index":{"route":"/admin/cms/workflows/list/","args":{}},"wagtailadmin_workflows:index_results":{"route":"/admin/cms/workflows/list/results/","args":{}},"wagtailadmin_workflows:add":{"route":"/admin/cms/workflows/add/","args":{}},"wagtailadmin_workflows:enable":{"route":"/admin/cms/workflows/enable/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:disable":{"route":"/admin/cms/workflows/disable/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:edit":{"route":"/admin/cms/workflows/edit/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:usage":{"route":"/admin/cms/workflows/usage/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:usage_results":{"route":"/admin/cms/workflows/usage/<int:pk>/results/","args":{"pk":"number"}},"wagtailadmin_workflows:remove":{"route":"/admin/cms/workflows/remove/<int:page_pk>/<int:workflow_pk>/","args":{"page_pk":"number","workflow_pk":"number"}},"wagtailadmin_workflows:add_task":{"route":"/admin/cms/workflows/tasks/add/<str:app_label>/<str:model_name>/","args":{"app_label":"string","model_name":"string"}},"wagtailadmin_workflows:select_task_type":{"route":"/admin/cms/workflows/tasks/select_type/","args":{}},"wagtailadmin_workflows:task_index":{"route":"/admin/cms/workflows/tasks/index/","args":{}},"wagtailadmin_workflows:task_index_results":{"route":"/admin/cms/workflows/tasks/index/results/","args":{}},"wagtailadmin_workflows:edit_task":{"route":"/admin/cms/workflows/tasks/edit/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:disable_task":{"route":"/admin/cms/workflows/tasks/disable/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:enable_task":{"route":"/admin/cms/workflows/tasks/enable/<int:pk>/","args":{"pk":"number"}},"wagtailadmin_workflows:task_chooser":{"route":"/admin/cms/workflows/task_chooser/","args":{}},"wagtailadmin_workflows:task_chooser_results":{"route":"/admin/cms/workflows/task_chooser/results/","args":{}},"wagtailadmin_workflows:task_chooser_create":{"route":"/admin/cms/workflows/task_chooser/create/","args":{}},"wagtailadmin_workflows:task_chosen":{"route":"/admin/cms/workflows/task_chooser/<int:task_id>/","args":{"task_id":"number"}},"wagtailadmin_reports:locked_pages":{"route":"/admin/cms/reports/locked/","args":{}},"wagtailadmin_reports:locked_pages_results":{"route":"/admin/cms/reports/locked/results/","args":{}},"wagtailadmin_reports:workflow":{"route":"/admin/cms/reports/workflow/","args":{}},"wagtailadmin_reports:workflow_results":{"route":"/admin/cms/reports/workflow/results/","args":{}},"wagtailadmin_reports:workflow_tasks":{"route":"/admin/cms/reports/workflow_tasks/","args":{}},"wagtailadmin_reports:workflow_tasks_results":{"route":"/admin/cms/reports/workflow_tasks/results/","args":{}},"wagtailadmin_reports:site_history":{"route":"/admin/cms/reports/site-history/","args":{}},"wagtailadmin_reports:site_history_results":{"route":"/admin/cms/reports/site-history/results/","args":{}},"wagtailadmin_reports:aging_pages":{"route":"/admin/cms/reports/aging-pages/","args":{}},"wagtailadmin_reports:aging_pages_results":{"route":"/admin/cms/reports/aging-pages/results/","args":{}},"wagtailadmin_reports:page_types_usage":{"route":"/admin/cms/reports/page-types-usage/","args":{}},"wagtailadmin_reports:page_types_usage_results":{"route":"/admin/cms/reports/page-types-usage/results/","args":{}},"wagtailadmin_account":{"route":"/admin/cms/account/","args":{}},"wagtailadmin_logout":{"route":"/admin/cms/logout/","args":{}},"wagtailadmin_dismissibles":{"route":"/admin/cms/dismissibles/","args":{}},"wagtailadmin_editing_sessions:ping":{"route":"/admin/cms/editing-sessions/ping/<str:app_label>/<str:model_name>/<str:object_id>/<int:session_id>/","args":{"app_label":"string","model_name":"string","object_id":"string","session_id":"number"}},"wagtailadmin_editing_sessions:release":{"route":"/admin/cms/editing-sessions/release/<int:session_id>/","args":{"session_id":"number"}},"wagtailadmin_block_preview":{"route":"/admin/cms/block-preview/","args":{}},"wagtailvideos:add":{"route":"/admin/cms/videos/add/","args":{}},"wagtailvideos:add_multiple":{"route":"/admin/cms/videos/multiple/add/","args":{}},"wagtailvideos:edit_multiple":{"route":"/admin/cms/videos/multiple/<int:video_id>/","args":{"video_id":"number"}},"wagtailvideos:create_multiple_from_uploaded_image":{"route":"/admin/cms/videos/multiple/create_from_uploaded_image/<int:uploaded_file_id>/","args":{"uploaded_file_id":"number"}},"wagtailvideos:delete_multiple":{"route":"/admin/cms/videos/multiple/<int:video_id>/delete/","args":{"video_id":"number"}},"wagtailvideos:delete_upload_multiple":{"route":"/admin/cms/videos/multiple/delete_upload/<int:uploaded_file_id>/","args":{"uploaded_file_id":"number"}},"wagtailvideos:index":{"route":"/admin/cms/videos/","args":{}},"wagtailvideos:index_results":{"route":"/admin/cms/videos/results/","args":{}},"wagtailsettings:edit":{"route":"/admin/cms/settings/<slug:app_name>/<slug:model_name>/<int:pk>/","args":{"app_name":"string","model_name":"string","pk":"number"}},"wagtailsnippets_wagtail_links_link:list":{"route":"/admin/cms/snippets/wagtail_links/link/","args":{}},"wagtailsnippets_wagtail_links_link:list_results":{"route":"/admin/cms/snippets/wagtail_links/link/results/","args":{}},"wagtailsnippets_wagtail_links_link:add":{"route":"/admin/cms/snippets/wagtail_links/link/add/","args":{}},"wagtailsnippets_wagtail_links_link:edit":{"route":"/admin/cms/snippets/wagtail_links/link/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_wagtail_links_link:delete":{"route":"/admin/cms/snippets/wagtail_links/link/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_wagtail_links_link:usage":{"route":"/admin/cms/snippets/wagtail_links/link/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_wagtail_links_link:history":{"route":"/admin/cms/snippets/wagtail_links/link/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_wagtail_links_link:history_results":{"route":"/admin/cms/snippets/wagtail_links/link/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_wagtail_links_link:copy":{"route":"/admin/cms/snippets/wagtail_links/link/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_wagtail_links_link:choose":{"route":"/admin/cms/snippets/choose/wagtail_links/link/","args":{}},"wagtailsnippetchoosers_wagtail_links_link:choose_results":{"route":"/admin/cms/snippets/choose/wagtail_links/link/results/","args":{}},"wagtailsnippetchoosers_wagtail_links_link:chosen":{"route":"/admin/cms/snippets/choose/wagtail_links/link/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_wagtail_links_link:chosen_multiple":{"route":"/admin/cms/snippets/choose/wagtail_links/link/chosen-multiple/","args":{}},"wagtailsnippetchoosers_wagtail_links_link:create":{"route":"/admin/cms/snippets/choose/wagtail_links/link/create/","args":{}},"wagtailsnippets_tsicommon_cms_mattressmatchcondition:list":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchcondition/","args":{}},"wagtailsnippets_tsicommon_cms_mattressmatchcondition:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchcondition/results/","args":{}},"wagtailsnippets_tsicommon_cms_mattressmatchcondition:add":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchcondition/add/","args":{}},"wagtailsnippets_tsicommon_cms_mattressmatchcondition:edit":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchcondition/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressmatchcondition:delete":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchcondition/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressmatchcondition:usage":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchcondition/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressmatchcondition:history":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchcondition/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressmatchcondition:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchcondition/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressmatchcondition:copy":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchcondition/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressmatchcondition/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressmatchcondition/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressmatchcondition/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressmatchcondition/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressmatchcondition/create/","args":{}},"wagtailsnippets_tsicommon_cms_promoperiod:list":{"route":"/admin/cms/snippets/tsicommon_cms/promoperiod/","args":{}},"wagtailsnippets_tsicommon_cms_promoperiod:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/promoperiod/results/","args":{}},"wagtailsnippets_tsicommon_cms_promoperiod:add":{"route":"/admin/cms/snippets/tsicommon_cms/promoperiod/add/","args":{}},"wagtailsnippets_tsicommon_cms_promoperiod:edit":{"route":"/admin/cms/snippets/tsicommon_cms/promoperiod/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_promoperiod:delete":{"route":"/admin/cms/snippets/tsicommon_cms/promoperiod/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_promoperiod:usage":{"route":"/admin/cms/snippets/tsicommon_cms/promoperiod/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_promoperiod:history":{"route":"/admin/cms/snippets/tsicommon_cms/promoperiod/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_promoperiod:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/promoperiod/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_promoperiod:copy":{"route":"/admin/cms/snippets/tsicommon_cms/promoperiod/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_promoperiod:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/promoperiod/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_promoperiod:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/promoperiod/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_promoperiod:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/promoperiod/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_promoperiod:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/promoperiod/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_promoperiod:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/promoperiod/create/","args":{}},"wagtailsnippets_tsicommon_cms_mattressmatchresult:list":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchresult/","args":{}},"wagtailsnippets_tsicommon_cms_mattressmatchresult:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchresult/results/","args":{}},"wagtailsnippets_tsicommon_cms_mattressmatchresult:add":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchresult/add/","args":{}},"wagtailsnippets_tsicommon_cms_mattressmatchresult:edit":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchresult/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressmatchresult:delete":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchresult/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressmatchresult:usage":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchresult/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressmatchresult:history":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchresult/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressmatchresult:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchresult/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressmatchresult:copy":{"route":"/admin/cms/snippets/tsicommon_cms/mattressmatchresult/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressmatchresult/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressmatchresult/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressmatchresult/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressmatchresult/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressmatchresult/create/","args":{}},"wagtailsnippets_tsicommon_cms_mattressfeel:list":{"route":"/admin/cms/snippets/tsicommon_cms/mattressfeel/","args":{}},"wagtailsnippets_tsicommon_cms_mattressfeel:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/mattressfeel/results/","args":{}},"wagtailsnippets_tsicommon_cms_mattressfeel:add":{"route":"/admin/cms/snippets/tsicommon_cms/mattressfeel/add/","args":{}},"wagtailsnippets_tsicommon_cms_mattressfeel:edit":{"route":"/admin/cms/snippets/tsicommon_cms/mattressfeel/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressfeel:delete":{"route":"/admin/cms/snippets/tsicommon_cms/mattressfeel/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressfeel:usage":{"route":"/admin/cms/snippets/tsicommon_cms/mattressfeel/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressfeel:history":{"route":"/admin/cms/snippets/tsicommon_cms/mattressfeel/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressfeel:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/mattressfeel/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_mattressfeel:copy":{"route":"/admin/cms/snippets/tsicommon_cms/mattressfeel/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_mattressfeel:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressfeel/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_mattressfeel:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressfeel/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_mattressfeel:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressfeel/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_mattressfeel:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressfeel/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_mattressfeel:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/mattressfeel/create/","args":{}},"wagtailsnippets_tsicommon_cms_featuredofferscard:list":{"route":"/admin/cms/snippets/tsicommon_cms/featuredofferscard/","args":{}},"wagtailsnippets_tsicommon_cms_featuredofferscard:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/featuredofferscard/results/","args":{}},"wagtailsnippets_tsicommon_cms_featuredofferscard:add":{"route":"/admin/cms/snippets/tsicommon_cms/featuredofferscard/add/","args":{}},"wagtailsnippets_tsicommon_cms_featuredofferscard:edit":{"route":"/admin/cms/snippets/tsicommon_cms/featuredofferscard/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_featuredofferscard:delete":{"route":"/admin/cms/snippets/tsicommon_cms/featuredofferscard/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_featuredofferscard:usage":{"route":"/admin/cms/snippets/tsicommon_cms/featuredofferscard/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_featuredofferscard:history":{"route":"/admin/cms/snippets/tsicommon_cms/featuredofferscard/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_featuredofferscard:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/featuredofferscard/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_featuredofferscard:copy":{"route":"/admin/cms/snippets/tsicommon_cms/featuredofferscard/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_featuredofferscard:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/featuredofferscard/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_featuredofferscard:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/featuredofferscard/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_featuredofferscard:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/featuredofferscard/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_featuredofferscard:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/featuredofferscard/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_featuredofferscard:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/featuredofferscard/create/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:list":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratoroptionset/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratoroptionset/results/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:add":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratoroptionset/add/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:edit":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratoroptionset/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:delete":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratoroptionset/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:usage":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratoroptionset/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:history":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratoroptionset/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratoroptionset/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:copy":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratoroptionset/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratoroptionset/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratoroptionset/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratoroptionset/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratoroptionset/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratoroptionset/create/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:list":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_promocard/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_promocard/results/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:add":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_promocard/add/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:edit":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_promocard/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:delete":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_promocard/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:usage":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_promocard/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:history":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_promocard/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_promocard/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:copy":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_promocard/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfigurator_promocard/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfigurator_promocard/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfigurator_promocard/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfigurator_promocard/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfigurator_promocard/create/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:list":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_upsellinfomodal/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_upsellinfomodal/results/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:add":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_upsellinfomodal/add/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:edit":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_upsellinfomodal/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:delete":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_upsellinfomodal/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:usage":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_upsellinfomodal/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:history":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_upsellinfomodal/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_upsellinfomodal/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:copy":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfigurator_upsellinfomodal/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfigurator_upsellinfomodal/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfigurator_upsellinfomodal/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfigurator_upsellinfomodal/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfigurator_upsellinfomodal/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfigurator_upsellinfomodal/create/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:list":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorshippingmessage/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorshippingmessage/results/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:add":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorshippingmessage/add/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:edit":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorshippingmessage/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:delete":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorshippingmessage/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:usage":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorshippingmessage/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:history":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorshippingmessage/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorshippingmessage/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:copy":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorshippingmessage/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorshippingmessage/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorshippingmessage/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorshippingmessage/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorshippingmessage/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorshippingmessage/create/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:list":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/results/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:add":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/add/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:edit":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:delete":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:usage":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:history":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:copy":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratordynamicshippingtimemessaging/create/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:list":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorreviewaggregation/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorreviewaggregation/results/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:add":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorreviewaggregation/add/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:edit":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorreviewaggregation/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:delete":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorreviewaggregation/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:usage":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorreviewaggregation/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:history":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorreviewaggregation/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorreviewaggregation/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:copy":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorreviewaggregation/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorreviewaggregation/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorreviewaggregation/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorreviewaggregation/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorreviewaggregation/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorreviewaggregation/create/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:list":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorpromocardinfomodal/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorpromocardinfomodal/results/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:add":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorpromocardinfomodal/add/","args":{}},"wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:edit":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorpromocardinfomodal/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:delete":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorpromocardinfomodal/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:usage":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorpromocardinfomodal/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:history":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorpromocardinfomodal/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorpromocardinfomodal/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:copy":{"route":"/admin/cms/snippets/tsicommon_cms/modularconfiguratorpromocardinfomodal/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorpromocardinfomodal/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorpromocardinfomodal/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorpromocardinfomodal/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorpromocardinfomodal/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/modularconfiguratorpromocardinfomodal/create/","args":{}},"wagtailsnippets_tsicommon_cms_offeradvertisingcontent:list":{"route":"/admin/cms/snippets/tsicommon_cms/offeradvertisingcontent/","args":{}},"wagtailsnippets_tsicommon_cms_offeradvertisingcontent:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/offeradvertisingcontent/results/","args":{}},"wagtailsnippets_tsicommon_cms_offeradvertisingcontent:add":{"route":"/admin/cms/snippets/tsicommon_cms/offeradvertisingcontent/add/","args":{}},"wagtailsnippets_tsicommon_cms_offeradvertisingcontent:edit":{"route":"/admin/cms/snippets/tsicommon_cms/offeradvertisingcontent/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_offeradvertisingcontent:delete":{"route":"/admin/cms/snippets/tsicommon_cms/offeradvertisingcontent/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_offeradvertisingcontent:usage":{"route":"/admin/cms/snippets/tsicommon_cms/offeradvertisingcontent/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_offeradvertisingcontent:history":{"route":"/admin/cms/snippets/tsicommon_cms/offeradvertisingcontent/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_offeradvertisingcontent:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/offeradvertisingcontent/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_offeradvertisingcontent:copy":{"route":"/admin/cms/snippets/tsicommon_cms/offeradvertisingcontent/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/offeradvertisingcontent/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/offeradvertisingcontent/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/offeradvertisingcontent/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/offeradvertisingcontent/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/offeradvertisingcontent/create/","args":{}},"wagtailsnippets_tsicommon_cms_countdowntimerqueue:list":{"route":"/admin/cms/snippets/tsicommon_cms/countdowntimerqueue/","args":{}},"wagtailsnippets_tsicommon_cms_countdowntimerqueue:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/countdowntimerqueue/results/","args":{}},"wagtailsnippets_tsicommon_cms_countdowntimerqueue:add":{"route":"/admin/cms/snippets/tsicommon_cms/countdowntimerqueue/add/","args":{}},"wagtailsnippets_tsicommon_cms_countdowntimerqueue:edit":{"route":"/admin/cms/snippets/tsicommon_cms/countdowntimerqueue/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_countdowntimerqueue:delete":{"route":"/admin/cms/snippets/tsicommon_cms/countdowntimerqueue/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_countdowntimerqueue:usage":{"route":"/admin/cms/snippets/tsicommon_cms/countdowntimerqueue/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_countdowntimerqueue:history":{"route":"/admin/cms/snippets/tsicommon_cms/countdowntimerqueue/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_countdowntimerqueue:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/countdowntimerqueue/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_countdowntimerqueue:copy":{"route":"/admin/cms/snippets/tsicommon_cms/countdowntimerqueue/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/countdowntimerqueue/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/countdowntimerqueue/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/countdowntimerqueue/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/countdowntimerqueue/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/countdowntimerqueue/create/","args":{}},"wagtailsnippets_tsicommon_cms_faq:list":{"route":"/admin/cms/snippets/tsicommon_cms/faq/","args":{}},"wagtailsnippets_tsicommon_cms_faq:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/faq/results/","args":{}},"wagtailsnippets_tsicommon_cms_faq:add":{"route":"/admin/cms/snippets/tsicommon_cms/faq/add/","args":{}},"wagtailsnippets_tsicommon_cms_faq:edit":{"route":"/admin/cms/snippets/tsicommon_cms/faq/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_faq:delete":{"route":"/admin/cms/snippets/tsicommon_cms/faq/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_faq:usage":{"route":"/admin/cms/snippets/tsicommon_cms/faq/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_faq:history":{"route":"/admin/cms/snippets/tsicommon_cms/faq/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_faq:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/faq/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_faq:copy":{"route":"/admin/cms/snippets/tsicommon_cms/faq/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_faq:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/faq/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_faq:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/faq/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_faq:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/faq/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_faq:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/faq/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_faq:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/faq/create/","args":{}},"wagtailsnippets_tsicommon_cms_slidecollection:list":{"route":"/admin/cms/snippets/tsicommon_cms/slidecollection/","args":{}},"wagtailsnippets_tsicommon_cms_slidecollection:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/slidecollection/results/","args":{}},"wagtailsnippets_tsicommon_cms_slidecollection:add":{"route":"/admin/cms/snippets/tsicommon_cms/slidecollection/add/","args":{}},"wagtailsnippets_tsicommon_cms_slidecollection:edit":{"route":"/admin/cms/snippets/tsicommon_cms/slidecollection/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_slidecollection:delete":{"route":"/admin/cms/snippets/tsicommon_cms/slidecollection/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_slidecollection:usage":{"route":"/admin/cms/snippets/tsicommon_cms/slidecollection/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_slidecollection:history":{"route":"/admin/cms/snippets/tsicommon_cms/slidecollection/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_slidecollection:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/slidecollection/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_slidecollection:copy":{"route":"/admin/cms/snippets/tsicommon_cms/slidecollection/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_slidecollection:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/slidecollection/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_slidecollection:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/slidecollection/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_slidecollection:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/slidecollection/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_slidecollection:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/slidecollection/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_slidecollection:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/slidecollection/create/","args":{}},"wagtailsnippets_tsicommon_cms_link:list":{"route":"/admin/cms/snippets/tsicommon_cms/link/","args":{}},"wagtailsnippets_tsicommon_cms_link:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/link/results/","args":{}},"wagtailsnippets_tsicommon_cms_link:add":{"route":"/admin/cms/snippets/tsicommon_cms/link/add/","args":{}},"wagtailsnippets_tsicommon_cms_link:edit":{"route":"/admin/cms/snippets/tsicommon_cms/link/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_link:delete":{"route":"/admin/cms/snippets/tsicommon_cms/link/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_link:usage":{"route":"/admin/cms/snippets/tsicommon_cms/link/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_link:history":{"route":"/admin/cms/snippets/tsicommon_cms/link/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_link:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/link/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_link:copy":{"route":"/admin/cms/snippets/tsicommon_cms/link/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_link:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/link/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_link:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/link/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_link:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/link/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_link:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/link/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_link:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/link/create/","args":{}},"wagtailsnippets_tsicommon_cms_plainnavigation:list":{"route":"/admin/cms/snippets/tsicommon_cms/plainnavigation/","args":{}},"wagtailsnippets_tsicommon_cms_plainnavigation:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/plainnavigation/results/","args":{}},"wagtailsnippets_tsicommon_cms_plainnavigation:add":{"route":"/admin/cms/snippets/tsicommon_cms/plainnavigation/add/","args":{}},"wagtailsnippets_tsicommon_cms_plainnavigation:edit":{"route":"/admin/cms/snippets/tsicommon_cms/plainnavigation/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_plainnavigation:delete":{"route":"/admin/cms/snippets/tsicommon_cms/plainnavigation/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_plainnavigation:usage":{"route":"/admin/cms/snippets/tsicommon_cms/plainnavigation/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_plainnavigation:history":{"route":"/admin/cms/snippets/tsicommon_cms/plainnavigation/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_plainnavigation:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/plainnavigation/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_plainnavigation:copy":{"route":"/admin/cms/snippets/tsicommon_cms/plainnavigation/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_plainnavigation:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/plainnavigation/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_plainnavigation:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/plainnavigation/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_plainnavigation:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/plainnavigation/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_plainnavigation:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/plainnavigation/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_plainnavigation:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/plainnavigation/create/","args":{}},"wagtailsnippets_tsicommon_cms_productcomparetile:list":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparetile/","args":{}},"wagtailsnippets_tsicommon_cms_productcomparetile:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparetile/results/","args":{}},"wagtailsnippets_tsicommon_cms_productcomparetile:add":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparetile/add/","args":{}},"wagtailsnippets_tsicommon_cms_productcomparetile:edit":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparetile/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparetile:delete":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparetile/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparetile:usage":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparetile/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparetile:history":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparetile/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparetile:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparetile/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparetile:copy":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparetile/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_productcomparetile:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparetile/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_productcomparetile:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparetile/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_productcomparetile:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparetile/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_productcomparetile:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparetile/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_productcomparetile:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparetile/create/","args":{}},"wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:list":{"route":"/admin/cms/snippets/tsicommon_cms/attributeoptiongroupdescription/","args":{}},"wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/attributeoptiongroupdescription/results/","args":{}},"wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:add":{"route":"/admin/cms/snippets/tsicommon_cms/attributeoptiongroupdescription/add/","args":{}},"wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:edit":{"route":"/admin/cms/snippets/tsicommon_cms/attributeoptiongroupdescription/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:delete":{"route":"/admin/cms/snippets/tsicommon_cms/attributeoptiongroupdescription/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:usage":{"route":"/admin/cms/snippets/tsicommon_cms/attributeoptiongroupdescription/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:history":{"route":"/admin/cms/snippets/tsicommon_cms/attributeoptiongroupdescription/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/attributeoptiongroupdescription/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:copy":{"route":"/admin/cms/snippets/tsicommon_cms/attributeoptiongroupdescription/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/attributeoptiongroupdescription/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/attributeoptiongroupdescription/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/attributeoptiongroupdescription/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/attributeoptiongroupdescription/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/attributeoptiongroupdescription/create/","args":{}},"wagtailsnippets_tsicommon_cms_productcomparerowtype:list":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowtype/","args":{}},"wagtailsnippets_tsicommon_cms_productcomparerowtype:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowtype/results/","args":{}},"wagtailsnippets_tsicommon_cms_productcomparerowtype:add":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowtype/add/","args":{}},"wagtailsnippets_tsicommon_cms_productcomparerowtype:edit":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowtype/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparerowtype:delete":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowtype/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparerowtype:usage":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowtype/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparerowtype:history":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowtype/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparerowtype:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowtype/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparerowtype:copy":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowtype/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparerowtype/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparerowtype/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparerowtype/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparerowtype/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparerowtype/create/","args":{}},"wagtailsnippets_tsicommon_cms_productcomparerowcontent:list":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowcontent/","args":{}},"wagtailsnippets_tsicommon_cms_productcomparerowcontent:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowcontent/results/","args":{}},"wagtailsnippets_tsicommon_cms_productcomparerowcontent:add":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowcontent/add/","args":{}},"wagtailsnippets_tsicommon_cms_productcomparerowcontent:edit":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowcontent/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparerowcontent:delete":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowcontent/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparerowcontent:usage":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowcontent/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparerowcontent:history":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowcontent/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparerowcontent:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowcontent/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productcomparerowcontent:copy":{"route":"/admin/cms/snippets/tsicommon_cms/productcomparerowcontent/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparerowcontent/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparerowcontent/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparerowcontent/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparerowcontent/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productcomparerowcontent/create/","args":{}},"wagtailsnippets_tsicommon_cms_productgrid:list":{"route":"/admin/cms/snippets/tsicommon_cms/productgrid/","args":{}},"wagtailsnippets_tsicommon_cms_productgrid:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/productgrid/results/","args":{}},"wagtailsnippets_tsicommon_cms_productgrid:add":{"route":"/admin/cms/snippets/tsicommon_cms/productgrid/add/","args":{}},"wagtailsnippets_tsicommon_cms_productgrid:edit":{"route":"/admin/cms/snippets/tsicommon_cms/productgrid/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productgrid:delete":{"route":"/admin/cms/snippets/tsicommon_cms/productgrid/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productgrid:usage":{"route":"/admin/cms/snippets/tsicommon_cms/productgrid/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productgrid:history":{"route":"/admin/cms/snippets/tsicommon_cms/productgrid/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productgrid:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/productgrid/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_productgrid:copy":{"route":"/admin/cms/snippets/tsicommon_cms/productgrid/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_productgrid:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productgrid/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_productgrid:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productgrid/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_productgrid:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productgrid/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_productgrid:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productgrid/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_productgrid:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/productgrid/create/","args":{}},"wagtailsnippets_tsicommon_cms_plcconfigurator:list":{"route":"/admin/cms/snippets/tsicommon_cms/plcconfigurator/","args":{}},"wagtailsnippets_tsicommon_cms_plcconfigurator:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/plcconfigurator/results/","args":{}},"wagtailsnippets_tsicommon_cms_plcconfigurator:add":{"route":"/admin/cms/snippets/tsicommon_cms/plcconfigurator/add/","args":{}},"wagtailsnippets_tsicommon_cms_plcconfigurator:edit":{"route":"/admin/cms/snippets/tsicommon_cms/plcconfigurator/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_plcconfigurator:delete":{"route":"/admin/cms/snippets/tsicommon_cms/plcconfigurator/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_plcconfigurator:usage":{"route":"/admin/cms/snippets/tsicommon_cms/plcconfigurator/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_plcconfigurator:history":{"route":"/admin/cms/snippets/tsicommon_cms/plcconfigurator/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_plcconfigurator:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/plcconfigurator/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_plcconfigurator:copy":{"route":"/admin/cms/snippets/tsicommon_cms/plcconfigurator/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_plcconfigurator:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/plcconfigurator/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_plcconfigurator:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/plcconfigurator/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_plcconfigurator:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/plcconfigurator/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_plcconfigurator:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/plcconfigurator/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_plcconfigurator:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/plcconfigurator/create/","args":{}},"wagtailsnippets_tsicommon_cms_promomessagingbanner:list":{"route":"/admin/cms/snippets/tsicommon_cms/promomessagingbanner/","args":{}},"wagtailsnippets_tsicommon_cms_promomessagingbanner:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/promomessagingbanner/results/","args":{}},"wagtailsnippets_tsicommon_cms_promomessagingbanner:add":{"route":"/admin/cms/snippets/tsicommon_cms/promomessagingbanner/add/","args":{}},"wagtailsnippets_tsicommon_cms_promomessagingbanner:edit":{"route":"/admin/cms/snippets/tsicommon_cms/promomessagingbanner/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_promomessagingbanner:delete":{"route":"/admin/cms/snippets/tsicommon_cms/promomessagingbanner/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_promomessagingbanner:usage":{"route":"/admin/cms/snippets/tsicommon_cms/promomessagingbanner/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_promomessagingbanner:history":{"route":"/admin/cms/snippets/tsicommon_cms/promomessagingbanner/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_promomessagingbanner:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/promomessagingbanner/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_promomessagingbanner:copy":{"route":"/admin/cms/snippets/tsicommon_cms/promomessagingbanner/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/promomessagingbanner/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/promomessagingbanner/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/promomessagingbanner/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/promomessagingbanner/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/promomessagingbanner/create/","args":{}},"wagtailsnippets_tsicommon_cms_richnavigationlink:list":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigationlink/","args":{}},"wagtailsnippets_tsicommon_cms_richnavigationlink:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigationlink/results/","args":{}},"wagtailsnippets_tsicommon_cms_richnavigationlink:add":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigationlink/add/","args":{}},"wagtailsnippets_tsicommon_cms_richnavigationlink:edit":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigationlink/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_richnavigationlink:delete":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigationlink/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_richnavigationlink:usage":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigationlink/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_richnavigationlink:history":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigationlink/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_richnavigationlink:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigationlink/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_richnavigationlink:copy":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigationlink/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_richnavigationlink:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/richnavigationlink/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_richnavigationlink:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/richnavigationlink/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_richnavigationlink:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/richnavigationlink/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_richnavigationlink:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/richnavigationlink/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_richnavigationlink:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/richnavigationlink/create/","args":{}},"wagtailsnippets_tsicommon_cms_richnavigation:list":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigation/","args":{}},"wagtailsnippets_tsicommon_cms_richnavigation:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigation/results/","args":{}},"wagtailsnippets_tsicommon_cms_richnavigation:add":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigation/add/","args":{}},"wagtailsnippets_tsicommon_cms_richnavigation:edit":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigation/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_richnavigation:delete":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigation/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_richnavigation:usage":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigation/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_richnavigation:history":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigation/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_richnavigation:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigation/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_richnavigation:copy":{"route":"/admin/cms/snippets/tsicommon_cms/richnavigation/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_richnavigation:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/richnavigation/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_richnavigation:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/richnavigation/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_richnavigation:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/richnavigation/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_richnavigation:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/richnavigation/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_richnavigation:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/richnavigation/create/","args":{}},"wagtailsnippets_tsicommon_cms_emailmodal:list":{"route":"/admin/cms/snippets/tsicommon_cms/emailmodal/","args":{}},"wagtailsnippets_tsicommon_cms_emailmodal:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/emailmodal/results/","args":{}},"wagtailsnippets_tsicommon_cms_emailmodal:add":{"route":"/admin/cms/snippets/tsicommon_cms/emailmodal/add/","args":{}},"wagtailsnippets_tsicommon_cms_emailmodal:edit":{"route":"/admin/cms/snippets/tsicommon_cms/emailmodal/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_emailmodal:delete":{"route":"/admin/cms/snippets/tsicommon_cms/emailmodal/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_emailmodal:usage":{"route":"/admin/cms/snippets/tsicommon_cms/emailmodal/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_emailmodal:history":{"route":"/admin/cms/snippets/tsicommon_cms/emailmodal/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_emailmodal:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/emailmodal/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_emailmodal:copy":{"route":"/admin/cms/snippets/tsicommon_cms/emailmodal/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_emailmodal:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/emailmodal/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_emailmodal:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/emailmodal/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_emailmodal:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/emailmodal/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_emailmodal:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/emailmodal/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_emailmodal:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/emailmodal/create/","args":{}},"wagtailsnippets_tsicommon_cms_servicefootersnippet:list":{"route":"/admin/cms/snippets/tsicommon_cms/servicefootersnippet/","args":{}},"wagtailsnippets_tsicommon_cms_servicefootersnippet:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/servicefootersnippet/results/","args":{}},"wagtailsnippets_tsicommon_cms_servicefootersnippet:add":{"route":"/admin/cms/snippets/tsicommon_cms/servicefootersnippet/add/","args":{}},"wagtailsnippets_tsicommon_cms_servicefootersnippet:edit":{"route":"/admin/cms/snippets/tsicommon_cms/servicefootersnippet/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_servicefootersnippet:delete":{"route":"/admin/cms/snippets/tsicommon_cms/servicefootersnippet/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_servicefootersnippet:usage":{"route":"/admin/cms/snippets/tsicommon_cms/servicefootersnippet/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_servicefootersnippet:history":{"route":"/admin/cms/snippets/tsicommon_cms/servicefootersnippet/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_servicefootersnippet:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/servicefootersnippet/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_servicefootersnippet:copy":{"route":"/admin/cms/snippets/tsicommon_cms/servicefootersnippet/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/servicefootersnippet/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/servicefootersnippet/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/servicefootersnippet/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/servicefootersnippet/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/servicefootersnippet/create/","args":{}},"wagtailsnippets_tsicommon_cms_timedemailmodal:list":{"route":"/admin/cms/snippets/tsicommon_cms/timedemailmodal/","args":{}},"wagtailsnippets_tsicommon_cms_timedemailmodal:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/timedemailmodal/results/","args":{}},"wagtailsnippets_tsicommon_cms_timedemailmodal:add":{"route":"/admin/cms/snippets/tsicommon_cms/timedemailmodal/add/","args":{}},"wagtailsnippets_tsicommon_cms_timedemailmodal:edit":{"route":"/admin/cms/snippets/tsicommon_cms/timedemailmodal/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_timedemailmodal:delete":{"route":"/admin/cms/snippets/tsicommon_cms/timedemailmodal/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_timedemailmodal:usage":{"route":"/admin/cms/snippets/tsicommon_cms/timedemailmodal/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_timedemailmodal:history":{"route":"/admin/cms/snippets/tsicommon_cms/timedemailmodal/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_timedemailmodal:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/timedemailmodal/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_timedemailmodal:copy":{"route":"/admin/cms/snippets/tsicommon_cms/timedemailmodal/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_timedemailmodal:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/timedemailmodal/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_timedemailmodal:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/timedemailmodal/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_timedemailmodal:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/timedemailmodal/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_timedemailmodal:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/timedemailmodal/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_timedemailmodal:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/timedemailmodal/create/","args":{}},"wagtailsnippets_tsicommon_cms_comparefeature:list":{"route":"/admin/cms/snippets/tsicommon_cms/comparefeature/","args":{}},"wagtailsnippets_tsicommon_cms_comparefeature:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/comparefeature/results/","args":{}},"wagtailsnippets_tsicommon_cms_comparefeature:add":{"route":"/admin/cms/snippets/tsicommon_cms/comparefeature/add/","args":{}},"wagtailsnippets_tsicommon_cms_comparefeature:edit":{"route":"/admin/cms/snippets/tsicommon_cms/comparefeature/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_comparefeature:delete":{"route":"/admin/cms/snippets/tsicommon_cms/comparefeature/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_comparefeature:usage":{"route":"/admin/cms/snippets/tsicommon_cms/comparefeature/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_comparefeature:history":{"route":"/admin/cms/snippets/tsicommon_cms/comparefeature/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_comparefeature:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/comparefeature/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_comparefeature:copy":{"route":"/admin/cms/snippets/tsicommon_cms/comparefeature/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_comparefeature:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/comparefeature/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_comparefeature:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/comparefeature/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_comparefeature:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/comparefeature/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_comparefeature:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/comparefeature/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_comparefeature:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/comparefeature/create/","args":{}},"wagtailsnippets_tsicommon_cms_comparetile:list":{"route":"/admin/cms/snippets/tsicommon_cms/comparetile/","args":{}},"wagtailsnippets_tsicommon_cms_comparetile:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/comparetile/results/","args":{}},"wagtailsnippets_tsicommon_cms_comparetile:add":{"route":"/admin/cms/snippets/tsicommon_cms/comparetile/add/","args":{}},"wagtailsnippets_tsicommon_cms_comparetile:edit":{"route":"/admin/cms/snippets/tsicommon_cms/comparetile/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_comparetile:delete":{"route":"/admin/cms/snippets/tsicommon_cms/comparetile/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_comparetile:usage":{"route":"/admin/cms/snippets/tsicommon_cms/comparetile/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_comparetile:history":{"route":"/admin/cms/snippets/tsicommon_cms/comparetile/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_comparetile:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/comparetile/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_comparetile:copy":{"route":"/admin/cms/snippets/tsicommon_cms/comparetile/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_comparetile:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/comparetile/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_comparetile:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/comparetile/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_comparetile:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/comparetile/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_comparetile:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/comparetile/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_comparetile:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/comparetile/create/","args":{}},"wagtailsnippets_tsicommon_cms_shoptile:list":{"route":"/admin/cms/snippets/tsicommon_cms/shoptile/","args":{}},"wagtailsnippets_tsicommon_cms_shoptile:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/shoptile/results/","args":{}},"wagtailsnippets_tsicommon_cms_shoptile:add":{"route":"/admin/cms/snippets/tsicommon_cms/shoptile/add/","args":{}},"wagtailsnippets_tsicommon_cms_shoptile:edit":{"route":"/admin/cms/snippets/tsicommon_cms/shoptile/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_shoptile:delete":{"route":"/admin/cms/snippets/tsicommon_cms/shoptile/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_shoptile:usage":{"route":"/admin/cms/snippets/tsicommon_cms/shoptile/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_shoptile:history":{"route":"/admin/cms/snippets/tsicommon_cms/shoptile/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_shoptile:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/shoptile/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_shoptile:copy":{"route":"/admin/cms/snippets/tsicommon_cms/shoptile/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_shoptile:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/shoptile/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_shoptile:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/shoptile/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_shoptile:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/shoptile/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_shoptile:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/shoptile/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_shoptile:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/shoptile/create/","args":{}},"wagtailsnippets_tsicommon_cms_shopcomparetileset:list":{"route":"/admin/cms/snippets/tsicommon_cms/shopcomparetileset/","args":{}},"wagtailsnippets_tsicommon_cms_shopcomparetileset:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/shopcomparetileset/results/","args":{}},"wagtailsnippets_tsicommon_cms_shopcomparetileset:add":{"route":"/admin/cms/snippets/tsicommon_cms/shopcomparetileset/add/","args":{}},"wagtailsnippets_tsicommon_cms_shopcomparetileset:edit":{"route":"/admin/cms/snippets/tsicommon_cms/shopcomparetileset/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_shopcomparetileset:delete":{"route":"/admin/cms/snippets/tsicommon_cms/shopcomparetileset/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_shopcomparetileset:usage":{"route":"/admin/cms/snippets/tsicommon_cms/shopcomparetileset/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_shopcomparetileset:history":{"route":"/admin/cms/snippets/tsicommon_cms/shopcomparetileset/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_shopcomparetileset:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/shopcomparetileset/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_shopcomparetileset:copy":{"route":"/admin/cms/snippets/tsicommon_cms/shopcomparetileset/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/shopcomparetileset/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/shopcomparetileset/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/shopcomparetileset/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/shopcomparetileset/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/shopcomparetileset/create/","args":{}},"wagtailsnippets_tsicommon_cms_stickyemailbanner:list":{"route":"/admin/cms/snippets/tsicommon_cms/stickyemailbanner/","args":{}},"wagtailsnippets_tsicommon_cms_stickyemailbanner:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/stickyemailbanner/results/","args":{}},"wagtailsnippets_tsicommon_cms_stickyemailbanner:add":{"route":"/admin/cms/snippets/tsicommon_cms/stickyemailbanner/add/","args":{}},"wagtailsnippets_tsicommon_cms_stickyemailbanner:edit":{"route":"/admin/cms/snippets/tsicommon_cms/stickyemailbanner/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_stickyemailbanner:delete":{"route":"/admin/cms/snippets/tsicommon_cms/stickyemailbanner/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_stickyemailbanner:usage":{"route":"/admin/cms/snippets/tsicommon_cms/stickyemailbanner/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_stickyemailbanner:history":{"route":"/admin/cms/snippets/tsicommon_cms/stickyemailbanner/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_stickyemailbanner:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/stickyemailbanner/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_stickyemailbanner:copy":{"route":"/admin/cms/snippets/tsicommon_cms/stickyemailbanner/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/stickyemailbanner/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/stickyemailbanner/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/stickyemailbanner/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/stickyemailbanner/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/stickyemailbanner/create/","args":{}},"wagtailsnippets_tsicommon_cms_valueprop:list":{"route":"/admin/cms/snippets/tsicommon_cms/valueprop/","args":{}},"wagtailsnippets_tsicommon_cms_valueprop:list_results":{"route":"/admin/cms/snippets/tsicommon_cms/valueprop/results/","args":{}},"wagtailsnippets_tsicommon_cms_valueprop:add":{"route":"/admin/cms/snippets/tsicommon_cms/valueprop/add/","args":{}},"wagtailsnippets_tsicommon_cms_valueprop:edit":{"route":"/admin/cms/snippets/tsicommon_cms/valueprop/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_valueprop:delete":{"route":"/admin/cms/snippets/tsicommon_cms/valueprop/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_valueprop:usage":{"route":"/admin/cms/snippets/tsicommon_cms/valueprop/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_valueprop:history":{"route":"/admin/cms/snippets/tsicommon_cms/valueprop/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_valueprop:history_results":{"route":"/admin/cms/snippets/tsicommon_cms/valueprop/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tsicommon_cms_valueprop:copy":{"route":"/admin/cms/snippets/tsicommon_cms/valueprop/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_valueprop:choose":{"route":"/admin/cms/snippets/choose/tsicommon_cms/valueprop/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_valueprop:choose_results":{"route":"/admin/cms/snippets/choose/tsicommon_cms/valueprop/results/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_valueprop:chosen":{"route":"/admin/cms/snippets/choose/tsicommon_cms/valueprop/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tsicommon_cms_valueprop:chosen_multiple":{"route":"/admin/cms/snippets/choose/tsicommon_cms/valueprop/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tsicommon_cms_valueprop:create":{"route":"/admin/cms/snippets/choose/tsicommon_cms/valueprop/create/","args":{}},"wagtailsnippets_cms_navbar:list":{"route":"/admin/cms/snippets/cms/navbar/","args":{}},"wagtailsnippets_cms_navbar:list_results":{"route":"/admin/cms/snippets/cms/navbar/results/","args":{}},"wagtailsnippets_cms_navbar:add":{"route":"/admin/cms/snippets/cms/navbar/add/","args":{}},"wagtailsnippets_cms_navbar:edit":{"route":"/admin/cms/snippets/cms/navbar/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_navbar:delete":{"route":"/admin/cms/snippets/cms/navbar/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_navbar:usage":{"route":"/admin/cms/snippets/cms/navbar/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_navbar:history":{"route":"/admin/cms/snippets/cms/navbar/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_navbar:history_results":{"route":"/admin/cms/snippets/cms/navbar/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_navbar:copy":{"route":"/admin/cms/snippets/cms/navbar/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_navbar:choose":{"route":"/admin/cms/snippets/choose/cms/navbar/","args":{}},"wagtailsnippetchoosers_cms_navbar:choose_results":{"route":"/admin/cms/snippets/choose/cms/navbar/results/","args":{}},"wagtailsnippetchoosers_cms_navbar:chosen":{"route":"/admin/cms/snippets/choose/cms/navbar/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_navbar:chosen_multiple":{"route":"/admin/cms/snippets/choose/cms/navbar/chosen-multiple/","args":{}},"wagtailsnippetchoosers_cms_navbar:create":{"route":"/admin/cms/snippets/choose/cms/navbar/create/","args":{}},"wagtailsnippets_cms_contentblock:list":{"route":"/admin/cms/snippets/cms/contentblock/","args":{}},"wagtailsnippets_cms_contentblock:list_results":{"route":"/admin/cms/snippets/cms/contentblock/results/","args":{}},"wagtailsnippets_cms_contentblock:add":{"route":"/admin/cms/snippets/cms/contentblock/add/","args":{}},"wagtailsnippets_cms_contentblock:edit":{"route":"/admin/cms/snippets/cms/contentblock/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_contentblock:delete":{"route":"/admin/cms/snippets/cms/contentblock/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_contentblock:usage":{"route":"/admin/cms/snippets/cms/contentblock/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_contentblock:history":{"route":"/admin/cms/snippets/cms/contentblock/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_contentblock:history_results":{"route":"/admin/cms/snippets/cms/contentblock/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_contentblock:copy":{"route":"/admin/cms/snippets/cms/contentblock/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_contentblock:choose":{"route":"/admin/cms/snippets/choose/cms/contentblock/","args":{}},"wagtailsnippetchoosers_cms_contentblock:choose_results":{"route":"/admin/cms/snippets/choose/cms/contentblock/results/","args":{}},"wagtailsnippetchoosers_cms_contentblock:chosen":{"route":"/admin/cms/snippets/choose/cms/contentblock/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_contentblock:chosen_multiple":{"route":"/admin/cms/snippets/choose/cms/contentblock/chosen-multiple/","args":{}},"wagtailsnippetchoosers_cms_contentblock:create":{"route":"/admin/cms/snippets/choose/cms/contentblock/create/","args":{}},"wagtailsnippets_cms_promocopyheader:list":{"route":"/admin/cms/snippets/cms/promocopyheader/","args":{}},"wagtailsnippets_cms_promocopyheader:list_results":{"route":"/admin/cms/snippets/cms/promocopyheader/results/","args":{}},"wagtailsnippets_cms_promocopyheader:add":{"route":"/admin/cms/snippets/cms/promocopyheader/add/","args":{}},"wagtailsnippets_cms_promocopyheader:edit":{"route":"/admin/cms/snippets/cms/promocopyheader/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_promocopyheader:delete":{"route":"/admin/cms/snippets/cms/promocopyheader/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_promocopyheader:usage":{"route":"/admin/cms/snippets/cms/promocopyheader/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_promocopyheader:history":{"route":"/admin/cms/snippets/cms/promocopyheader/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_promocopyheader:history_results":{"route":"/admin/cms/snippets/cms/promocopyheader/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_promocopyheader:copy":{"route":"/admin/cms/snippets/cms/promocopyheader/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_promocopyheader:choose":{"route":"/admin/cms/snippets/choose/cms/promocopyheader/","args":{}},"wagtailsnippetchoosers_cms_promocopyheader:choose_results":{"route":"/admin/cms/snippets/choose/cms/promocopyheader/results/","args":{}},"wagtailsnippetchoosers_cms_promocopyheader:chosen":{"route":"/admin/cms/snippets/choose/cms/promocopyheader/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_promocopyheader:chosen_multiple":{"route":"/admin/cms/snippets/choose/cms/promocopyheader/chosen-multiple/","args":{}},"wagtailsnippetchoosers_cms_promocopyheader:create":{"route":"/admin/cms/snippets/choose/cms/promocopyheader/create/","args":{}},"wagtailsnippets_cms_promocopy:list":{"route":"/admin/cms/snippets/cms/promocopy/","args":{}},"wagtailsnippets_cms_promocopy:list_results":{"route":"/admin/cms/snippets/cms/promocopy/results/","args":{}},"wagtailsnippets_cms_promocopy:add":{"route":"/admin/cms/snippets/cms/promocopy/add/","args":{}},"wagtailsnippets_cms_promocopy:edit":{"route":"/admin/cms/snippets/cms/promocopy/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_promocopy:delete":{"route":"/admin/cms/snippets/cms/promocopy/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_promocopy:usage":{"route":"/admin/cms/snippets/cms/promocopy/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_promocopy:history":{"route":"/admin/cms/snippets/cms/promocopy/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_promocopy:history_results":{"route":"/admin/cms/snippets/cms/promocopy/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_promocopy:copy":{"route":"/admin/cms/snippets/cms/promocopy/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_promocopy:choose":{"route":"/admin/cms/snippets/choose/cms/promocopy/","args":{}},"wagtailsnippetchoosers_cms_promocopy:choose_results":{"route":"/admin/cms/snippets/choose/cms/promocopy/results/","args":{}},"wagtailsnippetchoosers_cms_promocopy:chosen":{"route":"/admin/cms/snippets/choose/cms/promocopy/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_promocopy:chosen_multiple":{"route":"/admin/cms/snippets/choose/cms/promocopy/chosen-multiple/","args":{}},"wagtailsnippetchoosers_cms_promocopy:create":{"route":"/admin/cms/snippets/choose/cms/promocopy/create/","args":{}},"wagtailsnippets_cms_navbadge:list":{"route":"/admin/cms/snippets/cms/navbadge/","args":{}},"wagtailsnippets_cms_navbadge:list_results":{"route":"/admin/cms/snippets/cms/navbadge/results/","args":{}},"wagtailsnippets_cms_navbadge:add":{"route":"/admin/cms/snippets/cms/navbadge/add/","args":{}},"wagtailsnippets_cms_navbadge:edit":{"route":"/admin/cms/snippets/cms/navbadge/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_navbadge:delete":{"route":"/admin/cms/snippets/cms/navbadge/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_navbadge:usage":{"route":"/admin/cms/snippets/cms/navbadge/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_navbadge:history":{"route":"/admin/cms/snippets/cms/navbadge/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_navbadge:history_results":{"route":"/admin/cms/snippets/cms/navbadge/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_navbadge:copy":{"route":"/admin/cms/snippets/cms/navbadge/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_navbadge:choose":{"route":"/admin/cms/snippets/choose/cms/navbadge/","args":{}},"wagtailsnippetchoosers_cms_navbadge:choose_results":{"route":"/admin/cms/snippets/choose/cms/navbadge/results/","args":{}},"wagtailsnippetchoosers_cms_navbadge:chosen":{"route":"/admin/cms/snippets/choose/cms/navbadge/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_navbadge:chosen_multiple":{"route":"/admin/cms/snippets/choose/cms/navbadge/chosen-multiple/","args":{}},"wagtailsnippetchoosers_cms_navbadge:create":{"route":"/admin/cms/snippets/choose/cms/navbadge/create/","args":{}},"wagtailsnippets_cms_ownerspotlight:list":{"route":"/admin/cms/snippets/cms/ownerspotlight/","args":{}},"wagtailsnippets_cms_ownerspotlight:list_results":{"route":"/admin/cms/snippets/cms/ownerspotlight/results/","args":{}},"wagtailsnippets_cms_ownerspotlight:add":{"route":"/admin/cms/snippets/cms/ownerspotlight/add/","args":{}},"wagtailsnippets_cms_ownerspotlight:edit":{"route":"/admin/cms/snippets/cms/ownerspotlight/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_ownerspotlight:delete":{"route":"/admin/cms/snippets/cms/ownerspotlight/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_ownerspotlight:usage":{"route":"/admin/cms/snippets/cms/ownerspotlight/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_ownerspotlight:history":{"route":"/admin/cms/snippets/cms/ownerspotlight/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_ownerspotlight:history_results":{"route":"/admin/cms/snippets/cms/ownerspotlight/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_ownerspotlight:copy":{"route":"/admin/cms/snippets/cms/ownerspotlight/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_ownerspotlight:choose":{"route":"/admin/cms/snippets/choose/cms/ownerspotlight/","args":{}},"wagtailsnippetchoosers_cms_ownerspotlight:choose_results":{"route":"/admin/cms/snippets/choose/cms/ownerspotlight/results/","args":{}},"wagtailsnippetchoosers_cms_ownerspotlight:chosen":{"route":"/admin/cms/snippets/choose/cms/ownerspotlight/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_ownerspotlight:chosen_multiple":{"route":"/admin/cms/snippets/choose/cms/ownerspotlight/chosen-multiple/","args":{}},"wagtailsnippetchoosers_cms_ownerspotlight:create":{"route":"/admin/cms/snippets/choose/cms/ownerspotlight/create/","args":{}},"wagtailsnippets_cms_ugcpost:list":{"route":"/admin/cms/snippets/cms/ugcpost/","args":{}},"wagtailsnippets_cms_ugcpost:list_results":{"route":"/admin/cms/snippets/cms/ugcpost/results/","args":{}},"wagtailsnippets_cms_ugcpost:add":{"route":"/admin/cms/snippets/cms/ugcpost/add/","args":{}},"wagtailsnippets_cms_ugcpost:edit":{"route":"/admin/cms/snippets/cms/ugcpost/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_ugcpost:delete":{"route":"/admin/cms/snippets/cms/ugcpost/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_ugcpost:usage":{"route":"/admin/cms/snippets/cms/ugcpost/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_ugcpost:history":{"route":"/admin/cms/snippets/cms/ugcpost/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_ugcpost:history_results":{"route":"/admin/cms/snippets/cms/ugcpost/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_ugcpost:copy":{"route":"/admin/cms/snippets/cms/ugcpost/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_ugcpost:choose":{"route":"/admin/cms/snippets/choose/cms/ugcpost/","args":{}},"wagtailsnippetchoosers_cms_ugcpost:choose_results":{"route":"/admin/cms/snippets/choose/cms/ugcpost/results/","args":{}},"wagtailsnippetchoosers_cms_ugcpost:chosen":{"route":"/admin/cms/snippets/choose/cms/ugcpost/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_ugcpost:chosen_multiple":{"route":"/admin/cms/snippets/choose/cms/ugcpost/chosen-multiple/","args":{}},"wagtailsnippetchoosers_cms_ugcpost:create":{"route":"/admin/cms/snippets/choose/cms/ugcpost/create/","args":{}},"wagtailsnippets_cms_tempurlovestorycategory:list":{"route":"/admin/cms/snippets/cms/tempurlovestorycategory/","args":{}},"wagtailsnippets_cms_tempurlovestorycategory:list_results":{"route":"/admin/cms/snippets/cms/tempurlovestorycategory/results/","args":{}},"wagtailsnippets_cms_tempurlovestorycategory:add":{"route":"/admin/cms/snippets/cms/tempurlovestorycategory/add/","args":{}},"wagtailsnippets_cms_tempurlovestorycategory:edit":{"route":"/admin/cms/snippets/cms/tempurlovestorycategory/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_tempurlovestorycategory:delete":{"route":"/admin/cms/snippets/cms/tempurlovestorycategory/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_tempurlovestorycategory:usage":{"route":"/admin/cms/snippets/cms/tempurlovestorycategory/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_tempurlovestorycategory:history":{"route":"/admin/cms/snippets/cms/tempurlovestorycategory/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_tempurlovestorycategory:history_results":{"route":"/admin/cms/snippets/cms/tempurlovestorycategory/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_cms_tempurlovestorycategory:copy":{"route":"/admin/cms/snippets/cms/tempurlovestorycategory/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_tempurlovestorycategory:choose":{"route":"/admin/cms/snippets/choose/cms/tempurlovestorycategory/","args":{}},"wagtailsnippetchoosers_cms_tempurlovestorycategory:choose_results":{"route":"/admin/cms/snippets/choose/cms/tempurlovestorycategory/results/","args":{}},"wagtailsnippetchoosers_cms_tempurlovestorycategory:chosen":{"route":"/admin/cms/snippets/choose/cms/tempurlovestorycategory/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_cms_tempurlovestorycategory:chosen_multiple":{"route":"/admin/cms/snippets/choose/cms/tempurlovestorycategory/chosen-multiple/","args":{}},"wagtailsnippetchoosers_cms_tempurlovestorycategory:create":{"route":"/admin/cms/snippets/choose/cms/tempurlovestorycategory/create/","args":{}},"wagtailsnippets_tempur_search_dynamicsearchsnippet:list":{"route":"/admin/cms/snippets/tempur_search/dynamicsearchsnippet/","args":{}},"wagtailsnippets_tempur_search_dynamicsearchsnippet:list_results":{"route":"/admin/cms/snippets/tempur_search/dynamicsearchsnippet/results/","args":{}},"wagtailsnippets_tempur_search_dynamicsearchsnippet:add":{"route":"/admin/cms/snippets/tempur_search/dynamicsearchsnippet/add/","args":{}},"wagtailsnippets_tempur_search_dynamicsearchsnippet:edit":{"route":"/admin/cms/snippets/tempur_search/dynamicsearchsnippet/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tempur_search_dynamicsearchsnippet:delete":{"route":"/admin/cms/snippets/tempur_search/dynamicsearchsnippet/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tempur_search_dynamicsearchsnippet:usage":{"route":"/admin/cms/snippets/tempur_search/dynamicsearchsnippet/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tempur_search_dynamicsearchsnippet:history":{"route":"/admin/cms/snippets/tempur_search/dynamicsearchsnippet/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tempur_search_dynamicsearchsnippet:history_results":{"route":"/admin/cms/snippets/tempur_search/dynamicsearchsnippet/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tempur_search_dynamicsearchsnippet:copy":{"route":"/admin/cms/snippets/tempur_search/dynamicsearchsnippet/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet:choose":{"route":"/admin/cms/snippets/choose/tempur_search/dynamicsearchsnippet/","args":{}},"wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet:choose_results":{"route":"/admin/cms/snippets/choose/tempur_search/dynamicsearchsnippet/results/","args":{}},"wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet:chosen":{"route":"/admin/cms/snippets/choose/tempur_search/dynamicsearchsnippet/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet:chosen_multiple":{"route":"/admin/cms/snippets/choose/tempur_search/dynamicsearchsnippet/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet:create":{"route":"/admin/cms/snippets/choose/tempur_search/dynamicsearchsnippet/create/","args":{}},"wagtailsnippets_tempur_search_dynamic404pagesnippet:list":{"route":"/admin/cms/snippets/tempur_search/dynamic404pagesnippet/","args":{}},"wagtailsnippets_tempur_search_dynamic404pagesnippet:list_results":{"route":"/admin/cms/snippets/tempur_search/dynamic404pagesnippet/results/","args":{}},"wagtailsnippets_tempur_search_dynamic404pagesnippet:add":{"route":"/admin/cms/snippets/tempur_search/dynamic404pagesnippet/add/","args":{}},"wagtailsnippets_tempur_search_dynamic404pagesnippet:edit":{"route":"/admin/cms/snippets/tempur_search/dynamic404pagesnippet/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tempur_search_dynamic404pagesnippet:delete":{"route":"/admin/cms/snippets/tempur_search/dynamic404pagesnippet/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tempur_search_dynamic404pagesnippet:usage":{"route":"/admin/cms/snippets/tempur_search/dynamic404pagesnippet/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tempur_search_dynamic404pagesnippet:history":{"route":"/admin/cms/snippets/tempur_search/dynamic404pagesnippet/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tempur_search_dynamic404pagesnippet:history_results":{"route":"/admin/cms/snippets/tempur_search/dynamic404pagesnippet/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_tempur_search_dynamic404pagesnippet:copy":{"route":"/admin/cms/snippets/tempur_search/dynamic404pagesnippet/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet:choose":{"route":"/admin/cms/snippets/choose/tempur_search/dynamic404pagesnippet/","args":{}},"wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet:choose_results":{"route":"/admin/cms/snippets/choose/tempur_search/dynamic404pagesnippet/results/","args":{}},"wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet:chosen":{"route":"/admin/cms/snippets/choose/tempur_search/dynamic404pagesnippet/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet:chosen_multiple":{"route":"/admin/cms/snippets/choose/tempur_search/dynamic404pagesnippet/chosen-multiple/","args":{}},"wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet:create":{"route":"/admin/cms/snippets/choose/tempur_search/dynamic404pagesnippet/create/","args":{}},"wagtailsnippets_thelabui_labuitoolboxsnippet:list":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/","args":{}},"wagtailsnippets_thelabui_labuitoolboxsnippet:list_results":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/results/","args":{}},"wagtailsnippets_thelabui_labuitoolboxsnippet:add":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/add/","args":{}},"wagtailsnippets_thelabui_labuitoolboxsnippet:edit":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:delete":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:usage":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:history":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/history/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:history_results":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:copy":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/copy/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:preview_on_add":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/preview/","args":{}},"wagtailsnippets_thelabui_labuitoolboxsnippet:preview_on_edit":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/preview/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:revisions_view":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/history/<str:pk>/revisions/<int:revision_id>/view/","args":{"pk":"string","revision_id":"number"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:revisions_revert":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/history/<str:pk>/revisions/<int:revision_id>/revert/","args":{"pk":"string","revision_id":"number"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:revisions_unschedule":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/history/<str:pk>/revisions/<int:revision_id>/unschedule/","args":{"pk":"string","revision_id":"number"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:unpublish":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/unpublish/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:lock":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/lock/<str:pk>/","args":{"pk":"string"}},"wagtailsnippets_thelabui_labuitoolboxsnippet:unlock":{"route":"/admin/cms/snippets/thelabui/labuitoolboxsnippet/unlock/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:choose":{"route":"/admin/cms/snippets/choose/thelabui/labuitoolboxsnippet/","args":{}},"wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:choose_results":{"route":"/admin/cms/snippets/choose/thelabui/labuitoolboxsnippet/results/","args":{}},"wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:chosen":{"route":"/admin/cms/snippets/choose/thelabui/labuitoolboxsnippet/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:chosen_multiple":{"route":"/admin/cms/snippets/choose/thelabui/labuitoolboxsnippet/chosen-multiple/","args":{}},"wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:create":{"route":"/admin/cms/snippets/choose/thelabui/labuitoolboxsnippet/create/","args":{}},"wagtailvideos_chooser:choose":{"route":"/admin/cms/videos/chooser/","args":{}},"wagtailvideos_chooser:choose_results":{"route":"/admin/cms/videos/chooser/results/","args":{}},"wagtailvideos_chooser:chosen":{"route":"/admin/cms/videos/chooser/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailvideos_chooser:chosen_multiple":{"route":"/admin/cms/videos/chooser/chosen-multiple/","args":{}},"wagtailvideos_chooser:create":{"route":"/admin/cms/videos/chooser/create/","args":{}},"wagtaildocs_chooser:choose":{"route":"/admin/cms/documents/chooser/","args":{}},"wagtaildocs_chooser:choose_results":{"route":"/admin/cms/documents/chooser/results/","args":{}},"wagtaildocs_chooser:chosen":{"route":"/admin/cms/documents/chooser/chosen/<str:pk>/","args":{"pk":"string"}},"wagtaildocs_chooser:chosen_multiple":{"route":"/admin/cms/documents/chooser/chosen-multiple/","args":{}},"wagtaildocs_chooser:create":{"route":"/admin/cms/documents/chooser/create/","args":{}},"wagtailsites:index":{"route":"/admin/cms/sites/","args":{}},"wagtailsites:index_results":{"route":"/admin/cms/sites/results/","args":{}},"wagtailsites:add":{"route":"/admin/cms/sites/new/","args":{}},"wagtailsites:edit":{"route":"/admin/cms/sites/edit/<str:pk>/","args":{"pk":"string"}},"wagtailsites:delete":{"route":"/admin/cms/sites/delete/<str:pk>/","args":{"pk":"string"}},"wagtailsites:history":{"route":"/admin/cms/sites/history/<str:pk>/","args":{"pk":"string"}},"wagtailsites:history_results":{"route":"/admin/cms/sites/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailsites:usage":{"route":"/admin/cms/sites/usage/<str:pk>/","args":{"pk":"string"}},"wagtailsites:copy":{"route":"/admin/cms/sites/copy/<str:pk>/","args":{"pk":"string"}},"wagtailusers_users:index":{"route":"/admin/cms/users/","args":{}},"wagtailusers_users:index_results":{"route":"/admin/cms/users/results/","args":{}},"wagtailusers_users:add":{"route":"/admin/cms/users/new/","args":{}},"wagtailusers_users:edit":{"route":"/admin/cms/users/edit/<str:pk>/","args":{"pk":"string"}},"wagtailusers_users:delete":{"route":"/admin/cms/users/delete/<str:pk>/","args":{"pk":"string"}},"wagtailusers_users:history":{"route":"/admin/cms/users/history/<str:pk>/","args":{"pk":"string"}},"wagtailusers_users:history_results":{"route":"/admin/cms/users/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailusers_users:usage":{"route":"/admin/cms/users/usage/<str:pk>/","args":{"pk":"string"}},"wagtailusers_users:copy":{"route":"/admin/cms/users/copy/<str:pk>/","args":{"pk":"string"}},"wagtailusers_groups:index":{"route":"/admin/cms/groups/","args":{}},"wagtailusers_groups:index_results":{"route":"/admin/cms/groups/results/","args":{}},"wagtailusers_groups:add":{"route":"/admin/cms/groups/new/","args":{}},"wagtailusers_groups:edit":{"route":"/admin/cms/groups/edit/<str:pk>/","args":{"pk":"string"}},"wagtailusers_groups:delete":{"route":"/admin/cms/groups/delete/<str:pk>/","args":{"pk":"string"}},"wagtailusers_groups:history":{"route":"/admin/cms/groups/history/<str:pk>/","args":{"pk":"string"}},"wagtailusers_groups:history_results":{"route":"/admin/cms/groups/history-results/<str:pk>/","args":{"pk":"string"}},"wagtailusers_groups:usage":{"route":"/admin/cms/groups/usage/<str:pk>/","args":{"pk":"string"}},"wagtaillocales:index":{"route":"/admin/cms/locales/","args":{}},"wagtaillocales:index_results":{"route":"/admin/cms/locales/results/","args":{}},"wagtaillocales:add":{"route":"/admin/cms/locales/new/","args":{}},"wagtaillocales:edit":{"route":"/admin/cms/locales/edit/<str:pk>/","args":{"pk":"string"}},"wagtaillocales:delete":{"route":"/admin/cms/locales/delete/<str:pk>/","args":{"pk":"string"}},"wagtaillocales:history":{"route":"/admin/cms/locales/history/<str:pk>/","args":{"pk":"string"}},"wagtaillocales:history_results":{"route":"/admin/cms/locales/history-results/<str:pk>/","args":{"pk":"string"}},"wagtaillocales:usage":{"route":"/admin/cms/locales/usage/<str:pk>/","args":{"pk":"string"}},"wagtaillocales:copy":{"route":"/admin/cms/locales/copy/<str:pk>/","args":{"pk":"string"}},"tsicommon_cms_product_chooser:choose":{"route":"/admin/cms/products/chooser/","args":{}},"tsicommon_cms_product_chooser:choose_results":{"route":"/admin/cms/products/chooser/results/","args":{}},"tsicommon_cms_product_chooser:chosen":{"route":"/admin/cms/products/chooser/chosen/<str:pk>/","args":{"pk":"string"}},"tsicommon_cms_product_chooser:chosen_multiple":{"route":"/admin/cms/products/chooser/chosen-multiple/","args":{}},"tsicommon_cms_product_chooser:create":{"route":"/admin/cms/products/chooser/create/","args":{}},"tsicommon_cms_location_chooser:choose":{"route":"/admin/cms/locations/chooser/","args":{}},"tsicommon_cms_location_chooser:choose_results":{"route":"/admin/cms/locations/chooser/results/","args":{}},"tsicommon_cms_location_chooser:chosen":{"route":"/admin/cms/locations/chooser/chosen/<str:pk>/","args":{"pk":"string"}},"tsicommon_cms_location_chooser:chosen_multiple":{"route":"/admin/cms/locations/chooser/chosen-multiple/","args":{}},"tsicommon_cms_location_chooser:create":{"route":"/admin/cms/locations/chooser/create/","args":{}},"wagtailimages_chooser:choose":{"route":"/admin/cms/images/chooser/","args":{}},"wagtailimages_chooser:choose_results":{"route":"/admin/cms/images/chooser/results/","args":{}},"wagtailimages_chooser:chosen":{"route":"/admin/cms/images/chooser/chosen/<str:pk>/","args":{"pk":"string"}},"wagtailimages_chooser:chosen_multiple":{"route":"/admin/cms/images/chooser/chosen-multiple/","args":{}},"wagtailimages_chooser:create":{"route":"/admin/cms/images/chooser/create/","args":{}},"wagtailimages_chooser:select_format":{"route":"/admin/cms/images/chooser/<int:image_id>/select_format/","args":{"image_id":"number"}},"wagtaildocs:index":{"route":"/admin/cms/documents/","args":{}},"wagtaildocs:index_results":{"route":"/admin/cms/documents/results/","args":{}},"wagtaildocs:add":{"route":"/admin/cms/documents/add/","args":{}},"wagtaildocs:edit":{"route":"/admin/cms/documents/edit/<int:document_id>/","args":{"document_id":"number"}},"wagtaildocs:delete":{"route":"/admin/cms/documents/delete/<int:document_id>/","args":{"document_id":"number"}},"wagtaildocs:add_multiple":{"route":"/admin/cms/documents/multiple/add/","args":{}},"wagtaildocs:edit_multiple":{"route":"/admin/cms/documents/multiple/<int:doc_id>/","args":{"doc_id":"number"}},"wagtaildocs:create_multiple_from_uploaded_document":{"route":"/admin/cms/documents/multiple/create_from_uploaded_document/<int:uploaded_file_id>/","args":{"uploaded_file_id":"number"}},"wagtaildocs:delete_multiple":{"route":"/admin/cms/documents/multiple/<int:doc_id>/delete/","args":{"doc_id":"number"}},"wagtaildocs:delete_upload_multiple":{"route":"/admin/cms/documents/multiple/delete_upload/<int:uploaded_file_id>/","args":{"uploaded_file_id":"number"}},"wagtaildocs:document_usage":{"route":"/admin/cms/documents/usage/<int:document_id>/","args":{"document_id":"number"}},"wagtailembeds:chooser":{"route":"/admin/cms/embeds/chooser/","args":{}},"wagtailembeds:chooser_upload":{"route":"/admin/cms/embeds/chooser/upload/","args":{}},"wagtailsnippets:index":{"route":"/admin/cms/snippets/","args":{}},"wagtail_localize:javascript_catalog":{"route":"/admin/cms/localize/jsi18n/","args":{}},"wagtail_localize:submit_page_translation":{"route":"/admin/cms/localize/submit/page/<int:page_id>/","args":{"page_id":"number"}},"wagtail_localize:submit_snippet_translation":{"route":"/admin/cms/localize/submit/snippet/<slug:app_label>/<slug:model_name>/<str:pk>/","args":{"app_label":"string","model_name":"string","pk":"string"}},"wagtail_localize:update_translations":{"route":"/admin/cms/localize/update/<int:translation_source_id>/","args":{"translation_source_id":"number"}},"wagtail_localize:edit_string_translation":{"route":"/admin/cms/localize/translate/<int:translation_id>/strings/<int:string_segment_id>/edit/","args":{"translation_id":"number","string_segment_id":"number"}},"wagtail_localize:edit_override":{"route":"/admin/cms/localize/translate/<int:translation_id>/overrides/<int:overridable_segment_id>/edit/","args":{"translation_id":"number","overridable_segment_id":"number"}},"wagtail_localize:download_pofile":{"route":"/admin/cms/localize/translate/<int:translation_id>/pofile/download/","args":{"translation_id":"number"}},"wagtail_localize:upload_pofile":{"route":"/admin/cms/localize/translate/<int:translation_id>/pofile/upload/","args":{"translation_id":"number"}},"wagtail_localize:machine_translate":{"route":"/admin/cms/localize/translate/<int:translation_id>/machine_translate/","args":{"translation_id":"number"}},"wagtail_localize:preview_translation":{"route":"/admin/cms/localize/translate/<int:translation_id>/preview/<str:mode>/","args":{"translation_id":"number","mode":"string"}},"wagtail_localize:stop_translation":{"route":"/admin/cms/localize/translate/<int:translation_id>/disable/","args":{"translation_id":"number"}},"wagtail_localize:convert_to_alias":{"route":"/admin/cms/localize/page/<int:page_id>/convert_to_alias/","args":{"page_id":"number"}},"wagtail_localize:translations_report":{"route":"/admin/cms/localize/reports/translations/","args":{}},"wagtail_localize:snippets_api_listing":{"route":"/admin/cms/localize/api/snippets/<slug:app_label>/<slug:model_name>/","args":{"app_label":"string","model_name":"string"}},"wagtail_localize:snippets_api_detail":{"route":"/admin/cms/localize/api/snippets/<slug:app_label>/<slug:model_name>/<str:pk>/","args":{"app_label":"string","model_name":"string","pk":"string"}},"wagtail_localize:translations_report_results":{"route":"/admin/cms/localize/reports/translations/results/","args":{}},"wagtailforms:index":{"route":"/admin/cms/forms/","args":{}},"wagtailforms:index_results":{"route":"/admin/cms/forms/results/","args":{}},"wagtailforms:list_submissions":{"route":"/admin/cms/forms/submissions/<int:page_id>/","args":{"page_id":"number"}},"wagtailforms:list_submissions_results":{"route":"/admin/cms/forms/submissions/<int:page_id>/results/","args":{"page_id":"number"}},"wagtailforms:delete_submissions":{"route":"/admin/cms/forms/submissions/<int:page_id>/delete/","args":{"page_id":"number"}},"wagtailredirects:index":{"route":"/admin/cms/redirects/","args":{}},"wagtailredirects:index_results":{"route":"/admin/cms/redirects/results/","args":{}},"wagtailredirects:add":{"route":"/admin/cms/redirects/add/","args":{}},"wagtailredirects:edit":{"route":"/admin/cms/redirects/<int:redirect_id>/","args":{"redirect_id":"number"}},"wagtailredirects:delete":{"route":"/admin/cms/redirects/<int:redirect_id>/delete/","args":{"redirect_id":"number"}},"wagtailredirects:start_import":{"route":"/admin/cms/redirects/import/","args":{}},"wagtailredirects:process_import":{"route":"/admin/cms/redirects/import/process/","args":{}},"wagtailsearchpromotions:index":{"route":"/admin/cms/searchpicks/","args":{}},"wagtailsearchpromotions:index_results":{"route":"/admin/cms/searchpicks/results/","args":{}},"wagtailsearchpromotions:add":{"route":"/admin/cms/searchpicks/add/","args":{}},"wagtailsearchpromotions:edit":{"route":"/admin/cms/searchpicks/<int:query_id>/","args":{"query_id":"number"}},"wagtailsearchpromotions:delete":{"route":"/admin/cms/searchpicks/<int:query_id>/delete/","args":{"query_id":"number"}},"wagtailsearchpromotions:chooser":{"route":"/admin/cms/searchpicks/queries/chooser/","args":{}},"wagtailsearchpromotions:chooserresults":{"route":"/admin/cms/searchpicks/queries/chooser/results/","args":{}},"wagtailsearchpromotions:search_terms":{"route":"/admin/cms/searchpicks/reports/search-terms/","args":{}},"wagtailsearchpromotions:search_terms_results":{"route":"/admin/cms/searchpicks/reports/search-terms/results/","args":{}},"wagtailstyleguide":{"route":"/admin/cms/styleguide/","args":{}},"wagtail_modeladmin:javascript_catalog":{"route":"/admin/cms/modeladmin/jsi18n/","args":{}},"cms:flagship_page_bulk_update":{"route":"/admin/cms/flagship-page-bulk-update/","args":{}},"cms:flagship_page_bulk_update_apply":{"route":"/admin/cms/flagship-page-bulk-update/apply/","args":{}},"cms:mattress-match-bulk-import":{"route":"/admin/cms/mattress-match-bulk-import/","args":{}},"cms:mattress-match-bulk-import-apply":{"route":"/admin/cms/mattress-match-bulk-import/apply/","args":{}},"tsicommon-cms-admin:tooltip-content-modal":{"route":"/admin/cms/tsicommon-cms/tooltip-content-modal/","args":{}},"tsicommon-cms-admin:wistia-link-content-modal":{"route":"/admin/cms/tsicommon-cms/wistia-link-content-modal/","args":{}},"wagtailimages:index":{"route":"/admin/cms/images/","args":{}},"wagtailimages:index_results":{"route":"/admin/cms/images/results/","args":{}},"wagtailimages:edit":{"route":"/admin/cms/images/<int:image_id>/","args":{"image_id":"number"}},"wagtailimages:delete":{"route":"/admin/cms/images/<int:image_id>/delete/","args":{"image_id":"number"}},"wagtailimages:url_generator":{"route":"/admin/cms/images/<int:image_id>/generate_url/","args":{"image_id":"number"}},"wagtailimages:generate_url":{"route":"/admin/cms/images/<int:image_id>/generate_url/<str:filter_spec>/","args":{"image_id":"number","filter_spec":"string"}},"wagtailimages:preview":{"route":"/admin/cms/images/<int:image_id>/preview/<str:filter_spec>/","args":{"image_id":"number","filter_spec":"string"}},"wagtailimages:add":{"route":"/admin/cms/images/add/","args":{}},"wagtailimages:image_usage":{"route":"/admin/cms/images/usage/<int:image_id>/","args":{"image_id":"number"}},"wagtailimages:add_multiple":{"route":"/admin/cms/images/multiple/add/","args":{}},"wagtailimages:edit_multiple":{"route":"/admin/cms/images/multiple/<int:image_id>/","args":{"image_id":"number"}},"wagtailimages:create_multiple_from_uploaded_image":{"route":"/admin/cms/images/multiple/create_from_uploaded_image/<int:uploaded_file_id>/","args":{"uploaded_file_id":"number"}},"wagtailimages:delete_multiple":{"route":"/admin/cms/images/multiple/<int:image_id>/delete/","args":{"image_id":"number"}},"wagtailimages:delete_upload_multiple":{"route":"/admin/cms/images/multiple/delete_upload/<int:uploaded_file_id>/","args":{"uploaded_file_id":"number"}},"wagtailadmin_sprite":{"route":"/admin/cms/sprite/","args":{}},"wagtailadmin_login":{"route":"/admin/cms/login/","args":{}},"wagtailadmin_password_reset":{"route":"/admin/cms/password_reset/","args":{}},"wagtailadmin_password_reset_done":{"route":"/admin/cms/password_reset/done/","args":{}},"wagtailadmin_password_reset_confirm":{"route":"/admin/cms/password_reset/confirm/<uidb64>/<token>/","args":{"uidb64":"string","token":"string"}},"wagtailadmin_password_reset_complete":{"route":"/admin/cms/password_reset/complete/","args":{}},"wagtailadmin_javascript_catalog":{"route":"/admin/cms/jsi18n/","args":{}},"django-admindocs-docroot":{"route":"/admin/doc/","args":{}},"django-admindocs-bookmarklets":{"route":"/admin/doc/bookmarklets/","args":{}},"django-admindocs-tags":{"route":"/admin/doc/tags/","args":{}},"django-admindocs-filters":{"route":"/admin/doc/filters/","args":{}},"django-admindocs-views-index":{"route":"/admin/doc/views/","args":{}},"django-admindocs-views-detail":{"route":"/admin/doc/views/<view>/","args":{"view":"string"}},"django-admindocs-models-index":{"route":"/admin/doc/models/","args":{}},"django-admindocs-templates":{"route":"/admin/doc/templates/<path:template>/","args":{"template":"string"}},"thelabui:load-balancer-health-check":{"route":"/admin/load-balancer-ht/","args":{}},"thelabui:csrftoken-get":{"route":"/api-nc/csrftoken/","args":{}},"thelabui:robots-txt":{"route":"/robots.txt","args":{}},"thelabui:security-txt":{"route":"/.well-known/security.txt","args":{}},"thelabui:sitemap":{"route":"/sitemap.xml","args":{}},"asymmetric_jwt_auth:jwks":{"route":"/.well-known/jwks.json","args":{}},"cybersource-reply":{"route":"/api/cybersource/cybersource-reply/","args":{}},"cybersource-review-notification":{"route":"/api/cybersource/decision-manager-review-notification/","args":{}},"cybersource-fingerprint-redirect":{"route":"/api/cybersource/fingerprint/<str:url_type>/","args":{"url_type":"string"}},"financingapi:apply":{"route":"/api/financing/apply/","args":{}},"financingapi:update-inquiry":{"route":"/api/financing/apply/update-inquiry/","args":{}},"financingapi:plan-list":{"route":"/api/financing/plans/","args":{}},"financingapi:estimated-payment":{"route":"/api/financing/estimated-payment/","args":{}},"financingapi:acct-inquiry":{"route":"/api/financing/inquiry/","args":{}},"financingapi:prequal":{"route":"/api/financing/prequal/","args":{}},"financingapi:prequal-customer-response":{"route":"/api/financing/prequal/set-customer-response/","args":{}},"financingapi:document-content-view":{"route":"/api/financing/document/<str:signed_idobj>/","args":{"signed_idobj":"string"}},"financingapi:syf-dpos-token":{"route":"/api/financing/synchrony/dpos-token/","args":{}},"financingapi:syf-transaction-lookup":{"route":"/api/financing/synchrony/transaction/<str:dpos_token>/","args":{"dpos_token":"string"}},"api-root":{"route":"/api/","args":{}},"tsi-auth-current-user":{"route":"/api/user/","args":{}},"tsi-auth-keep-alive":{"route":"/api/user/keep-alive/","args":{}},"tsi-auth-expired-token":{"route":"/api/user/expired-token/","args":{}},"tsi-auth-login":{"route":"/api/user/login/","args":{}},"tsi-auth-login-token":{"route":"/api/user/login/<str:token>/","args":{"token":"string"}},"tsi-auth-change-password":{"route":"/api/user/change-password/","args":{}},"tsi-yext-entity-webhook":{"route":"/api/yext/webhooks/<str:token>/entities/","args":{"token":"string"}},"product-bundle-list":{"route":"/api/products/<int:pk>/bundles/","args":{"pk":"number"}},"product-concretebundle-list":{"route":"/api/products/<int:pk>/concretebundles/","args":{"pk":"number"}},"product-userconfigurablebundle-list":{"route":"/api/products/<int:pk>/userconfigurablebundles/","args":{"pk":"number"}},"oscarbundles-i18n-js":{"route":"/api/bundles/i18n.js","args":{}},"bundlegrouptype-list":{"route":"/api/bundlegrouptypes/","args":{}},"bundlegroup-list":{"route":"/api/bundlegroups/","args":{}},"bundlegroup-detail":{"route":"/api/bundlegroups/<int:pk>/","args":{"pk":"number"}},"concretebundle-list":{"route":"/api/concretebundles/","args":{}},"concretebundle-detail":{"route":"/api/concretebundles/<int:pk>/","args":{"pk":"number"}},"concretebundle-product-choice-list":{"route":"/api/concretebundles/product-choices/","args":{}},"userconfigurablebundle-list":{"route":"/api/userconfigurablebundles/","args":{}},"userconfigurablebundle-detail":{"route":"/api/userconfigurablebundles/<int:pk>/","args":{"pk":"number"}},"userconfigurablebundle-range-choice-list":{"route":"/api/userconfigurablebundles/range-choices/","args":{}},"api-checkout-payment-methods":{"route":"/api/checkout/payment-methods/","args":{}},"api-payment":{"route":"/api/checkout/payment-states/<int:pk>/","args":{"pk":"number"}},"api-complete-deferred-payment":{"route":"/api/checkout/complete-deferred-payment/","args":{}},"api-checkout":{"route":"/api/checkout/","args":{}},"api-get-csrf-token":{"route":"/api/csrf-token/","args":{}},"api-user-data-layer":{"route":"/api/user-data-layer/","args":{}},"api-register":{"route":"/api/register/","args":{}},"api-login":{"route":"/api/login/","args":{}},"product-list":{"route":"/api/products/","args":{}},"product-detail":{"route":"/api/products/<int:pk>/","args":{"pk":"number"}},"product-price":{"route":"/api/products/<int:pk>/price/","args":{"pk":"number"}},"product-financing-plans":{"route":"/api/products/<int:pk>/financing-plans/","args":{"pk":"number"}},"product-stockrecords":{"route":"/api/products/<int:pk>/stockrecords/","args":{"pk":"number"}},"product-stockrecord-detail":{"route":"/api/products/<int:product_pk>/stockrecords/<int:pk>/","args":{"product_pk":"number","pk":"number"}},"product-shipping-methods":{"route":"/api/products/<int:pk>/shipping-methods/","args":{"pk":"number"}},"product-shipping-methods-by-location":{"route":"/api/products/<int:pk>/shipping-methods-by-location/","args":{"pk":"number"}},"product-upsellinfomodals":{"route":"/api/products/<int:pk>/upsell-info-modals/","args":{"pk":"number"}},"product-promocards":{"route":"/api/products/<int:pk>/promo-cards/","args":{"pk":"number"}},"option-list":{"route":"/api/options/","args":{}},"option-detail":{"route":"/api/options/<int:pk>/","args":{"pk":"number"}},"user-detail":{"route":"/api/users/<int:pk>/","args":{"pk":"number"}},"order-list":{"route":"/api/orders/","args":{}},"order-detail":{"route":"/api/orders/<int:pk>/","args":{"pk":"number"}},"order-cancel-detail":{"route":"/api/orders/<int:pk>/cancel/","args":{"pk":"number"}},"order-lines-list":{"route":"/api/orders/<int:pk>/lines/","args":{"pk":"number"}},"api-basket":{"route":"/api/basket/","args":{}},"api-basket-add-product":{"route":"/api/basket/add-product/","args":{}},"api-basket-add-voucher":{"route":"/api/basket/add-voucher/","args":{}},"api-basket-apply-voucher-code":{"route":"/api/basket/apply-voucher-code/","args":{}},"api-basket-email":{"route":"/api/basket/email/","args":{}},"api-basket-remove-voucher":{"route":"/api/basket/remove-voucher/","args":{}},"api-basket-last-modified":{"route":"/api/basket/last-modified/","args":{}},"api-basket-predicted-delivery-date":{"route":"/api/basket/predicted-delivery-date/","args":{}},"basket-list":{"route":"/api/baskets/","args":{}},"basket-detail":{"route":"/api/baskets/<int:pk>/","args":{"pk":"number"}},"basket-lines-list":{"route":"/api/baskets/<int:pk>/lines/","args":{"pk":"number"}},"basket-line-detail":{"route":"/api/baskets/<int:basket_pk>/lines/<int:pk>/","args":{"basket_pk":"number","pk":"number"}},"lineattribute-detail":{"route":"/api/baskets/<int:basket_pk>/lines/<int:line_pk>/lineattributes/<int:pk>/","args":{"basket_pk":"number","line_pk":"number","pk":"number"}},"category-list":{"route":"/api/categories/","args":{}},"category-detail":{"route":"/api/categories/<int:pk>/","args":{"pk":"number"}},"category-products":{"route":"/api/categories/<int:pk>/products/","args":{"pk":"number"}},"mattress-match":{"route":"/api/mattress-match/","args":{}},"productclass-list":{"route":"/api/product-classes/","args":{}},"productclass-detail":{"route":"/api/product-classes/<slug:slug>/","args":{"slug":"string"}},"productclass-members":{"route":"/api/product-classes/<slug:product_class__slug>/products/","args":{"product_class__slug":"string"}},"checkout-shipping-address":{"route":"/api/checkout/shipping-address/","args":{}},"checkout-billing-address":{"route":"/api/checkout/billing-address/","args":{}},"checkout-shipping-methods":{"route":"/api/checkout/shipping-methods/","args":{}},"country-list":{"route":"/api/countries/","args":{}},"country-detail":{"route":"/api/countries/<str:pk>/","args":{"pk":"string"}},"country-state-list":{"route":"/api/countries/<str:country_code>/states/","args":{"country_code":"string"}},"api-validate-phone-number":{"route":"/api/validate-phone-number/","args":{}},"useraddress-list":{"route":"/api/saved-addresses/","args":{}},"useraddress-detail":{"route":"/api/saved-addresses/<int:pk>/","args":{"pk":"number"}},"email-offers-signup":{"route":"/api/email-offers-signup/","args":{}},"email-retail-locator-results":{"route":"/api/email-retail-locator-results","args":{}},"wishlisttype-list":{"route":"/api/wishlist-types/","args":{}},"wishlisttype-detail":{"route":"/api/wishlist-types/<slug:code>/","args":{"code":"string"}},"wishlisttype-line-list":{"route":"/api/wishlist-types/<slug:code>/lines/","args":{"code":"string"}},"wishlisttype-line-detail":{"route":"/api/wishlist-types/<slug:code>/lines/<int:pk>/","args":{"code":"string","pk":"number"}},"api-basket-estimate-tax":{"route":"/api/basket/estimate-tax/","args":{}},"api-basket-shipping-methods":{"route":"/api/basket/shipping-methods/","args":{}},"financing-plan-list":{"route":"/store/dashboard/financing/plans/","args":{}},"financing-plan-create":{"route":"/store/dashboard/financing/plans/new/","args":{}},"financing-plan-edit":{"route":"/store/dashboard/financing/plans/<int:pk>/edit/","args":{"pk":"number"}},"financing-plan-delete":{"route":"/store/dashboard/financing/plans/<int:pk>/delete/","args":{"pk":"number"}},"financing-benefit-list":{"route":"/store/dashboard/financing/benefits/","args":{}},"financing-benefit-create":{"route":"/store/dashboard/financing/benefits/new/","args":{}},"financing-benefit-edit":{"route":"/store/dashboard/financing/benefits/<int:pk>/edit/","args":{"pk":"number"}},"financing-benefit-delete":{"route":"/store/dashboard/financing/benefits/<int:pk>/delete/","args":{"pk":"number"}},"financing-application-list":{"route":"/store/dashboard/financing/applications/","args":{}},"financing-application-detail":{"route":"/store/dashboard/financing/applications/<int:pk>/","args":{"pk":"number"}},"financing-transfer-list":{"route":"/store/dashboard/financing/transfers/","args":{}},"financing-transfer-detail":{"route":"/store/dashboard/financing/transfers/<int:pk>/","args":{"pk":"number"}},"financing-prequal-list":{"route":"/store/dashboard/financing/prequal-requests/","args":{}},"financing-prequal-detail":{"route":"/store/dashboard/financing/prequal-requests/<uuid:uuid>/","args":{"uuid":"string"}},"dashboard-bundle-group-list":{"route":"/store/dashboard/bundles/bundle-groups/","args":{}},"benefit-bundle-list":{"route":"/store/dashboard/benefit-bundles/benefit-bundles/","args":{}},"benefit-bundle-create":{"route":"/store/dashboard/benefit-bundles/benefit-bundles/new/","args":{}},"benefit-bundle-update":{"route":"/store/dashboard/benefit-bundles/benefit-bundles/<int:pk>/","args":{"pk":"number"}},"benefit-bundle-delete":{"route":"/store/dashboard/benefit-bundles/benefits-bundles/<int:pk>/delete/","args":{"pk":"number"}},"rma-vouchers-import":{"route":"/store/dashboard/benefit-bundles/rma-vouchers-import/","args":{}},"dashboard:index":{"route":"/store/dashboard/","args":{}},"dashboard:catalogue-product":{"route":"/store/dashboard/catalogue/products/<int:pk>/","args":{"pk":"number"}},"dashboard:catalogue-product-create":{"route":"/store/dashboard/catalogue/products/create/","args":{}},"dashboard:catalogue-product-create-child":{"route":"/store/dashboard/catalogue/products/<int:parent_pk>/create-variant/","args":{"parent_pk":"number"}},"dashboard:catalogue-product-delete":{"route":"/store/dashboard/catalogue/products/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:catalogue-product-list":{"route":"/store/dashboard/catalogue/","args":{}},"dashboard:stock-alert-list":{"route":"/store/dashboard/catalogue/stock-alerts/","args":{}},"dashboard:catalogue-product-lookup":{"route":"/store/dashboard/catalogue/product-lookup/","args":{}},"dashboard:catalogue-category-list":{"route":"/store/dashboard/catalogue/categories/","args":{}},"dashboard:catalogue-category-detail-list":{"route":"/store/dashboard/catalogue/categories/<int:pk>/","args":{"pk":"number"}},"dashboard:catalogue-category-create":{"route":"/store/dashboard/catalogue/categories/create/","args":{}},"dashboard:catalogue-category-create-child":{"route":"/store/dashboard/catalogue/categories/create/<int:parent>/","args":{"parent":"number"}},"dashboard:catalogue-category-update":{"route":"/store/dashboard/catalogue/categories/<int:pk>/update/","args":{"pk":"number"}},"dashboard:catalogue-category-delete":{"route":"/store/dashboard/catalogue/categories/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:catalogue-class-create":{"route":"/store/dashboard/catalogue/product-type/create/","args":{}},"dashboard:catalogue-class-list":{"route":"/store/dashboard/catalogue/product-types/","args":{}},"dashboard:catalogue-class-update":{"route":"/store/dashboard/catalogue/product-type/<int:pk>/update/","args":{"pk":"number"}},"dashboard:catalogue-class-delete":{"route":"/store/dashboard/catalogue/product-type/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:catalogue-attribute-option-group-create":{"route":"/store/dashboard/catalogue/attribute-option-group/create/","args":{}},"dashboard:catalogue-attribute-option-group-list":{"route":"/store/dashboard/catalogue/attribute-option-group/","args":{}},"dashboard:catalogue-attribute-option-group-update":{"route":"/store/dashboard/catalogue/attribute-option-group/<str:pk>/update/","args":{"pk":"string"}},"dashboard:catalogue-attribute-option-group-delete":{"route":"/store/dashboard/catalogue/attribute-option-group/<str:pk>/delete/","args":{"pk":"string"}},"dashboard:catalogue-option-list":{"route":"/store/dashboard/catalogue/option/","args":{}},"dashboard:catalogue-option-create":{"route":"/store/dashboard/catalogue/option/create/","args":{}},"dashboard:catalogue-option-update":{"route":"/store/dashboard/catalogue/option/<str:pk>/update/","args":{"pk":"string"}},"dashboard:catalogue-option-delete":{"route":"/store/dashboard/catalogue/option/<str:pk>/delete/","args":{"pk":"string"}},"dashboard:product-price-import":{"route":"/store/dashboard/catalogue/price-import/","args":{}},"dashboard:product-price-import-apply":{"route":"/store/dashboard/catalogue/price-import/apply/","args":{}},"dashboard:value-prop-list":{"route":"/store/dashboard/catalogue/value-prop/","args":{}},"dashboard:value-prop-create":{"route":"/store/dashboard/catalogue/value-prop/new/","args":{}},"dashboard:value-prop-edit":{"route":"/store/dashboard/catalogue/value-prop/<int:pk>/edit/","args":{"pk":"number"}},"dashboard:value-prop-delete":{"route":"/store/dashboard/catalogue/value-prop/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:reports-index":{"route":"/store/dashboard/reports/","args":{}},"dashboard:reports-download":{"route":"/store/dashboard/reports/<uuid:uuid>/download/","args":{"uuid":"string"}},"dashboard:reports-delete":{"route":"/store/dashboard/reports/<uuid:uuid>/delete/","args":{"uuid":"string"}},"dashboard:orderconfirmation-resend":{"route":"/store/dashboard/orders/order-confirmation-resend/","args":{}},"dashboard:order-billing-verification-send":{"route":"/store/dashboard/orders/order-billing-verification/","args":{}},"dashboard:order-send-deferred-payment-email":{"route":"/store/dashboard/orders/send-deferred-payment-email/","args":{}},"dashboard:order-request-pnp-resend":{"route":"/store/dashboard/orders/request-pnp-resend/","args":{}},"dashboard:order-list":{"route":"/store/dashboard/orders/","args":{}},"dashboard:order-stats":{"route":"/store/dashboard/orders/statistics/","args":{}},"dashboard:order-detail":{"route":"/store/dashboard/orders/<str:number>/","args":{"number":"string"}},"dashboard:order-detail-note":{"route":"/store/dashboard/orders/<str:number>/notes/<int:note_id>/","args":{"number":"string","note_id":"number"}},"dashboard:order-line-detail":{"route":"/store/dashboard/orders/<str:number>/lines/<int:line_id>/","args":{"number":"string","line_id":"number"}},"dashboard:order-shipping-address":{"route":"/store/dashboard/orders/<str:number>/shipping-address/","args":{"number":"string"}},"dashboard:users-index":{"route":"/store/dashboard/users/","args":{}},"dashboard:user-alert-list":{"route":"/store/dashboard/users/alerts/","args":{}},"dashboard:deletion-request-list":{"route":"/store/dashboard/users/deletion-requests/","args":{}},"dashboard:deletion-request-create":{"route":"/store/dashboard/users/deletion-requests/new/","args":{}},"dashboard:deletion-request-details":{"route":"/store/dashboard/users/deletion-requests/<str:pk>/view/","args":{"pk":"string"}},"dashboard:data-inquiry-list":{"route":"/store/dashboard/users/data-inquiries/","args":{}},"dashboard:data-inquiry-create":{"route":"/store/dashboard/users/data-inquiries/new/","args":{}},"dashboard:data-inquiry-details":{"route":"/store/dashboard/users/data-inquiries/<str:pk>/view/","args":{"pk":"string"}},"dashboard:data-inquiry-download":{"route":"/store/dashboard/users/data-inquiry-response/<str:pk>/download/<str:file_format>/","args":{"pk":"string","file_format":"string"}},"dashboard:page-list":{"route":"/store/dashboard/pages/","args":{}},"dashboard:page-create":{"route":"/store/dashboard/pages/create/","args":{}},"dashboard:page-update":{"route":"/store/dashboard/pages/update/<str:pk>/","args":{"pk":"string"}},"dashboard:page-delete":{"route":"/store/dashboard/pages/delete/<str:pk>/","args":{"pk":"string"}},"dashboard:partner-list":{"route":"/store/dashboard/partners/","args":{}},"dashboard:partner-create":{"route":"/store/dashboard/partners/create/","args":{}},"dashboard:partner-manage":{"route":"/store/dashboard/partners/<int:pk>/","args":{"pk":"number"}},"dashboard:partner-delete":{"route":"/store/dashboard/partners/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:partner-user-create":{"route":"/store/dashboard/partners/<int:partner_pk>/users/add/","args":{"partner_pk":"number"}},"dashboard:partner-user-select":{"route":"/store/dashboard/partners/<int:partner_pk>/users/select/","args":{"partner_pk":"number"}},"dashboard:partner-user-link":{"route":"/store/dashboard/partners/<int:partner_pk>/users/<int:user_pk>/link/","args":{"partner_pk":"number","user_pk":"number"}},"dashboard:partner-user-unlink":{"route":"/store/dashboard/partners/<int:partner_pk>/users/<int:user_pk>/unlink/","args":{"partner_pk":"number","user_pk":"number"}},"dashboard:partner-user-update":{"route":"/store/dashboard/partners/<int:partner_pk>/users/<int:user_pk>/update/","args":{"partner_pk":"number","user_pk":"number"}},"dashboard:offer-list":{"route":"/store/dashboard/offers/","args":{}},"dashboard:offer-metadata":{"route":"/store/dashboard/offers/<int:pk>/metadata/","args":{"pk":"number"}},"dashboard:offer-condition":{"route":"/store/dashboard/offers/<int:pk>/condition/","args":{"pk":"number"}},"dashboard:offer-benefit":{"route":"/store/dashboard/offers/<int:pk>/incentive/","args":{"pk":"number"}},"dashboard:offer-restrictions":{"route":"/store/dashboard/offers/<int:pk>/restrictions/","args":{"pk":"number"}},"dashboard:offer-delete":{"route":"/store/dashboard/offers/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:offer-detail":{"route":"/store/dashboard/offers/<int:pk>/","args":{"pk":"number"}},"dashboard:api-root":{"route":"/store/dashboard/offers/api/<drf_format_suffix:format>","args":{"format":"string"}},"dashboard:oscarbluelight-i18n-js":{"route":"/store/dashboard/offers/bluelight-i18n.js","args":{}},"dashboard:offer-images":{"route":"/store/dashboard/offers/<int:pk>/images/","args":{"pk":"number"}},"dashboard:offer-api-list":{"route":"/store/dashboard/offers/offers/","args":{}},"dashboard:benefit-list":{"route":"/store/dashboard/offers/benefits/","args":{}},"dashboard:benefit-create":{"route":"/store/dashboard/offers/benefits/new/","args":{}},"dashboard:benefit-create-compound":{"route":"/store/dashboard/offers/benefits/new-compound/","args":{}},"dashboard:benefit-update":{"route":"/store/dashboard/offers/benefits/<int:pk>/","args":{"pk":"number"}},"dashboard:benefit-delete":{"route":"/store/dashboard/offers/benefits/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:condition-list":{"route":"/store/dashboard/offers/conditions/","args":{}},"dashboard:condition-create":{"route":"/store/dashboard/offers/conditions/new/","args":{}},"dashboard:condition-create-compound":{"route":"/store/dashboard/offers/conditions/new-compound/","args":{}},"dashboard:condition-update":{"route":"/store/dashboard/offers/conditions/<int:pk>/","args":{"pk":"number"}},"dashboard:condition-delete":{"route":"/store/dashboard/offers/conditions/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:offergroup-list":{"route":"/store/dashboard/offers/offer_group/","args":{}},"dashboard:offergroup-create":{"route":"/store/dashboard/offers/offer_group/new/","args":{}},"dashboard:offergroup-update":{"route":"/store/dashboard/offers/offer_group/<int:pk>/","args":{"pk":"number"}},"dashboard:offergroup-delete":{"route":"/store/dashboard/offers/offer_group/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:range-list":{"route":"/store/dashboard/ranges/","args":{}},"dashboard:range-create":{"route":"/store/dashboard/ranges/create/","args":{}},"dashboard:range-update":{"route":"/store/dashboard/ranges/<int:pk>/","args":{"pk":"number"}},"dashboard:range-delete":{"route":"/store/dashboard/ranges/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:range-products":{"route":"/store/dashboard/ranges/<int:pk>/products/","args":{"pk":"number"}},"dashboard:range-reorder":{"route":"/store/dashboard/ranges/<int:pk>/reorder/","args":{"pk":"number"}},"dashboard:range-prices":{"route":"/store/dashboard/ranges/<int:pk>/prices/","args":{"pk":"number"}},"dashboard:range-excluded-products":{"route":"/store/dashboard/ranges/<int:pk>/excluded-products/","args":{"pk":"number"}},"dashboard:reviews-list":{"route":"/store/dashboard/reviews/","args":{}},"dashboard:reviews-update":{"route":"/store/dashboard/reviews/<int:pk>/","args":{"pk":"number"}},"dashboard:reviews-delete":{"route":"/store/dashboard/reviews/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:voucher-list":{"route":"/store/dashboard/vouchers/","args":{}},"dashboard:voucher-create":{"route":"/store/dashboard/vouchers/create/","args":{}},"dashboard:voucher-update":{"route":"/store/dashboard/vouchers/update/<int:pk>/","args":{"pk":"number"}},"dashboard:voucher-delete":{"route":"/store/dashboard/vouchers/delete/<int:pk>/","args":{"pk":"number"}},"dashboard:voucher-stats":{"route":"/store/dashboard/vouchers/stats/<int:pk>/","args":{"pk":"number"}},"dashboard:voucher-set-list":{"route":"/store/dashboard/vouchers/sets/","args":{}},"dashboard:voucher-set-create":{"route":"/store/dashboard/vouchers/sets/create/","args":{}},"dashboard:voucher-set-update":{"route":"/store/dashboard/vouchers/sets/update/<int:pk>/","args":{"pk":"number"}},"dashboard:voucher-set-detail":{"route":"/store/dashboard/vouchers/sets/detail/<int:pk>/","args":{"pk":"number"}},"dashboard:voucher-set-download":{"route":"/store/dashboard/vouchers/sets/download/<int:pk>/","args":{"pk":"number"}},"dashboard:voucher-set-delete":{"route":"/store/dashboard/vouchers/sets/delete/<int:pk>/","args":{"pk":"number"}},"dashboard:voucher-list-children":{"route":"/store/dashboard/vouchers/stats/<int:parent_pk>/children/","args":{"parent_pk":"number"}},"dashboard:voucher-add-children":{"route":"/store/dashboard/vouchers/stats/<int:pk>/add-children/","args":{"pk":"number"}},"dashboard:voucher-export-children":{"route":"/store/dashboard/vouchers/stats/<int:pk>/export-children/","args":{"pk":"number"}},"dashboard:voucher-export-children-file":{"route":"/store/dashboard/vouchers/stats/<int:pk>/export-children.<slug:file_format>","args":{"pk":"number","file_format":"string"}},"dashboard:voucher-update-suspension-status":{"route":"/store/dashboard/vouchers/stats/<int:pk>/update-suspension-status/","args":{"pk":"number"}},"dashboard:comms-list":{"route":"/store/dashboard/comms/","args":{}},"dashboard:country-list":{"route":"/store/dashboard/shipping/countries/","args":{}},"dashboard:country-create":{"route":"/store/dashboard/shipping/countries/new/","args":{}},"dashboard:country-edit":{"route":"/store/dashboard/shipping/countries/<str:pk>/edit/","args":{"pk":"string"}},"dashboard:country-delete":{"route":"/store/dashboard/shipping/countries/<str:pk>/delete/","args":{"pk":"string"}},"dashboard:delivery-region-list":{"route":"/store/dashboard/shipping/regions/","args":{}},"dashboard:delivery-region-create":{"route":"/store/dashboard/shipping/regions/new/","args":{}},"dashboard:delivery-region-edit":{"route":"/store/dashboard/shipping/regions/<int:pk>/edit/","args":{"pk":"number"}},"dashboard:delivery-region-delete":{"route":"/store/dashboard/shipping/regions/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:delivery-region-group-list":{"route":"/store/dashboard/shipping/region-groups/","args":{}},"dashboard:delivery-region-group-create":{"route":"/store/dashboard/shipping/region-groups/new/","args":{}},"dashboard:delivery-region-group-edit":{"route":"/store/dashboard/shipping/region-groups/<int:pk>/edit/","args":{"pk":"number"}},"dashboard:delivery-region-group-delete":{"route":"/store/dashboard/shipping/region-groups/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:shipping-product-class-list":{"route":"/store/dashboard/shipping/product-classes/","args":{}},"dashboard:shipping-product-class-create":{"route":"/store/dashboard/shipping/product-classes/new/","args":{}},"dashboard:shipping-product-class-edit":{"route":"/store/dashboard/shipping/product-classes/<int:pk>/edit/","args":{"pk":"number"}},"dashboard:shipping-product-class-delete":{"route":"/store/dashboard/shipping/product-classes/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:shipping-method-list":{"route":"/store/dashboard/shipping/methods/","args":{}},"dashboard:shipping-method-create":{"route":"/store/dashboard/shipping/methods/new/","args":{}},"dashboard:shipping-method-detail":{"route":"/store/dashboard/shipping/methods/<int:pk>/","args":{"pk":"number"}},"dashboard:shipping-method-edit":{"route":"/store/dashboard/shipping/methods/<int:pk>/edit/","args":{"pk":"number"}},"dashboard:shipping-method-delete":{"route":"/store/dashboard/shipping/methods/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:shipping-method-description-list":{"route":"/store/dashboard/shipping/methods/descriptions/","args":{}},"dashboard:shipping-method-description-create":{"route":"/store/dashboard/shipping/methods/descriptions/new/","args":{}},"dashboard:shipping-method-description-edit":{"route":"/store/dashboard/shipping/methods/descriptions/<int:pk>/edit/","args":{"pk":"number"}},"dashboard:shipping-method-description-delete":{"route":"/store/dashboard/shipping/methods/descriptions/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:shipping-price-create":{"route":"/store/dashboard/shipping/methods/<int:method_pk>/region-group/<int:region_group_pk>/prices/new/","args":{"method_pk":"number","region_group_pk":"number"}},"dashboard:shipping-price-edit":{"route":"/store/dashboard/shipping/methods/<int:method_pk>/region-group/<int:region_group_pk>/prices/<int:pk>/edit/","args":{"method_pk":"number","region_group_pk":"number","pk":"number"}},"dashboard:shipping-price-delete":{"route":"/store/dashboard/shipping/methods/<int:method_pk>/region-group/<int:region_group_pk>/prices/<int:pk>/delete/","args":{"method_pk":"number","region_group_pk":"number","pk":"number"}},"dashboard:shipping-option-list":{"route":"/store/dashboard/shipping/options/","args":{}},"dashboard:shipping-option-create":{"route":"/store/dashboard/shipping/options/new/","args":{}},"dashboard:shipping-option-edit":{"route":"/store/dashboard/shipping/options/<int:pk>/edit/","args":{"pk":"number"}},"dashboard:shipping-option-delete":{"route":"/store/dashboard/shipping/options/<int:pk>/delete/","args":{"pk":"number"}},"dashboard:login":{"route":"/store/dashboard/login/","args":{}},"dashboard:logout":{"route":"/store/dashboard/logout/","args":{}},"basket:summary":{"route":"/store/basket/","args":{}},"basket:add":{"route":"/store/basket/add/<int:pk>/","args":{"pk":"number"}},"basket:vouchers-add":{"route":"/store/basket/vouchers/add/","args":{}},"basket:vouchers-remove":{"route":"/store/basket/vouchers/<int:pk>/remove/","args":{"pk":"number"}},"basket:saved":{"route":"/store/basket/saved/","args":{}},"basket:configure-gifts":{"route":"/store/basket/configure-gifts/","args":{}},"checkout:index":{"route":"/store/checkout/","args":{}},"checkout:payment-submit":{"route":"/store/checkout/payment-submit/","args":{}},"checkout:payment-redirect":{"route":"/store/checkout/payment-redirect/","args":{}},"checkout:order-pending":{"route":"/store/checkout/order-pending/","args":{}},"checkout:complete-deferred-payment":{"route":"/store/checkout/complete-deferred-payment/<str:order_number>/","args":{"order_number":"string"}},"checkout:thank-you":{"route":"/store/checkout/thank-you/","args":{}},"customer:login":{"route":"/store/accounts/login/","args":{}},"customer:logout":{"route":"/store/accounts/logout/","args":{}},"customer:lookup-orders-by-email":{"route":"/store/accounts/lookup-order-status/","args":{}},"customer:lookup-orders-by-email-confirmation":{"route":"/store/accounts/lookup-order-status/confirm/","args":{}},"customer:unified-order-lookup":{"route":"/store/accounts/order-status/","args":{}},"customer:unified-order-status":{"route":"/store/accounts/order-status/<str:order_number_token>/","args":{"order_number_token":"string"}},"customer:unified-order-shipment-status":{"route":"/store/accounts/order-status/<str:order_number_token>/track/<str:tracking_number>/","args":{"order_number_token":"string","tracking_number":"string"}},"customer:register":{"route":"/store/accounts/register/","args":{}},"customer:summary":{"route":"/store/accounts/","args":{}},"customer:change-password":{"route":"/store/accounts/change-password/","args":{}},"customer:profile-view":{"route":"/store/accounts/profile/","args":{}},"customer:profile-update":{"route":"/store/accounts/profile/edit/","args":{}},"customer:profile-delete":{"route":"/store/accounts/profile/delete/","args":{}},"customer:order-list":{"route":"/store/accounts/orders/","args":{}},"customer:trs-order-history":{"route":"/store/accounts/trs-orders/","args":{}},"customer:anon-order":{"route":"/store/accounts/order-status/<str:order_number>/<str:hash>/","args":{"order_number":"string","hash":"string"}},"customer:order":{"route":"/store/accounts/orders/<str:order_number>/","args":{"order_number":"string"}},"customer:review-order-products":{"route":"/store/accounts/orders/<str:order_number>/review/","args":{"order_number":"string"}},"customer:order-shipment-tracking":{"route":"/store/accounts/orders/<str:order_number>/track/<str:tracking_number>/","args":{"order_number":"string","tracking_number":"string"}},"customer:order-line":{"route":"/store/accounts/orders/<str:order_number>/<int:line_id>","args":{"order_number":"string","line_id":"number"}},"customer:address-list":{"route":"/store/accounts/addresses/","args":{}},"customer:address-create":{"route":"/store/accounts/addresses/add/","args":{}},"customer:address-detail":{"route":"/store/accounts/addresses/<int:pk>/","args":{"pk":"number"}},"customer:address-delete":{"route":"/store/accounts/addresses/<int:pk>/delete/","args":{"pk":"number"}},"customer:email-list":{"route":"/store/accounts/emails/","args":{}},"customer:email-detail":{"route":"/store/accounts/emails/<int:email_id>/","args":{"email_id":"number"}},"customer:notifications-inbox":{"route":"/store/accounts/notifications/inbox/","args":{}},"customer:notifications-archive":{"route":"/store/accounts/notifications/archive/","args":{}},"customer:notifications-update":{"route":"/store/accounts/notifications/update/","args":{}},"customer:notifications-detail":{"route":"/store/accounts/notifications/<int:pk>/","args":{"pk":"number"}},"customer:alerts-list":{"route":"/store/accounts/alerts/","args":{}},"customer:alert-create":{"route":"/store/accounts/alerts/create/<int:pk>/","args":{"pk":"number"}},"customer:alerts-confirm":{"route":"/store/accounts/alerts/confirm/<str:key>/","args":{"key":"string"}},"customer:alerts-cancel-by-key":{"route":"/store/accounts/alerts/cancel/key/<str:key>/","args":{"key":"string"}},"customer:alerts-cancel-by-pk":{"route":"/store/accounts/alerts/cancel/<int:pk>/","args":{"pk":"number"}},"customer:wishlists-list":{"route":"/store/accounts/wishlists/","args":{}},"customer:wishlists-add-product":{"route":"/store/accounts/wishlists/<str:key>/add/<int:product_pk>/","args":{"key":"string","product_pk":"number"}},"customer:wishlists-create":{"route":"/store/accounts/wishlists/create/","args":{}},"customer:wishlists-create-with-product":{"route":"/store/accounts/wishlists/create/with-product/<int:product_pk>/","args":{"product_pk":"number"}},"customer:wishlists-detail":{"route":"/store/accounts/wishlists/<str:key>/","args":{"key":"string"}},"customer:wishlists-update":{"route":"/store/accounts/wishlists/<str:key>/update/","args":{"key":"string"}},"customer:wishlists-delete":{"route":"/store/accounts/wishlists/<str:key>/delete/","args":{"key":"string"}},"customer:wishlists-remove-product":{"route":"/store/accounts/wishlists/<str:key>/products/<int:product_pk>/delete/","args":{"key":"string","product_pk":"number"}},"customer:wishlists-move-product-to-another":{"route":"/store/accounts/wishlists/<str:key>/lines/<int:line_pk>/move-to/<str:to_key>/","args":{"key":"string","line_pk":"number","to_key":"string"}},"catalogue:reviews-detail":{"route":"/store/catalogue/^(?P<product_slug>[\\w-]*)_(?P<product_pk>\\d+)/reviews/<int:pk>/","args":{"pk":"number"}},"catalogue:reviews-add":{"route":"/store/catalogue/^(?P<product_slug>[\\w-]*)_(?P<product_pk>\\d+)/reviews/add/","args":{}},"catalogue:reviews-vote":{"route":"/store/catalogue/^(?P<product_slug>[\\w-]*)_(?P<product_pk>\\d+)/reviews/<int:pk>/vote/","args":{"pk":"number"}},"catalogue:reviews-list":{"route":"/store/catalogue/^(?P<product_slug>[\\w-]*)_(?P<product_pk>\\d+)/reviews/","args":{}},"catalogue:index":{"route":"/store/catalogue/","args":{}},"search:search":{"route":"/store/search/","args":{}},"offer:list":{"route":"/store/offers/","args":{}},"loadup-submit-request":{"route":"/store/loadup/offer/<int:pk>/<str:token>/submit-request/","args":{"pk":"number","token":"string"}},"loadup-request-confirmation":{"route":"/store/loadup/offer/<int:pk>/<str:token>/confirmation/","args":{"pk":"number","token":"string"}},"password-reset":{"route":"/store/password-reset/","args":{}},"password-reset-done":{"route":"/store/password-reset/done/","args":{}},"password-reset-confirm":{"route":"/store/password-reset/confirm/<str:uidb64>/<str:token>/","args":{"uidb64":"string","token":"string"}},"password-reset-complete":{"route":"/store/password-reset/complete/","args":{}},"wagtaildocs_authenticate_with_password":{"route":"/documents/authenticate_with_password/<int:restriction_id>/","args":{"restriction_id":"number"}},"search":{"route":"/search/","args":{}},"location-directory:state-list":{"route":"/locations/states/","args":{}},"location-directory:city-list":{"route":"/locations/states/<str:state>/cities/","args":{"state":"string"}},"location-directory:store-list":{"route":"/locations/states/<str:state>/cities/<str:city_slug>/stores/","args":{"state":"string","city_slug":"string"}},"location-directory:store-detail":{"route":"/locations/states/<str:state>/cities/<str:city_slug>/stores/<int:pk>/","args":{"state":"string","city_slug":"string","pk":"number"}},"cms-nav-iframe":{"route":"/frameutils/navigation/","args":{}},"cms-footer-iframe":{"route":"/frameutils/footer/","args":{}},"cms-iframe-test":{"route":"/frameutils/test/","args":{}},"shop-tile":{"route":"/shop-tiles/<int:shop_tile_pk>/compare","args":{"shop_tile_pk":"number"}},"html_sitemap":{"route":"/sitemap/","args":{}},"wagtailcore_authenticate_with_password":{"route":"/_util/authenticate_with_password/<int:page_view_restriction_id>/<int:page_id>/","args":{"page_view_restriction_id":"number","page_id":"number"}},"wagtailcore_login":{"route":"/_util/login/","args":{}},"__reactivated_do_not_use":{"route":"__reactivated_do_not_use","args":{}},"__reactivated_do_not_use_args":{"route":"__reactivated_do_not_use_args","args":{"_":"string"}}};

interface URLMap {
    wagtailapi_pages_listing: wagtailapi_pages_listing;
    wagtailapi_pages_detail: wagtailapi_pages_detail;
    wagtailapi_pages_find: wagtailapi_pages_find;
    wagtailapi_images_listing: wagtailapi_images_listing;
    wagtailapi_images_detail: wagtailapi_images_detail;
    wagtailapi_images_find: wagtailapi_images_find;
    wagtailapi_documents_listing: wagtailapi_documents_listing;
    wagtailapi_documents_detail: wagtailapi_documents_detail;
    wagtailapi_documents_find: wagtailapi_documents_find;
    wagtailapi_flagship_pages_listing: wagtailapi_flagship_pages_listing;
    wagtailapi_flagship_pages_detail: wagtailapi_flagship_pages_detail;
    wagtailapi_flagship_pages_find: wagtailapi_flagship_pages_find;
    wagtailapi_social_listing: wagtailapi_social_listing;
    wagtailapi_social_detail: wagtailapi_social_detail;
    wagtailapi_social_find: wagtailapi_social_find;
    oidc_authentication_callback: oidc_authentication_callback;
    oidc_authentication_init: oidc_authentication_init;
    oidc_logout: oidc_logout;
    health_check_health_check_home: health_check_health_check_home;
    health_check_health_check_subset: health_check_health_check_subset;
    download_periodic_report: download_periodic_report;
    wagtailadmin_home: wagtailadmin_home;
    wagtailadmin_api_pages_listing: wagtailadmin_api_pages_listing;
    wagtailadmin_api_pages_detail: wagtailadmin_api_pages_detail;
    wagtailadmin_api_pages_find: wagtailadmin_api_pages_find;
    wagtailadmin_api_pages_action: wagtailadmin_api_pages_action;
    wagtailadmin_api_documents_listing: wagtailadmin_api_documents_listing;
    wagtailadmin_api_documents_detail: wagtailadmin_api_documents_detail;
    wagtailadmin_api_documents_find: wagtailadmin_api_documents_find;
    wagtailadmin_api_images_listing: wagtailadmin_api_images_listing;
    wagtailadmin_api_images_detail: wagtailadmin_api_images_detail;
    wagtailadmin_api_images_find: wagtailadmin_api_images_find;
    wagtailadmin_error_test: wagtailadmin_error_test;
    wagtailadmin_explore_root: wagtailadmin_explore_root;
    wagtailadmin_explore: wagtailadmin_explore;
    wagtailadmin_explore_results: wagtailadmin_explore_results;
    wagtail_bulk_action: wagtail_bulk_action;
    wagtailadmin_pages_add: wagtailadmin_pages_add;
    wagtailadmin_pages_preview_on_add: wagtailadmin_pages_preview_on_add;
    wagtailadmin_pages_type_use: wagtailadmin_pages_type_use;
    wagtailadmin_pages_type_use_results: wagtailadmin_pages_type_use_results;
    wagtailadmin_pages_usage: wagtailadmin_pages_usage;
    wagtailadmin_pages_edit: wagtailadmin_pages_edit;
    wagtailadmin_pages_preview_on_edit: wagtailadmin_pages_preview_on_edit;
    wagtailadmin_pages_view_draft: wagtailadmin_pages_view_draft;
    wagtailadmin_pages_add_subpage: wagtailadmin_pages_add_subpage;
    wagtailadmin_pages_delete: wagtailadmin_pages_delete;
    wagtailadmin_pages_unpublish: wagtailadmin_pages_unpublish;
    wagtailadmin_pages_convert_alias: wagtailadmin_pages_convert_alias;
    wagtailadmin_pages_search: wagtailadmin_pages_search;
    wagtailadmin_pages_search_results: wagtailadmin_pages_search_results;
    wagtailadmin_pages_move: wagtailadmin_pages_move;
    wagtailadmin_pages_move_confirm: wagtailadmin_pages_move_confirm;
    wagtailadmin_pages_set_page_position: wagtailadmin_pages_set_page_position;
    wagtailadmin_pages_copy: wagtailadmin_pages_copy;
    wagtailadmin_pages_workflow_action: wagtailadmin_pages_workflow_action;
    wagtailadmin_pages_collect_workflow_action_data: wagtailadmin_pages_collect_workflow_action_data;
    wagtailadmin_pages_confirm_workflow_cancellation: wagtailadmin_pages_confirm_workflow_cancellation;
    wagtailadmin_pages_workflow_preview: wagtailadmin_pages_workflow_preview;
    wagtailadmin_pages_set_privacy: wagtailadmin_pages_set_privacy;
    wagtailadmin_pages_lock: wagtailadmin_pages_lock;
    wagtailadmin_pages_unlock: wagtailadmin_pages_unlock;
    wagtailadmin_pages_revisions_index: wagtailadmin_pages_revisions_index;
    wagtailadmin_pages_revisions_view: wagtailadmin_pages_revisions_view;
    wagtailadmin_pages_revisions_revert: wagtailadmin_pages_revisions_revert;
    wagtailadmin_pages_revisions_unschedule: wagtailadmin_pages_revisions_unschedule;
    wagtailadmin_pages_workflow_history: wagtailadmin_pages_workflow_history;
    wagtailadmin_pages_workflow_history_detail: wagtailadmin_pages_workflow_history_detail;
    wagtailadmin_pages_history: wagtailadmin_pages_history;
    wagtailadmin_pages_history_results: wagtailadmin_pages_history_results;
    wagtailadmin_choose_page: wagtailadmin_choose_page;
    wagtailadmin_choose_page_child: wagtailadmin_choose_page_child;
    wagtailadmin_choose_page_search: wagtailadmin_choose_page_search;
    wagtailadmin_choose_page_chosen_multiple: wagtailadmin_choose_page_chosen_multiple;
    wagtailadmin_choose_page_external_link: wagtailadmin_choose_page_external_link;
    wagtailadmin_choose_page_email_link: wagtailadmin_choose_page_email_link;
    wagtailadmin_choose_page_phone_link: wagtailadmin_choose_page_phone_link;
    wagtailadmin_choose_page_anchor_link: wagtailadmin_choose_page_anchor_link;
    wagtailadmin_tag_autocomplete: wagtailadmin_tag_autocomplete;
    wagtailadmin_tag_model_autocomplete: wagtailadmin_tag_model_autocomplete;
    wagtailadmin_collections_index: wagtailadmin_collections_index;
    wagtailadmin_collections_add: wagtailadmin_collections_add;
    wagtailadmin_collections_edit: wagtailadmin_collections_edit;
    wagtailadmin_collections_delete: wagtailadmin_collections_delete;
    wagtailadmin_collections_set_privacy: wagtailadmin_collections_set_privacy;
    wagtailadmin_workflows_index: wagtailadmin_workflows_index;
    wagtailadmin_workflows_index_results: wagtailadmin_workflows_index_results;
    wagtailadmin_workflows_add: wagtailadmin_workflows_add;
    wagtailadmin_workflows_enable: wagtailadmin_workflows_enable;
    wagtailadmin_workflows_disable: wagtailadmin_workflows_disable;
    wagtailadmin_workflows_edit: wagtailadmin_workflows_edit;
    wagtailadmin_workflows_usage: wagtailadmin_workflows_usage;
    wagtailadmin_workflows_usage_results: wagtailadmin_workflows_usage_results;
    wagtailadmin_workflows_remove: wagtailadmin_workflows_remove;
    wagtailadmin_workflows_add_task: wagtailadmin_workflows_add_task;
    wagtailadmin_workflows_select_task_type: wagtailadmin_workflows_select_task_type;
    wagtailadmin_workflows_task_index: wagtailadmin_workflows_task_index;
    wagtailadmin_workflows_task_index_results: wagtailadmin_workflows_task_index_results;
    wagtailadmin_workflows_edit_task: wagtailadmin_workflows_edit_task;
    wagtailadmin_workflows_disable_task: wagtailadmin_workflows_disable_task;
    wagtailadmin_workflows_enable_task: wagtailadmin_workflows_enable_task;
    wagtailadmin_workflows_task_chooser: wagtailadmin_workflows_task_chooser;
    wagtailadmin_workflows_task_chooser_results: wagtailadmin_workflows_task_chooser_results;
    wagtailadmin_workflows_task_chooser_create: wagtailadmin_workflows_task_chooser_create;
    wagtailadmin_workflows_task_chosen: wagtailadmin_workflows_task_chosen;
    wagtailadmin_reports_locked_pages: wagtailadmin_reports_locked_pages;
    wagtailadmin_reports_locked_pages_results: wagtailadmin_reports_locked_pages_results;
    wagtailadmin_reports_workflow: wagtailadmin_reports_workflow;
    wagtailadmin_reports_workflow_results: wagtailadmin_reports_workflow_results;
    wagtailadmin_reports_workflow_tasks: wagtailadmin_reports_workflow_tasks;
    wagtailadmin_reports_workflow_tasks_results: wagtailadmin_reports_workflow_tasks_results;
    wagtailadmin_reports_site_history: wagtailadmin_reports_site_history;
    wagtailadmin_reports_site_history_results: wagtailadmin_reports_site_history_results;
    wagtailadmin_reports_aging_pages: wagtailadmin_reports_aging_pages;
    wagtailadmin_reports_aging_pages_results: wagtailadmin_reports_aging_pages_results;
    wagtailadmin_reports_page_types_usage: wagtailadmin_reports_page_types_usage;
    wagtailadmin_reports_page_types_usage_results: wagtailadmin_reports_page_types_usage_results;
    wagtailadmin_account: wagtailadmin_account;
    wagtailadmin_logout: wagtailadmin_logout;
    wagtailadmin_dismissibles: wagtailadmin_dismissibles;
    wagtailadmin_editing_sessions_ping: wagtailadmin_editing_sessions_ping;
    wagtailadmin_editing_sessions_release: wagtailadmin_editing_sessions_release;
    wagtailadmin_block_preview: wagtailadmin_block_preview;
    wagtailvideos_add: wagtailvideos_add;
    wagtailvideos_add_multiple: wagtailvideos_add_multiple;
    wagtailvideos_edit_multiple: wagtailvideos_edit_multiple;
    wagtailvideos_create_multiple_from_uploaded_image: wagtailvideos_create_multiple_from_uploaded_image;
    wagtailvideos_delete_multiple: wagtailvideos_delete_multiple;
    wagtailvideos_delete_upload_multiple: wagtailvideos_delete_upload_multiple;
    wagtailvideos_index: wagtailvideos_index;
    wagtailvideos_index_results: wagtailvideos_index_results;
    wagtailsettings_edit: wagtailsettings_edit;
    wagtailsnippets_wagtail_links_link_list: wagtailsnippets_wagtail_links_link_list;
    wagtailsnippets_wagtail_links_link_list_results: wagtailsnippets_wagtail_links_link_list_results;
    wagtailsnippets_wagtail_links_link_add: wagtailsnippets_wagtail_links_link_add;
    wagtailsnippets_wagtail_links_link_edit: wagtailsnippets_wagtail_links_link_edit;
    wagtailsnippets_wagtail_links_link_delete: wagtailsnippets_wagtail_links_link_delete;
    wagtailsnippets_wagtail_links_link_usage: wagtailsnippets_wagtail_links_link_usage;
    wagtailsnippets_wagtail_links_link_history: wagtailsnippets_wagtail_links_link_history;
    wagtailsnippets_wagtail_links_link_history_results: wagtailsnippets_wagtail_links_link_history_results;
    wagtailsnippets_wagtail_links_link_copy: wagtailsnippets_wagtail_links_link_copy;
    wagtailsnippetchoosers_wagtail_links_link_choose: wagtailsnippetchoosers_wagtail_links_link_choose;
    wagtailsnippetchoosers_wagtail_links_link_choose_results: wagtailsnippetchoosers_wagtail_links_link_choose_results;
    wagtailsnippetchoosers_wagtail_links_link_chosen: wagtailsnippetchoosers_wagtail_links_link_chosen;
    wagtailsnippetchoosers_wagtail_links_link_chosen_multiple: wagtailsnippetchoosers_wagtail_links_link_chosen_multiple;
    wagtailsnippetchoosers_wagtail_links_link_create: wagtailsnippetchoosers_wagtail_links_link_create;
    wagtailsnippets_tsicommon_cms_mattressmatchcondition_list: wagtailsnippets_tsicommon_cms_mattressmatchcondition_list;
    wagtailsnippets_tsicommon_cms_mattressmatchcondition_list_results: wagtailsnippets_tsicommon_cms_mattressmatchcondition_list_results;
    wagtailsnippets_tsicommon_cms_mattressmatchcondition_add: wagtailsnippets_tsicommon_cms_mattressmatchcondition_add;
    wagtailsnippets_tsicommon_cms_mattressmatchcondition_edit: wagtailsnippets_tsicommon_cms_mattressmatchcondition_edit;
    wagtailsnippets_tsicommon_cms_mattressmatchcondition_delete: wagtailsnippets_tsicommon_cms_mattressmatchcondition_delete;
    wagtailsnippets_tsicommon_cms_mattressmatchcondition_usage: wagtailsnippets_tsicommon_cms_mattressmatchcondition_usage;
    wagtailsnippets_tsicommon_cms_mattressmatchcondition_history: wagtailsnippets_tsicommon_cms_mattressmatchcondition_history;
    wagtailsnippets_tsicommon_cms_mattressmatchcondition_history_results: wagtailsnippets_tsicommon_cms_mattressmatchcondition_history_results;
    wagtailsnippets_tsicommon_cms_mattressmatchcondition_copy: wagtailsnippets_tsicommon_cms_mattressmatchcondition_copy;
    wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_choose: wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_choose;
    wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_choose_results: wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_chosen: wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_chosen;
    wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_create: wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_create;
    wagtailsnippets_tsicommon_cms_promoperiod_list: wagtailsnippets_tsicommon_cms_promoperiod_list;
    wagtailsnippets_tsicommon_cms_promoperiod_list_results: wagtailsnippets_tsicommon_cms_promoperiod_list_results;
    wagtailsnippets_tsicommon_cms_promoperiod_add: wagtailsnippets_tsicommon_cms_promoperiod_add;
    wagtailsnippets_tsicommon_cms_promoperiod_edit: wagtailsnippets_tsicommon_cms_promoperiod_edit;
    wagtailsnippets_tsicommon_cms_promoperiod_delete: wagtailsnippets_tsicommon_cms_promoperiod_delete;
    wagtailsnippets_tsicommon_cms_promoperiod_usage: wagtailsnippets_tsicommon_cms_promoperiod_usage;
    wagtailsnippets_tsicommon_cms_promoperiod_history: wagtailsnippets_tsicommon_cms_promoperiod_history;
    wagtailsnippets_tsicommon_cms_promoperiod_history_results: wagtailsnippets_tsicommon_cms_promoperiod_history_results;
    wagtailsnippets_tsicommon_cms_promoperiod_copy: wagtailsnippets_tsicommon_cms_promoperiod_copy;
    wagtailsnippetchoosers_tsicommon_cms_promoperiod_choose: wagtailsnippetchoosers_tsicommon_cms_promoperiod_choose;
    wagtailsnippetchoosers_tsicommon_cms_promoperiod_choose_results: wagtailsnippetchoosers_tsicommon_cms_promoperiod_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_promoperiod_chosen: wagtailsnippetchoosers_tsicommon_cms_promoperiod_chosen;
    wagtailsnippetchoosers_tsicommon_cms_promoperiod_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_promoperiod_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_promoperiod_create: wagtailsnippetchoosers_tsicommon_cms_promoperiod_create;
    wagtailsnippets_tsicommon_cms_mattressmatchresult_list: wagtailsnippets_tsicommon_cms_mattressmatchresult_list;
    wagtailsnippets_tsicommon_cms_mattressmatchresult_list_results: wagtailsnippets_tsicommon_cms_mattressmatchresult_list_results;
    wagtailsnippets_tsicommon_cms_mattressmatchresult_add: wagtailsnippets_tsicommon_cms_mattressmatchresult_add;
    wagtailsnippets_tsicommon_cms_mattressmatchresult_edit: wagtailsnippets_tsicommon_cms_mattressmatchresult_edit;
    wagtailsnippets_tsicommon_cms_mattressmatchresult_delete: wagtailsnippets_tsicommon_cms_mattressmatchresult_delete;
    wagtailsnippets_tsicommon_cms_mattressmatchresult_usage: wagtailsnippets_tsicommon_cms_mattressmatchresult_usage;
    wagtailsnippets_tsicommon_cms_mattressmatchresult_history: wagtailsnippets_tsicommon_cms_mattressmatchresult_history;
    wagtailsnippets_tsicommon_cms_mattressmatchresult_history_results: wagtailsnippets_tsicommon_cms_mattressmatchresult_history_results;
    wagtailsnippets_tsicommon_cms_mattressmatchresult_copy: wagtailsnippets_tsicommon_cms_mattressmatchresult_copy;
    wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_choose: wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_choose;
    wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_choose_results: wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_chosen: wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_chosen;
    wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_create: wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_create;
    wagtailsnippets_tsicommon_cms_mattressfeel_list: wagtailsnippets_tsicommon_cms_mattressfeel_list;
    wagtailsnippets_tsicommon_cms_mattressfeel_list_results: wagtailsnippets_tsicommon_cms_mattressfeel_list_results;
    wagtailsnippets_tsicommon_cms_mattressfeel_add: wagtailsnippets_tsicommon_cms_mattressfeel_add;
    wagtailsnippets_tsicommon_cms_mattressfeel_edit: wagtailsnippets_tsicommon_cms_mattressfeel_edit;
    wagtailsnippets_tsicommon_cms_mattressfeel_delete: wagtailsnippets_tsicommon_cms_mattressfeel_delete;
    wagtailsnippets_tsicommon_cms_mattressfeel_usage: wagtailsnippets_tsicommon_cms_mattressfeel_usage;
    wagtailsnippets_tsicommon_cms_mattressfeel_history: wagtailsnippets_tsicommon_cms_mattressfeel_history;
    wagtailsnippets_tsicommon_cms_mattressfeel_history_results: wagtailsnippets_tsicommon_cms_mattressfeel_history_results;
    wagtailsnippets_tsicommon_cms_mattressfeel_copy: wagtailsnippets_tsicommon_cms_mattressfeel_copy;
    wagtailsnippetchoosers_tsicommon_cms_mattressfeel_choose: wagtailsnippetchoosers_tsicommon_cms_mattressfeel_choose;
    wagtailsnippetchoosers_tsicommon_cms_mattressfeel_choose_results: wagtailsnippetchoosers_tsicommon_cms_mattressfeel_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_mattressfeel_chosen: wagtailsnippetchoosers_tsicommon_cms_mattressfeel_chosen;
    wagtailsnippetchoosers_tsicommon_cms_mattressfeel_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_mattressfeel_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_mattressfeel_create: wagtailsnippetchoosers_tsicommon_cms_mattressfeel_create;
    wagtailsnippets_tsicommon_cms_featuredofferscard_list: wagtailsnippets_tsicommon_cms_featuredofferscard_list;
    wagtailsnippets_tsicommon_cms_featuredofferscard_list_results: wagtailsnippets_tsicommon_cms_featuredofferscard_list_results;
    wagtailsnippets_tsicommon_cms_featuredofferscard_add: wagtailsnippets_tsicommon_cms_featuredofferscard_add;
    wagtailsnippets_tsicommon_cms_featuredofferscard_edit: wagtailsnippets_tsicommon_cms_featuredofferscard_edit;
    wagtailsnippets_tsicommon_cms_featuredofferscard_delete: wagtailsnippets_tsicommon_cms_featuredofferscard_delete;
    wagtailsnippets_tsicommon_cms_featuredofferscard_usage: wagtailsnippets_tsicommon_cms_featuredofferscard_usage;
    wagtailsnippets_tsicommon_cms_featuredofferscard_history: wagtailsnippets_tsicommon_cms_featuredofferscard_history;
    wagtailsnippets_tsicommon_cms_featuredofferscard_history_results: wagtailsnippets_tsicommon_cms_featuredofferscard_history_results;
    wagtailsnippets_tsicommon_cms_featuredofferscard_copy: wagtailsnippets_tsicommon_cms_featuredofferscard_copy;
    wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_choose: wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_choose;
    wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_choose_results: wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_chosen: wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_chosen;
    wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_create: wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_create;
    wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_list: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_list;
    wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_list_results: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_list_results;
    wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_add: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_add;
    wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_edit: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_edit;
    wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_delete: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_delete;
    wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_usage: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_usage;
    wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_history: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_history;
    wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_history_results: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_history_results;
    wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_copy: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_copy;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_choose: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_choose;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_choose_results: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_chosen: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_chosen;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_create: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_create;
    wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_list: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_list;
    wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_list_results: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_list_results;
    wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_add: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_add;
    wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_edit: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_edit;
    wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_delete: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_delete;
    wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_usage: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_usage;
    wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_history: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_history;
    wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_history_results: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_history_results;
    wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_copy: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_copy;
    wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_choose: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_choose;
    wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_choose_results: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_chosen: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_chosen;
    wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_create: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_create;
    wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_list: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_list;
    wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_list_results: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_list_results;
    wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_add: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_add;
    wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_edit: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_edit;
    wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_delete: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_delete;
    wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_usage: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_usage;
    wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_history: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_history;
    wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_history_results: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_history_results;
    wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_copy: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_copy;
    wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_choose: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_choose;
    wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_choose_results: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_chosen: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_chosen;
    wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_create: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_create;
    wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_list: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_list;
    wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_list_results: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_list_results;
    wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_add: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_add;
    wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_edit: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_edit;
    wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_delete: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_delete;
    wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_usage: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_usage;
    wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_history: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_history;
    wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_history_results: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_history_results;
    wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_copy: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_copy;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_choose: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_choose;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_choose_results: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_chosen: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_chosen;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_create: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_create;
    wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_list: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_list;
    wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_list_results: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_list_results;
    wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_add: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_add;
    wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_edit: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_edit;
    wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_delete: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_delete;
    wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_usage: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_usage;
    wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_history: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_history;
    wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_history_results: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_history_results;
    wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_copy: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_copy;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_choose: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_choose;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_choose_results: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_chosen: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_chosen;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_create: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_create;
    wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_list: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_list;
    wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_list_results: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_list_results;
    wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_add: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_add;
    wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_edit: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_edit;
    wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_delete: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_delete;
    wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_usage: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_usage;
    wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_history: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_history;
    wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_history_results: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_history_results;
    wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_copy: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_copy;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_choose: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_choose;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_choose_results: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_chosen: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_chosen;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_create: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_create;
    wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_list: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_list;
    wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_list_results: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_list_results;
    wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_add: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_add;
    wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_edit: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_edit;
    wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_delete: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_delete;
    wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_usage: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_usage;
    wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_history: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_history;
    wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_history_results: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_history_results;
    wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_copy: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_copy;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_choose: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_choose;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_choose_results: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_chosen: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_chosen;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_create: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_create;
    wagtailsnippets_tsicommon_cms_offeradvertisingcontent_list: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_list;
    wagtailsnippets_tsicommon_cms_offeradvertisingcontent_list_results: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_list_results;
    wagtailsnippets_tsicommon_cms_offeradvertisingcontent_add: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_add;
    wagtailsnippets_tsicommon_cms_offeradvertisingcontent_edit: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_edit;
    wagtailsnippets_tsicommon_cms_offeradvertisingcontent_delete: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_delete;
    wagtailsnippets_tsicommon_cms_offeradvertisingcontent_usage: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_usage;
    wagtailsnippets_tsicommon_cms_offeradvertisingcontent_history: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_history;
    wagtailsnippets_tsicommon_cms_offeradvertisingcontent_history_results: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_history_results;
    wagtailsnippets_tsicommon_cms_offeradvertisingcontent_copy: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_copy;
    wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_choose: wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_choose;
    wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_choose_results: wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_chosen: wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_chosen;
    wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_create: wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_create;
    wagtailsnippets_tsicommon_cms_countdowntimerqueue_list: wagtailsnippets_tsicommon_cms_countdowntimerqueue_list;
    wagtailsnippets_tsicommon_cms_countdowntimerqueue_list_results: wagtailsnippets_tsicommon_cms_countdowntimerqueue_list_results;
    wagtailsnippets_tsicommon_cms_countdowntimerqueue_add: wagtailsnippets_tsicommon_cms_countdowntimerqueue_add;
    wagtailsnippets_tsicommon_cms_countdowntimerqueue_edit: wagtailsnippets_tsicommon_cms_countdowntimerqueue_edit;
    wagtailsnippets_tsicommon_cms_countdowntimerqueue_delete: wagtailsnippets_tsicommon_cms_countdowntimerqueue_delete;
    wagtailsnippets_tsicommon_cms_countdowntimerqueue_usage: wagtailsnippets_tsicommon_cms_countdowntimerqueue_usage;
    wagtailsnippets_tsicommon_cms_countdowntimerqueue_history: wagtailsnippets_tsicommon_cms_countdowntimerqueue_history;
    wagtailsnippets_tsicommon_cms_countdowntimerqueue_history_results: wagtailsnippets_tsicommon_cms_countdowntimerqueue_history_results;
    wagtailsnippets_tsicommon_cms_countdowntimerqueue_copy: wagtailsnippets_tsicommon_cms_countdowntimerqueue_copy;
    wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_choose: wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_choose;
    wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_choose_results: wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_chosen: wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_chosen;
    wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_create: wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_create;
    wagtailsnippets_tsicommon_cms_faq_list: wagtailsnippets_tsicommon_cms_faq_list;
    wagtailsnippets_tsicommon_cms_faq_list_results: wagtailsnippets_tsicommon_cms_faq_list_results;
    wagtailsnippets_tsicommon_cms_faq_add: wagtailsnippets_tsicommon_cms_faq_add;
    wagtailsnippets_tsicommon_cms_faq_edit: wagtailsnippets_tsicommon_cms_faq_edit;
    wagtailsnippets_tsicommon_cms_faq_delete: wagtailsnippets_tsicommon_cms_faq_delete;
    wagtailsnippets_tsicommon_cms_faq_usage: wagtailsnippets_tsicommon_cms_faq_usage;
    wagtailsnippets_tsicommon_cms_faq_history: wagtailsnippets_tsicommon_cms_faq_history;
    wagtailsnippets_tsicommon_cms_faq_history_results: wagtailsnippets_tsicommon_cms_faq_history_results;
    wagtailsnippets_tsicommon_cms_faq_copy: wagtailsnippets_tsicommon_cms_faq_copy;
    wagtailsnippetchoosers_tsicommon_cms_faq_choose: wagtailsnippetchoosers_tsicommon_cms_faq_choose;
    wagtailsnippetchoosers_tsicommon_cms_faq_choose_results: wagtailsnippetchoosers_tsicommon_cms_faq_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_faq_chosen: wagtailsnippetchoosers_tsicommon_cms_faq_chosen;
    wagtailsnippetchoosers_tsicommon_cms_faq_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_faq_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_faq_create: wagtailsnippetchoosers_tsicommon_cms_faq_create;
    wagtailsnippets_tsicommon_cms_slidecollection_list: wagtailsnippets_tsicommon_cms_slidecollection_list;
    wagtailsnippets_tsicommon_cms_slidecollection_list_results: wagtailsnippets_tsicommon_cms_slidecollection_list_results;
    wagtailsnippets_tsicommon_cms_slidecollection_add: wagtailsnippets_tsicommon_cms_slidecollection_add;
    wagtailsnippets_tsicommon_cms_slidecollection_edit: wagtailsnippets_tsicommon_cms_slidecollection_edit;
    wagtailsnippets_tsicommon_cms_slidecollection_delete: wagtailsnippets_tsicommon_cms_slidecollection_delete;
    wagtailsnippets_tsicommon_cms_slidecollection_usage: wagtailsnippets_tsicommon_cms_slidecollection_usage;
    wagtailsnippets_tsicommon_cms_slidecollection_history: wagtailsnippets_tsicommon_cms_slidecollection_history;
    wagtailsnippets_tsicommon_cms_slidecollection_history_results: wagtailsnippets_tsicommon_cms_slidecollection_history_results;
    wagtailsnippets_tsicommon_cms_slidecollection_copy: wagtailsnippets_tsicommon_cms_slidecollection_copy;
    wagtailsnippetchoosers_tsicommon_cms_slidecollection_choose: wagtailsnippetchoosers_tsicommon_cms_slidecollection_choose;
    wagtailsnippetchoosers_tsicommon_cms_slidecollection_choose_results: wagtailsnippetchoosers_tsicommon_cms_slidecollection_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_slidecollection_chosen: wagtailsnippetchoosers_tsicommon_cms_slidecollection_chosen;
    wagtailsnippetchoosers_tsicommon_cms_slidecollection_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_slidecollection_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_slidecollection_create: wagtailsnippetchoosers_tsicommon_cms_slidecollection_create;
    wagtailsnippets_tsicommon_cms_link_list: wagtailsnippets_tsicommon_cms_link_list;
    wagtailsnippets_tsicommon_cms_link_list_results: wagtailsnippets_tsicommon_cms_link_list_results;
    wagtailsnippets_tsicommon_cms_link_add: wagtailsnippets_tsicommon_cms_link_add;
    wagtailsnippets_tsicommon_cms_link_edit: wagtailsnippets_tsicommon_cms_link_edit;
    wagtailsnippets_tsicommon_cms_link_delete: wagtailsnippets_tsicommon_cms_link_delete;
    wagtailsnippets_tsicommon_cms_link_usage: wagtailsnippets_tsicommon_cms_link_usage;
    wagtailsnippets_tsicommon_cms_link_history: wagtailsnippets_tsicommon_cms_link_history;
    wagtailsnippets_tsicommon_cms_link_history_results: wagtailsnippets_tsicommon_cms_link_history_results;
    wagtailsnippets_tsicommon_cms_link_copy: wagtailsnippets_tsicommon_cms_link_copy;
    wagtailsnippetchoosers_tsicommon_cms_link_choose: wagtailsnippetchoosers_tsicommon_cms_link_choose;
    wagtailsnippetchoosers_tsicommon_cms_link_choose_results: wagtailsnippetchoosers_tsicommon_cms_link_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_link_chosen: wagtailsnippetchoosers_tsicommon_cms_link_chosen;
    wagtailsnippetchoosers_tsicommon_cms_link_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_link_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_link_create: wagtailsnippetchoosers_tsicommon_cms_link_create;
    wagtailsnippets_tsicommon_cms_plainnavigation_list: wagtailsnippets_tsicommon_cms_plainnavigation_list;
    wagtailsnippets_tsicommon_cms_plainnavigation_list_results: wagtailsnippets_tsicommon_cms_plainnavigation_list_results;
    wagtailsnippets_tsicommon_cms_plainnavigation_add: wagtailsnippets_tsicommon_cms_plainnavigation_add;
    wagtailsnippets_tsicommon_cms_plainnavigation_edit: wagtailsnippets_tsicommon_cms_plainnavigation_edit;
    wagtailsnippets_tsicommon_cms_plainnavigation_delete: wagtailsnippets_tsicommon_cms_plainnavigation_delete;
    wagtailsnippets_tsicommon_cms_plainnavigation_usage: wagtailsnippets_tsicommon_cms_plainnavigation_usage;
    wagtailsnippets_tsicommon_cms_plainnavigation_history: wagtailsnippets_tsicommon_cms_plainnavigation_history;
    wagtailsnippets_tsicommon_cms_plainnavigation_history_results: wagtailsnippets_tsicommon_cms_plainnavigation_history_results;
    wagtailsnippets_tsicommon_cms_plainnavigation_copy: wagtailsnippets_tsicommon_cms_plainnavigation_copy;
    wagtailsnippetchoosers_tsicommon_cms_plainnavigation_choose: wagtailsnippetchoosers_tsicommon_cms_plainnavigation_choose;
    wagtailsnippetchoosers_tsicommon_cms_plainnavigation_choose_results: wagtailsnippetchoosers_tsicommon_cms_plainnavigation_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_plainnavigation_chosen: wagtailsnippetchoosers_tsicommon_cms_plainnavigation_chosen;
    wagtailsnippetchoosers_tsicommon_cms_plainnavigation_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_plainnavigation_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_plainnavigation_create: wagtailsnippetchoosers_tsicommon_cms_plainnavigation_create;
    wagtailsnippets_tsicommon_cms_productcomparetile_list: wagtailsnippets_tsicommon_cms_productcomparetile_list;
    wagtailsnippets_tsicommon_cms_productcomparetile_list_results: wagtailsnippets_tsicommon_cms_productcomparetile_list_results;
    wagtailsnippets_tsicommon_cms_productcomparetile_add: wagtailsnippets_tsicommon_cms_productcomparetile_add;
    wagtailsnippets_tsicommon_cms_productcomparetile_edit: wagtailsnippets_tsicommon_cms_productcomparetile_edit;
    wagtailsnippets_tsicommon_cms_productcomparetile_delete: wagtailsnippets_tsicommon_cms_productcomparetile_delete;
    wagtailsnippets_tsicommon_cms_productcomparetile_usage: wagtailsnippets_tsicommon_cms_productcomparetile_usage;
    wagtailsnippets_tsicommon_cms_productcomparetile_history: wagtailsnippets_tsicommon_cms_productcomparetile_history;
    wagtailsnippets_tsicommon_cms_productcomparetile_history_results: wagtailsnippets_tsicommon_cms_productcomparetile_history_results;
    wagtailsnippets_tsicommon_cms_productcomparetile_copy: wagtailsnippets_tsicommon_cms_productcomparetile_copy;
    wagtailsnippetchoosers_tsicommon_cms_productcomparetile_choose: wagtailsnippetchoosers_tsicommon_cms_productcomparetile_choose;
    wagtailsnippetchoosers_tsicommon_cms_productcomparetile_choose_results: wagtailsnippetchoosers_tsicommon_cms_productcomparetile_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_productcomparetile_chosen: wagtailsnippetchoosers_tsicommon_cms_productcomparetile_chosen;
    wagtailsnippetchoosers_tsicommon_cms_productcomparetile_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_productcomparetile_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_productcomparetile_create: wagtailsnippetchoosers_tsicommon_cms_productcomparetile_create;
    wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_list: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_list;
    wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_list_results: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_list_results;
    wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_add: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_add;
    wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_edit: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_edit;
    wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_delete: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_delete;
    wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_usage: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_usage;
    wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_history: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_history;
    wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_history_results: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_history_results;
    wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_copy: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_copy;
    wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_choose: wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_choose;
    wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_choose_results: wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_chosen: wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_chosen;
    wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_create: wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_create;
    wagtailsnippets_tsicommon_cms_productcomparerowtype_list: wagtailsnippets_tsicommon_cms_productcomparerowtype_list;
    wagtailsnippets_tsicommon_cms_productcomparerowtype_list_results: wagtailsnippets_tsicommon_cms_productcomparerowtype_list_results;
    wagtailsnippets_tsicommon_cms_productcomparerowtype_add: wagtailsnippets_tsicommon_cms_productcomparerowtype_add;
    wagtailsnippets_tsicommon_cms_productcomparerowtype_edit: wagtailsnippets_tsicommon_cms_productcomparerowtype_edit;
    wagtailsnippets_tsicommon_cms_productcomparerowtype_delete: wagtailsnippets_tsicommon_cms_productcomparerowtype_delete;
    wagtailsnippets_tsicommon_cms_productcomparerowtype_usage: wagtailsnippets_tsicommon_cms_productcomparerowtype_usage;
    wagtailsnippets_tsicommon_cms_productcomparerowtype_history: wagtailsnippets_tsicommon_cms_productcomparerowtype_history;
    wagtailsnippets_tsicommon_cms_productcomparerowtype_history_results: wagtailsnippets_tsicommon_cms_productcomparerowtype_history_results;
    wagtailsnippets_tsicommon_cms_productcomparerowtype_copy: wagtailsnippets_tsicommon_cms_productcomparerowtype_copy;
    wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_choose: wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_choose;
    wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_choose_results: wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_chosen: wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_chosen;
    wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_create: wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_create;
    wagtailsnippets_tsicommon_cms_productcomparerowcontent_list: wagtailsnippets_tsicommon_cms_productcomparerowcontent_list;
    wagtailsnippets_tsicommon_cms_productcomparerowcontent_list_results: wagtailsnippets_tsicommon_cms_productcomparerowcontent_list_results;
    wagtailsnippets_tsicommon_cms_productcomparerowcontent_add: wagtailsnippets_tsicommon_cms_productcomparerowcontent_add;
    wagtailsnippets_tsicommon_cms_productcomparerowcontent_edit: wagtailsnippets_tsicommon_cms_productcomparerowcontent_edit;
    wagtailsnippets_tsicommon_cms_productcomparerowcontent_delete: wagtailsnippets_tsicommon_cms_productcomparerowcontent_delete;
    wagtailsnippets_tsicommon_cms_productcomparerowcontent_usage: wagtailsnippets_tsicommon_cms_productcomparerowcontent_usage;
    wagtailsnippets_tsicommon_cms_productcomparerowcontent_history: wagtailsnippets_tsicommon_cms_productcomparerowcontent_history;
    wagtailsnippets_tsicommon_cms_productcomparerowcontent_history_results: wagtailsnippets_tsicommon_cms_productcomparerowcontent_history_results;
    wagtailsnippets_tsicommon_cms_productcomparerowcontent_copy: wagtailsnippets_tsicommon_cms_productcomparerowcontent_copy;
    wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_choose: wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_choose;
    wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_choose_results: wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_chosen: wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_chosen;
    wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_create: wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_create;
    wagtailsnippets_tsicommon_cms_productgrid_list: wagtailsnippets_tsicommon_cms_productgrid_list;
    wagtailsnippets_tsicommon_cms_productgrid_list_results: wagtailsnippets_tsicommon_cms_productgrid_list_results;
    wagtailsnippets_tsicommon_cms_productgrid_add: wagtailsnippets_tsicommon_cms_productgrid_add;
    wagtailsnippets_tsicommon_cms_productgrid_edit: wagtailsnippets_tsicommon_cms_productgrid_edit;
    wagtailsnippets_tsicommon_cms_productgrid_delete: wagtailsnippets_tsicommon_cms_productgrid_delete;
    wagtailsnippets_tsicommon_cms_productgrid_usage: wagtailsnippets_tsicommon_cms_productgrid_usage;
    wagtailsnippets_tsicommon_cms_productgrid_history: wagtailsnippets_tsicommon_cms_productgrid_history;
    wagtailsnippets_tsicommon_cms_productgrid_history_results: wagtailsnippets_tsicommon_cms_productgrid_history_results;
    wagtailsnippets_tsicommon_cms_productgrid_copy: wagtailsnippets_tsicommon_cms_productgrid_copy;
    wagtailsnippetchoosers_tsicommon_cms_productgrid_choose: wagtailsnippetchoosers_tsicommon_cms_productgrid_choose;
    wagtailsnippetchoosers_tsicommon_cms_productgrid_choose_results: wagtailsnippetchoosers_tsicommon_cms_productgrid_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_productgrid_chosen: wagtailsnippetchoosers_tsicommon_cms_productgrid_chosen;
    wagtailsnippetchoosers_tsicommon_cms_productgrid_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_productgrid_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_productgrid_create: wagtailsnippetchoosers_tsicommon_cms_productgrid_create;
    wagtailsnippets_tsicommon_cms_plcconfigurator_list: wagtailsnippets_tsicommon_cms_plcconfigurator_list;
    wagtailsnippets_tsicommon_cms_plcconfigurator_list_results: wagtailsnippets_tsicommon_cms_plcconfigurator_list_results;
    wagtailsnippets_tsicommon_cms_plcconfigurator_add: wagtailsnippets_tsicommon_cms_plcconfigurator_add;
    wagtailsnippets_tsicommon_cms_plcconfigurator_edit: wagtailsnippets_tsicommon_cms_plcconfigurator_edit;
    wagtailsnippets_tsicommon_cms_plcconfigurator_delete: wagtailsnippets_tsicommon_cms_plcconfigurator_delete;
    wagtailsnippets_tsicommon_cms_plcconfigurator_usage: wagtailsnippets_tsicommon_cms_plcconfigurator_usage;
    wagtailsnippets_tsicommon_cms_plcconfigurator_history: wagtailsnippets_tsicommon_cms_plcconfigurator_history;
    wagtailsnippets_tsicommon_cms_plcconfigurator_history_results: wagtailsnippets_tsicommon_cms_plcconfigurator_history_results;
    wagtailsnippets_tsicommon_cms_plcconfigurator_copy: wagtailsnippets_tsicommon_cms_plcconfigurator_copy;
    wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_choose: wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_choose;
    wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_choose_results: wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_chosen: wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_chosen;
    wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_create: wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_create;
    wagtailsnippets_tsicommon_cms_promomessagingbanner_list: wagtailsnippets_tsicommon_cms_promomessagingbanner_list;
    wagtailsnippets_tsicommon_cms_promomessagingbanner_list_results: wagtailsnippets_tsicommon_cms_promomessagingbanner_list_results;
    wagtailsnippets_tsicommon_cms_promomessagingbanner_add: wagtailsnippets_tsicommon_cms_promomessagingbanner_add;
    wagtailsnippets_tsicommon_cms_promomessagingbanner_edit: wagtailsnippets_tsicommon_cms_promomessagingbanner_edit;
    wagtailsnippets_tsicommon_cms_promomessagingbanner_delete: wagtailsnippets_tsicommon_cms_promomessagingbanner_delete;
    wagtailsnippets_tsicommon_cms_promomessagingbanner_usage: wagtailsnippets_tsicommon_cms_promomessagingbanner_usage;
    wagtailsnippets_tsicommon_cms_promomessagingbanner_history: wagtailsnippets_tsicommon_cms_promomessagingbanner_history;
    wagtailsnippets_tsicommon_cms_promomessagingbanner_history_results: wagtailsnippets_tsicommon_cms_promomessagingbanner_history_results;
    wagtailsnippets_tsicommon_cms_promomessagingbanner_copy: wagtailsnippets_tsicommon_cms_promomessagingbanner_copy;
    wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_choose: wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_choose;
    wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_choose_results: wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_chosen: wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_chosen;
    wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_create: wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_create;
    wagtailsnippets_tsicommon_cms_richnavigationlink_list: wagtailsnippets_tsicommon_cms_richnavigationlink_list;
    wagtailsnippets_tsicommon_cms_richnavigationlink_list_results: wagtailsnippets_tsicommon_cms_richnavigationlink_list_results;
    wagtailsnippets_tsicommon_cms_richnavigationlink_add: wagtailsnippets_tsicommon_cms_richnavigationlink_add;
    wagtailsnippets_tsicommon_cms_richnavigationlink_edit: wagtailsnippets_tsicommon_cms_richnavigationlink_edit;
    wagtailsnippets_tsicommon_cms_richnavigationlink_delete: wagtailsnippets_tsicommon_cms_richnavigationlink_delete;
    wagtailsnippets_tsicommon_cms_richnavigationlink_usage: wagtailsnippets_tsicommon_cms_richnavigationlink_usage;
    wagtailsnippets_tsicommon_cms_richnavigationlink_history: wagtailsnippets_tsicommon_cms_richnavigationlink_history;
    wagtailsnippets_tsicommon_cms_richnavigationlink_history_results: wagtailsnippets_tsicommon_cms_richnavigationlink_history_results;
    wagtailsnippets_tsicommon_cms_richnavigationlink_copy: wagtailsnippets_tsicommon_cms_richnavigationlink_copy;
    wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_choose: wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_choose;
    wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_choose_results: wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_chosen: wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_chosen;
    wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_create: wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_create;
    wagtailsnippets_tsicommon_cms_richnavigation_list: wagtailsnippets_tsicommon_cms_richnavigation_list;
    wagtailsnippets_tsicommon_cms_richnavigation_list_results: wagtailsnippets_tsicommon_cms_richnavigation_list_results;
    wagtailsnippets_tsicommon_cms_richnavigation_add: wagtailsnippets_tsicommon_cms_richnavigation_add;
    wagtailsnippets_tsicommon_cms_richnavigation_edit: wagtailsnippets_tsicommon_cms_richnavigation_edit;
    wagtailsnippets_tsicommon_cms_richnavigation_delete: wagtailsnippets_tsicommon_cms_richnavigation_delete;
    wagtailsnippets_tsicommon_cms_richnavigation_usage: wagtailsnippets_tsicommon_cms_richnavigation_usage;
    wagtailsnippets_tsicommon_cms_richnavigation_history: wagtailsnippets_tsicommon_cms_richnavigation_history;
    wagtailsnippets_tsicommon_cms_richnavigation_history_results: wagtailsnippets_tsicommon_cms_richnavigation_history_results;
    wagtailsnippets_tsicommon_cms_richnavigation_copy: wagtailsnippets_tsicommon_cms_richnavigation_copy;
    wagtailsnippetchoosers_tsicommon_cms_richnavigation_choose: wagtailsnippetchoosers_tsicommon_cms_richnavigation_choose;
    wagtailsnippetchoosers_tsicommon_cms_richnavigation_choose_results: wagtailsnippetchoosers_tsicommon_cms_richnavigation_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_richnavigation_chosen: wagtailsnippetchoosers_tsicommon_cms_richnavigation_chosen;
    wagtailsnippetchoosers_tsicommon_cms_richnavigation_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_richnavigation_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_richnavigation_create: wagtailsnippetchoosers_tsicommon_cms_richnavigation_create;
    wagtailsnippets_tsicommon_cms_emailmodal_list: wagtailsnippets_tsicommon_cms_emailmodal_list;
    wagtailsnippets_tsicommon_cms_emailmodal_list_results: wagtailsnippets_tsicommon_cms_emailmodal_list_results;
    wagtailsnippets_tsicommon_cms_emailmodal_add: wagtailsnippets_tsicommon_cms_emailmodal_add;
    wagtailsnippets_tsicommon_cms_emailmodal_edit: wagtailsnippets_tsicommon_cms_emailmodal_edit;
    wagtailsnippets_tsicommon_cms_emailmodal_delete: wagtailsnippets_tsicommon_cms_emailmodal_delete;
    wagtailsnippets_tsicommon_cms_emailmodal_usage: wagtailsnippets_tsicommon_cms_emailmodal_usage;
    wagtailsnippets_tsicommon_cms_emailmodal_history: wagtailsnippets_tsicommon_cms_emailmodal_history;
    wagtailsnippets_tsicommon_cms_emailmodal_history_results: wagtailsnippets_tsicommon_cms_emailmodal_history_results;
    wagtailsnippets_tsicommon_cms_emailmodal_copy: wagtailsnippets_tsicommon_cms_emailmodal_copy;
    wagtailsnippetchoosers_tsicommon_cms_emailmodal_choose: wagtailsnippetchoosers_tsicommon_cms_emailmodal_choose;
    wagtailsnippetchoosers_tsicommon_cms_emailmodal_choose_results: wagtailsnippetchoosers_tsicommon_cms_emailmodal_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_emailmodal_chosen: wagtailsnippetchoosers_tsicommon_cms_emailmodal_chosen;
    wagtailsnippetchoosers_tsicommon_cms_emailmodal_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_emailmodal_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_emailmodal_create: wagtailsnippetchoosers_tsicommon_cms_emailmodal_create;
    wagtailsnippets_tsicommon_cms_servicefootersnippet_list: wagtailsnippets_tsicommon_cms_servicefootersnippet_list;
    wagtailsnippets_tsicommon_cms_servicefootersnippet_list_results: wagtailsnippets_tsicommon_cms_servicefootersnippet_list_results;
    wagtailsnippets_tsicommon_cms_servicefootersnippet_add: wagtailsnippets_tsicommon_cms_servicefootersnippet_add;
    wagtailsnippets_tsicommon_cms_servicefootersnippet_edit: wagtailsnippets_tsicommon_cms_servicefootersnippet_edit;
    wagtailsnippets_tsicommon_cms_servicefootersnippet_delete: wagtailsnippets_tsicommon_cms_servicefootersnippet_delete;
    wagtailsnippets_tsicommon_cms_servicefootersnippet_usage: wagtailsnippets_tsicommon_cms_servicefootersnippet_usage;
    wagtailsnippets_tsicommon_cms_servicefootersnippet_history: wagtailsnippets_tsicommon_cms_servicefootersnippet_history;
    wagtailsnippets_tsicommon_cms_servicefootersnippet_history_results: wagtailsnippets_tsicommon_cms_servicefootersnippet_history_results;
    wagtailsnippets_tsicommon_cms_servicefootersnippet_copy: wagtailsnippets_tsicommon_cms_servicefootersnippet_copy;
    wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_choose: wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_choose;
    wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_choose_results: wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_chosen: wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_chosen;
    wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_create: wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_create;
    wagtailsnippets_tsicommon_cms_timedemailmodal_list: wagtailsnippets_tsicommon_cms_timedemailmodal_list;
    wagtailsnippets_tsicommon_cms_timedemailmodal_list_results: wagtailsnippets_tsicommon_cms_timedemailmodal_list_results;
    wagtailsnippets_tsicommon_cms_timedemailmodal_add: wagtailsnippets_tsicommon_cms_timedemailmodal_add;
    wagtailsnippets_tsicommon_cms_timedemailmodal_edit: wagtailsnippets_tsicommon_cms_timedemailmodal_edit;
    wagtailsnippets_tsicommon_cms_timedemailmodal_delete: wagtailsnippets_tsicommon_cms_timedemailmodal_delete;
    wagtailsnippets_tsicommon_cms_timedemailmodal_usage: wagtailsnippets_tsicommon_cms_timedemailmodal_usage;
    wagtailsnippets_tsicommon_cms_timedemailmodal_history: wagtailsnippets_tsicommon_cms_timedemailmodal_history;
    wagtailsnippets_tsicommon_cms_timedemailmodal_history_results: wagtailsnippets_tsicommon_cms_timedemailmodal_history_results;
    wagtailsnippets_tsicommon_cms_timedemailmodal_copy: wagtailsnippets_tsicommon_cms_timedemailmodal_copy;
    wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_choose: wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_choose;
    wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_choose_results: wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_chosen: wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_chosen;
    wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_create: wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_create;
    wagtailsnippets_tsicommon_cms_comparefeature_list: wagtailsnippets_tsicommon_cms_comparefeature_list;
    wagtailsnippets_tsicommon_cms_comparefeature_list_results: wagtailsnippets_tsicommon_cms_comparefeature_list_results;
    wagtailsnippets_tsicommon_cms_comparefeature_add: wagtailsnippets_tsicommon_cms_comparefeature_add;
    wagtailsnippets_tsicommon_cms_comparefeature_edit: wagtailsnippets_tsicommon_cms_comparefeature_edit;
    wagtailsnippets_tsicommon_cms_comparefeature_delete: wagtailsnippets_tsicommon_cms_comparefeature_delete;
    wagtailsnippets_tsicommon_cms_comparefeature_usage: wagtailsnippets_tsicommon_cms_comparefeature_usage;
    wagtailsnippets_tsicommon_cms_comparefeature_history: wagtailsnippets_tsicommon_cms_comparefeature_history;
    wagtailsnippets_tsicommon_cms_comparefeature_history_results: wagtailsnippets_tsicommon_cms_comparefeature_history_results;
    wagtailsnippets_tsicommon_cms_comparefeature_copy: wagtailsnippets_tsicommon_cms_comparefeature_copy;
    wagtailsnippetchoosers_tsicommon_cms_comparefeature_choose: wagtailsnippetchoosers_tsicommon_cms_comparefeature_choose;
    wagtailsnippetchoosers_tsicommon_cms_comparefeature_choose_results: wagtailsnippetchoosers_tsicommon_cms_comparefeature_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_comparefeature_chosen: wagtailsnippetchoosers_tsicommon_cms_comparefeature_chosen;
    wagtailsnippetchoosers_tsicommon_cms_comparefeature_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_comparefeature_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_comparefeature_create: wagtailsnippetchoosers_tsicommon_cms_comparefeature_create;
    wagtailsnippets_tsicommon_cms_comparetile_list: wagtailsnippets_tsicommon_cms_comparetile_list;
    wagtailsnippets_tsicommon_cms_comparetile_list_results: wagtailsnippets_tsicommon_cms_comparetile_list_results;
    wagtailsnippets_tsicommon_cms_comparetile_add: wagtailsnippets_tsicommon_cms_comparetile_add;
    wagtailsnippets_tsicommon_cms_comparetile_edit: wagtailsnippets_tsicommon_cms_comparetile_edit;
    wagtailsnippets_tsicommon_cms_comparetile_delete: wagtailsnippets_tsicommon_cms_comparetile_delete;
    wagtailsnippets_tsicommon_cms_comparetile_usage: wagtailsnippets_tsicommon_cms_comparetile_usage;
    wagtailsnippets_tsicommon_cms_comparetile_history: wagtailsnippets_tsicommon_cms_comparetile_history;
    wagtailsnippets_tsicommon_cms_comparetile_history_results: wagtailsnippets_tsicommon_cms_comparetile_history_results;
    wagtailsnippets_tsicommon_cms_comparetile_copy: wagtailsnippets_tsicommon_cms_comparetile_copy;
    wagtailsnippetchoosers_tsicommon_cms_comparetile_choose: wagtailsnippetchoosers_tsicommon_cms_comparetile_choose;
    wagtailsnippetchoosers_tsicommon_cms_comparetile_choose_results: wagtailsnippetchoosers_tsicommon_cms_comparetile_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_comparetile_chosen: wagtailsnippetchoosers_tsicommon_cms_comparetile_chosen;
    wagtailsnippetchoosers_tsicommon_cms_comparetile_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_comparetile_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_comparetile_create: wagtailsnippetchoosers_tsicommon_cms_comparetile_create;
    wagtailsnippets_tsicommon_cms_shoptile_list: wagtailsnippets_tsicommon_cms_shoptile_list;
    wagtailsnippets_tsicommon_cms_shoptile_list_results: wagtailsnippets_tsicommon_cms_shoptile_list_results;
    wagtailsnippets_tsicommon_cms_shoptile_add: wagtailsnippets_tsicommon_cms_shoptile_add;
    wagtailsnippets_tsicommon_cms_shoptile_edit: wagtailsnippets_tsicommon_cms_shoptile_edit;
    wagtailsnippets_tsicommon_cms_shoptile_delete: wagtailsnippets_tsicommon_cms_shoptile_delete;
    wagtailsnippets_tsicommon_cms_shoptile_usage: wagtailsnippets_tsicommon_cms_shoptile_usage;
    wagtailsnippets_tsicommon_cms_shoptile_history: wagtailsnippets_tsicommon_cms_shoptile_history;
    wagtailsnippets_tsicommon_cms_shoptile_history_results: wagtailsnippets_tsicommon_cms_shoptile_history_results;
    wagtailsnippets_tsicommon_cms_shoptile_copy: wagtailsnippets_tsicommon_cms_shoptile_copy;
    wagtailsnippetchoosers_tsicommon_cms_shoptile_choose: wagtailsnippetchoosers_tsicommon_cms_shoptile_choose;
    wagtailsnippetchoosers_tsicommon_cms_shoptile_choose_results: wagtailsnippetchoosers_tsicommon_cms_shoptile_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_shoptile_chosen: wagtailsnippetchoosers_tsicommon_cms_shoptile_chosen;
    wagtailsnippetchoosers_tsicommon_cms_shoptile_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_shoptile_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_shoptile_create: wagtailsnippetchoosers_tsicommon_cms_shoptile_create;
    wagtailsnippets_tsicommon_cms_shopcomparetileset_list: wagtailsnippets_tsicommon_cms_shopcomparetileset_list;
    wagtailsnippets_tsicommon_cms_shopcomparetileset_list_results: wagtailsnippets_tsicommon_cms_shopcomparetileset_list_results;
    wagtailsnippets_tsicommon_cms_shopcomparetileset_add: wagtailsnippets_tsicommon_cms_shopcomparetileset_add;
    wagtailsnippets_tsicommon_cms_shopcomparetileset_edit: wagtailsnippets_tsicommon_cms_shopcomparetileset_edit;
    wagtailsnippets_tsicommon_cms_shopcomparetileset_delete: wagtailsnippets_tsicommon_cms_shopcomparetileset_delete;
    wagtailsnippets_tsicommon_cms_shopcomparetileset_usage: wagtailsnippets_tsicommon_cms_shopcomparetileset_usage;
    wagtailsnippets_tsicommon_cms_shopcomparetileset_history: wagtailsnippets_tsicommon_cms_shopcomparetileset_history;
    wagtailsnippets_tsicommon_cms_shopcomparetileset_history_results: wagtailsnippets_tsicommon_cms_shopcomparetileset_history_results;
    wagtailsnippets_tsicommon_cms_shopcomparetileset_copy: wagtailsnippets_tsicommon_cms_shopcomparetileset_copy;
    wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_choose: wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_choose;
    wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_choose_results: wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_chosen: wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_chosen;
    wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_create: wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_create;
    wagtailsnippets_tsicommon_cms_stickyemailbanner_list: wagtailsnippets_tsicommon_cms_stickyemailbanner_list;
    wagtailsnippets_tsicommon_cms_stickyemailbanner_list_results: wagtailsnippets_tsicommon_cms_stickyemailbanner_list_results;
    wagtailsnippets_tsicommon_cms_stickyemailbanner_add: wagtailsnippets_tsicommon_cms_stickyemailbanner_add;
    wagtailsnippets_tsicommon_cms_stickyemailbanner_edit: wagtailsnippets_tsicommon_cms_stickyemailbanner_edit;
    wagtailsnippets_tsicommon_cms_stickyemailbanner_delete: wagtailsnippets_tsicommon_cms_stickyemailbanner_delete;
    wagtailsnippets_tsicommon_cms_stickyemailbanner_usage: wagtailsnippets_tsicommon_cms_stickyemailbanner_usage;
    wagtailsnippets_tsicommon_cms_stickyemailbanner_history: wagtailsnippets_tsicommon_cms_stickyemailbanner_history;
    wagtailsnippets_tsicommon_cms_stickyemailbanner_history_results: wagtailsnippets_tsicommon_cms_stickyemailbanner_history_results;
    wagtailsnippets_tsicommon_cms_stickyemailbanner_copy: wagtailsnippets_tsicommon_cms_stickyemailbanner_copy;
    wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_choose: wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_choose;
    wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_choose_results: wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_chosen: wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_chosen;
    wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_create: wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_create;
    wagtailsnippets_tsicommon_cms_valueprop_list: wagtailsnippets_tsicommon_cms_valueprop_list;
    wagtailsnippets_tsicommon_cms_valueprop_list_results: wagtailsnippets_tsicommon_cms_valueprop_list_results;
    wagtailsnippets_tsicommon_cms_valueprop_add: wagtailsnippets_tsicommon_cms_valueprop_add;
    wagtailsnippets_tsicommon_cms_valueprop_edit: wagtailsnippets_tsicommon_cms_valueprop_edit;
    wagtailsnippets_tsicommon_cms_valueprop_delete: wagtailsnippets_tsicommon_cms_valueprop_delete;
    wagtailsnippets_tsicommon_cms_valueprop_usage: wagtailsnippets_tsicommon_cms_valueprop_usage;
    wagtailsnippets_tsicommon_cms_valueprop_history: wagtailsnippets_tsicommon_cms_valueprop_history;
    wagtailsnippets_tsicommon_cms_valueprop_history_results: wagtailsnippets_tsicommon_cms_valueprop_history_results;
    wagtailsnippets_tsicommon_cms_valueprop_copy: wagtailsnippets_tsicommon_cms_valueprop_copy;
    wagtailsnippetchoosers_tsicommon_cms_valueprop_choose: wagtailsnippetchoosers_tsicommon_cms_valueprop_choose;
    wagtailsnippetchoosers_tsicommon_cms_valueprop_choose_results: wagtailsnippetchoosers_tsicommon_cms_valueprop_choose_results;
    wagtailsnippetchoosers_tsicommon_cms_valueprop_chosen: wagtailsnippetchoosers_tsicommon_cms_valueprop_chosen;
    wagtailsnippetchoosers_tsicommon_cms_valueprop_chosen_multiple: wagtailsnippetchoosers_tsicommon_cms_valueprop_chosen_multiple;
    wagtailsnippetchoosers_tsicommon_cms_valueprop_create: wagtailsnippetchoosers_tsicommon_cms_valueprop_create;
    wagtailsnippets_cms_navbar_list: wagtailsnippets_cms_navbar_list;
    wagtailsnippets_cms_navbar_list_results: wagtailsnippets_cms_navbar_list_results;
    wagtailsnippets_cms_navbar_add: wagtailsnippets_cms_navbar_add;
    wagtailsnippets_cms_navbar_edit: wagtailsnippets_cms_navbar_edit;
    wagtailsnippets_cms_navbar_delete: wagtailsnippets_cms_navbar_delete;
    wagtailsnippets_cms_navbar_usage: wagtailsnippets_cms_navbar_usage;
    wagtailsnippets_cms_navbar_history: wagtailsnippets_cms_navbar_history;
    wagtailsnippets_cms_navbar_history_results: wagtailsnippets_cms_navbar_history_results;
    wagtailsnippets_cms_navbar_copy: wagtailsnippets_cms_navbar_copy;
    wagtailsnippetchoosers_cms_navbar_choose: wagtailsnippetchoosers_cms_navbar_choose;
    wagtailsnippetchoosers_cms_navbar_choose_results: wagtailsnippetchoosers_cms_navbar_choose_results;
    wagtailsnippetchoosers_cms_navbar_chosen: wagtailsnippetchoosers_cms_navbar_chosen;
    wagtailsnippetchoosers_cms_navbar_chosen_multiple: wagtailsnippetchoosers_cms_navbar_chosen_multiple;
    wagtailsnippetchoosers_cms_navbar_create: wagtailsnippetchoosers_cms_navbar_create;
    wagtailsnippets_cms_contentblock_list: wagtailsnippets_cms_contentblock_list;
    wagtailsnippets_cms_contentblock_list_results: wagtailsnippets_cms_contentblock_list_results;
    wagtailsnippets_cms_contentblock_add: wagtailsnippets_cms_contentblock_add;
    wagtailsnippets_cms_contentblock_edit: wagtailsnippets_cms_contentblock_edit;
    wagtailsnippets_cms_contentblock_delete: wagtailsnippets_cms_contentblock_delete;
    wagtailsnippets_cms_contentblock_usage: wagtailsnippets_cms_contentblock_usage;
    wagtailsnippets_cms_contentblock_history: wagtailsnippets_cms_contentblock_history;
    wagtailsnippets_cms_contentblock_history_results: wagtailsnippets_cms_contentblock_history_results;
    wagtailsnippets_cms_contentblock_copy: wagtailsnippets_cms_contentblock_copy;
    wagtailsnippetchoosers_cms_contentblock_choose: wagtailsnippetchoosers_cms_contentblock_choose;
    wagtailsnippetchoosers_cms_contentblock_choose_results: wagtailsnippetchoosers_cms_contentblock_choose_results;
    wagtailsnippetchoosers_cms_contentblock_chosen: wagtailsnippetchoosers_cms_contentblock_chosen;
    wagtailsnippetchoosers_cms_contentblock_chosen_multiple: wagtailsnippetchoosers_cms_contentblock_chosen_multiple;
    wagtailsnippetchoosers_cms_contentblock_create: wagtailsnippetchoosers_cms_contentblock_create;
    wagtailsnippets_cms_promocopyheader_list: wagtailsnippets_cms_promocopyheader_list;
    wagtailsnippets_cms_promocopyheader_list_results: wagtailsnippets_cms_promocopyheader_list_results;
    wagtailsnippets_cms_promocopyheader_add: wagtailsnippets_cms_promocopyheader_add;
    wagtailsnippets_cms_promocopyheader_edit: wagtailsnippets_cms_promocopyheader_edit;
    wagtailsnippets_cms_promocopyheader_delete: wagtailsnippets_cms_promocopyheader_delete;
    wagtailsnippets_cms_promocopyheader_usage: wagtailsnippets_cms_promocopyheader_usage;
    wagtailsnippets_cms_promocopyheader_history: wagtailsnippets_cms_promocopyheader_history;
    wagtailsnippets_cms_promocopyheader_history_results: wagtailsnippets_cms_promocopyheader_history_results;
    wagtailsnippets_cms_promocopyheader_copy: wagtailsnippets_cms_promocopyheader_copy;
    wagtailsnippetchoosers_cms_promocopyheader_choose: wagtailsnippetchoosers_cms_promocopyheader_choose;
    wagtailsnippetchoosers_cms_promocopyheader_choose_results: wagtailsnippetchoosers_cms_promocopyheader_choose_results;
    wagtailsnippetchoosers_cms_promocopyheader_chosen: wagtailsnippetchoosers_cms_promocopyheader_chosen;
    wagtailsnippetchoosers_cms_promocopyheader_chosen_multiple: wagtailsnippetchoosers_cms_promocopyheader_chosen_multiple;
    wagtailsnippetchoosers_cms_promocopyheader_create: wagtailsnippetchoosers_cms_promocopyheader_create;
    wagtailsnippets_cms_promocopy_list: wagtailsnippets_cms_promocopy_list;
    wagtailsnippets_cms_promocopy_list_results: wagtailsnippets_cms_promocopy_list_results;
    wagtailsnippets_cms_promocopy_add: wagtailsnippets_cms_promocopy_add;
    wagtailsnippets_cms_promocopy_edit: wagtailsnippets_cms_promocopy_edit;
    wagtailsnippets_cms_promocopy_delete: wagtailsnippets_cms_promocopy_delete;
    wagtailsnippets_cms_promocopy_usage: wagtailsnippets_cms_promocopy_usage;
    wagtailsnippets_cms_promocopy_history: wagtailsnippets_cms_promocopy_history;
    wagtailsnippets_cms_promocopy_history_results: wagtailsnippets_cms_promocopy_history_results;
    wagtailsnippets_cms_promocopy_copy: wagtailsnippets_cms_promocopy_copy;
    wagtailsnippetchoosers_cms_promocopy_choose: wagtailsnippetchoosers_cms_promocopy_choose;
    wagtailsnippetchoosers_cms_promocopy_choose_results: wagtailsnippetchoosers_cms_promocopy_choose_results;
    wagtailsnippetchoosers_cms_promocopy_chosen: wagtailsnippetchoosers_cms_promocopy_chosen;
    wagtailsnippetchoosers_cms_promocopy_chosen_multiple: wagtailsnippetchoosers_cms_promocopy_chosen_multiple;
    wagtailsnippetchoosers_cms_promocopy_create: wagtailsnippetchoosers_cms_promocopy_create;
    wagtailsnippets_cms_navbadge_list: wagtailsnippets_cms_navbadge_list;
    wagtailsnippets_cms_navbadge_list_results: wagtailsnippets_cms_navbadge_list_results;
    wagtailsnippets_cms_navbadge_add: wagtailsnippets_cms_navbadge_add;
    wagtailsnippets_cms_navbadge_edit: wagtailsnippets_cms_navbadge_edit;
    wagtailsnippets_cms_navbadge_delete: wagtailsnippets_cms_navbadge_delete;
    wagtailsnippets_cms_navbadge_usage: wagtailsnippets_cms_navbadge_usage;
    wagtailsnippets_cms_navbadge_history: wagtailsnippets_cms_navbadge_history;
    wagtailsnippets_cms_navbadge_history_results: wagtailsnippets_cms_navbadge_history_results;
    wagtailsnippets_cms_navbadge_copy: wagtailsnippets_cms_navbadge_copy;
    wagtailsnippetchoosers_cms_navbadge_choose: wagtailsnippetchoosers_cms_navbadge_choose;
    wagtailsnippetchoosers_cms_navbadge_choose_results: wagtailsnippetchoosers_cms_navbadge_choose_results;
    wagtailsnippetchoosers_cms_navbadge_chosen: wagtailsnippetchoosers_cms_navbadge_chosen;
    wagtailsnippetchoosers_cms_navbadge_chosen_multiple: wagtailsnippetchoosers_cms_navbadge_chosen_multiple;
    wagtailsnippetchoosers_cms_navbadge_create: wagtailsnippetchoosers_cms_navbadge_create;
    wagtailsnippets_cms_ownerspotlight_list: wagtailsnippets_cms_ownerspotlight_list;
    wagtailsnippets_cms_ownerspotlight_list_results: wagtailsnippets_cms_ownerspotlight_list_results;
    wagtailsnippets_cms_ownerspotlight_add: wagtailsnippets_cms_ownerspotlight_add;
    wagtailsnippets_cms_ownerspotlight_edit: wagtailsnippets_cms_ownerspotlight_edit;
    wagtailsnippets_cms_ownerspotlight_delete: wagtailsnippets_cms_ownerspotlight_delete;
    wagtailsnippets_cms_ownerspotlight_usage: wagtailsnippets_cms_ownerspotlight_usage;
    wagtailsnippets_cms_ownerspotlight_history: wagtailsnippets_cms_ownerspotlight_history;
    wagtailsnippets_cms_ownerspotlight_history_results: wagtailsnippets_cms_ownerspotlight_history_results;
    wagtailsnippets_cms_ownerspotlight_copy: wagtailsnippets_cms_ownerspotlight_copy;
    wagtailsnippetchoosers_cms_ownerspotlight_choose: wagtailsnippetchoosers_cms_ownerspotlight_choose;
    wagtailsnippetchoosers_cms_ownerspotlight_choose_results: wagtailsnippetchoosers_cms_ownerspotlight_choose_results;
    wagtailsnippetchoosers_cms_ownerspotlight_chosen: wagtailsnippetchoosers_cms_ownerspotlight_chosen;
    wagtailsnippetchoosers_cms_ownerspotlight_chosen_multiple: wagtailsnippetchoosers_cms_ownerspotlight_chosen_multiple;
    wagtailsnippetchoosers_cms_ownerspotlight_create: wagtailsnippetchoosers_cms_ownerspotlight_create;
    wagtailsnippets_cms_ugcpost_list: wagtailsnippets_cms_ugcpost_list;
    wagtailsnippets_cms_ugcpost_list_results: wagtailsnippets_cms_ugcpost_list_results;
    wagtailsnippets_cms_ugcpost_add: wagtailsnippets_cms_ugcpost_add;
    wagtailsnippets_cms_ugcpost_edit: wagtailsnippets_cms_ugcpost_edit;
    wagtailsnippets_cms_ugcpost_delete: wagtailsnippets_cms_ugcpost_delete;
    wagtailsnippets_cms_ugcpost_usage: wagtailsnippets_cms_ugcpost_usage;
    wagtailsnippets_cms_ugcpost_history: wagtailsnippets_cms_ugcpost_history;
    wagtailsnippets_cms_ugcpost_history_results: wagtailsnippets_cms_ugcpost_history_results;
    wagtailsnippets_cms_ugcpost_copy: wagtailsnippets_cms_ugcpost_copy;
    wagtailsnippetchoosers_cms_ugcpost_choose: wagtailsnippetchoosers_cms_ugcpost_choose;
    wagtailsnippetchoosers_cms_ugcpost_choose_results: wagtailsnippetchoosers_cms_ugcpost_choose_results;
    wagtailsnippetchoosers_cms_ugcpost_chosen: wagtailsnippetchoosers_cms_ugcpost_chosen;
    wagtailsnippetchoosers_cms_ugcpost_chosen_multiple: wagtailsnippetchoosers_cms_ugcpost_chosen_multiple;
    wagtailsnippetchoosers_cms_ugcpost_create: wagtailsnippetchoosers_cms_ugcpost_create;
    wagtailsnippets_cms_tempurlovestorycategory_list: wagtailsnippets_cms_tempurlovestorycategory_list;
    wagtailsnippets_cms_tempurlovestorycategory_list_results: wagtailsnippets_cms_tempurlovestorycategory_list_results;
    wagtailsnippets_cms_tempurlovestorycategory_add: wagtailsnippets_cms_tempurlovestorycategory_add;
    wagtailsnippets_cms_tempurlovestorycategory_edit: wagtailsnippets_cms_tempurlovestorycategory_edit;
    wagtailsnippets_cms_tempurlovestorycategory_delete: wagtailsnippets_cms_tempurlovestorycategory_delete;
    wagtailsnippets_cms_tempurlovestorycategory_usage: wagtailsnippets_cms_tempurlovestorycategory_usage;
    wagtailsnippets_cms_tempurlovestorycategory_history: wagtailsnippets_cms_tempurlovestorycategory_history;
    wagtailsnippets_cms_tempurlovestorycategory_history_results: wagtailsnippets_cms_tempurlovestorycategory_history_results;
    wagtailsnippets_cms_tempurlovestorycategory_copy: wagtailsnippets_cms_tempurlovestorycategory_copy;
    wagtailsnippetchoosers_cms_tempurlovestorycategory_choose: wagtailsnippetchoosers_cms_tempurlovestorycategory_choose;
    wagtailsnippetchoosers_cms_tempurlovestorycategory_choose_results: wagtailsnippetchoosers_cms_tempurlovestorycategory_choose_results;
    wagtailsnippetchoosers_cms_tempurlovestorycategory_chosen: wagtailsnippetchoosers_cms_tempurlovestorycategory_chosen;
    wagtailsnippetchoosers_cms_tempurlovestorycategory_chosen_multiple: wagtailsnippetchoosers_cms_tempurlovestorycategory_chosen_multiple;
    wagtailsnippetchoosers_cms_tempurlovestorycategory_create: wagtailsnippetchoosers_cms_tempurlovestorycategory_create;
    wagtailsnippets_tempur_search_dynamicsearchsnippet_list: wagtailsnippets_tempur_search_dynamicsearchsnippet_list;
    wagtailsnippets_tempur_search_dynamicsearchsnippet_list_results: wagtailsnippets_tempur_search_dynamicsearchsnippet_list_results;
    wagtailsnippets_tempur_search_dynamicsearchsnippet_add: wagtailsnippets_tempur_search_dynamicsearchsnippet_add;
    wagtailsnippets_tempur_search_dynamicsearchsnippet_edit: wagtailsnippets_tempur_search_dynamicsearchsnippet_edit;
    wagtailsnippets_tempur_search_dynamicsearchsnippet_delete: wagtailsnippets_tempur_search_dynamicsearchsnippet_delete;
    wagtailsnippets_tempur_search_dynamicsearchsnippet_usage: wagtailsnippets_tempur_search_dynamicsearchsnippet_usage;
    wagtailsnippets_tempur_search_dynamicsearchsnippet_history: wagtailsnippets_tempur_search_dynamicsearchsnippet_history;
    wagtailsnippets_tempur_search_dynamicsearchsnippet_history_results: wagtailsnippets_tempur_search_dynamicsearchsnippet_history_results;
    wagtailsnippets_tempur_search_dynamicsearchsnippet_copy: wagtailsnippets_tempur_search_dynamicsearchsnippet_copy;
    wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_choose: wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_choose;
    wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_choose_results: wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_choose_results;
    wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_chosen: wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_chosen;
    wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_chosen_multiple: wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_chosen_multiple;
    wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_create: wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_create;
    wagtailsnippets_tempur_search_dynamic404pagesnippet_list: wagtailsnippets_tempur_search_dynamic404pagesnippet_list;
    wagtailsnippets_tempur_search_dynamic404pagesnippet_list_results: wagtailsnippets_tempur_search_dynamic404pagesnippet_list_results;
    wagtailsnippets_tempur_search_dynamic404pagesnippet_add: wagtailsnippets_tempur_search_dynamic404pagesnippet_add;
    wagtailsnippets_tempur_search_dynamic404pagesnippet_edit: wagtailsnippets_tempur_search_dynamic404pagesnippet_edit;
    wagtailsnippets_tempur_search_dynamic404pagesnippet_delete: wagtailsnippets_tempur_search_dynamic404pagesnippet_delete;
    wagtailsnippets_tempur_search_dynamic404pagesnippet_usage: wagtailsnippets_tempur_search_dynamic404pagesnippet_usage;
    wagtailsnippets_tempur_search_dynamic404pagesnippet_history: wagtailsnippets_tempur_search_dynamic404pagesnippet_history;
    wagtailsnippets_tempur_search_dynamic404pagesnippet_history_results: wagtailsnippets_tempur_search_dynamic404pagesnippet_history_results;
    wagtailsnippets_tempur_search_dynamic404pagesnippet_copy: wagtailsnippets_tempur_search_dynamic404pagesnippet_copy;
    wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_choose: wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_choose;
    wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_choose_results: wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_choose_results;
    wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_chosen: wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_chosen;
    wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_chosen_multiple: wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_chosen_multiple;
    wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_create: wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_create;
    wagtailsnippets_thelabui_labuitoolboxsnippet_list: wagtailsnippets_thelabui_labuitoolboxsnippet_list;
    wagtailsnippets_thelabui_labuitoolboxsnippet_list_results: wagtailsnippets_thelabui_labuitoolboxsnippet_list_results;
    wagtailsnippets_thelabui_labuitoolboxsnippet_add: wagtailsnippets_thelabui_labuitoolboxsnippet_add;
    wagtailsnippets_thelabui_labuitoolboxsnippet_edit: wagtailsnippets_thelabui_labuitoolboxsnippet_edit;
    wagtailsnippets_thelabui_labuitoolboxsnippet_delete: wagtailsnippets_thelabui_labuitoolboxsnippet_delete;
    wagtailsnippets_thelabui_labuitoolboxsnippet_usage: wagtailsnippets_thelabui_labuitoolboxsnippet_usage;
    wagtailsnippets_thelabui_labuitoolboxsnippet_history: wagtailsnippets_thelabui_labuitoolboxsnippet_history;
    wagtailsnippets_thelabui_labuitoolboxsnippet_history_results: wagtailsnippets_thelabui_labuitoolboxsnippet_history_results;
    wagtailsnippets_thelabui_labuitoolboxsnippet_copy: wagtailsnippets_thelabui_labuitoolboxsnippet_copy;
    wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_add: wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_add;
    wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_edit: wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_edit;
    wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_view: wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_view;
    wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_revert: wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_revert;
    wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_unschedule: wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_unschedule;
    wagtailsnippets_thelabui_labuitoolboxsnippet_unpublish: wagtailsnippets_thelabui_labuitoolboxsnippet_unpublish;
    wagtailsnippets_thelabui_labuitoolboxsnippet_lock: wagtailsnippets_thelabui_labuitoolboxsnippet_lock;
    wagtailsnippets_thelabui_labuitoolboxsnippet_unlock: wagtailsnippets_thelabui_labuitoolboxsnippet_unlock;
    wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose;
    wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_results: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_results;
    wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen;
    wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_multiple: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_multiple;
    wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_create: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_create;
    wagtailvideos_chooser_choose: wagtailvideos_chooser_choose;
    wagtailvideos_chooser_choose_results: wagtailvideos_chooser_choose_results;
    wagtailvideos_chooser_chosen: wagtailvideos_chooser_chosen;
    wagtailvideos_chooser_chosen_multiple: wagtailvideos_chooser_chosen_multiple;
    wagtailvideos_chooser_create: wagtailvideos_chooser_create;
    wagtaildocs_chooser_choose: wagtaildocs_chooser_choose;
    wagtaildocs_chooser_choose_results: wagtaildocs_chooser_choose_results;
    wagtaildocs_chooser_chosen: wagtaildocs_chooser_chosen;
    wagtaildocs_chooser_chosen_multiple: wagtaildocs_chooser_chosen_multiple;
    wagtaildocs_chooser_create: wagtaildocs_chooser_create;
    wagtailsites_index: wagtailsites_index;
    wagtailsites_index_results: wagtailsites_index_results;
    wagtailsites_add: wagtailsites_add;
    wagtailsites_edit: wagtailsites_edit;
    wagtailsites_delete: wagtailsites_delete;
    wagtailsites_history: wagtailsites_history;
    wagtailsites_history_results: wagtailsites_history_results;
    wagtailsites_usage: wagtailsites_usage;
    wagtailsites_copy: wagtailsites_copy;
    wagtailusers_users_index: wagtailusers_users_index;
    wagtailusers_users_index_results: wagtailusers_users_index_results;
    wagtailusers_users_add: wagtailusers_users_add;
    wagtailusers_users_edit: wagtailusers_users_edit;
    wagtailusers_users_delete: wagtailusers_users_delete;
    wagtailusers_users_history: wagtailusers_users_history;
    wagtailusers_users_history_results: wagtailusers_users_history_results;
    wagtailusers_users_usage: wagtailusers_users_usage;
    wagtailusers_users_copy: wagtailusers_users_copy;
    wagtailusers_groups_index: wagtailusers_groups_index;
    wagtailusers_groups_index_results: wagtailusers_groups_index_results;
    wagtailusers_groups_add: wagtailusers_groups_add;
    wagtailusers_groups_edit: wagtailusers_groups_edit;
    wagtailusers_groups_delete: wagtailusers_groups_delete;
    wagtailusers_groups_history: wagtailusers_groups_history;
    wagtailusers_groups_history_results: wagtailusers_groups_history_results;
    wagtailusers_groups_usage: wagtailusers_groups_usage;
    wagtaillocales_index: wagtaillocales_index;
    wagtaillocales_index_results: wagtaillocales_index_results;
    wagtaillocales_add: wagtaillocales_add;
    wagtaillocales_edit: wagtaillocales_edit;
    wagtaillocales_delete: wagtaillocales_delete;
    wagtaillocales_history: wagtaillocales_history;
    wagtaillocales_history_results: wagtaillocales_history_results;
    wagtaillocales_usage: wagtaillocales_usage;
    wagtaillocales_copy: wagtaillocales_copy;
    tsicommon_cms_product_chooser_choose: tsicommon_cms_product_chooser_choose;
    tsicommon_cms_product_chooser_choose_results: tsicommon_cms_product_chooser_choose_results;
    tsicommon_cms_product_chooser_chosen: tsicommon_cms_product_chooser_chosen;
    tsicommon_cms_product_chooser_chosen_multiple: tsicommon_cms_product_chooser_chosen_multiple;
    tsicommon_cms_product_chooser_create: tsicommon_cms_product_chooser_create;
    tsicommon_cms_location_chooser_choose: tsicommon_cms_location_chooser_choose;
    tsicommon_cms_location_chooser_choose_results: tsicommon_cms_location_chooser_choose_results;
    tsicommon_cms_location_chooser_chosen: tsicommon_cms_location_chooser_chosen;
    tsicommon_cms_location_chooser_chosen_multiple: tsicommon_cms_location_chooser_chosen_multiple;
    tsicommon_cms_location_chooser_create: tsicommon_cms_location_chooser_create;
    wagtailimages_chooser_choose: wagtailimages_chooser_choose;
    wagtailimages_chooser_choose_results: wagtailimages_chooser_choose_results;
    wagtailimages_chooser_chosen: wagtailimages_chooser_chosen;
    wagtailimages_chooser_chosen_multiple: wagtailimages_chooser_chosen_multiple;
    wagtailimages_chooser_create: wagtailimages_chooser_create;
    wagtailimages_chooser_select_format: wagtailimages_chooser_select_format;
    wagtaildocs_index: wagtaildocs_index;
    wagtaildocs_index_results: wagtaildocs_index_results;
    wagtaildocs_add: wagtaildocs_add;
    wagtaildocs_edit: wagtaildocs_edit;
    wagtaildocs_delete: wagtaildocs_delete;
    wagtaildocs_add_multiple: wagtaildocs_add_multiple;
    wagtaildocs_edit_multiple: wagtaildocs_edit_multiple;
    wagtaildocs_create_multiple_from_uploaded_document: wagtaildocs_create_multiple_from_uploaded_document;
    wagtaildocs_delete_multiple: wagtaildocs_delete_multiple;
    wagtaildocs_delete_upload_multiple: wagtaildocs_delete_upload_multiple;
    wagtaildocs_document_usage: wagtaildocs_document_usage;
    wagtailembeds_chooser: wagtailembeds_chooser;
    wagtailembeds_chooser_upload: wagtailembeds_chooser_upload;
    wagtailsnippets_index: wagtailsnippets_index;
    wagtail_localize_javascript_catalog: wagtail_localize_javascript_catalog;
    wagtail_localize_submit_page_translation: wagtail_localize_submit_page_translation;
    wagtail_localize_submit_snippet_translation: wagtail_localize_submit_snippet_translation;
    wagtail_localize_update_translations: wagtail_localize_update_translations;
    wagtail_localize_edit_string_translation: wagtail_localize_edit_string_translation;
    wagtail_localize_edit_override: wagtail_localize_edit_override;
    wagtail_localize_download_pofile: wagtail_localize_download_pofile;
    wagtail_localize_upload_pofile: wagtail_localize_upload_pofile;
    wagtail_localize_machine_translate: wagtail_localize_machine_translate;
    wagtail_localize_preview_translation: wagtail_localize_preview_translation;
    wagtail_localize_stop_translation: wagtail_localize_stop_translation;
    wagtail_localize_convert_to_alias: wagtail_localize_convert_to_alias;
    wagtail_localize_translations_report: wagtail_localize_translations_report;
    wagtail_localize_snippets_api_listing: wagtail_localize_snippets_api_listing;
    wagtail_localize_snippets_api_detail: wagtail_localize_snippets_api_detail;
    wagtail_localize_translations_report_results: wagtail_localize_translations_report_results;
    wagtailforms_index: wagtailforms_index;
    wagtailforms_index_results: wagtailforms_index_results;
    wagtailforms_list_submissions: wagtailforms_list_submissions;
    wagtailforms_list_submissions_results: wagtailforms_list_submissions_results;
    wagtailforms_delete_submissions: wagtailforms_delete_submissions;
    wagtailredirects_index: wagtailredirects_index;
    wagtailredirects_index_results: wagtailredirects_index_results;
    wagtailredirects_add: wagtailredirects_add;
    wagtailredirects_edit: wagtailredirects_edit;
    wagtailredirects_delete: wagtailredirects_delete;
    wagtailredirects_start_import: wagtailredirects_start_import;
    wagtailredirects_process_import: wagtailredirects_process_import;
    wagtailsearchpromotions_index: wagtailsearchpromotions_index;
    wagtailsearchpromotions_index_results: wagtailsearchpromotions_index_results;
    wagtailsearchpromotions_add: wagtailsearchpromotions_add;
    wagtailsearchpromotions_edit: wagtailsearchpromotions_edit;
    wagtailsearchpromotions_delete: wagtailsearchpromotions_delete;
    wagtailsearchpromotions_chooser: wagtailsearchpromotions_chooser;
    wagtailsearchpromotions_chooserresults: wagtailsearchpromotions_chooserresults;
    wagtailsearchpromotions_search_terms: wagtailsearchpromotions_search_terms;
    wagtailsearchpromotions_search_terms_results: wagtailsearchpromotions_search_terms_results;
    wagtailstyleguide: wagtailstyleguide;
    wagtail_modeladmin_javascript_catalog: wagtail_modeladmin_javascript_catalog;
    cms_flagship_page_bulk_update: cms_flagship_page_bulk_update;
    cms_flagship_page_bulk_update_apply: cms_flagship_page_bulk_update_apply;
    cms_mattress_match_bulk_import: cms_mattress_match_bulk_import;
    cms_mattress_match_bulk_import_apply: cms_mattress_match_bulk_import_apply;
    tsicommon_cms_admin_tooltip_content_modal: tsicommon_cms_admin_tooltip_content_modal;
    tsicommon_cms_admin_wistia_link_content_modal: tsicommon_cms_admin_wistia_link_content_modal;
    wagtailimages_index: wagtailimages_index;
    wagtailimages_index_results: wagtailimages_index_results;
    wagtailimages_edit: wagtailimages_edit;
    wagtailimages_delete: wagtailimages_delete;
    wagtailimages_url_generator: wagtailimages_url_generator;
    wagtailimages_generate_url: wagtailimages_generate_url;
    wagtailimages_preview: wagtailimages_preview;
    wagtailimages_add: wagtailimages_add;
    wagtailimages_image_usage: wagtailimages_image_usage;
    wagtailimages_add_multiple: wagtailimages_add_multiple;
    wagtailimages_edit_multiple: wagtailimages_edit_multiple;
    wagtailimages_create_multiple_from_uploaded_image: wagtailimages_create_multiple_from_uploaded_image;
    wagtailimages_delete_multiple: wagtailimages_delete_multiple;
    wagtailimages_delete_upload_multiple: wagtailimages_delete_upload_multiple;
    wagtailadmin_sprite: wagtailadmin_sprite;
    wagtailadmin_login: wagtailadmin_login;
    wagtailadmin_password_reset: wagtailadmin_password_reset;
    wagtailadmin_password_reset_done: wagtailadmin_password_reset_done;
    wagtailadmin_password_reset_confirm: wagtailadmin_password_reset_confirm;
    wagtailadmin_password_reset_complete: wagtailadmin_password_reset_complete;
    wagtailadmin_javascript_catalog: wagtailadmin_javascript_catalog;
    django_admindocs_docroot: django_admindocs_docroot;
    django_admindocs_bookmarklets: django_admindocs_bookmarklets;
    django_admindocs_tags: django_admindocs_tags;
    django_admindocs_filters: django_admindocs_filters;
    django_admindocs_views_index: django_admindocs_views_index;
    django_admindocs_views_detail: django_admindocs_views_detail;
    django_admindocs_models_index: django_admindocs_models_index;
    django_admindocs_templates: django_admindocs_templates;
    thelabui_load_balancer_health_check: thelabui_load_balancer_health_check;
    thelabui_csrftoken_get: thelabui_csrftoken_get;
    thelabui_robots_txt: thelabui_robots_txt;
    thelabui_security_txt: thelabui_security_txt;
    thelabui_sitemap: thelabui_sitemap;
    asymmetric_jwt_auth_jwks: asymmetric_jwt_auth_jwks;
    cybersource_reply: cybersource_reply;
    cybersource_review_notification: cybersource_review_notification;
    cybersource_fingerprint_redirect: cybersource_fingerprint_redirect;
    financingapi_apply: financingapi_apply;
    financingapi_update_inquiry: financingapi_update_inquiry;
    financingapi_plan_list: financingapi_plan_list;
    financingapi_estimated_payment: financingapi_estimated_payment;
    financingapi_acct_inquiry: financingapi_acct_inquiry;
    financingapi_prequal: financingapi_prequal;
    financingapi_prequal_customer_response: financingapi_prequal_customer_response;
    financingapi_document_content_view: financingapi_document_content_view;
    financingapi_syf_dpos_token: financingapi_syf_dpos_token;
    financingapi_syf_transaction_lookup: financingapi_syf_transaction_lookup;
    api_root: api_root;
    tsi_auth_current_user: tsi_auth_current_user;
    tsi_auth_keep_alive: tsi_auth_keep_alive;
    tsi_auth_expired_token: tsi_auth_expired_token;
    tsi_auth_login: tsi_auth_login;
    tsi_auth_login_token: tsi_auth_login_token;
    tsi_auth_change_password: tsi_auth_change_password;
    tsi_yext_entity_webhook: tsi_yext_entity_webhook;
    product_bundle_list: product_bundle_list;
    product_concretebundle_list: product_concretebundle_list;
    product_userconfigurablebundle_list: product_userconfigurablebundle_list;
    oscarbundles_i18n_js: oscarbundles_i18n_js;
    bundlegrouptype_list: bundlegrouptype_list;
    bundlegroup_list: bundlegroup_list;
    bundlegroup_detail: bundlegroup_detail;
    concretebundle_list: concretebundle_list;
    concretebundle_detail: concretebundle_detail;
    concretebundle_product_choice_list: concretebundle_product_choice_list;
    userconfigurablebundle_list: userconfigurablebundle_list;
    userconfigurablebundle_detail: userconfigurablebundle_detail;
    userconfigurablebundle_range_choice_list: userconfigurablebundle_range_choice_list;
    api_checkout_payment_methods: api_checkout_payment_methods;
    api_payment: api_payment;
    api_complete_deferred_payment: api_complete_deferred_payment;
    api_checkout: api_checkout;
    api_get_csrf_token: api_get_csrf_token;
    api_user_data_layer: api_user_data_layer;
    api_register: api_register;
    api_login: api_login;
    product_list: product_list;
    product_detail: product_detail;
    product_price: product_price;
    product_financing_plans: product_financing_plans;
    product_stockrecords: product_stockrecords;
    product_stockrecord_detail: product_stockrecord_detail;
    product_shipping_methods: product_shipping_methods;
    product_shipping_methods_by_location: product_shipping_methods_by_location;
    product_upsellinfomodals: product_upsellinfomodals;
    product_promocards: product_promocards;
    option_list: option_list;
    option_detail: option_detail;
    user_detail: user_detail;
    order_list: order_list;
    order_detail: order_detail;
    order_cancel_detail: order_cancel_detail;
    order_lines_list: order_lines_list;
    api_basket: api_basket;
    api_basket_add_product: api_basket_add_product;
    api_basket_add_voucher: api_basket_add_voucher;
    api_basket_apply_voucher_code: api_basket_apply_voucher_code;
    api_basket_email: api_basket_email;
    api_basket_remove_voucher: api_basket_remove_voucher;
    api_basket_last_modified: api_basket_last_modified;
    api_basket_predicted_delivery_date: api_basket_predicted_delivery_date;
    basket_list: basket_list;
    basket_detail: basket_detail;
    basket_lines_list: basket_lines_list;
    basket_line_detail: basket_line_detail;
    lineattribute_detail: lineattribute_detail;
    category_list: category_list;
    category_detail: category_detail;
    category_products: category_products;
    mattress_match: mattress_match;
    productclass_list: productclass_list;
    productclass_detail: productclass_detail;
    productclass_members: productclass_members;
    checkout_shipping_address: checkout_shipping_address;
    checkout_billing_address: checkout_billing_address;
    checkout_shipping_methods: checkout_shipping_methods;
    country_list: country_list;
    country_detail: country_detail;
    country_state_list: country_state_list;
    api_validate_phone_number: api_validate_phone_number;
    useraddress_list: useraddress_list;
    useraddress_detail: useraddress_detail;
    email_offers_signup: email_offers_signup;
    email_retail_locator_results: email_retail_locator_results;
    wishlisttype_list: wishlisttype_list;
    wishlisttype_detail: wishlisttype_detail;
    wishlisttype_line_list: wishlisttype_line_list;
    wishlisttype_line_detail: wishlisttype_line_detail;
    api_basket_estimate_tax: api_basket_estimate_tax;
    api_basket_shipping_methods: api_basket_shipping_methods;
    financing_plan_list: financing_plan_list;
    financing_plan_create: financing_plan_create;
    financing_plan_edit: financing_plan_edit;
    financing_plan_delete: financing_plan_delete;
    financing_benefit_list: financing_benefit_list;
    financing_benefit_create: financing_benefit_create;
    financing_benefit_edit: financing_benefit_edit;
    financing_benefit_delete: financing_benefit_delete;
    financing_application_list: financing_application_list;
    financing_application_detail: financing_application_detail;
    financing_transfer_list: financing_transfer_list;
    financing_transfer_detail: financing_transfer_detail;
    financing_prequal_list: financing_prequal_list;
    financing_prequal_detail: financing_prequal_detail;
    dashboard_bundle_group_list: dashboard_bundle_group_list;
    benefit_bundle_list: benefit_bundle_list;
    benefit_bundle_create: benefit_bundle_create;
    benefit_bundle_update: benefit_bundle_update;
    benefit_bundle_delete: benefit_bundle_delete;
    rma_vouchers_import: rma_vouchers_import;
    dashboard_index: dashboard_index;
    dashboard_catalogue_product: dashboard_catalogue_product;
    dashboard_catalogue_product_create: dashboard_catalogue_product_create;
    dashboard_catalogue_product_create_child: dashboard_catalogue_product_create_child;
    dashboard_catalogue_product_delete: dashboard_catalogue_product_delete;
    dashboard_catalogue_product_list: dashboard_catalogue_product_list;
    dashboard_stock_alert_list: dashboard_stock_alert_list;
    dashboard_catalogue_product_lookup: dashboard_catalogue_product_lookup;
    dashboard_catalogue_category_list: dashboard_catalogue_category_list;
    dashboard_catalogue_category_detail_list: dashboard_catalogue_category_detail_list;
    dashboard_catalogue_category_create: dashboard_catalogue_category_create;
    dashboard_catalogue_category_create_child: dashboard_catalogue_category_create_child;
    dashboard_catalogue_category_update: dashboard_catalogue_category_update;
    dashboard_catalogue_category_delete: dashboard_catalogue_category_delete;
    dashboard_catalogue_class_create: dashboard_catalogue_class_create;
    dashboard_catalogue_class_list: dashboard_catalogue_class_list;
    dashboard_catalogue_class_update: dashboard_catalogue_class_update;
    dashboard_catalogue_class_delete: dashboard_catalogue_class_delete;
    dashboard_catalogue_attribute_option_group_create: dashboard_catalogue_attribute_option_group_create;
    dashboard_catalogue_attribute_option_group_list: dashboard_catalogue_attribute_option_group_list;
    dashboard_catalogue_attribute_option_group_update: dashboard_catalogue_attribute_option_group_update;
    dashboard_catalogue_attribute_option_group_delete: dashboard_catalogue_attribute_option_group_delete;
    dashboard_catalogue_option_list: dashboard_catalogue_option_list;
    dashboard_catalogue_option_create: dashboard_catalogue_option_create;
    dashboard_catalogue_option_update: dashboard_catalogue_option_update;
    dashboard_catalogue_option_delete: dashboard_catalogue_option_delete;
    dashboard_product_price_import: dashboard_product_price_import;
    dashboard_product_price_import_apply: dashboard_product_price_import_apply;
    dashboard_value_prop_list: dashboard_value_prop_list;
    dashboard_value_prop_create: dashboard_value_prop_create;
    dashboard_value_prop_edit: dashboard_value_prop_edit;
    dashboard_value_prop_delete: dashboard_value_prop_delete;
    dashboard_reports_index: dashboard_reports_index;
    dashboard_reports_download: dashboard_reports_download;
    dashboard_reports_delete: dashboard_reports_delete;
    dashboard_orderconfirmation_resend: dashboard_orderconfirmation_resend;
    dashboard_order_billing_verification_send: dashboard_order_billing_verification_send;
    dashboard_order_send_deferred_payment_email: dashboard_order_send_deferred_payment_email;
    dashboard_order_request_pnp_resend: dashboard_order_request_pnp_resend;
    dashboard_order_list: dashboard_order_list;
    dashboard_order_stats: dashboard_order_stats;
    dashboard_order_detail: dashboard_order_detail;
    dashboard_order_detail_note: dashboard_order_detail_note;
    dashboard_order_line_detail: dashboard_order_line_detail;
    dashboard_order_shipping_address: dashboard_order_shipping_address;
    dashboard_users_index: dashboard_users_index;
    dashboard_user_alert_list: dashboard_user_alert_list;
    dashboard_deletion_request_list: dashboard_deletion_request_list;
    dashboard_deletion_request_create: dashboard_deletion_request_create;
    dashboard_deletion_request_details: dashboard_deletion_request_details;
    dashboard_data_inquiry_list: dashboard_data_inquiry_list;
    dashboard_data_inquiry_create: dashboard_data_inquiry_create;
    dashboard_data_inquiry_details: dashboard_data_inquiry_details;
    dashboard_data_inquiry_download: dashboard_data_inquiry_download;
    dashboard_page_list: dashboard_page_list;
    dashboard_page_create: dashboard_page_create;
    dashboard_page_update: dashboard_page_update;
    dashboard_page_delete: dashboard_page_delete;
    dashboard_partner_list: dashboard_partner_list;
    dashboard_partner_create: dashboard_partner_create;
    dashboard_partner_manage: dashboard_partner_manage;
    dashboard_partner_delete: dashboard_partner_delete;
    dashboard_partner_user_create: dashboard_partner_user_create;
    dashboard_partner_user_select: dashboard_partner_user_select;
    dashboard_partner_user_link: dashboard_partner_user_link;
    dashboard_partner_user_unlink: dashboard_partner_user_unlink;
    dashboard_partner_user_update: dashboard_partner_user_update;
    dashboard_offer_list: dashboard_offer_list;
    dashboard_offer_metadata: dashboard_offer_metadata;
    dashboard_offer_condition: dashboard_offer_condition;
    dashboard_offer_benefit: dashboard_offer_benefit;
    dashboard_offer_restrictions: dashboard_offer_restrictions;
    dashboard_offer_delete: dashboard_offer_delete;
    dashboard_offer_detail: dashboard_offer_detail;
    dashboard_api_root: dashboard_api_root;
    dashboard_oscarbluelight_i18n_js: dashboard_oscarbluelight_i18n_js;
    dashboard_offer_images: dashboard_offer_images;
    dashboard_offer_api_list: dashboard_offer_api_list;
    dashboard_benefit_list: dashboard_benefit_list;
    dashboard_benefit_create: dashboard_benefit_create;
    dashboard_benefit_create_compound: dashboard_benefit_create_compound;
    dashboard_benefit_update: dashboard_benefit_update;
    dashboard_benefit_delete: dashboard_benefit_delete;
    dashboard_condition_list: dashboard_condition_list;
    dashboard_condition_create: dashboard_condition_create;
    dashboard_condition_create_compound: dashboard_condition_create_compound;
    dashboard_condition_update: dashboard_condition_update;
    dashboard_condition_delete: dashboard_condition_delete;
    dashboard_offergroup_list: dashboard_offergroup_list;
    dashboard_offergroup_create: dashboard_offergroup_create;
    dashboard_offergroup_update: dashboard_offergroup_update;
    dashboard_offergroup_delete: dashboard_offergroup_delete;
    dashboard_range_list: dashboard_range_list;
    dashboard_range_create: dashboard_range_create;
    dashboard_range_update: dashboard_range_update;
    dashboard_range_delete: dashboard_range_delete;
    dashboard_range_products: dashboard_range_products;
    dashboard_range_reorder: dashboard_range_reorder;
    dashboard_range_prices: dashboard_range_prices;
    dashboard_range_excluded_products: dashboard_range_excluded_products;
    dashboard_reviews_list: dashboard_reviews_list;
    dashboard_reviews_update: dashboard_reviews_update;
    dashboard_reviews_delete: dashboard_reviews_delete;
    dashboard_voucher_list: dashboard_voucher_list;
    dashboard_voucher_create: dashboard_voucher_create;
    dashboard_voucher_update: dashboard_voucher_update;
    dashboard_voucher_delete: dashboard_voucher_delete;
    dashboard_voucher_stats: dashboard_voucher_stats;
    dashboard_voucher_set_list: dashboard_voucher_set_list;
    dashboard_voucher_set_create: dashboard_voucher_set_create;
    dashboard_voucher_set_update: dashboard_voucher_set_update;
    dashboard_voucher_set_detail: dashboard_voucher_set_detail;
    dashboard_voucher_set_download: dashboard_voucher_set_download;
    dashboard_voucher_set_delete: dashboard_voucher_set_delete;
    dashboard_voucher_list_children: dashboard_voucher_list_children;
    dashboard_voucher_add_children: dashboard_voucher_add_children;
    dashboard_voucher_export_children: dashboard_voucher_export_children;
    dashboard_voucher_export_children_file: dashboard_voucher_export_children_file;
    dashboard_voucher_update_suspension_status: dashboard_voucher_update_suspension_status;
    dashboard_comms_list: dashboard_comms_list;
    dashboard_country_list: dashboard_country_list;
    dashboard_country_create: dashboard_country_create;
    dashboard_country_edit: dashboard_country_edit;
    dashboard_country_delete: dashboard_country_delete;
    dashboard_delivery_region_list: dashboard_delivery_region_list;
    dashboard_delivery_region_create: dashboard_delivery_region_create;
    dashboard_delivery_region_edit: dashboard_delivery_region_edit;
    dashboard_delivery_region_delete: dashboard_delivery_region_delete;
    dashboard_delivery_region_group_list: dashboard_delivery_region_group_list;
    dashboard_delivery_region_group_create: dashboard_delivery_region_group_create;
    dashboard_delivery_region_group_edit: dashboard_delivery_region_group_edit;
    dashboard_delivery_region_group_delete: dashboard_delivery_region_group_delete;
    dashboard_shipping_product_class_list: dashboard_shipping_product_class_list;
    dashboard_shipping_product_class_create: dashboard_shipping_product_class_create;
    dashboard_shipping_product_class_edit: dashboard_shipping_product_class_edit;
    dashboard_shipping_product_class_delete: dashboard_shipping_product_class_delete;
    dashboard_shipping_method_list: dashboard_shipping_method_list;
    dashboard_shipping_method_create: dashboard_shipping_method_create;
    dashboard_shipping_method_detail: dashboard_shipping_method_detail;
    dashboard_shipping_method_edit: dashboard_shipping_method_edit;
    dashboard_shipping_method_delete: dashboard_shipping_method_delete;
    dashboard_shipping_method_description_list: dashboard_shipping_method_description_list;
    dashboard_shipping_method_description_create: dashboard_shipping_method_description_create;
    dashboard_shipping_method_description_edit: dashboard_shipping_method_description_edit;
    dashboard_shipping_method_description_delete: dashboard_shipping_method_description_delete;
    dashboard_shipping_price_create: dashboard_shipping_price_create;
    dashboard_shipping_price_edit: dashboard_shipping_price_edit;
    dashboard_shipping_price_delete: dashboard_shipping_price_delete;
    dashboard_shipping_option_list: dashboard_shipping_option_list;
    dashboard_shipping_option_create: dashboard_shipping_option_create;
    dashboard_shipping_option_edit: dashboard_shipping_option_edit;
    dashboard_shipping_option_delete: dashboard_shipping_option_delete;
    dashboard_login: dashboard_login;
    dashboard_logout: dashboard_logout;
    basket_summary: basket_summary;
    basket_add: basket_add;
    basket_vouchers_add: basket_vouchers_add;
    basket_vouchers_remove: basket_vouchers_remove;
    basket_saved: basket_saved;
    basket_configure_gifts: basket_configure_gifts;
    checkout_index: checkout_index;
    checkout_payment_submit: checkout_payment_submit;
    checkout_payment_redirect: checkout_payment_redirect;
    checkout_order_pending: checkout_order_pending;
    checkout_complete_deferred_payment: checkout_complete_deferred_payment;
    checkout_thank_you: checkout_thank_you;
    customer_login: customer_login;
    customer_logout: customer_logout;
    customer_lookup_orders_by_email: customer_lookup_orders_by_email;
    customer_lookup_orders_by_email_confirmation: customer_lookup_orders_by_email_confirmation;
    customer_unified_order_lookup: customer_unified_order_lookup;
    customer_unified_order_status: customer_unified_order_status;
    customer_unified_order_shipment_status: customer_unified_order_shipment_status;
    customer_register: customer_register;
    customer_summary: customer_summary;
    customer_change_password: customer_change_password;
    customer_profile_view: customer_profile_view;
    customer_profile_update: customer_profile_update;
    customer_profile_delete: customer_profile_delete;
    customer_order_list: customer_order_list;
    customer_trs_order_history: customer_trs_order_history;
    customer_anon_order: customer_anon_order;
    customer_order: customer_order;
    customer_review_order_products: customer_review_order_products;
    customer_order_shipment_tracking: customer_order_shipment_tracking;
    customer_order_line: customer_order_line;
    customer_address_list: customer_address_list;
    customer_address_create: customer_address_create;
    customer_address_detail: customer_address_detail;
    customer_address_delete: customer_address_delete;
    customer_email_list: customer_email_list;
    customer_email_detail: customer_email_detail;
    customer_notifications_inbox: customer_notifications_inbox;
    customer_notifications_archive: customer_notifications_archive;
    customer_notifications_update: customer_notifications_update;
    customer_notifications_detail: customer_notifications_detail;
    customer_alerts_list: customer_alerts_list;
    customer_alert_create: customer_alert_create;
    customer_alerts_confirm: customer_alerts_confirm;
    customer_alerts_cancel_by_key: customer_alerts_cancel_by_key;
    customer_alerts_cancel_by_pk: customer_alerts_cancel_by_pk;
    customer_wishlists_list: customer_wishlists_list;
    customer_wishlists_add_product: customer_wishlists_add_product;
    customer_wishlists_create: customer_wishlists_create;
    customer_wishlists_create_with_product: customer_wishlists_create_with_product;
    customer_wishlists_detail: customer_wishlists_detail;
    customer_wishlists_update: customer_wishlists_update;
    customer_wishlists_delete: customer_wishlists_delete;
    customer_wishlists_remove_product: customer_wishlists_remove_product;
    customer_wishlists_move_product_to_another: customer_wishlists_move_product_to_another;
    catalogue_reviews_detail: catalogue_reviews_detail;
    catalogue_reviews_add: catalogue_reviews_add;
    catalogue_reviews_vote: catalogue_reviews_vote;
    catalogue_reviews_list: catalogue_reviews_list;
    catalogue_index: catalogue_index;
    search_search: search_search;
    offer_list: offer_list;
    loadup_submit_request: loadup_submit_request;
    loadup_request_confirmation: loadup_request_confirmation;
    password_reset: password_reset;
    password_reset_done: password_reset_done;
    password_reset_confirm: password_reset_confirm;
    password_reset_complete: password_reset_complete;
    wagtaildocs_authenticate_with_password: wagtaildocs_authenticate_with_password;
    search: search;
    location_directory_state_list: location_directory_state_list;
    location_directory_city_list: location_directory_city_list;
    location_directory_store_list: location_directory_store_list;
    location_directory_store_detail: location_directory_store_detail;
    cms_nav_iframe: cms_nav_iframe;
    cms_footer_iframe: cms_footer_iframe;
    cms_iframe_test: cms_iframe_test;
    shop_tile: shop_tile;
    html_sitemap: html_sitemap;
    wagtailcore_authenticate_with_password: wagtailcore_authenticate_with_password;
    wagtailcore_login: wagtailcore_login;
    __reactivated_do_not_use: __reactivated_do_not_use;
    __reactivated_do_not_use_args: __reactivated_do_not_use_args;
}

interface wagtailapi_pages_listing {
    name: 'wagtailapi:pages:listing';
    args: wagtailapi_pages_listing_args;
}

interface wagtailapi_pages_listing_args {
}

interface wagtailapi_pages_detail {
    name: 'wagtailapi:pages:detail';
    args: wagtailapi_pages_detail_args;
}

interface wagtailapi_pages_detail_args {
    pk: number;
}

interface wagtailapi_pages_find {
    name: 'wagtailapi:pages:find';
    args: wagtailapi_pages_find_args;
}

interface wagtailapi_pages_find_args {
}

interface wagtailapi_images_listing {
    name: 'wagtailapi:images:listing';
    args: wagtailapi_images_listing_args;
}

interface wagtailapi_images_listing_args {
}

interface wagtailapi_images_detail {
    name: 'wagtailapi:images:detail';
    args: wagtailapi_images_detail_args;
}

interface wagtailapi_images_detail_args {
    pk: number;
}

interface wagtailapi_images_find {
    name: 'wagtailapi:images:find';
    args: wagtailapi_images_find_args;
}

interface wagtailapi_images_find_args {
}

interface wagtailapi_documents_listing {
    name: 'wagtailapi:documents:listing';
    args: wagtailapi_documents_listing_args;
}

interface wagtailapi_documents_listing_args {
}

interface wagtailapi_documents_detail {
    name: 'wagtailapi:documents:detail';
    args: wagtailapi_documents_detail_args;
}

interface wagtailapi_documents_detail_args {
    pk: number;
}

interface wagtailapi_documents_find {
    name: 'wagtailapi:documents:find';
    args: wagtailapi_documents_find_args;
}

interface wagtailapi_documents_find_args {
}

interface wagtailapi_flagship_pages_listing {
    name: 'wagtailapi:flagship-pages:listing';
    args: wagtailapi_flagship_pages_listing_args;
}

interface wagtailapi_flagship_pages_listing_args {
}

interface wagtailapi_flagship_pages_detail {
    name: 'wagtailapi:flagship-pages:detail';
    args: wagtailapi_flagship_pages_detail_args;
}

interface wagtailapi_flagship_pages_detail_args {
    pk: number;
}

interface wagtailapi_flagship_pages_find {
    name: 'wagtailapi:flagship-pages:find';
    args: wagtailapi_flagship_pages_find_args;
}

interface wagtailapi_flagship_pages_find_args {
}

interface wagtailapi_social_listing {
    name: 'wagtailapi:social:listing';
    args: wagtailapi_social_listing_args;
}

interface wagtailapi_social_listing_args {
}

interface wagtailapi_social_detail {
    name: 'wagtailapi:social:detail';
    args: wagtailapi_social_detail_args;
}

interface wagtailapi_social_detail_args {
    pk: number;
}

interface wagtailapi_social_find {
    name: 'wagtailapi:social:find';
    args: wagtailapi_social_find_args;
}

interface wagtailapi_social_find_args {
}

interface oidc_authentication_callback {
    name: 'oidc_authentication_callback';
    args: oidc_authentication_callback_args;
}

interface oidc_authentication_callback_args {
}

interface oidc_authentication_init {
    name: 'oidc_authentication_init';
    args: oidc_authentication_init_args;
}

interface oidc_authentication_init_args {
}

interface oidc_logout {
    name: 'oidc_logout';
    args: oidc_logout_args;
}

interface oidc_logout_args {
}

interface health_check_health_check_home {
    name: 'health_check:health_check_home';
    args: health_check_health_check_home_args;
}

interface health_check_health_check_home_args {
}

interface health_check_health_check_subset {
    name: 'health_check:health_check_subset';
    args: health_check_health_check_subset_args;
}

interface health_check_health_check_subset_args {
    subset: string;
}

interface download_periodic_report {
    name: 'download-periodic-report';
    args: download_periodic_report_args;
}

interface download_periodic_report_args {
    key: string;
    filename: string;
}

interface wagtailadmin_home {
    name: 'wagtailadmin_home';
    args: wagtailadmin_home_args;
}

interface wagtailadmin_home_args {
}

interface wagtailadmin_api_pages_listing {
    name: 'wagtailadmin_api:pages:listing';
    args: wagtailadmin_api_pages_listing_args;
}

interface wagtailadmin_api_pages_listing_args {
}

interface wagtailadmin_api_pages_detail {
    name: 'wagtailadmin_api:pages:detail';
    args: wagtailadmin_api_pages_detail_args;
}

interface wagtailadmin_api_pages_detail_args {
    pk: number;
}

interface wagtailadmin_api_pages_find {
    name: 'wagtailadmin_api:pages:find';
    args: wagtailadmin_api_pages_find_args;
}

interface wagtailadmin_api_pages_find_args {
}

interface wagtailadmin_api_pages_action {
    name: 'wagtailadmin_api:pages:action';
    args: wagtailadmin_api_pages_action_args;
}

interface wagtailadmin_api_pages_action_args {
    pk: number;
    action_name: string;
}

interface wagtailadmin_api_documents_listing {
    name: 'wagtailadmin_api:documents:listing';
    args: wagtailadmin_api_documents_listing_args;
}

interface wagtailadmin_api_documents_listing_args {
}

interface wagtailadmin_api_documents_detail {
    name: 'wagtailadmin_api:documents:detail';
    args: wagtailadmin_api_documents_detail_args;
}

interface wagtailadmin_api_documents_detail_args {
    pk: number;
}

interface wagtailadmin_api_documents_find {
    name: 'wagtailadmin_api:documents:find';
    args: wagtailadmin_api_documents_find_args;
}

interface wagtailadmin_api_documents_find_args {
}

interface wagtailadmin_api_images_listing {
    name: 'wagtailadmin_api:images:listing';
    args: wagtailadmin_api_images_listing_args;
}

interface wagtailadmin_api_images_listing_args {
}

interface wagtailadmin_api_images_detail {
    name: 'wagtailadmin_api:images:detail';
    args: wagtailadmin_api_images_detail_args;
}

interface wagtailadmin_api_images_detail_args {
    pk: number;
}

interface wagtailadmin_api_images_find {
    name: 'wagtailadmin_api:images:find';
    args: wagtailadmin_api_images_find_args;
}

interface wagtailadmin_api_images_find_args {
}

interface wagtailadmin_error_test {
    name: 'wagtailadmin_error_test';
    args: wagtailadmin_error_test_args;
}

interface wagtailadmin_error_test_args {
}

interface wagtailadmin_explore_root {
    name: 'wagtailadmin_explore_root';
    args: wagtailadmin_explore_root_args;
}

interface wagtailadmin_explore_root_args {
}

interface wagtailadmin_explore {
    name: 'wagtailadmin_explore';
    args: wagtailadmin_explore_args;
}

interface wagtailadmin_explore_args {
    parent_page_id: number;
}

interface wagtailadmin_explore_results {
    name: 'wagtailadmin_explore_results';
    args: wagtailadmin_explore_results_args;
}

interface wagtailadmin_explore_results_args {
    parent_page_id: number;
}

interface wagtail_bulk_action {
    name: 'wagtail_bulk_action';
    args: wagtail_bulk_action_args;
}

interface wagtail_bulk_action_args {
    app_label: string;
    model_name: string;
    action: string;
}

interface wagtailadmin_pages_add {
    name: 'wagtailadmin_pages:add';
    args: wagtailadmin_pages_add_args;
}

interface wagtailadmin_pages_add_args {
    content_type_app_name: string;
    content_type_model_name: string;
    parent_page_id: number;
}

interface wagtailadmin_pages_preview_on_add {
    name: 'wagtailadmin_pages:preview_on_add';
    args: wagtailadmin_pages_preview_on_add_args;
}

interface wagtailadmin_pages_preview_on_add_args {
    content_type_app_name: string;
    content_type_model_name: string;
    parent_page_id: number;
}

interface wagtailadmin_pages_type_use {
    name: 'wagtailadmin_pages:type_use';
    args: wagtailadmin_pages_type_use_args;
}

interface wagtailadmin_pages_type_use_args {
    content_type_app_name: string;
    content_type_model_name: string;
}

interface wagtailadmin_pages_type_use_results {
    name: 'wagtailadmin_pages:type_use_results';
    args: wagtailadmin_pages_type_use_results_args;
}

interface wagtailadmin_pages_type_use_results_args {
    content_type_app_name: string;
    content_type_model_name: string;
}

interface wagtailadmin_pages_usage {
    name: 'wagtailadmin_pages:usage';
    args: wagtailadmin_pages_usage_args;
}

interface wagtailadmin_pages_usage_args {
    page_id: number;
}

interface wagtailadmin_pages_edit {
    name: 'wagtailadmin_pages:edit';
    args: wagtailadmin_pages_edit_args;
}

interface wagtailadmin_pages_edit_args {
    page_id: number;
}

interface wagtailadmin_pages_preview_on_edit {
    name: 'wagtailadmin_pages:preview_on_edit';
    args: wagtailadmin_pages_preview_on_edit_args;
}

interface wagtailadmin_pages_preview_on_edit_args {
    page_id: number;
}

interface wagtailadmin_pages_view_draft {
    name: 'wagtailadmin_pages:view_draft';
    args: wagtailadmin_pages_view_draft_args;
}

interface wagtailadmin_pages_view_draft_args {
    page_id: number;
}

interface wagtailadmin_pages_add_subpage {
    name: 'wagtailadmin_pages:add_subpage';
    args: wagtailadmin_pages_add_subpage_args;
}

interface wagtailadmin_pages_add_subpage_args {
    parent_page_id: number;
}

interface wagtailadmin_pages_delete {
    name: 'wagtailadmin_pages:delete';
    args: wagtailadmin_pages_delete_args;
}

interface wagtailadmin_pages_delete_args {
    page_id: number;
}

interface wagtailadmin_pages_unpublish {
    name: 'wagtailadmin_pages:unpublish';
    args: wagtailadmin_pages_unpublish_args;
}

interface wagtailadmin_pages_unpublish_args {
    page_id: number;
}

interface wagtailadmin_pages_convert_alias {
    name: 'wagtailadmin_pages:convert_alias';
    args: wagtailadmin_pages_convert_alias_args;
}

interface wagtailadmin_pages_convert_alias_args {
    page_id: number;
}

interface wagtailadmin_pages_search {
    name: 'wagtailadmin_pages:search';
    args: wagtailadmin_pages_search_args;
}

interface wagtailadmin_pages_search_args {
}

interface wagtailadmin_pages_search_results {
    name: 'wagtailadmin_pages:search_results';
    args: wagtailadmin_pages_search_results_args;
}

interface wagtailadmin_pages_search_results_args {
}

interface wagtailadmin_pages_move {
    name: 'wagtailadmin_pages:move';
    args: wagtailadmin_pages_move_args;
}

interface wagtailadmin_pages_move_args {
    page_to_move_id: number;
}

interface wagtailadmin_pages_move_confirm {
    name: 'wagtailadmin_pages:move_confirm';
    args: wagtailadmin_pages_move_confirm_args;
}

interface wagtailadmin_pages_move_confirm_args {
    page_to_move_id: number;
    destination_id: number;
}

interface wagtailadmin_pages_set_page_position {
    name: 'wagtailadmin_pages:set_page_position';
    args: wagtailadmin_pages_set_page_position_args;
}

interface wagtailadmin_pages_set_page_position_args {
    page_to_move_id: number;
}

interface wagtailadmin_pages_copy {
    name: 'wagtailadmin_pages:copy';
    args: wagtailadmin_pages_copy_args;
}

interface wagtailadmin_pages_copy_args {
    page_id: number;
}

interface wagtailadmin_pages_workflow_action {
    name: 'wagtailadmin_pages:workflow_action';
    args: wagtailadmin_pages_workflow_action_args;
}

interface wagtailadmin_pages_workflow_action_args {
    page_id: number;
    action_name: string;
    task_state_id: number;
}

interface wagtailadmin_pages_collect_workflow_action_data {
    name: 'wagtailadmin_pages:collect_workflow_action_data';
    args: wagtailadmin_pages_collect_workflow_action_data_args;
}

interface wagtailadmin_pages_collect_workflow_action_data_args {
    page_id: number;
    action_name: string;
    task_state_id: number;
}

interface wagtailadmin_pages_confirm_workflow_cancellation {
    name: 'wagtailadmin_pages:confirm_workflow_cancellation';
    args: wagtailadmin_pages_confirm_workflow_cancellation_args;
}

interface wagtailadmin_pages_confirm_workflow_cancellation_args {
    page_id: number;
}

interface wagtailadmin_pages_workflow_preview {
    name: 'wagtailadmin_pages:workflow_preview';
    args: wagtailadmin_pages_workflow_preview_args;
}

interface wagtailadmin_pages_workflow_preview_args {
    page_id: number;
    task_id: number;
}

interface wagtailadmin_pages_set_privacy {
    name: 'wagtailadmin_pages:set_privacy';
    args: wagtailadmin_pages_set_privacy_args;
}

interface wagtailadmin_pages_set_privacy_args {
    page_id: number;
}

interface wagtailadmin_pages_lock {
    name: 'wagtailadmin_pages:lock';
    args: wagtailadmin_pages_lock_args;
}

interface wagtailadmin_pages_lock_args {
    page_id: number;
}

interface wagtailadmin_pages_unlock {
    name: 'wagtailadmin_pages:unlock';
    args: wagtailadmin_pages_unlock_args;
}

interface wagtailadmin_pages_unlock_args {
    page_id: number;
}

interface wagtailadmin_pages_revisions_index {
    name: 'wagtailadmin_pages:revisions_index';
    args: wagtailadmin_pages_revisions_index_args;
}

interface wagtailadmin_pages_revisions_index_args {
    page_id: number;
}

interface wagtailadmin_pages_revisions_view {
    name: 'wagtailadmin_pages:revisions_view';
    args: wagtailadmin_pages_revisions_view_args;
}

interface wagtailadmin_pages_revisions_view_args {
    page_id: number;
    revision_id: number;
}

interface wagtailadmin_pages_revisions_revert {
    name: 'wagtailadmin_pages:revisions_revert';
    args: wagtailadmin_pages_revisions_revert_args;
}

interface wagtailadmin_pages_revisions_revert_args {
    page_id: number;
    revision_id: number;
}

interface wagtailadmin_pages_revisions_unschedule {
    name: 'wagtailadmin_pages:revisions_unschedule';
    args: wagtailadmin_pages_revisions_unschedule_args;
}

interface wagtailadmin_pages_revisions_unschedule_args {
    page_id: number;
    revision_id: number;
}

interface wagtailadmin_pages_workflow_history {
    name: 'wagtailadmin_pages:workflow_history';
    args: wagtailadmin_pages_workflow_history_args;
}

interface wagtailadmin_pages_workflow_history_args {
    page_id: number;
}

interface wagtailadmin_pages_workflow_history_detail {
    name: 'wagtailadmin_pages:workflow_history_detail';
    args: wagtailadmin_pages_workflow_history_detail_args;
}

interface wagtailadmin_pages_workflow_history_detail_args {
    page_id: number;
    workflow_state_id: number;
}

interface wagtailadmin_pages_history {
    name: 'wagtailadmin_pages:history';
    args: wagtailadmin_pages_history_args;
}

interface wagtailadmin_pages_history_args {
    page_id: number;
}

interface wagtailadmin_pages_history_results {
    name: 'wagtailadmin_pages:history_results';
    args: wagtailadmin_pages_history_results_args;
}

interface wagtailadmin_pages_history_results_args {
    page_id: number;
}

interface wagtailadmin_choose_page {
    name: 'wagtailadmin_choose_page';
    args: wagtailadmin_choose_page_args;
}

interface wagtailadmin_choose_page_args {
}

interface wagtailadmin_choose_page_child {
    name: 'wagtailadmin_choose_page_child';
    args: wagtailadmin_choose_page_child_args;
}

interface wagtailadmin_choose_page_child_args {
    parent_page_id: number;
}

interface wagtailadmin_choose_page_search {
    name: 'wagtailadmin_choose_page_search';
    args: wagtailadmin_choose_page_search_args;
}

interface wagtailadmin_choose_page_search_args {
}

interface wagtailadmin_choose_page_chosen_multiple {
    name: 'wagtailadmin_choose_page_chosen_multiple';
    args: wagtailadmin_choose_page_chosen_multiple_args;
}

interface wagtailadmin_choose_page_chosen_multiple_args {
}

interface wagtailadmin_choose_page_external_link {
    name: 'wagtailadmin_choose_page_external_link';
    args: wagtailadmin_choose_page_external_link_args;
}

interface wagtailadmin_choose_page_external_link_args {
}

interface wagtailadmin_choose_page_email_link {
    name: 'wagtailadmin_choose_page_email_link';
    args: wagtailadmin_choose_page_email_link_args;
}

interface wagtailadmin_choose_page_email_link_args {
}

interface wagtailadmin_choose_page_phone_link {
    name: 'wagtailadmin_choose_page_phone_link';
    args: wagtailadmin_choose_page_phone_link_args;
}

interface wagtailadmin_choose_page_phone_link_args {
}

interface wagtailadmin_choose_page_anchor_link {
    name: 'wagtailadmin_choose_page_anchor_link';
    args: wagtailadmin_choose_page_anchor_link_args;
}

interface wagtailadmin_choose_page_anchor_link_args {
}

interface wagtailadmin_tag_autocomplete {
    name: 'wagtailadmin_tag_autocomplete';
    args: wagtailadmin_tag_autocomplete_args;
}

interface wagtailadmin_tag_autocomplete_args {
}

interface wagtailadmin_tag_model_autocomplete {
    name: 'wagtailadmin_tag_model_autocomplete';
    args: wagtailadmin_tag_model_autocomplete_args;
}

interface wagtailadmin_tag_model_autocomplete_args {
    app_name: string;
    model_name: string;
}

interface wagtailadmin_collections_index {
    name: 'wagtailadmin_collections:index';
    args: wagtailadmin_collections_index_args;
}

interface wagtailadmin_collections_index_args {
}

interface wagtailadmin_collections_add {
    name: 'wagtailadmin_collections:add';
    args: wagtailadmin_collections_add_args;
}

interface wagtailadmin_collections_add_args {
}

interface wagtailadmin_collections_edit {
    name: 'wagtailadmin_collections:edit';
    args: wagtailadmin_collections_edit_args;
}

interface wagtailadmin_collections_edit_args {
    pk: number;
}

interface wagtailadmin_collections_delete {
    name: 'wagtailadmin_collections:delete';
    args: wagtailadmin_collections_delete_args;
}

interface wagtailadmin_collections_delete_args {
    pk: number;
}

interface wagtailadmin_collections_set_privacy {
    name: 'wagtailadmin_collections:set_privacy';
    args: wagtailadmin_collections_set_privacy_args;
}

interface wagtailadmin_collections_set_privacy_args {
    collection_id: number;
}

interface wagtailadmin_workflows_index {
    name: 'wagtailadmin_workflows:index';
    args: wagtailadmin_workflows_index_args;
}

interface wagtailadmin_workflows_index_args {
}

interface wagtailadmin_workflows_index_results {
    name: 'wagtailadmin_workflows:index_results';
    args: wagtailadmin_workflows_index_results_args;
}

interface wagtailadmin_workflows_index_results_args {
}

interface wagtailadmin_workflows_add {
    name: 'wagtailadmin_workflows:add';
    args: wagtailadmin_workflows_add_args;
}

interface wagtailadmin_workflows_add_args {
}

interface wagtailadmin_workflows_enable {
    name: 'wagtailadmin_workflows:enable';
    args: wagtailadmin_workflows_enable_args;
}

interface wagtailadmin_workflows_enable_args {
    pk: number;
}

interface wagtailadmin_workflows_disable {
    name: 'wagtailadmin_workflows:disable';
    args: wagtailadmin_workflows_disable_args;
}

interface wagtailadmin_workflows_disable_args {
    pk: number;
}

interface wagtailadmin_workflows_edit {
    name: 'wagtailadmin_workflows:edit';
    args: wagtailadmin_workflows_edit_args;
}

interface wagtailadmin_workflows_edit_args {
    pk: number;
}

interface wagtailadmin_workflows_usage {
    name: 'wagtailadmin_workflows:usage';
    args: wagtailadmin_workflows_usage_args;
}

interface wagtailadmin_workflows_usage_args {
    pk: number;
}

interface wagtailadmin_workflows_usage_results {
    name: 'wagtailadmin_workflows:usage_results';
    args: wagtailadmin_workflows_usage_results_args;
}

interface wagtailadmin_workflows_usage_results_args {
    pk: number;
}

interface wagtailadmin_workflows_remove {
    name: 'wagtailadmin_workflows:remove';
    args: wagtailadmin_workflows_remove_args;
}

interface wagtailadmin_workflows_remove_args {
    page_pk: number;
    workflow_pk: number;
}

interface wagtailadmin_workflows_add_task {
    name: 'wagtailadmin_workflows:add_task';
    args: wagtailadmin_workflows_add_task_args;
}

interface wagtailadmin_workflows_add_task_args {
    app_label: string;
    model_name: string;
}

interface wagtailadmin_workflows_select_task_type {
    name: 'wagtailadmin_workflows:select_task_type';
    args: wagtailadmin_workflows_select_task_type_args;
}

interface wagtailadmin_workflows_select_task_type_args {
}

interface wagtailadmin_workflows_task_index {
    name: 'wagtailadmin_workflows:task_index';
    args: wagtailadmin_workflows_task_index_args;
}

interface wagtailadmin_workflows_task_index_args {
}

interface wagtailadmin_workflows_task_index_results {
    name: 'wagtailadmin_workflows:task_index_results';
    args: wagtailadmin_workflows_task_index_results_args;
}

interface wagtailadmin_workflows_task_index_results_args {
}

interface wagtailadmin_workflows_edit_task {
    name: 'wagtailadmin_workflows:edit_task';
    args: wagtailadmin_workflows_edit_task_args;
}

interface wagtailadmin_workflows_edit_task_args {
    pk: number;
}

interface wagtailadmin_workflows_disable_task {
    name: 'wagtailadmin_workflows:disable_task';
    args: wagtailadmin_workflows_disable_task_args;
}

interface wagtailadmin_workflows_disable_task_args {
    pk: number;
}

interface wagtailadmin_workflows_enable_task {
    name: 'wagtailadmin_workflows:enable_task';
    args: wagtailadmin_workflows_enable_task_args;
}

interface wagtailadmin_workflows_enable_task_args {
    pk: number;
}

interface wagtailadmin_workflows_task_chooser {
    name: 'wagtailadmin_workflows:task_chooser';
    args: wagtailadmin_workflows_task_chooser_args;
}

interface wagtailadmin_workflows_task_chooser_args {
}

interface wagtailadmin_workflows_task_chooser_results {
    name: 'wagtailadmin_workflows:task_chooser_results';
    args: wagtailadmin_workflows_task_chooser_results_args;
}

interface wagtailadmin_workflows_task_chooser_results_args {
}

interface wagtailadmin_workflows_task_chooser_create {
    name: 'wagtailadmin_workflows:task_chooser_create';
    args: wagtailadmin_workflows_task_chooser_create_args;
}

interface wagtailadmin_workflows_task_chooser_create_args {
}

interface wagtailadmin_workflows_task_chosen {
    name: 'wagtailadmin_workflows:task_chosen';
    args: wagtailadmin_workflows_task_chosen_args;
}

interface wagtailadmin_workflows_task_chosen_args {
    task_id: number;
}

interface wagtailadmin_reports_locked_pages {
    name: 'wagtailadmin_reports:locked_pages';
    args: wagtailadmin_reports_locked_pages_args;
}

interface wagtailadmin_reports_locked_pages_args {
}

interface wagtailadmin_reports_locked_pages_results {
    name: 'wagtailadmin_reports:locked_pages_results';
    args: wagtailadmin_reports_locked_pages_results_args;
}

interface wagtailadmin_reports_locked_pages_results_args {
}

interface wagtailadmin_reports_workflow {
    name: 'wagtailadmin_reports:workflow';
    args: wagtailadmin_reports_workflow_args;
}

interface wagtailadmin_reports_workflow_args {
}

interface wagtailadmin_reports_workflow_results {
    name: 'wagtailadmin_reports:workflow_results';
    args: wagtailadmin_reports_workflow_results_args;
}

interface wagtailadmin_reports_workflow_results_args {
}

interface wagtailadmin_reports_workflow_tasks {
    name: 'wagtailadmin_reports:workflow_tasks';
    args: wagtailadmin_reports_workflow_tasks_args;
}

interface wagtailadmin_reports_workflow_tasks_args {
}

interface wagtailadmin_reports_workflow_tasks_results {
    name: 'wagtailadmin_reports:workflow_tasks_results';
    args: wagtailadmin_reports_workflow_tasks_results_args;
}

interface wagtailadmin_reports_workflow_tasks_results_args {
}

interface wagtailadmin_reports_site_history {
    name: 'wagtailadmin_reports:site_history';
    args: wagtailadmin_reports_site_history_args;
}

interface wagtailadmin_reports_site_history_args {
}

interface wagtailadmin_reports_site_history_results {
    name: 'wagtailadmin_reports:site_history_results';
    args: wagtailadmin_reports_site_history_results_args;
}

interface wagtailadmin_reports_site_history_results_args {
}

interface wagtailadmin_reports_aging_pages {
    name: 'wagtailadmin_reports:aging_pages';
    args: wagtailadmin_reports_aging_pages_args;
}

interface wagtailadmin_reports_aging_pages_args {
}

interface wagtailadmin_reports_aging_pages_results {
    name: 'wagtailadmin_reports:aging_pages_results';
    args: wagtailadmin_reports_aging_pages_results_args;
}

interface wagtailadmin_reports_aging_pages_results_args {
}

interface wagtailadmin_reports_page_types_usage {
    name: 'wagtailadmin_reports:page_types_usage';
    args: wagtailadmin_reports_page_types_usage_args;
}

interface wagtailadmin_reports_page_types_usage_args {
}

interface wagtailadmin_reports_page_types_usage_results {
    name: 'wagtailadmin_reports:page_types_usage_results';
    args: wagtailadmin_reports_page_types_usage_results_args;
}

interface wagtailadmin_reports_page_types_usage_results_args {
}

interface wagtailadmin_account {
    name: 'wagtailadmin_account';
    args: wagtailadmin_account_args;
}

interface wagtailadmin_account_args {
}

interface wagtailadmin_logout {
    name: 'wagtailadmin_logout';
    args: wagtailadmin_logout_args;
}

interface wagtailadmin_logout_args {
}

interface wagtailadmin_dismissibles {
    name: 'wagtailadmin_dismissibles';
    args: wagtailadmin_dismissibles_args;
}

interface wagtailadmin_dismissibles_args {
}

interface wagtailadmin_editing_sessions_ping {
    name: 'wagtailadmin_editing_sessions:ping';
    args: wagtailadmin_editing_sessions_ping_args;
}

interface wagtailadmin_editing_sessions_ping_args {
    app_label: string;
    model_name: string;
    object_id: string;
    session_id: number;
}

interface wagtailadmin_editing_sessions_release {
    name: 'wagtailadmin_editing_sessions:release';
    args: wagtailadmin_editing_sessions_release_args;
}

interface wagtailadmin_editing_sessions_release_args {
    session_id: number;
}

interface wagtailadmin_block_preview {
    name: 'wagtailadmin_block_preview';
    args: wagtailadmin_block_preview_args;
}

interface wagtailadmin_block_preview_args {
}

interface wagtailvideos_add {
    name: 'wagtailvideos:add';
    args: wagtailvideos_add_args;
}

interface wagtailvideos_add_args {
}

interface wagtailvideos_add_multiple {
    name: 'wagtailvideos:add_multiple';
    args: wagtailvideos_add_multiple_args;
}

interface wagtailvideos_add_multiple_args {
}

interface wagtailvideos_edit_multiple {
    name: 'wagtailvideos:edit_multiple';
    args: wagtailvideos_edit_multiple_args;
}

interface wagtailvideos_edit_multiple_args {
    video_id: number;
}

interface wagtailvideos_create_multiple_from_uploaded_image {
    name: 'wagtailvideos:create_multiple_from_uploaded_image';
    args: wagtailvideos_create_multiple_from_uploaded_image_args;
}

interface wagtailvideos_create_multiple_from_uploaded_image_args {
    uploaded_file_id: number;
}

interface wagtailvideos_delete_multiple {
    name: 'wagtailvideos:delete_multiple';
    args: wagtailvideos_delete_multiple_args;
}

interface wagtailvideos_delete_multiple_args {
    video_id: number;
}

interface wagtailvideos_delete_upload_multiple {
    name: 'wagtailvideos:delete_upload_multiple';
    args: wagtailvideos_delete_upload_multiple_args;
}

interface wagtailvideos_delete_upload_multiple_args {
    uploaded_file_id: number;
}

interface wagtailvideos_index {
    name: 'wagtailvideos:index';
    args: wagtailvideos_index_args;
}

interface wagtailvideos_index_args {
}

interface wagtailvideos_index_results {
    name: 'wagtailvideos:index_results';
    args: wagtailvideos_index_results_args;
}

interface wagtailvideos_index_results_args {
}

interface wagtailsettings_edit {
    name: 'wagtailsettings:edit';
    args: wagtailsettings_edit_args;
}

interface wagtailsettings_edit_args {
    app_name: string;
    model_name: string;
    pk: number;
}

interface wagtailsnippets_wagtail_links_link_list {
    name: 'wagtailsnippets_wagtail_links_link:list';
    args: wagtailsnippets_wagtail_links_link_list_args;
}

interface wagtailsnippets_wagtail_links_link_list_args {
}

interface wagtailsnippets_wagtail_links_link_list_results {
    name: 'wagtailsnippets_wagtail_links_link:list_results';
    args: wagtailsnippets_wagtail_links_link_list_results_args;
}

interface wagtailsnippets_wagtail_links_link_list_results_args {
}

interface wagtailsnippets_wagtail_links_link_add {
    name: 'wagtailsnippets_wagtail_links_link:add';
    args: wagtailsnippets_wagtail_links_link_add_args;
}

interface wagtailsnippets_wagtail_links_link_add_args {
}

interface wagtailsnippets_wagtail_links_link_edit {
    name: 'wagtailsnippets_wagtail_links_link:edit';
    args: wagtailsnippets_wagtail_links_link_edit_args;
}

interface wagtailsnippets_wagtail_links_link_edit_args {
    pk: string;
}

interface wagtailsnippets_wagtail_links_link_delete {
    name: 'wagtailsnippets_wagtail_links_link:delete';
    args: wagtailsnippets_wagtail_links_link_delete_args;
}

interface wagtailsnippets_wagtail_links_link_delete_args {
    pk: string;
}

interface wagtailsnippets_wagtail_links_link_usage {
    name: 'wagtailsnippets_wagtail_links_link:usage';
    args: wagtailsnippets_wagtail_links_link_usage_args;
}

interface wagtailsnippets_wagtail_links_link_usage_args {
    pk: string;
}

interface wagtailsnippets_wagtail_links_link_history {
    name: 'wagtailsnippets_wagtail_links_link:history';
    args: wagtailsnippets_wagtail_links_link_history_args;
}

interface wagtailsnippets_wagtail_links_link_history_args {
    pk: string;
}

interface wagtailsnippets_wagtail_links_link_history_results {
    name: 'wagtailsnippets_wagtail_links_link:history_results';
    args: wagtailsnippets_wagtail_links_link_history_results_args;
}

interface wagtailsnippets_wagtail_links_link_history_results_args {
    pk: string;
}

interface wagtailsnippets_wagtail_links_link_copy {
    name: 'wagtailsnippets_wagtail_links_link:copy';
    args: wagtailsnippets_wagtail_links_link_copy_args;
}

interface wagtailsnippets_wagtail_links_link_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_wagtail_links_link_choose {
    name: 'wagtailsnippetchoosers_wagtail_links_link:choose';
    args: wagtailsnippetchoosers_wagtail_links_link_choose_args;
}

interface wagtailsnippetchoosers_wagtail_links_link_choose_args {
}

interface wagtailsnippetchoosers_wagtail_links_link_choose_results {
    name: 'wagtailsnippetchoosers_wagtail_links_link:choose_results';
    args: wagtailsnippetchoosers_wagtail_links_link_choose_results_args;
}

interface wagtailsnippetchoosers_wagtail_links_link_choose_results_args {
}

interface wagtailsnippetchoosers_wagtail_links_link_chosen {
    name: 'wagtailsnippetchoosers_wagtail_links_link:chosen';
    args: wagtailsnippetchoosers_wagtail_links_link_chosen_args;
}

interface wagtailsnippetchoosers_wagtail_links_link_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_wagtail_links_link_chosen_multiple {
    name: 'wagtailsnippetchoosers_wagtail_links_link:chosen_multiple';
    args: wagtailsnippetchoosers_wagtail_links_link_chosen_multiple_args;
}

interface wagtailsnippetchoosers_wagtail_links_link_chosen_multiple_args {
}

interface wagtailsnippetchoosers_wagtail_links_link_create {
    name: 'wagtailsnippetchoosers_wagtail_links_link:create';
    args: wagtailsnippetchoosers_wagtail_links_link_create_args;
}

interface wagtailsnippetchoosers_wagtail_links_link_create_args {
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_list {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchcondition:list';
    args: wagtailsnippets_tsicommon_cms_mattressmatchcondition_list_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_list_args {
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_list_results {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchcondition:list_results';
    args: wagtailsnippets_tsicommon_cms_mattressmatchcondition_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_add {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchcondition:add';
    args: wagtailsnippets_tsicommon_cms_mattressmatchcondition_add_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_add_args {
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_edit {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchcondition:edit';
    args: wagtailsnippets_tsicommon_cms_mattressmatchcondition_edit_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_delete {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchcondition:delete';
    args: wagtailsnippets_tsicommon_cms_mattressmatchcondition_delete_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_usage {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchcondition:usage';
    args: wagtailsnippets_tsicommon_cms_mattressmatchcondition_usage_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_history {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchcondition:history';
    args: wagtailsnippets_tsicommon_cms_mattressmatchcondition_history_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_history_results {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchcondition:history_results';
    args: wagtailsnippets_tsicommon_cms_mattressmatchcondition_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_copy {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchcondition:copy';
    args: wagtailsnippets_tsicommon_cms_mattressmatchcondition_copy_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchcondition_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition:create';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_create_args {
}

interface wagtailsnippets_tsicommon_cms_promoperiod_list {
    name: 'wagtailsnippets_tsicommon_cms_promoperiod:list';
    args: wagtailsnippets_tsicommon_cms_promoperiod_list_args;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_list_args {
}

interface wagtailsnippets_tsicommon_cms_promoperiod_list_results {
    name: 'wagtailsnippets_tsicommon_cms_promoperiod:list_results';
    args: wagtailsnippets_tsicommon_cms_promoperiod_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_promoperiod_add {
    name: 'wagtailsnippets_tsicommon_cms_promoperiod:add';
    args: wagtailsnippets_tsicommon_cms_promoperiod_add_args;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_add_args {
}

interface wagtailsnippets_tsicommon_cms_promoperiod_edit {
    name: 'wagtailsnippets_tsicommon_cms_promoperiod:edit';
    args: wagtailsnippets_tsicommon_cms_promoperiod_edit_args;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_delete {
    name: 'wagtailsnippets_tsicommon_cms_promoperiod:delete';
    args: wagtailsnippets_tsicommon_cms_promoperiod_delete_args;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_usage {
    name: 'wagtailsnippets_tsicommon_cms_promoperiod:usage';
    args: wagtailsnippets_tsicommon_cms_promoperiod_usage_args;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_history {
    name: 'wagtailsnippets_tsicommon_cms_promoperiod:history';
    args: wagtailsnippets_tsicommon_cms_promoperiod_history_args;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_history_results {
    name: 'wagtailsnippets_tsicommon_cms_promoperiod:history_results';
    args: wagtailsnippets_tsicommon_cms_promoperiod_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_copy {
    name: 'wagtailsnippets_tsicommon_cms_promoperiod:copy';
    args: wagtailsnippets_tsicommon_cms_promoperiod_copy_args;
}

interface wagtailsnippets_tsicommon_cms_promoperiod_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_promoperiod_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_promoperiod:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_promoperiod_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_promoperiod_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_promoperiod_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_promoperiod:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_promoperiod_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_promoperiod_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_promoperiod_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_promoperiod:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_promoperiod_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_promoperiod_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_promoperiod_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_promoperiod:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_promoperiod_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_promoperiod_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_promoperiod_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_promoperiod:create';
    args: wagtailsnippetchoosers_tsicommon_cms_promoperiod_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_promoperiod_create_args {
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_list {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchresult:list';
    args: wagtailsnippets_tsicommon_cms_mattressmatchresult_list_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_list_args {
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_list_results {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchresult:list_results';
    args: wagtailsnippets_tsicommon_cms_mattressmatchresult_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_add {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchresult:add';
    args: wagtailsnippets_tsicommon_cms_mattressmatchresult_add_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_add_args {
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_edit {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchresult:edit';
    args: wagtailsnippets_tsicommon_cms_mattressmatchresult_edit_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_delete {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchresult:delete';
    args: wagtailsnippets_tsicommon_cms_mattressmatchresult_delete_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_usage {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchresult:usage';
    args: wagtailsnippets_tsicommon_cms_mattressmatchresult_usage_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_history {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchresult:history';
    args: wagtailsnippets_tsicommon_cms_mattressmatchresult_history_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_history_results {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchresult:history_results';
    args: wagtailsnippets_tsicommon_cms_mattressmatchresult_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_copy {
    name: 'wagtailsnippets_tsicommon_cms_mattressmatchresult:copy';
    args: wagtailsnippets_tsicommon_cms_mattressmatchresult_copy_args;
}

interface wagtailsnippets_tsicommon_cms_mattressmatchresult_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult:create';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_create_args {
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_list {
    name: 'wagtailsnippets_tsicommon_cms_mattressfeel:list';
    args: wagtailsnippets_tsicommon_cms_mattressfeel_list_args;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_list_args {
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_list_results {
    name: 'wagtailsnippets_tsicommon_cms_mattressfeel:list_results';
    args: wagtailsnippets_tsicommon_cms_mattressfeel_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_add {
    name: 'wagtailsnippets_tsicommon_cms_mattressfeel:add';
    args: wagtailsnippets_tsicommon_cms_mattressfeel_add_args;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_add_args {
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_edit {
    name: 'wagtailsnippets_tsicommon_cms_mattressfeel:edit';
    args: wagtailsnippets_tsicommon_cms_mattressfeel_edit_args;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_delete {
    name: 'wagtailsnippets_tsicommon_cms_mattressfeel:delete';
    args: wagtailsnippets_tsicommon_cms_mattressfeel_delete_args;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_usage {
    name: 'wagtailsnippets_tsicommon_cms_mattressfeel:usage';
    args: wagtailsnippets_tsicommon_cms_mattressfeel_usage_args;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_history {
    name: 'wagtailsnippets_tsicommon_cms_mattressfeel:history';
    args: wagtailsnippets_tsicommon_cms_mattressfeel_history_args;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_history_results {
    name: 'wagtailsnippets_tsicommon_cms_mattressfeel:history_results';
    args: wagtailsnippets_tsicommon_cms_mattressfeel_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_copy {
    name: 'wagtailsnippets_tsicommon_cms_mattressfeel:copy';
    args: wagtailsnippets_tsicommon_cms_mattressfeel_copy_args;
}

interface wagtailsnippets_tsicommon_cms_mattressfeel_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressfeel_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressfeel:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressfeel_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressfeel_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressfeel_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressfeel:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressfeel_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressfeel_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressfeel_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressfeel:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressfeel_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressfeel_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressfeel_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressfeel:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressfeel_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressfeel_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressfeel_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_mattressfeel:create';
    args: wagtailsnippetchoosers_tsicommon_cms_mattressfeel_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_mattressfeel_create_args {
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_list {
    name: 'wagtailsnippets_tsicommon_cms_featuredofferscard:list';
    args: wagtailsnippets_tsicommon_cms_featuredofferscard_list_args;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_list_args {
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_list_results {
    name: 'wagtailsnippets_tsicommon_cms_featuredofferscard:list_results';
    args: wagtailsnippets_tsicommon_cms_featuredofferscard_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_add {
    name: 'wagtailsnippets_tsicommon_cms_featuredofferscard:add';
    args: wagtailsnippets_tsicommon_cms_featuredofferscard_add_args;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_add_args {
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_edit {
    name: 'wagtailsnippets_tsicommon_cms_featuredofferscard:edit';
    args: wagtailsnippets_tsicommon_cms_featuredofferscard_edit_args;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_delete {
    name: 'wagtailsnippets_tsicommon_cms_featuredofferscard:delete';
    args: wagtailsnippets_tsicommon_cms_featuredofferscard_delete_args;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_usage {
    name: 'wagtailsnippets_tsicommon_cms_featuredofferscard:usage';
    args: wagtailsnippets_tsicommon_cms_featuredofferscard_usage_args;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_history {
    name: 'wagtailsnippets_tsicommon_cms_featuredofferscard:history';
    args: wagtailsnippets_tsicommon_cms_featuredofferscard_history_args;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_history_results {
    name: 'wagtailsnippets_tsicommon_cms_featuredofferscard:history_results';
    args: wagtailsnippets_tsicommon_cms_featuredofferscard_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_copy {
    name: 'wagtailsnippets_tsicommon_cms_featuredofferscard:copy';
    args: wagtailsnippets_tsicommon_cms_featuredofferscard_copy_args;
}

interface wagtailsnippets_tsicommon_cms_featuredofferscard_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_featuredofferscard:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_featuredofferscard:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_featuredofferscard:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_featuredofferscard:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_featuredofferscard:create';
    args: wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_create_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_list {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:list';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_list_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_list_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_list_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:list_results';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_add {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:add';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_add_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_add_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_edit {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:edit';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_edit_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_delete {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:delete';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_delete_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_usage {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:usage';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_usage_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_history {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:history';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_history_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_history_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:history_results';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_copy {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset:copy';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_copy_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset:create';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_create_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_list {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:list';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_list_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_list_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_list_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:list_results';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_add {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:add';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_add_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_add_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_edit {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:edit';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_edit_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_delete {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:delete';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_delete_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_usage {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:usage';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_usage_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_history {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:history';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_history_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_history_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:history_results';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_copy {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_promocard:copy';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_copy_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard:create';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_create_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_list {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:list';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_list_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_list_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_list_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:list_results';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_add {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:add';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_add_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_add_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_edit {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:edit';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_edit_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_delete {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:delete';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_delete_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_usage {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:usage';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_usage_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_history {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:history';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_history_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_history_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:history_results';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_copy {
    name: 'wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal:copy';
    args: wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_copy_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal:create';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_create_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_list {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:list';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_list_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_list_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_list_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:list_results';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_add {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:add';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_add_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_add_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_edit {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:edit';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_edit_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_delete {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:delete';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_delete_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_usage {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:usage';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_usage_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_history {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:history';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_history_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_history_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:history_results';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_copy {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage:copy';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_copy_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage:create';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_create_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_list {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:list';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_list_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_list_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_list_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:list_results';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_add {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:add';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_add_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_add_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_edit {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:edit';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_edit_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_delete {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:delete';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_delete_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_usage {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:usage';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_usage_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_history {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:history';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_history_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_history_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:history_results';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_copy {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:copy';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_copy_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging:create';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_create_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_list {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:list';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_list_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_list_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_list_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:list_results';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_add {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:add';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_add_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_add_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_edit {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:edit';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_edit_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_delete {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:delete';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_delete_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_usage {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:usage';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_usage_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_history {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:history';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_history_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_history_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:history_results';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_copy {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation:copy';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_copy_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation:create';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_create_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_list {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:list';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_list_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_list_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_list_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:list_results';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_add {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:add';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_add_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_add_args {
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_edit {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:edit';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_edit_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_delete {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:delete';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_delete_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_usage {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:usage';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_usage_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_history {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:history';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_history_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_history_results {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:history_results';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_copy {
    name: 'wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal:copy';
    args: wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_copy_args;
}

interface wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal:create';
    args: wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_create_args {
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_list {
    name: 'wagtailsnippets_tsicommon_cms_offeradvertisingcontent:list';
    args: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_list_args;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_list_args {
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_list_results {
    name: 'wagtailsnippets_tsicommon_cms_offeradvertisingcontent:list_results';
    args: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_add {
    name: 'wagtailsnippets_tsicommon_cms_offeradvertisingcontent:add';
    args: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_add_args;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_add_args {
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_edit {
    name: 'wagtailsnippets_tsicommon_cms_offeradvertisingcontent:edit';
    args: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_edit_args;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_delete {
    name: 'wagtailsnippets_tsicommon_cms_offeradvertisingcontent:delete';
    args: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_delete_args;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_usage {
    name: 'wagtailsnippets_tsicommon_cms_offeradvertisingcontent:usage';
    args: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_usage_args;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_history {
    name: 'wagtailsnippets_tsicommon_cms_offeradvertisingcontent:history';
    args: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_history_args;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_history_results {
    name: 'wagtailsnippets_tsicommon_cms_offeradvertisingcontent:history_results';
    args: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_copy {
    name: 'wagtailsnippets_tsicommon_cms_offeradvertisingcontent:copy';
    args: wagtailsnippets_tsicommon_cms_offeradvertisingcontent_copy_args;
}

interface wagtailsnippets_tsicommon_cms_offeradvertisingcontent_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent:create';
    args: wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_create_args {
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_list {
    name: 'wagtailsnippets_tsicommon_cms_countdowntimerqueue:list';
    args: wagtailsnippets_tsicommon_cms_countdowntimerqueue_list_args;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_list_args {
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_list_results {
    name: 'wagtailsnippets_tsicommon_cms_countdowntimerqueue:list_results';
    args: wagtailsnippets_tsicommon_cms_countdowntimerqueue_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_add {
    name: 'wagtailsnippets_tsicommon_cms_countdowntimerqueue:add';
    args: wagtailsnippets_tsicommon_cms_countdowntimerqueue_add_args;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_add_args {
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_edit {
    name: 'wagtailsnippets_tsicommon_cms_countdowntimerqueue:edit';
    args: wagtailsnippets_tsicommon_cms_countdowntimerqueue_edit_args;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_delete {
    name: 'wagtailsnippets_tsicommon_cms_countdowntimerqueue:delete';
    args: wagtailsnippets_tsicommon_cms_countdowntimerqueue_delete_args;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_usage {
    name: 'wagtailsnippets_tsicommon_cms_countdowntimerqueue:usage';
    args: wagtailsnippets_tsicommon_cms_countdowntimerqueue_usage_args;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_history {
    name: 'wagtailsnippets_tsicommon_cms_countdowntimerqueue:history';
    args: wagtailsnippets_tsicommon_cms_countdowntimerqueue_history_args;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_history_results {
    name: 'wagtailsnippets_tsicommon_cms_countdowntimerqueue:history_results';
    args: wagtailsnippets_tsicommon_cms_countdowntimerqueue_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_copy {
    name: 'wagtailsnippets_tsicommon_cms_countdowntimerqueue:copy';
    args: wagtailsnippets_tsicommon_cms_countdowntimerqueue_copy_args;
}

interface wagtailsnippets_tsicommon_cms_countdowntimerqueue_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue:create';
    args: wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_create_args {
}

interface wagtailsnippets_tsicommon_cms_faq_list {
    name: 'wagtailsnippets_tsicommon_cms_faq:list';
    args: wagtailsnippets_tsicommon_cms_faq_list_args;
}

interface wagtailsnippets_tsicommon_cms_faq_list_args {
}

interface wagtailsnippets_tsicommon_cms_faq_list_results {
    name: 'wagtailsnippets_tsicommon_cms_faq:list_results';
    args: wagtailsnippets_tsicommon_cms_faq_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_faq_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_faq_add {
    name: 'wagtailsnippets_tsicommon_cms_faq:add';
    args: wagtailsnippets_tsicommon_cms_faq_add_args;
}

interface wagtailsnippets_tsicommon_cms_faq_add_args {
}

interface wagtailsnippets_tsicommon_cms_faq_edit {
    name: 'wagtailsnippets_tsicommon_cms_faq:edit';
    args: wagtailsnippets_tsicommon_cms_faq_edit_args;
}

interface wagtailsnippets_tsicommon_cms_faq_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_faq_delete {
    name: 'wagtailsnippets_tsicommon_cms_faq:delete';
    args: wagtailsnippets_tsicommon_cms_faq_delete_args;
}

interface wagtailsnippets_tsicommon_cms_faq_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_faq_usage {
    name: 'wagtailsnippets_tsicommon_cms_faq:usage';
    args: wagtailsnippets_tsicommon_cms_faq_usage_args;
}

interface wagtailsnippets_tsicommon_cms_faq_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_faq_history {
    name: 'wagtailsnippets_tsicommon_cms_faq:history';
    args: wagtailsnippets_tsicommon_cms_faq_history_args;
}

interface wagtailsnippets_tsicommon_cms_faq_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_faq_history_results {
    name: 'wagtailsnippets_tsicommon_cms_faq:history_results';
    args: wagtailsnippets_tsicommon_cms_faq_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_faq_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_faq_copy {
    name: 'wagtailsnippets_tsicommon_cms_faq:copy';
    args: wagtailsnippets_tsicommon_cms_faq_copy_args;
}

interface wagtailsnippets_tsicommon_cms_faq_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_faq_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_faq:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_faq_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_faq_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_faq_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_faq:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_faq_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_faq_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_faq_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_faq:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_faq_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_faq_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_faq_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_faq:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_faq_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_faq_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_faq_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_faq:create';
    args: wagtailsnippetchoosers_tsicommon_cms_faq_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_faq_create_args {
}

interface wagtailsnippets_tsicommon_cms_slidecollection_list {
    name: 'wagtailsnippets_tsicommon_cms_slidecollection:list';
    args: wagtailsnippets_tsicommon_cms_slidecollection_list_args;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_list_args {
}

interface wagtailsnippets_tsicommon_cms_slidecollection_list_results {
    name: 'wagtailsnippets_tsicommon_cms_slidecollection:list_results';
    args: wagtailsnippets_tsicommon_cms_slidecollection_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_slidecollection_add {
    name: 'wagtailsnippets_tsicommon_cms_slidecollection:add';
    args: wagtailsnippets_tsicommon_cms_slidecollection_add_args;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_add_args {
}

interface wagtailsnippets_tsicommon_cms_slidecollection_edit {
    name: 'wagtailsnippets_tsicommon_cms_slidecollection:edit';
    args: wagtailsnippets_tsicommon_cms_slidecollection_edit_args;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_delete {
    name: 'wagtailsnippets_tsicommon_cms_slidecollection:delete';
    args: wagtailsnippets_tsicommon_cms_slidecollection_delete_args;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_usage {
    name: 'wagtailsnippets_tsicommon_cms_slidecollection:usage';
    args: wagtailsnippets_tsicommon_cms_slidecollection_usage_args;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_history {
    name: 'wagtailsnippets_tsicommon_cms_slidecollection:history';
    args: wagtailsnippets_tsicommon_cms_slidecollection_history_args;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_history_results {
    name: 'wagtailsnippets_tsicommon_cms_slidecollection:history_results';
    args: wagtailsnippets_tsicommon_cms_slidecollection_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_copy {
    name: 'wagtailsnippets_tsicommon_cms_slidecollection:copy';
    args: wagtailsnippets_tsicommon_cms_slidecollection_copy_args;
}

interface wagtailsnippets_tsicommon_cms_slidecollection_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_slidecollection_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_slidecollection:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_slidecollection_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_slidecollection_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_slidecollection_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_slidecollection:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_slidecollection_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_slidecollection_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_slidecollection_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_slidecollection:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_slidecollection_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_slidecollection_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_slidecollection_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_slidecollection:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_slidecollection_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_slidecollection_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_slidecollection_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_slidecollection:create';
    args: wagtailsnippetchoosers_tsicommon_cms_slidecollection_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_slidecollection_create_args {
}

interface wagtailsnippets_tsicommon_cms_link_list {
    name: 'wagtailsnippets_tsicommon_cms_link:list';
    args: wagtailsnippets_tsicommon_cms_link_list_args;
}

interface wagtailsnippets_tsicommon_cms_link_list_args {
}

interface wagtailsnippets_tsicommon_cms_link_list_results {
    name: 'wagtailsnippets_tsicommon_cms_link:list_results';
    args: wagtailsnippets_tsicommon_cms_link_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_link_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_link_add {
    name: 'wagtailsnippets_tsicommon_cms_link:add';
    args: wagtailsnippets_tsicommon_cms_link_add_args;
}

interface wagtailsnippets_tsicommon_cms_link_add_args {
}

interface wagtailsnippets_tsicommon_cms_link_edit {
    name: 'wagtailsnippets_tsicommon_cms_link:edit';
    args: wagtailsnippets_tsicommon_cms_link_edit_args;
}

interface wagtailsnippets_tsicommon_cms_link_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_link_delete {
    name: 'wagtailsnippets_tsicommon_cms_link:delete';
    args: wagtailsnippets_tsicommon_cms_link_delete_args;
}

interface wagtailsnippets_tsicommon_cms_link_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_link_usage {
    name: 'wagtailsnippets_tsicommon_cms_link:usage';
    args: wagtailsnippets_tsicommon_cms_link_usage_args;
}

interface wagtailsnippets_tsicommon_cms_link_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_link_history {
    name: 'wagtailsnippets_tsicommon_cms_link:history';
    args: wagtailsnippets_tsicommon_cms_link_history_args;
}

interface wagtailsnippets_tsicommon_cms_link_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_link_history_results {
    name: 'wagtailsnippets_tsicommon_cms_link:history_results';
    args: wagtailsnippets_tsicommon_cms_link_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_link_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_link_copy {
    name: 'wagtailsnippets_tsicommon_cms_link:copy';
    args: wagtailsnippets_tsicommon_cms_link_copy_args;
}

interface wagtailsnippets_tsicommon_cms_link_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_link_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_link:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_link_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_link_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_link_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_link:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_link_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_link_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_link_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_link:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_link_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_link_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_link_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_link:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_link_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_link_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_link_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_link:create';
    args: wagtailsnippetchoosers_tsicommon_cms_link_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_link_create_args {
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_list {
    name: 'wagtailsnippets_tsicommon_cms_plainnavigation:list';
    args: wagtailsnippets_tsicommon_cms_plainnavigation_list_args;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_list_args {
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_list_results {
    name: 'wagtailsnippets_tsicommon_cms_plainnavigation:list_results';
    args: wagtailsnippets_tsicommon_cms_plainnavigation_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_add {
    name: 'wagtailsnippets_tsicommon_cms_plainnavigation:add';
    args: wagtailsnippets_tsicommon_cms_plainnavigation_add_args;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_add_args {
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_edit {
    name: 'wagtailsnippets_tsicommon_cms_plainnavigation:edit';
    args: wagtailsnippets_tsicommon_cms_plainnavigation_edit_args;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_delete {
    name: 'wagtailsnippets_tsicommon_cms_plainnavigation:delete';
    args: wagtailsnippets_tsicommon_cms_plainnavigation_delete_args;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_usage {
    name: 'wagtailsnippets_tsicommon_cms_plainnavigation:usage';
    args: wagtailsnippets_tsicommon_cms_plainnavigation_usage_args;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_history {
    name: 'wagtailsnippets_tsicommon_cms_plainnavigation:history';
    args: wagtailsnippets_tsicommon_cms_plainnavigation_history_args;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_history_results {
    name: 'wagtailsnippets_tsicommon_cms_plainnavigation:history_results';
    args: wagtailsnippets_tsicommon_cms_plainnavigation_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_copy {
    name: 'wagtailsnippets_tsicommon_cms_plainnavigation:copy';
    args: wagtailsnippets_tsicommon_cms_plainnavigation_copy_args;
}

interface wagtailsnippets_tsicommon_cms_plainnavigation_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_plainnavigation_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_plainnavigation:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_plainnavigation_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_plainnavigation_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_plainnavigation_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_plainnavigation:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_plainnavigation_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_plainnavigation_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_plainnavigation_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_plainnavigation:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_plainnavigation_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_plainnavigation_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_plainnavigation_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_plainnavigation:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_plainnavigation_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_plainnavigation_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_plainnavigation_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_plainnavigation:create';
    args: wagtailsnippetchoosers_tsicommon_cms_plainnavigation_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_plainnavigation_create_args {
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_list {
    name: 'wagtailsnippets_tsicommon_cms_productcomparetile:list';
    args: wagtailsnippets_tsicommon_cms_productcomparetile_list_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_list_args {
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_list_results {
    name: 'wagtailsnippets_tsicommon_cms_productcomparetile:list_results';
    args: wagtailsnippets_tsicommon_cms_productcomparetile_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_add {
    name: 'wagtailsnippets_tsicommon_cms_productcomparetile:add';
    args: wagtailsnippets_tsicommon_cms_productcomparetile_add_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_add_args {
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_edit {
    name: 'wagtailsnippets_tsicommon_cms_productcomparetile:edit';
    args: wagtailsnippets_tsicommon_cms_productcomparetile_edit_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_delete {
    name: 'wagtailsnippets_tsicommon_cms_productcomparetile:delete';
    args: wagtailsnippets_tsicommon_cms_productcomparetile_delete_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_usage {
    name: 'wagtailsnippets_tsicommon_cms_productcomparetile:usage';
    args: wagtailsnippets_tsicommon_cms_productcomparetile_usage_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_history {
    name: 'wagtailsnippets_tsicommon_cms_productcomparetile:history';
    args: wagtailsnippets_tsicommon_cms_productcomparetile_history_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_history_results {
    name: 'wagtailsnippets_tsicommon_cms_productcomparetile:history_results';
    args: wagtailsnippets_tsicommon_cms_productcomparetile_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_copy {
    name: 'wagtailsnippets_tsicommon_cms_productcomparetile:copy';
    args: wagtailsnippets_tsicommon_cms_productcomparetile_copy_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparetile_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparetile_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparetile:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparetile_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparetile_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparetile_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparetile:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparetile_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparetile_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparetile_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparetile:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparetile_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparetile_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparetile_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparetile:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparetile_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparetile_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparetile_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparetile:create';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparetile_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparetile_create_args {
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_list {
    name: 'wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:list';
    args: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_list_args;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_list_args {
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_list_results {
    name: 'wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:list_results';
    args: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_add {
    name: 'wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:add';
    args: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_add_args;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_add_args {
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_edit {
    name: 'wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:edit';
    args: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_edit_args;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_delete {
    name: 'wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:delete';
    args: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_delete_args;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_usage {
    name: 'wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:usage';
    args: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_usage_args;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_history {
    name: 'wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:history';
    args: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_history_args;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_history_results {
    name: 'wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:history_results';
    args: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_copy {
    name: 'wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription:copy';
    args: wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_copy_args;
}

interface wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription:create';
    args: wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_create_args {
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_list {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowtype:list';
    args: wagtailsnippets_tsicommon_cms_productcomparerowtype_list_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_list_args {
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_list_results {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowtype:list_results';
    args: wagtailsnippets_tsicommon_cms_productcomparerowtype_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_add {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowtype:add';
    args: wagtailsnippets_tsicommon_cms_productcomparerowtype_add_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_add_args {
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_edit {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowtype:edit';
    args: wagtailsnippets_tsicommon_cms_productcomparerowtype_edit_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_delete {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowtype:delete';
    args: wagtailsnippets_tsicommon_cms_productcomparerowtype_delete_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_usage {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowtype:usage';
    args: wagtailsnippets_tsicommon_cms_productcomparerowtype_usage_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_history {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowtype:history';
    args: wagtailsnippets_tsicommon_cms_productcomparerowtype_history_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_history_results {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowtype:history_results';
    args: wagtailsnippets_tsicommon_cms_productcomparerowtype_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_copy {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowtype:copy';
    args: wagtailsnippets_tsicommon_cms_productcomparerowtype_copy_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowtype_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype:create';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_create_args {
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_list {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowcontent:list';
    args: wagtailsnippets_tsicommon_cms_productcomparerowcontent_list_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_list_args {
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_list_results {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowcontent:list_results';
    args: wagtailsnippets_tsicommon_cms_productcomparerowcontent_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_add {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowcontent:add';
    args: wagtailsnippets_tsicommon_cms_productcomparerowcontent_add_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_add_args {
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_edit {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowcontent:edit';
    args: wagtailsnippets_tsicommon_cms_productcomparerowcontent_edit_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_delete {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowcontent:delete';
    args: wagtailsnippets_tsicommon_cms_productcomparerowcontent_delete_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_usage {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowcontent:usage';
    args: wagtailsnippets_tsicommon_cms_productcomparerowcontent_usage_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_history {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowcontent:history';
    args: wagtailsnippets_tsicommon_cms_productcomparerowcontent_history_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_history_results {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowcontent:history_results';
    args: wagtailsnippets_tsicommon_cms_productcomparerowcontent_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_copy {
    name: 'wagtailsnippets_tsicommon_cms_productcomparerowcontent:copy';
    args: wagtailsnippets_tsicommon_cms_productcomparerowcontent_copy_args;
}

interface wagtailsnippets_tsicommon_cms_productcomparerowcontent_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent:create';
    args: wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_create_args {
}

interface wagtailsnippets_tsicommon_cms_productgrid_list {
    name: 'wagtailsnippets_tsicommon_cms_productgrid:list';
    args: wagtailsnippets_tsicommon_cms_productgrid_list_args;
}

interface wagtailsnippets_tsicommon_cms_productgrid_list_args {
}

interface wagtailsnippets_tsicommon_cms_productgrid_list_results {
    name: 'wagtailsnippets_tsicommon_cms_productgrid:list_results';
    args: wagtailsnippets_tsicommon_cms_productgrid_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_productgrid_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_productgrid_add {
    name: 'wagtailsnippets_tsicommon_cms_productgrid:add';
    args: wagtailsnippets_tsicommon_cms_productgrid_add_args;
}

interface wagtailsnippets_tsicommon_cms_productgrid_add_args {
}

interface wagtailsnippets_tsicommon_cms_productgrid_edit {
    name: 'wagtailsnippets_tsicommon_cms_productgrid:edit';
    args: wagtailsnippets_tsicommon_cms_productgrid_edit_args;
}

interface wagtailsnippets_tsicommon_cms_productgrid_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productgrid_delete {
    name: 'wagtailsnippets_tsicommon_cms_productgrid:delete';
    args: wagtailsnippets_tsicommon_cms_productgrid_delete_args;
}

interface wagtailsnippets_tsicommon_cms_productgrid_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productgrid_usage {
    name: 'wagtailsnippets_tsicommon_cms_productgrid:usage';
    args: wagtailsnippets_tsicommon_cms_productgrid_usage_args;
}

interface wagtailsnippets_tsicommon_cms_productgrid_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productgrid_history {
    name: 'wagtailsnippets_tsicommon_cms_productgrid:history';
    args: wagtailsnippets_tsicommon_cms_productgrid_history_args;
}

interface wagtailsnippets_tsicommon_cms_productgrid_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productgrid_history_results {
    name: 'wagtailsnippets_tsicommon_cms_productgrid:history_results';
    args: wagtailsnippets_tsicommon_cms_productgrid_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_productgrid_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_productgrid_copy {
    name: 'wagtailsnippets_tsicommon_cms_productgrid:copy';
    args: wagtailsnippets_tsicommon_cms_productgrid_copy_args;
}

interface wagtailsnippets_tsicommon_cms_productgrid_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_productgrid_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productgrid:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_productgrid_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productgrid_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_productgrid_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productgrid:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_productgrid_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productgrid_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_productgrid_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productgrid:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_productgrid_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productgrid_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_productgrid_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productgrid:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_productgrid_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productgrid_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_productgrid_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_productgrid:create';
    args: wagtailsnippetchoosers_tsicommon_cms_productgrid_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_productgrid_create_args {
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_list {
    name: 'wagtailsnippets_tsicommon_cms_plcconfigurator:list';
    args: wagtailsnippets_tsicommon_cms_plcconfigurator_list_args;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_list_args {
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_list_results {
    name: 'wagtailsnippets_tsicommon_cms_plcconfigurator:list_results';
    args: wagtailsnippets_tsicommon_cms_plcconfigurator_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_add {
    name: 'wagtailsnippets_tsicommon_cms_plcconfigurator:add';
    args: wagtailsnippets_tsicommon_cms_plcconfigurator_add_args;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_add_args {
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_edit {
    name: 'wagtailsnippets_tsicommon_cms_plcconfigurator:edit';
    args: wagtailsnippets_tsicommon_cms_plcconfigurator_edit_args;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_delete {
    name: 'wagtailsnippets_tsicommon_cms_plcconfigurator:delete';
    args: wagtailsnippets_tsicommon_cms_plcconfigurator_delete_args;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_usage {
    name: 'wagtailsnippets_tsicommon_cms_plcconfigurator:usage';
    args: wagtailsnippets_tsicommon_cms_plcconfigurator_usage_args;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_history {
    name: 'wagtailsnippets_tsicommon_cms_plcconfigurator:history';
    args: wagtailsnippets_tsicommon_cms_plcconfigurator_history_args;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_history_results {
    name: 'wagtailsnippets_tsicommon_cms_plcconfigurator:history_results';
    args: wagtailsnippets_tsicommon_cms_plcconfigurator_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_copy {
    name: 'wagtailsnippets_tsicommon_cms_plcconfigurator:copy';
    args: wagtailsnippets_tsicommon_cms_plcconfigurator_copy_args;
}

interface wagtailsnippets_tsicommon_cms_plcconfigurator_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_plcconfigurator:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_plcconfigurator:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_plcconfigurator:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_plcconfigurator:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_plcconfigurator:create';
    args: wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_create_args {
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_list {
    name: 'wagtailsnippets_tsicommon_cms_promomessagingbanner:list';
    args: wagtailsnippets_tsicommon_cms_promomessagingbanner_list_args;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_list_args {
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_list_results {
    name: 'wagtailsnippets_tsicommon_cms_promomessagingbanner:list_results';
    args: wagtailsnippets_tsicommon_cms_promomessagingbanner_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_add {
    name: 'wagtailsnippets_tsicommon_cms_promomessagingbanner:add';
    args: wagtailsnippets_tsicommon_cms_promomessagingbanner_add_args;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_add_args {
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_edit {
    name: 'wagtailsnippets_tsicommon_cms_promomessagingbanner:edit';
    args: wagtailsnippets_tsicommon_cms_promomessagingbanner_edit_args;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_delete {
    name: 'wagtailsnippets_tsicommon_cms_promomessagingbanner:delete';
    args: wagtailsnippets_tsicommon_cms_promomessagingbanner_delete_args;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_usage {
    name: 'wagtailsnippets_tsicommon_cms_promomessagingbanner:usage';
    args: wagtailsnippets_tsicommon_cms_promomessagingbanner_usage_args;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_history {
    name: 'wagtailsnippets_tsicommon_cms_promomessagingbanner:history';
    args: wagtailsnippets_tsicommon_cms_promomessagingbanner_history_args;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_history_results {
    name: 'wagtailsnippets_tsicommon_cms_promomessagingbanner:history_results';
    args: wagtailsnippets_tsicommon_cms_promomessagingbanner_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_copy {
    name: 'wagtailsnippets_tsicommon_cms_promomessagingbanner:copy';
    args: wagtailsnippets_tsicommon_cms_promomessagingbanner_copy_args;
}

interface wagtailsnippets_tsicommon_cms_promomessagingbanner_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner:create';
    args: wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_create_args {
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_list {
    name: 'wagtailsnippets_tsicommon_cms_richnavigationlink:list';
    args: wagtailsnippets_tsicommon_cms_richnavigationlink_list_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_list_args {
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_list_results {
    name: 'wagtailsnippets_tsicommon_cms_richnavigationlink:list_results';
    args: wagtailsnippets_tsicommon_cms_richnavigationlink_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_add {
    name: 'wagtailsnippets_tsicommon_cms_richnavigationlink:add';
    args: wagtailsnippets_tsicommon_cms_richnavigationlink_add_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_add_args {
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_edit {
    name: 'wagtailsnippets_tsicommon_cms_richnavigationlink:edit';
    args: wagtailsnippets_tsicommon_cms_richnavigationlink_edit_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_delete {
    name: 'wagtailsnippets_tsicommon_cms_richnavigationlink:delete';
    args: wagtailsnippets_tsicommon_cms_richnavigationlink_delete_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_usage {
    name: 'wagtailsnippets_tsicommon_cms_richnavigationlink:usage';
    args: wagtailsnippets_tsicommon_cms_richnavigationlink_usage_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_history {
    name: 'wagtailsnippets_tsicommon_cms_richnavigationlink:history';
    args: wagtailsnippets_tsicommon_cms_richnavigationlink_history_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_history_results {
    name: 'wagtailsnippets_tsicommon_cms_richnavigationlink:history_results';
    args: wagtailsnippets_tsicommon_cms_richnavigationlink_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_copy {
    name: 'wagtailsnippets_tsicommon_cms_richnavigationlink:copy';
    args: wagtailsnippets_tsicommon_cms_richnavigationlink_copy_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigationlink_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_richnavigationlink:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_richnavigationlink:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_richnavigationlink:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_richnavigationlink:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_richnavigationlink:create';
    args: wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_create_args {
}

interface wagtailsnippets_tsicommon_cms_richnavigation_list {
    name: 'wagtailsnippets_tsicommon_cms_richnavigation:list';
    args: wagtailsnippets_tsicommon_cms_richnavigation_list_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_list_args {
}

interface wagtailsnippets_tsicommon_cms_richnavigation_list_results {
    name: 'wagtailsnippets_tsicommon_cms_richnavigation:list_results';
    args: wagtailsnippets_tsicommon_cms_richnavigation_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_richnavigation_add {
    name: 'wagtailsnippets_tsicommon_cms_richnavigation:add';
    args: wagtailsnippets_tsicommon_cms_richnavigation_add_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_add_args {
}

interface wagtailsnippets_tsicommon_cms_richnavigation_edit {
    name: 'wagtailsnippets_tsicommon_cms_richnavigation:edit';
    args: wagtailsnippets_tsicommon_cms_richnavigation_edit_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_delete {
    name: 'wagtailsnippets_tsicommon_cms_richnavigation:delete';
    args: wagtailsnippets_tsicommon_cms_richnavigation_delete_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_usage {
    name: 'wagtailsnippets_tsicommon_cms_richnavigation:usage';
    args: wagtailsnippets_tsicommon_cms_richnavigation_usage_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_history {
    name: 'wagtailsnippets_tsicommon_cms_richnavigation:history';
    args: wagtailsnippets_tsicommon_cms_richnavigation_history_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_history_results {
    name: 'wagtailsnippets_tsicommon_cms_richnavigation:history_results';
    args: wagtailsnippets_tsicommon_cms_richnavigation_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_copy {
    name: 'wagtailsnippets_tsicommon_cms_richnavigation:copy';
    args: wagtailsnippets_tsicommon_cms_richnavigation_copy_args;
}

interface wagtailsnippets_tsicommon_cms_richnavigation_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigation_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_richnavigation:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_richnavigation_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigation_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigation_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_richnavigation:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_richnavigation_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigation_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigation_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_richnavigation:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_richnavigation_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigation_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigation_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_richnavigation:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_richnavigation_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigation_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigation_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_richnavigation:create';
    args: wagtailsnippetchoosers_tsicommon_cms_richnavigation_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_richnavigation_create_args {
}

interface wagtailsnippets_tsicommon_cms_emailmodal_list {
    name: 'wagtailsnippets_tsicommon_cms_emailmodal:list';
    args: wagtailsnippets_tsicommon_cms_emailmodal_list_args;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_list_args {
}

interface wagtailsnippets_tsicommon_cms_emailmodal_list_results {
    name: 'wagtailsnippets_tsicommon_cms_emailmodal:list_results';
    args: wagtailsnippets_tsicommon_cms_emailmodal_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_emailmodal_add {
    name: 'wagtailsnippets_tsicommon_cms_emailmodal:add';
    args: wagtailsnippets_tsicommon_cms_emailmodal_add_args;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_add_args {
}

interface wagtailsnippets_tsicommon_cms_emailmodal_edit {
    name: 'wagtailsnippets_tsicommon_cms_emailmodal:edit';
    args: wagtailsnippets_tsicommon_cms_emailmodal_edit_args;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_delete {
    name: 'wagtailsnippets_tsicommon_cms_emailmodal:delete';
    args: wagtailsnippets_tsicommon_cms_emailmodal_delete_args;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_usage {
    name: 'wagtailsnippets_tsicommon_cms_emailmodal:usage';
    args: wagtailsnippets_tsicommon_cms_emailmodal_usage_args;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_history {
    name: 'wagtailsnippets_tsicommon_cms_emailmodal:history';
    args: wagtailsnippets_tsicommon_cms_emailmodal_history_args;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_history_results {
    name: 'wagtailsnippets_tsicommon_cms_emailmodal:history_results';
    args: wagtailsnippets_tsicommon_cms_emailmodal_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_copy {
    name: 'wagtailsnippets_tsicommon_cms_emailmodal:copy';
    args: wagtailsnippets_tsicommon_cms_emailmodal_copy_args;
}

interface wagtailsnippets_tsicommon_cms_emailmodal_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_emailmodal_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_emailmodal:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_emailmodal_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_emailmodal_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_emailmodal_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_emailmodal:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_emailmodal_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_emailmodal_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_emailmodal_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_emailmodal:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_emailmodal_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_emailmodal_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_emailmodal_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_emailmodal:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_emailmodal_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_emailmodal_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_emailmodal_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_emailmodal:create';
    args: wagtailsnippetchoosers_tsicommon_cms_emailmodal_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_emailmodal_create_args {
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_list {
    name: 'wagtailsnippets_tsicommon_cms_servicefootersnippet:list';
    args: wagtailsnippets_tsicommon_cms_servicefootersnippet_list_args;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_list_args {
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_list_results {
    name: 'wagtailsnippets_tsicommon_cms_servicefootersnippet:list_results';
    args: wagtailsnippets_tsicommon_cms_servicefootersnippet_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_add {
    name: 'wagtailsnippets_tsicommon_cms_servicefootersnippet:add';
    args: wagtailsnippets_tsicommon_cms_servicefootersnippet_add_args;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_add_args {
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_edit {
    name: 'wagtailsnippets_tsicommon_cms_servicefootersnippet:edit';
    args: wagtailsnippets_tsicommon_cms_servicefootersnippet_edit_args;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_delete {
    name: 'wagtailsnippets_tsicommon_cms_servicefootersnippet:delete';
    args: wagtailsnippets_tsicommon_cms_servicefootersnippet_delete_args;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_usage {
    name: 'wagtailsnippets_tsicommon_cms_servicefootersnippet:usage';
    args: wagtailsnippets_tsicommon_cms_servicefootersnippet_usage_args;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_history {
    name: 'wagtailsnippets_tsicommon_cms_servicefootersnippet:history';
    args: wagtailsnippets_tsicommon_cms_servicefootersnippet_history_args;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_history_results {
    name: 'wagtailsnippets_tsicommon_cms_servicefootersnippet:history_results';
    args: wagtailsnippets_tsicommon_cms_servicefootersnippet_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_copy {
    name: 'wagtailsnippets_tsicommon_cms_servicefootersnippet:copy';
    args: wagtailsnippets_tsicommon_cms_servicefootersnippet_copy_args;
}

interface wagtailsnippets_tsicommon_cms_servicefootersnippet_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet:create';
    args: wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_create_args {
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_list {
    name: 'wagtailsnippets_tsicommon_cms_timedemailmodal:list';
    args: wagtailsnippets_tsicommon_cms_timedemailmodal_list_args;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_list_args {
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_list_results {
    name: 'wagtailsnippets_tsicommon_cms_timedemailmodal:list_results';
    args: wagtailsnippets_tsicommon_cms_timedemailmodal_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_add {
    name: 'wagtailsnippets_tsicommon_cms_timedemailmodal:add';
    args: wagtailsnippets_tsicommon_cms_timedemailmodal_add_args;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_add_args {
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_edit {
    name: 'wagtailsnippets_tsicommon_cms_timedemailmodal:edit';
    args: wagtailsnippets_tsicommon_cms_timedemailmodal_edit_args;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_delete {
    name: 'wagtailsnippets_tsicommon_cms_timedemailmodal:delete';
    args: wagtailsnippets_tsicommon_cms_timedemailmodal_delete_args;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_usage {
    name: 'wagtailsnippets_tsicommon_cms_timedemailmodal:usage';
    args: wagtailsnippets_tsicommon_cms_timedemailmodal_usage_args;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_history {
    name: 'wagtailsnippets_tsicommon_cms_timedemailmodal:history';
    args: wagtailsnippets_tsicommon_cms_timedemailmodal_history_args;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_history_results {
    name: 'wagtailsnippets_tsicommon_cms_timedemailmodal:history_results';
    args: wagtailsnippets_tsicommon_cms_timedemailmodal_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_copy {
    name: 'wagtailsnippets_tsicommon_cms_timedemailmodal:copy';
    args: wagtailsnippets_tsicommon_cms_timedemailmodal_copy_args;
}

interface wagtailsnippets_tsicommon_cms_timedemailmodal_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_timedemailmodal:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_timedemailmodal:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_timedemailmodal:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_timedemailmodal:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_timedemailmodal:create';
    args: wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_create_args {
}

interface wagtailsnippets_tsicommon_cms_comparefeature_list {
    name: 'wagtailsnippets_tsicommon_cms_comparefeature:list';
    args: wagtailsnippets_tsicommon_cms_comparefeature_list_args;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_list_args {
}

interface wagtailsnippets_tsicommon_cms_comparefeature_list_results {
    name: 'wagtailsnippets_tsicommon_cms_comparefeature:list_results';
    args: wagtailsnippets_tsicommon_cms_comparefeature_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_comparefeature_add {
    name: 'wagtailsnippets_tsicommon_cms_comparefeature:add';
    args: wagtailsnippets_tsicommon_cms_comparefeature_add_args;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_add_args {
}

interface wagtailsnippets_tsicommon_cms_comparefeature_edit {
    name: 'wagtailsnippets_tsicommon_cms_comparefeature:edit';
    args: wagtailsnippets_tsicommon_cms_comparefeature_edit_args;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_delete {
    name: 'wagtailsnippets_tsicommon_cms_comparefeature:delete';
    args: wagtailsnippets_tsicommon_cms_comparefeature_delete_args;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_usage {
    name: 'wagtailsnippets_tsicommon_cms_comparefeature:usage';
    args: wagtailsnippets_tsicommon_cms_comparefeature_usage_args;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_history {
    name: 'wagtailsnippets_tsicommon_cms_comparefeature:history';
    args: wagtailsnippets_tsicommon_cms_comparefeature_history_args;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_history_results {
    name: 'wagtailsnippets_tsicommon_cms_comparefeature:history_results';
    args: wagtailsnippets_tsicommon_cms_comparefeature_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_copy {
    name: 'wagtailsnippets_tsicommon_cms_comparefeature:copy';
    args: wagtailsnippets_tsicommon_cms_comparefeature_copy_args;
}

interface wagtailsnippets_tsicommon_cms_comparefeature_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparefeature_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_comparefeature:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_comparefeature_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparefeature_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_comparefeature_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_comparefeature:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_comparefeature_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparefeature_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_comparefeature_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_comparefeature:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_comparefeature_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparefeature_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparefeature_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_comparefeature:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_comparefeature_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparefeature_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_comparefeature_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_comparefeature:create';
    args: wagtailsnippetchoosers_tsicommon_cms_comparefeature_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparefeature_create_args {
}

interface wagtailsnippets_tsicommon_cms_comparetile_list {
    name: 'wagtailsnippets_tsicommon_cms_comparetile:list';
    args: wagtailsnippets_tsicommon_cms_comparetile_list_args;
}

interface wagtailsnippets_tsicommon_cms_comparetile_list_args {
}

interface wagtailsnippets_tsicommon_cms_comparetile_list_results {
    name: 'wagtailsnippets_tsicommon_cms_comparetile:list_results';
    args: wagtailsnippets_tsicommon_cms_comparetile_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_comparetile_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_comparetile_add {
    name: 'wagtailsnippets_tsicommon_cms_comparetile:add';
    args: wagtailsnippets_tsicommon_cms_comparetile_add_args;
}

interface wagtailsnippets_tsicommon_cms_comparetile_add_args {
}

interface wagtailsnippets_tsicommon_cms_comparetile_edit {
    name: 'wagtailsnippets_tsicommon_cms_comparetile:edit';
    args: wagtailsnippets_tsicommon_cms_comparetile_edit_args;
}

interface wagtailsnippets_tsicommon_cms_comparetile_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_comparetile_delete {
    name: 'wagtailsnippets_tsicommon_cms_comparetile:delete';
    args: wagtailsnippets_tsicommon_cms_comparetile_delete_args;
}

interface wagtailsnippets_tsicommon_cms_comparetile_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_comparetile_usage {
    name: 'wagtailsnippets_tsicommon_cms_comparetile:usage';
    args: wagtailsnippets_tsicommon_cms_comparetile_usage_args;
}

interface wagtailsnippets_tsicommon_cms_comparetile_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_comparetile_history {
    name: 'wagtailsnippets_tsicommon_cms_comparetile:history';
    args: wagtailsnippets_tsicommon_cms_comparetile_history_args;
}

interface wagtailsnippets_tsicommon_cms_comparetile_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_comparetile_history_results {
    name: 'wagtailsnippets_tsicommon_cms_comparetile:history_results';
    args: wagtailsnippets_tsicommon_cms_comparetile_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_comparetile_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_comparetile_copy {
    name: 'wagtailsnippets_tsicommon_cms_comparetile:copy';
    args: wagtailsnippets_tsicommon_cms_comparetile_copy_args;
}

interface wagtailsnippets_tsicommon_cms_comparetile_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparetile_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_comparetile:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_comparetile_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparetile_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_comparetile_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_comparetile:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_comparetile_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparetile_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_comparetile_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_comparetile:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_comparetile_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparetile_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparetile_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_comparetile:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_comparetile_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparetile_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_comparetile_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_comparetile:create';
    args: wagtailsnippetchoosers_tsicommon_cms_comparetile_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_comparetile_create_args {
}

interface wagtailsnippets_tsicommon_cms_shoptile_list {
    name: 'wagtailsnippets_tsicommon_cms_shoptile:list';
    args: wagtailsnippets_tsicommon_cms_shoptile_list_args;
}

interface wagtailsnippets_tsicommon_cms_shoptile_list_args {
}

interface wagtailsnippets_tsicommon_cms_shoptile_list_results {
    name: 'wagtailsnippets_tsicommon_cms_shoptile:list_results';
    args: wagtailsnippets_tsicommon_cms_shoptile_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_shoptile_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_shoptile_add {
    name: 'wagtailsnippets_tsicommon_cms_shoptile:add';
    args: wagtailsnippets_tsicommon_cms_shoptile_add_args;
}

interface wagtailsnippets_tsicommon_cms_shoptile_add_args {
}

interface wagtailsnippets_tsicommon_cms_shoptile_edit {
    name: 'wagtailsnippets_tsicommon_cms_shoptile:edit';
    args: wagtailsnippets_tsicommon_cms_shoptile_edit_args;
}

interface wagtailsnippets_tsicommon_cms_shoptile_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_shoptile_delete {
    name: 'wagtailsnippets_tsicommon_cms_shoptile:delete';
    args: wagtailsnippets_tsicommon_cms_shoptile_delete_args;
}

interface wagtailsnippets_tsicommon_cms_shoptile_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_shoptile_usage {
    name: 'wagtailsnippets_tsicommon_cms_shoptile:usage';
    args: wagtailsnippets_tsicommon_cms_shoptile_usage_args;
}

interface wagtailsnippets_tsicommon_cms_shoptile_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_shoptile_history {
    name: 'wagtailsnippets_tsicommon_cms_shoptile:history';
    args: wagtailsnippets_tsicommon_cms_shoptile_history_args;
}

interface wagtailsnippets_tsicommon_cms_shoptile_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_shoptile_history_results {
    name: 'wagtailsnippets_tsicommon_cms_shoptile:history_results';
    args: wagtailsnippets_tsicommon_cms_shoptile_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_shoptile_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_shoptile_copy {
    name: 'wagtailsnippets_tsicommon_cms_shoptile:copy';
    args: wagtailsnippets_tsicommon_cms_shoptile_copy_args;
}

interface wagtailsnippets_tsicommon_cms_shoptile_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_shoptile_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_shoptile:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_shoptile_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_shoptile_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_shoptile_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_shoptile:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_shoptile_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_shoptile_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_shoptile_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_shoptile:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_shoptile_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_shoptile_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_shoptile_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_shoptile:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_shoptile_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_shoptile_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_shoptile_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_shoptile:create';
    args: wagtailsnippetchoosers_tsicommon_cms_shoptile_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_shoptile_create_args {
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_list {
    name: 'wagtailsnippets_tsicommon_cms_shopcomparetileset:list';
    args: wagtailsnippets_tsicommon_cms_shopcomparetileset_list_args;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_list_args {
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_list_results {
    name: 'wagtailsnippets_tsicommon_cms_shopcomparetileset:list_results';
    args: wagtailsnippets_tsicommon_cms_shopcomparetileset_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_add {
    name: 'wagtailsnippets_tsicommon_cms_shopcomparetileset:add';
    args: wagtailsnippets_tsicommon_cms_shopcomparetileset_add_args;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_add_args {
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_edit {
    name: 'wagtailsnippets_tsicommon_cms_shopcomparetileset:edit';
    args: wagtailsnippets_tsicommon_cms_shopcomparetileset_edit_args;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_delete {
    name: 'wagtailsnippets_tsicommon_cms_shopcomparetileset:delete';
    args: wagtailsnippets_tsicommon_cms_shopcomparetileset_delete_args;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_usage {
    name: 'wagtailsnippets_tsicommon_cms_shopcomparetileset:usage';
    args: wagtailsnippets_tsicommon_cms_shopcomparetileset_usage_args;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_history {
    name: 'wagtailsnippets_tsicommon_cms_shopcomparetileset:history';
    args: wagtailsnippets_tsicommon_cms_shopcomparetileset_history_args;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_history_results {
    name: 'wagtailsnippets_tsicommon_cms_shopcomparetileset:history_results';
    args: wagtailsnippets_tsicommon_cms_shopcomparetileset_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_copy {
    name: 'wagtailsnippets_tsicommon_cms_shopcomparetileset:copy';
    args: wagtailsnippets_tsicommon_cms_shopcomparetileset_copy_args;
}

interface wagtailsnippets_tsicommon_cms_shopcomparetileset_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset:create';
    args: wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_create_args {
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_list {
    name: 'wagtailsnippets_tsicommon_cms_stickyemailbanner:list';
    args: wagtailsnippets_tsicommon_cms_stickyemailbanner_list_args;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_list_args {
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_list_results {
    name: 'wagtailsnippets_tsicommon_cms_stickyemailbanner:list_results';
    args: wagtailsnippets_tsicommon_cms_stickyemailbanner_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_add {
    name: 'wagtailsnippets_tsicommon_cms_stickyemailbanner:add';
    args: wagtailsnippets_tsicommon_cms_stickyemailbanner_add_args;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_add_args {
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_edit {
    name: 'wagtailsnippets_tsicommon_cms_stickyemailbanner:edit';
    args: wagtailsnippets_tsicommon_cms_stickyemailbanner_edit_args;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_delete {
    name: 'wagtailsnippets_tsicommon_cms_stickyemailbanner:delete';
    args: wagtailsnippets_tsicommon_cms_stickyemailbanner_delete_args;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_usage {
    name: 'wagtailsnippets_tsicommon_cms_stickyemailbanner:usage';
    args: wagtailsnippets_tsicommon_cms_stickyemailbanner_usage_args;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_history {
    name: 'wagtailsnippets_tsicommon_cms_stickyemailbanner:history';
    args: wagtailsnippets_tsicommon_cms_stickyemailbanner_history_args;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_history_results {
    name: 'wagtailsnippets_tsicommon_cms_stickyemailbanner:history_results';
    args: wagtailsnippets_tsicommon_cms_stickyemailbanner_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_copy {
    name: 'wagtailsnippets_tsicommon_cms_stickyemailbanner:copy';
    args: wagtailsnippets_tsicommon_cms_stickyemailbanner_copy_args;
}

interface wagtailsnippets_tsicommon_cms_stickyemailbanner_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner:create';
    args: wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_create_args {
}

interface wagtailsnippets_tsicommon_cms_valueprop_list {
    name: 'wagtailsnippets_tsicommon_cms_valueprop:list';
    args: wagtailsnippets_tsicommon_cms_valueprop_list_args;
}

interface wagtailsnippets_tsicommon_cms_valueprop_list_args {
}

interface wagtailsnippets_tsicommon_cms_valueprop_list_results {
    name: 'wagtailsnippets_tsicommon_cms_valueprop:list_results';
    args: wagtailsnippets_tsicommon_cms_valueprop_list_results_args;
}

interface wagtailsnippets_tsicommon_cms_valueprop_list_results_args {
}

interface wagtailsnippets_tsicommon_cms_valueprop_add {
    name: 'wagtailsnippets_tsicommon_cms_valueprop:add';
    args: wagtailsnippets_tsicommon_cms_valueprop_add_args;
}

interface wagtailsnippets_tsicommon_cms_valueprop_add_args {
}

interface wagtailsnippets_tsicommon_cms_valueprop_edit {
    name: 'wagtailsnippets_tsicommon_cms_valueprop:edit';
    args: wagtailsnippets_tsicommon_cms_valueprop_edit_args;
}

interface wagtailsnippets_tsicommon_cms_valueprop_edit_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_valueprop_delete {
    name: 'wagtailsnippets_tsicommon_cms_valueprop:delete';
    args: wagtailsnippets_tsicommon_cms_valueprop_delete_args;
}

interface wagtailsnippets_tsicommon_cms_valueprop_delete_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_valueprop_usage {
    name: 'wagtailsnippets_tsicommon_cms_valueprop:usage';
    args: wagtailsnippets_tsicommon_cms_valueprop_usage_args;
}

interface wagtailsnippets_tsicommon_cms_valueprop_usage_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_valueprop_history {
    name: 'wagtailsnippets_tsicommon_cms_valueprop:history';
    args: wagtailsnippets_tsicommon_cms_valueprop_history_args;
}

interface wagtailsnippets_tsicommon_cms_valueprop_history_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_valueprop_history_results {
    name: 'wagtailsnippets_tsicommon_cms_valueprop:history_results';
    args: wagtailsnippets_tsicommon_cms_valueprop_history_results_args;
}

interface wagtailsnippets_tsicommon_cms_valueprop_history_results_args {
    pk: string;
}

interface wagtailsnippets_tsicommon_cms_valueprop_copy {
    name: 'wagtailsnippets_tsicommon_cms_valueprop:copy';
    args: wagtailsnippets_tsicommon_cms_valueprop_copy_args;
}

interface wagtailsnippets_tsicommon_cms_valueprop_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_valueprop_choose {
    name: 'wagtailsnippetchoosers_tsicommon_cms_valueprop:choose';
    args: wagtailsnippetchoosers_tsicommon_cms_valueprop_choose_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_valueprop_choose_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_valueprop_choose_results {
    name: 'wagtailsnippetchoosers_tsicommon_cms_valueprop:choose_results';
    args: wagtailsnippetchoosers_tsicommon_cms_valueprop_choose_results_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_valueprop_choose_results_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_valueprop_chosen {
    name: 'wagtailsnippetchoosers_tsicommon_cms_valueprop:chosen';
    args: wagtailsnippetchoosers_tsicommon_cms_valueprop_chosen_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_valueprop_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tsicommon_cms_valueprop_chosen_multiple {
    name: 'wagtailsnippetchoosers_tsicommon_cms_valueprop:chosen_multiple';
    args: wagtailsnippetchoosers_tsicommon_cms_valueprop_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_valueprop_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tsicommon_cms_valueprop_create {
    name: 'wagtailsnippetchoosers_tsicommon_cms_valueprop:create';
    args: wagtailsnippetchoosers_tsicommon_cms_valueprop_create_args;
}

interface wagtailsnippetchoosers_tsicommon_cms_valueprop_create_args {
}

interface wagtailsnippets_cms_navbar_list {
    name: 'wagtailsnippets_cms_navbar:list';
    args: wagtailsnippets_cms_navbar_list_args;
}

interface wagtailsnippets_cms_navbar_list_args {
}

interface wagtailsnippets_cms_navbar_list_results {
    name: 'wagtailsnippets_cms_navbar:list_results';
    args: wagtailsnippets_cms_navbar_list_results_args;
}

interface wagtailsnippets_cms_navbar_list_results_args {
}

interface wagtailsnippets_cms_navbar_add {
    name: 'wagtailsnippets_cms_navbar:add';
    args: wagtailsnippets_cms_navbar_add_args;
}

interface wagtailsnippets_cms_navbar_add_args {
}

interface wagtailsnippets_cms_navbar_edit {
    name: 'wagtailsnippets_cms_navbar:edit';
    args: wagtailsnippets_cms_navbar_edit_args;
}

interface wagtailsnippets_cms_navbar_edit_args {
    pk: string;
}

interface wagtailsnippets_cms_navbar_delete {
    name: 'wagtailsnippets_cms_navbar:delete';
    args: wagtailsnippets_cms_navbar_delete_args;
}

interface wagtailsnippets_cms_navbar_delete_args {
    pk: string;
}

interface wagtailsnippets_cms_navbar_usage {
    name: 'wagtailsnippets_cms_navbar:usage';
    args: wagtailsnippets_cms_navbar_usage_args;
}

interface wagtailsnippets_cms_navbar_usage_args {
    pk: string;
}

interface wagtailsnippets_cms_navbar_history {
    name: 'wagtailsnippets_cms_navbar:history';
    args: wagtailsnippets_cms_navbar_history_args;
}

interface wagtailsnippets_cms_navbar_history_args {
    pk: string;
}

interface wagtailsnippets_cms_navbar_history_results {
    name: 'wagtailsnippets_cms_navbar:history_results';
    args: wagtailsnippets_cms_navbar_history_results_args;
}

interface wagtailsnippets_cms_navbar_history_results_args {
    pk: string;
}

interface wagtailsnippets_cms_navbar_copy {
    name: 'wagtailsnippets_cms_navbar:copy';
    args: wagtailsnippets_cms_navbar_copy_args;
}

interface wagtailsnippets_cms_navbar_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_navbar_choose {
    name: 'wagtailsnippetchoosers_cms_navbar:choose';
    args: wagtailsnippetchoosers_cms_navbar_choose_args;
}

interface wagtailsnippetchoosers_cms_navbar_choose_args {
}

interface wagtailsnippetchoosers_cms_navbar_choose_results {
    name: 'wagtailsnippetchoosers_cms_navbar:choose_results';
    args: wagtailsnippetchoosers_cms_navbar_choose_results_args;
}

interface wagtailsnippetchoosers_cms_navbar_choose_results_args {
}

interface wagtailsnippetchoosers_cms_navbar_chosen {
    name: 'wagtailsnippetchoosers_cms_navbar:chosen';
    args: wagtailsnippetchoosers_cms_navbar_chosen_args;
}

interface wagtailsnippetchoosers_cms_navbar_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_navbar_chosen_multiple {
    name: 'wagtailsnippetchoosers_cms_navbar:chosen_multiple';
    args: wagtailsnippetchoosers_cms_navbar_chosen_multiple_args;
}

interface wagtailsnippetchoosers_cms_navbar_chosen_multiple_args {
}

interface wagtailsnippetchoosers_cms_navbar_create {
    name: 'wagtailsnippetchoosers_cms_navbar:create';
    args: wagtailsnippetchoosers_cms_navbar_create_args;
}

interface wagtailsnippetchoosers_cms_navbar_create_args {
}

interface wagtailsnippets_cms_contentblock_list {
    name: 'wagtailsnippets_cms_contentblock:list';
    args: wagtailsnippets_cms_contentblock_list_args;
}

interface wagtailsnippets_cms_contentblock_list_args {
}

interface wagtailsnippets_cms_contentblock_list_results {
    name: 'wagtailsnippets_cms_contentblock:list_results';
    args: wagtailsnippets_cms_contentblock_list_results_args;
}

interface wagtailsnippets_cms_contentblock_list_results_args {
}

interface wagtailsnippets_cms_contentblock_add {
    name: 'wagtailsnippets_cms_contentblock:add';
    args: wagtailsnippets_cms_contentblock_add_args;
}

interface wagtailsnippets_cms_contentblock_add_args {
}

interface wagtailsnippets_cms_contentblock_edit {
    name: 'wagtailsnippets_cms_contentblock:edit';
    args: wagtailsnippets_cms_contentblock_edit_args;
}

interface wagtailsnippets_cms_contentblock_edit_args {
    pk: string;
}

interface wagtailsnippets_cms_contentblock_delete {
    name: 'wagtailsnippets_cms_contentblock:delete';
    args: wagtailsnippets_cms_contentblock_delete_args;
}

interface wagtailsnippets_cms_contentblock_delete_args {
    pk: string;
}

interface wagtailsnippets_cms_contentblock_usage {
    name: 'wagtailsnippets_cms_contentblock:usage';
    args: wagtailsnippets_cms_contentblock_usage_args;
}

interface wagtailsnippets_cms_contentblock_usage_args {
    pk: string;
}

interface wagtailsnippets_cms_contentblock_history {
    name: 'wagtailsnippets_cms_contentblock:history';
    args: wagtailsnippets_cms_contentblock_history_args;
}

interface wagtailsnippets_cms_contentblock_history_args {
    pk: string;
}

interface wagtailsnippets_cms_contentblock_history_results {
    name: 'wagtailsnippets_cms_contentblock:history_results';
    args: wagtailsnippets_cms_contentblock_history_results_args;
}

interface wagtailsnippets_cms_contentblock_history_results_args {
    pk: string;
}

interface wagtailsnippets_cms_contentblock_copy {
    name: 'wagtailsnippets_cms_contentblock:copy';
    args: wagtailsnippets_cms_contentblock_copy_args;
}

interface wagtailsnippets_cms_contentblock_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_contentblock_choose {
    name: 'wagtailsnippetchoosers_cms_contentblock:choose';
    args: wagtailsnippetchoosers_cms_contentblock_choose_args;
}

interface wagtailsnippetchoosers_cms_contentblock_choose_args {
}

interface wagtailsnippetchoosers_cms_contentblock_choose_results {
    name: 'wagtailsnippetchoosers_cms_contentblock:choose_results';
    args: wagtailsnippetchoosers_cms_contentblock_choose_results_args;
}

interface wagtailsnippetchoosers_cms_contentblock_choose_results_args {
}

interface wagtailsnippetchoosers_cms_contentblock_chosen {
    name: 'wagtailsnippetchoosers_cms_contentblock:chosen';
    args: wagtailsnippetchoosers_cms_contentblock_chosen_args;
}

interface wagtailsnippetchoosers_cms_contentblock_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_contentblock_chosen_multiple {
    name: 'wagtailsnippetchoosers_cms_contentblock:chosen_multiple';
    args: wagtailsnippetchoosers_cms_contentblock_chosen_multiple_args;
}

interface wagtailsnippetchoosers_cms_contentblock_chosen_multiple_args {
}

interface wagtailsnippetchoosers_cms_contentblock_create {
    name: 'wagtailsnippetchoosers_cms_contentblock:create';
    args: wagtailsnippetchoosers_cms_contentblock_create_args;
}

interface wagtailsnippetchoosers_cms_contentblock_create_args {
}

interface wagtailsnippets_cms_promocopyheader_list {
    name: 'wagtailsnippets_cms_promocopyheader:list';
    args: wagtailsnippets_cms_promocopyheader_list_args;
}

interface wagtailsnippets_cms_promocopyheader_list_args {
}

interface wagtailsnippets_cms_promocopyheader_list_results {
    name: 'wagtailsnippets_cms_promocopyheader:list_results';
    args: wagtailsnippets_cms_promocopyheader_list_results_args;
}

interface wagtailsnippets_cms_promocopyheader_list_results_args {
}

interface wagtailsnippets_cms_promocopyheader_add {
    name: 'wagtailsnippets_cms_promocopyheader:add';
    args: wagtailsnippets_cms_promocopyheader_add_args;
}

interface wagtailsnippets_cms_promocopyheader_add_args {
}

interface wagtailsnippets_cms_promocopyheader_edit {
    name: 'wagtailsnippets_cms_promocopyheader:edit';
    args: wagtailsnippets_cms_promocopyheader_edit_args;
}

interface wagtailsnippets_cms_promocopyheader_edit_args {
    pk: string;
}

interface wagtailsnippets_cms_promocopyheader_delete {
    name: 'wagtailsnippets_cms_promocopyheader:delete';
    args: wagtailsnippets_cms_promocopyheader_delete_args;
}

interface wagtailsnippets_cms_promocopyheader_delete_args {
    pk: string;
}

interface wagtailsnippets_cms_promocopyheader_usage {
    name: 'wagtailsnippets_cms_promocopyheader:usage';
    args: wagtailsnippets_cms_promocopyheader_usage_args;
}

interface wagtailsnippets_cms_promocopyheader_usage_args {
    pk: string;
}

interface wagtailsnippets_cms_promocopyheader_history {
    name: 'wagtailsnippets_cms_promocopyheader:history';
    args: wagtailsnippets_cms_promocopyheader_history_args;
}

interface wagtailsnippets_cms_promocopyheader_history_args {
    pk: string;
}

interface wagtailsnippets_cms_promocopyheader_history_results {
    name: 'wagtailsnippets_cms_promocopyheader:history_results';
    args: wagtailsnippets_cms_promocopyheader_history_results_args;
}

interface wagtailsnippets_cms_promocopyheader_history_results_args {
    pk: string;
}

interface wagtailsnippets_cms_promocopyheader_copy {
    name: 'wagtailsnippets_cms_promocopyheader:copy';
    args: wagtailsnippets_cms_promocopyheader_copy_args;
}

interface wagtailsnippets_cms_promocopyheader_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_promocopyheader_choose {
    name: 'wagtailsnippetchoosers_cms_promocopyheader:choose';
    args: wagtailsnippetchoosers_cms_promocopyheader_choose_args;
}

interface wagtailsnippetchoosers_cms_promocopyheader_choose_args {
}

interface wagtailsnippetchoosers_cms_promocopyheader_choose_results {
    name: 'wagtailsnippetchoosers_cms_promocopyheader:choose_results';
    args: wagtailsnippetchoosers_cms_promocopyheader_choose_results_args;
}

interface wagtailsnippetchoosers_cms_promocopyheader_choose_results_args {
}

interface wagtailsnippetchoosers_cms_promocopyheader_chosen {
    name: 'wagtailsnippetchoosers_cms_promocopyheader:chosen';
    args: wagtailsnippetchoosers_cms_promocopyheader_chosen_args;
}

interface wagtailsnippetchoosers_cms_promocopyheader_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_promocopyheader_chosen_multiple {
    name: 'wagtailsnippetchoosers_cms_promocopyheader:chosen_multiple';
    args: wagtailsnippetchoosers_cms_promocopyheader_chosen_multiple_args;
}

interface wagtailsnippetchoosers_cms_promocopyheader_chosen_multiple_args {
}

interface wagtailsnippetchoosers_cms_promocopyheader_create {
    name: 'wagtailsnippetchoosers_cms_promocopyheader:create';
    args: wagtailsnippetchoosers_cms_promocopyheader_create_args;
}

interface wagtailsnippetchoosers_cms_promocopyheader_create_args {
}

interface wagtailsnippets_cms_promocopy_list {
    name: 'wagtailsnippets_cms_promocopy:list';
    args: wagtailsnippets_cms_promocopy_list_args;
}

interface wagtailsnippets_cms_promocopy_list_args {
}

interface wagtailsnippets_cms_promocopy_list_results {
    name: 'wagtailsnippets_cms_promocopy:list_results';
    args: wagtailsnippets_cms_promocopy_list_results_args;
}

interface wagtailsnippets_cms_promocopy_list_results_args {
}

interface wagtailsnippets_cms_promocopy_add {
    name: 'wagtailsnippets_cms_promocopy:add';
    args: wagtailsnippets_cms_promocopy_add_args;
}

interface wagtailsnippets_cms_promocopy_add_args {
}

interface wagtailsnippets_cms_promocopy_edit {
    name: 'wagtailsnippets_cms_promocopy:edit';
    args: wagtailsnippets_cms_promocopy_edit_args;
}

interface wagtailsnippets_cms_promocopy_edit_args {
    pk: string;
}

interface wagtailsnippets_cms_promocopy_delete {
    name: 'wagtailsnippets_cms_promocopy:delete';
    args: wagtailsnippets_cms_promocopy_delete_args;
}

interface wagtailsnippets_cms_promocopy_delete_args {
    pk: string;
}

interface wagtailsnippets_cms_promocopy_usage {
    name: 'wagtailsnippets_cms_promocopy:usage';
    args: wagtailsnippets_cms_promocopy_usage_args;
}

interface wagtailsnippets_cms_promocopy_usage_args {
    pk: string;
}

interface wagtailsnippets_cms_promocopy_history {
    name: 'wagtailsnippets_cms_promocopy:history';
    args: wagtailsnippets_cms_promocopy_history_args;
}

interface wagtailsnippets_cms_promocopy_history_args {
    pk: string;
}

interface wagtailsnippets_cms_promocopy_history_results {
    name: 'wagtailsnippets_cms_promocopy:history_results';
    args: wagtailsnippets_cms_promocopy_history_results_args;
}

interface wagtailsnippets_cms_promocopy_history_results_args {
    pk: string;
}

interface wagtailsnippets_cms_promocopy_copy {
    name: 'wagtailsnippets_cms_promocopy:copy';
    args: wagtailsnippets_cms_promocopy_copy_args;
}

interface wagtailsnippets_cms_promocopy_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_promocopy_choose {
    name: 'wagtailsnippetchoosers_cms_promocopy:choose';
    args: wagtailsnippetchoosers_cms_promocopy_choose_args;
}

interface wagtailsnippetchoosers_cms_promocopy_choose_args {
}

interface wagtailsnippetchoosers_cms_promocopy_choose_results {
    name: 'wagtailsnippetchoosers_cms_promocopy:choose_results';
    args: wagtailsnippetchoosers_cms_promocopy_choose_results_args;
}

interface wagtailsnippetchoosers_cms_promocopy_choose_results_args {
}

interface wagtailsnippetchoosers_cms_promocopy_chosen {
    name: 'wagtailsnippetchoosers_cms_promocopy:chosen';
    args: wagtailsnippetchoosers_cms_promocopy_chosen_args;
}

interface wagtailsnippetchoosers_cms_promocopy_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_promocopy_chosen_multiple {
    name: 'wagtailsnippetchoosers_cms_promocopy:chosen_multiple';
    args: wagtailsnippetchoosers_cms_promocopy_chosen_multiple_args;
}

interface wagtailsnippetchoosers_cms_promocopy_chosen_multiple_args {
}

interface wagtailsnippetchoosers_cms_promocopy_create {
    name: 'wagtailsnippetchoosers_cms_promocopy:create';
    args: wagtailsnippetchoosers_cms_promocopy_create_args;
}

interface wagtailsnippetchoosers_cms_promocopy_create_args {
}

interface wagtailsnippets_cms_navbadge_list {
    name: 'wagtailsnippets_cms_navbadge:list';
    args: wagtailsnippets_cms_navbadge_list_args;
}

interface wagtailsnippets_cms_navbadge_list_args {
}

interface wagtailsnippets_cms_navbadge_list_results {
    name: 'wagtailsnippets_cms_navbadge:list_results';
    args: wagtailsnippets_cms_navbadge_list_results_args;
}

interface wagtailsnippets_cms_navbadge_list_results_args {
}

interface wagtailsnippets_cms_navbadge_add {
    name: 'wagtailsnippets_cms_navbadge:add';
    args: wagtailsnippets_cms_navbadge_add_args;
}

interface wagtailsnippets_cms_navbadge_add_args {
}

interface wagtailsnippets_cms_navbadge_edit {
    name: 'wagtailsnippets_cms_navbadge:edit';
    args: wagtailsnippets_cms_navbadge_edit_args;
}

interface wagtailsnippets_cms_navbadge_edit_args {
    pk: string;
}

interface wagtailsnippets_cms_navbadge_delete {
    name: 'wagtailsnippets_cms_navbadge:delete';
    args: wagtailsnippets_cms_navbadge_delete_args;
}

interface wagtailsnippets_cms_navbadge_delete_args {
    pk: string;
}

interface wagtailsnippets_cms_navbadge_usage {
    name: 'wagtailsnippets_cms_navbadge:usage';
    args: wagtailsnippets_cms_navbadge_usage_args;
}

interface wagtailsnippets_cms_navbadge_usage_args {
    pk: string;
}

interface wagtailsnippets_cms_navbadge_history {
    name: 'wagtailsnippets_cms_navbadge:history';
    args: wagtailsnippets_cms_navbadge_history_args;
}

interface wagtailsnippets_cms_navbadge_history_args {
    pk: string;
}

interface wagtailsnippets_cms_navbadge_history_results {
    name: 'wagtailsnippets_cms_navbadge:history_results';
    args: wagtailsnippets_cms_navbadge_history_results_args;
}

interface wagtailsnippets_cms_navbadge_history_results_args {
    pk: string;
}

interface wagtailsnippets_cms_navbadge_copy {
    name: 'wagtailsnippets_cms_navbadge:copy';
    args: wagtailsnippets_cms_navbadge_copy_args;
}

interface wagtailsnippets_cms_navbadge_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_navbadge_choose {
    name: 'wagtailsnippetchoosers_cms_navbadge:choose';
    args: wagtailsnippetchoosers_cms_navbadge_choose_args;
}

interface wagtailsnippetchoosers_cms_navbadge_choose_args {
}

interface wagtailsnippetchoosers_cms_navbadge_choose_results {
    name: 'wagtailsnippetchoosers_cms_navbadge:choose_results';
    args: wagtailsnippetchoosers_cms_navbadge_choose_results_args;
}

interface wagtailsnippetchoosers_cms_navbadge_choose_results_args {
}

interface wagtailsnippetchoosers_cms_navbadge_chosen {
    name: 'wagtailsnippetchoosers_cms_navbadge:chosen';
    args: wagtailsnippetchoosers_cms_navbadge_chosen_args;
}

interface wagtailsnippetchoosers_cms_navbadge_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_navbadge_chosen_multiple {
    name: 'wagtailsnippetchoosers_cms_navbadge:chosen_multiple';
    args: wagtailsnippetchoosers_cms_navbadge_chosen_multiple_args;
}

interface wagtailsnippetchoosers_cms_navbadge_chosen_multiple_args {
}

interface wagtailsnippetchoosers_cms_navbadge_create {
    name: 'wagtailsnippetchoosers_cms_navbadge:create';
    args: wagtailsnippetchoosers_cms_navbadge_create_args;
}

interface wagtailsnippetchoosers_cms_navbadge_create_args {
}

interface wagtailsnippets_cms_ownerspotlight_list {
    name: 'wagtailsnippets_cms_ownerspotlight:list';
    args: wagtailsnippets_cms_ownerspotlight_list_args;
}

interface wagtailsnippets_cms_ownerspotlight_list_args {
}

interface wagtailsnippets_cms_ownerspotlight_list_results {
    name: 'wagtailsnippets_cms_ownerspotlight:list_results';
    args: wagtailsnippets_cms_ownerspotlight_list_results_args;
}

interface wagtailsnippets_cms_ownerspotlight_list_results_args {
}

interface wagtailsnippets_cms_ownerspotlight_add {
    name: 'wagtailsnippets_cms_ownerspotlight:add';
    args: wagtailsnippets_cms_ownerspotlight_add_args;
}

interface wagtailsnippets_cms_ownerspotlight_add_args {
}

interface wagtailsnippets_cms_ownerspotlight_edit {
    name: 'wagtailsnippets_cms_ownerspotlight:edit';
    args: wagtailsnippets_cms_ownerspotlight_edit_args;
}

interface wagtailsnippets_cms_ownerspotlight_edit_args {
    pk: string;
}

interface wagtailsnippets_cms_ownerspotlight_delete {
    name: 'wagtailsnippets_cms_ownerspotlight:delete';
    args: wagtailsnippets_cms_ownerspotlight_delete_args;
}

interface wagtailsnippets_cms_ownerspotlight_delete_args {
    pk: string;
}

interface wagtailsnippets_cms_ownerspotlight_usage {
    name: 'wagtailsnippets_cms_ownerspotlight:usage';
    args: wagtailsnippets_cms_ownerspotlight_usage_args;
}

interface wagtailsnippets_cms_ownerspotlight_usage_args {
    pk: string;
}

interface wagtailsnippets_cms_ownerspotlight_history {
    name: 'wagtailsnippets_cms_ownerspotlight:history';
    args: wagtailsnippets_cms_ownerspotlight_history_args;
}

interface wagtailsnippets_cms_ownerspotlight_history_args {
    pk: string;
}

interface wagtailsnippets_cms_ownerspotlight_history_results {
    name: 'wagtailsnippets_cms_ownerspotlight:history_results';
    args: wagtailsnippets_cms_ownerspotlight_history_results_args;
}

interface wagtailsnippets_cms_ownerspotlight_history_results_args {
    pk: string;
}

interface wagtailsnippets_cms_ownerspotlight_copy {
    name: 'wagtailsnippets_cms_ownerspotlight:copy';
    args: wagtailsnippets_cms_ownerspotlight_copy_args;
}

interface wagtailsnippets_cms_ownerspotlight_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_ownerspotlight_choose {
    name: 'wagtailsnippetchoosers_cms_ownerspotlight:choose';
    args: wagtailsnippetchoosers_cms_ownerspotlight_choose_args;
}

interface wagtailsnippetchoosers_cms_ownerspotlight_choose_args {
}

interface wagtailsnippetchoosers_cms_ownerspotlight_choose_results {
    name: 'wagtailsnippetchoosers_cms_ownerspotlight:choose_results';
    args: wagtailsnippetchoosers_cms_ownerspotlight_choose_results_args;
}

interface wagtailsnippetchoosers_cms_ownerspotlight_choose_results_args {
}

interface wagtailsnippetchoosers_cms_ownerspotlight_chosen {
    name: 'wagtailsnippetchoosers_cms_ownerspotlight:chosen';
    args: wagtailsnippetchoosers_cms_ownerspotlight_chosen_args;
}

interface wagtailsnippetchoosers_cms_ownerspotlight_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_ownerspotlight_chosen_multiple {
    name: 'wagtailsnippetchoosers_cms_ownerspotlight:chosen_multiple';
    args: wagtailsnippetchoosers_cms_ownerspotlight_chosen_multiple_args;
}

interface wagtailsnippetchoosers_cms_ownerspotlight_chosen_multiple_args {
}

interface wagtailsnippetchoosers_cms_ownerspotlight_create {
    name: 'wagtailsnippetchoosers_cms_ownerspotlight:create';
    args: wagtailsnippetchoosers_cms_ownerspotlight_create_args;
}

interface wagtailsnippetchoosers_cms_ownerspotlight_create_args {
}

interface wagtailsnippets_cms_ugcpost_list {
    name: 'wagtailsnippets_cms_ugcpost:list';
    args: wagtailsnippets_cms_ugcpost_list_args;
}

interface wagtailsnippets_cms_ugcpost_list_args {
}

interface wagtailsnippets_cms_ugcpost_list_results {
    name: 'wagtailsnippets_cms_ugcpost:list_results';
    args: wagtailsnippets_cms_ugcpost_list_results_args;
}

interface wagtailsnippets_cms_ugcpost_list_results_args {
}

interface wagtailsnippets_cms_ugcpost_add {
    name: 'wagtailsnippets_cms_ugcpost:add';
    args: wagtailsnippets_cms_ugcpost_add_args;
}

interface wagtailsnippets_cms_ugcpost_add_args {
}

interface wagtailsnippets_cms_ugcpost_edit {
    name: 'wagtailsnippets_cms_ugcpost:edit';
    args: wagtailsnippets_cms_ugcpost_edit_args;
}

interface wagtailsnippets_cms_ugcpost_edit_args {
    pk: string;
}

interface wagtailsnippets_cms_ugcpost_delete {
    name: 'wagtailsnippets_cms_ugcpost:delete';
    args: wagtailsnippets_cms_ugcpost_delete_args;
}

interface wagtailsnippets_cms_ugcpost_delete_args {
    pk: string;
}

interface wagtailsnippets_cms_ugcpost_usage {
    name: 'wagtailsnippets_cms_ugcpost:usage';
    args: wagtailsnippets_cms_ugcpost_usage_args;
}

interface wagtailsnippets_cms_ugcpost_usage_args {
    pk: string;
}

interface wagtailsnippets_cms_ugcpost_history {
    name: 'wagtailsnippets_cms_ugcpost:history';
    args: wagtailsnippets_cms_ugcpost_history_args;
}

interface wagtailsnippets_cms_ugcpost_history_args {
    pk: string;
}

interface wagtailsnippets_cms_ugcpost_history_results {
    name: 'wagtailsnippets_cms_ugcpost:history_results';
    args: wagtailsnippets_cms_ugcpost_history_results_args;
}

interface wagtailsnippets_cms_ugcpost_history_results_args {
    pk: string;
}

interface wagtailsnippets_cms_ugcpost_copy {
    name: 'wagtailsnippets_cms_ugcpost:copy';
    args: wagtailsnippets_cms_ugcpost_copy_args;
}

interface wagtailsnippets_cms_ugcpost_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_ugcpost_choose {
    name: 'wagtailsnippetchoosers_cms_ugcpost:choose';
    args: wagtailsnippetchoosers_cms_ugcpost_choose_args;
}

interface wagtailsnippetchoosers_cms_ugcpost_choose_args {
}

interface wagtailsnippetchoosers_cms_ugcpost_choose_results {
    name: 'wagtailsnippetchoosers_cms_ugcpost:choose_results';
    args: wagtailsnippetchoosers_cms_ugcpost_choose_results_args;
}

interface wagtailsnippetchoosers_cms_ugcpost_choose_results_args {
}

interface wagtailsnippetchoosers_cms_ugcpost_chosen {
    name: 'wagtailsnippetchoosers_cms_ugcpost:chosen';
    args: wagtailsnippetchoosers_cms_ugcpost_chosen_args;
}

interface wagtailsnippetchoosers_cms_ugcpost_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_ugcpost_chosen_multiple {
    name: 'wagtailsnippetchoosers_cms_ugcpost:chosen_multiple';
    args: wagtailsnippetchoosers_cms_ugcpost_chosen_multiple_args;
}

interface wagtailsnippetchoosers_cms_ugcpost_chosen_multiple_args {
}

interface wagtailsnippetchoosers_cms_ugcpost_create {
    name: 'wagtailsnippetchoosers_cms_ugcpost:create';
    args: wagtailsnippetchoosers_cms_ugcpost_create_args;
}

interface wagtailsnippetchoosers_cms_ugcpost_create_args {
}

interface wagtailsnippets_cms_tempurlovestorycategory_list {
    name: 'wagtailsnippets_cms_tempurlovestorycategory:list';
    args: wagtailsnippets_cms_tempurlovestorycategory_list_args;
}

interface wagtailsnippets_cms_tempurlovestorycategory_list_args {
}

interface wagtailsnippets_cms_tempurlovestorycategory_list_results {
    name: 'wagtailsnippets_cms_tempurlovestorycategory:list_results';
    args: wagtailsnippets_cms_tempurlovestorycategory_list_results_args;
}

interface wagtailsnippets_cms_tempurlovestorycategory_list_results_args {
}

interface wagtailsnippets_cms_tempurlovestorycategory_add {
    name: 'wagtailsnippets_cms_tempurlovestorycategory:add';
    args: wagtailsnippets_cms_tempurlovestorycategory_add_args;
}

interface wagtailsnippets_cms_tempurlovestorycategory_add_args {
}

interface wagtailsnippets_cms_tempurlovestorycategory_edit {
    name: 'wagtailsnippets_cms_tempurlovestorycategory:edit';
    args: wagtailsnippets_cms_tempurlovestorycategory_edit_args;
}

interface wagtailsnippets_cms_tempurlovestorycategory_edit_args {
    pk: string;
}

interface wagtailsnippets_cms_tempurlovestorycategory_delete {
    name: 'wagtailsnippets_cms_tempurlovestorycategory:delete';
    args: wagtailsnippets_cms_tempurlovestorycategory_delete_args;
}

interface wagtailsnippets_cms_tempurlovestorycategory_delete_args {
    pk: string;
}

interface wagtailsnippets_cms_tempurlovestorycategory_usage {
    name: 'wagtailsnippets_cms_tempurlovestorycategory:usage';
    args: wagtailsnippets_cms_tempurlovestorycategory_usage_args;
}

interface wagtailsnippets_cms_tempurlovestorycategory_usage_args {
    pk: string;
}

interface wagtailsnippets_cms_tempurlovestorycategory_history {
    name: 'wagtailsnippets_cms_tempurlovestorycategory:history';
    args: wagtailsnippets_cms_tempurlovestorycategory_history_args;
}

interface wagtailsnippets_cms_tempurlovestorycategory_history_args {
    pk: string;
}

interface wagtailsnippets_cms_tempurlovestorycategory_history_results {
    name: 'wagtailsnippets_cms_tempurlovestorycategory:history_results';
    args: wagtailsnippets_cms_tempurlovestorycategory_history_results_args;
}

interface wagtailsnippets_cms_tempurlovestorycategory_history_results_args {
    pk: string;
}

interface wagtailsnippets_cms_tempurlovestorycategory_copy {
    name: 'wagtailsnippets_cms_tempurlovestorycategory:copy';
    args: wagtailsnippets_cms_tempurlovestorycategory_copy_args;
}

interface wagtailsnippets_cms_tempurlovestorycategory_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_tempurlovestorycategory_choose {
    name: 'wagtailsnippetchoosers_cms_tempurlovestorycategory:choose';
    args: wagtailsnippetchoosers_cms_tempurlovestorycategory_choose_args;
}

interface wagtailsnippetchoosers_cms_tempurlovestorycategory_choose_args {
}

interface wagtailsnippetchoosers_cms_tempurlovestorycategory_choose_results {
    name: 'wagtailsnippetchoosers_cms_tempurlovestorycategory:choose_results';
    args: wagtailsnippetchoosers_cms_tempurlovestorycategory_choose_results_args;
}

interface wagtailsnippetchoosers_cms_tempurlovestorycategory_choose_results_args {
}

interface wagtailsnippetchoosers_cms_tempurlovestorycategory_chosen {
    name: 'wagtailsnippetchoosers_cms_tempurlovestorycategory:chosen';
    args: wagtailsnippetchoosers_cms_tempurlovestorycategory_chosen_args;
}

interface wagtailsnippetchoosers_cms_tempurlovestorycategory_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_cms_tempurlovestorycategory_chosen_multiple {
    name: 'wagtailsnippetchoosers_cms_tempurlovestorycategory:chosen_multiple';
    args: wagtailsnippetchoosers_cms_tempurlovestorycategory_chosen_multiple_args;
}

interface wagtailsnippetchoosers_cms_tempurlovestorycategory_chosen_multiple_args {
}

interface wagtailsnippetchoosers_cms_tempurlovestorycategory_create {
    name: 'wagtailsnippetchoosers_cms_tempurlovestorycategory:create';
    args: wagtailsnippetchoosers_cms_tempurlovestorycategory_create_args;
}

interface wagtailsnippetchoosers_cms_tempurlovestorycategory_create_args {
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_list {
    name: 'wagtailsnippets_tempur_search_dynamicsearchsnippet:list';
    args: wagtailsnippets_tempur_search_dynamicsearchsnippet_list_args;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_list_args {
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_list_results {
    name: 'wagtailsnippets_tempur_search_dynamicsearchsnippet:list_results';
    args: wagtailsnippets_tempur_search_dynamicsearchsnippet_list_results_args;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_list_results_args {
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_add {
    name: 'wagtailsnippets_tempur_search_dynamicsearchsnippet:add';
    args: wagtailsnippets_tempur_search_dynamicsearchsnippet_add_args;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_add_args {
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_edit {
    name: 'wagtailsnippets_tempur_search_dynamicsearchsnippet:edit';
    args: wagtailsnippets_tempur_search_dynamicsearchsnippet_edit_args;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_edit_args {
    pk: string;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_delete {
    name: 'wagtailsnippets_tempur_search_dynamicsearchsnippet:delete';
    args: wagtailsnippets_tempur_search_dynamicsearchsnippet_delete_args;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_delete_args {
    pk: string;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_usage {
    name: 'wagtailsnippets_tempur_search_dynamicsearchsnippet:usage';
    args: wagtailsnippets_tempur_search_dynamicsearchsnippet_usage_args;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_usage_args {
    pk: string;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_history {
    name: 'wagtailsnippets_tempur_search_dynamicsearchsnippet:history';
    args: wagtailsnippets_tempur_search_dynamicsearchsnippet_history_args;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_history_args {
    pk: string;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_history_results {
    name: 'wagtailsnippets_tempur_search_dynamicsearchsnippet:history_results';
    args: wagtailsnippets_tempur_search_dynamicsearchsnippet_history_results_args;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_history_results_args {
    pk: string;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_copy {
    name: 'wagtailsnippets_tempur_search_dynamicsearchsnippet:copy';
    args: wagtailsnippets_tempur_search_dynamicsearchsnippet_copy_args;
}

interface wagtailsnippets_tempur_search_dynamicsearchsnippet_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_choose {
    name: 'wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet:choose';
    args: wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_choose_args;
}

interface wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_choose_args {
}

interface wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_choose_results {
    name: 'wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet:choose_results';
    args: wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_choose_results_args;
}

interface wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_choose_results_args {
}

interface wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_chosen {
    name: 'wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet:chosen';
    args: wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_chosen_args;
}

interface wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_chosen_multiple {
    name: 'wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet:chosen_multiple';
    args: wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_create {
    name: 'wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet:create';
    args: wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_create_args;
}

interface wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_create_args {
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_list {
    name: 'wagtailsnippets_tempur_search_dynamic404pagesnippet:list';
    args: wagtailsnippets_tempur_search_dynamic404pagesnippet_list_args;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_list_args {
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_list_results {
    name: 'wagtailsnippets_tempur_search_dynamic404pagesnippet:list_results';
    args: wagtailsnippets_tempur_search_dynamic404pagesnippet_list_results_args;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_list_results_args {
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_add {
    name: 'wagtailsnippets_tempur_search_dynamic404pagesnippet:add';
    args: wagtailsnippets_tempur_search_dynamic404pagesnippet_add_args;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_add_args {
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_edit {
    name: 'wagtailsnippets_tempur_search_dynamic404pagesnippet:edit';
    args: wagtailsnippets_tempur_search_dynamic404pagesnippet_edit_args;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_edit_args {
    pk: string;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_delete {
    name: 'wagtailsnippets_tempur_search_dynamic404pagesnippet:delete';
    args: wagtailsnippets_tempur_search_dynamic404pagesnippet_delete_args;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_delete_args {
    pk: string;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_usage {
    name: 'wagtailsnippets_tempur_search_dynamic404pagesnippet:usage';
    args: wagtailsnippets_tempur_search_dynamic404pagesnippet_usage_args;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_usage_args {
    pk: string;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_history {
    name: 'wagtailsnippets_tempur_search_dynamic404pagesnippet:history';
    args: wagtailsnippets_tempur_search_dynamic404pagesnippet_history_args;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_history_args {
    pk: string;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_history_results {
    name: 'wagtailsnippets_tempur_search_dynamic404pagesnippet:history_results';
    args: wagtailsnippets_tempur_search_dynamic404pagesnippet_history_results_args;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_history_results_args {
    pk: string;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_copy {
    name: 'wagtailsnippets_tempur_search_dynamic404pagesnippet:copy';
    args: wagtailsnippets_tempur_search_dynamic404pagesnippet_copy_args;
}

interface wagtailsnippets_tempur_search_dynamic404pagesnippet_copy_args {
    pk: string;
}

interface wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_choose {
    name: 'wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet:choose';
    args: wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_choose_args;
}

interface wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_choose_args {
}

interface wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_choose_results {
    name: 'wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet:choose_results';
    args: wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_choose_results_args;
}

interface wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_choose_results_args {
}

interface wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_chosen {
    name: 'wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet:chosen';
    args: wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_chosen_args;
}

interface wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_chosen_multiple {
    name: 'wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet:chosen_multiple';
    args: wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_chosen_multiple_args;
}

interface wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_chosen_multiple_args {
}

interface wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_create {
    name: 'wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet:create';
    args: wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_create_args;
}

interface wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_create_args {
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_list {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:list';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_list_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_list_args {
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_list_results {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:list_results';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_list_results_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_list_results_args {
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_add {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:add';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_add_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_add_args {
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_edit {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:edit';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_edit_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_edit_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_delete {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:delete';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_delete_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_delete_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_usage {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:usage';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_usage_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_usage_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_history {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:history';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_history_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_history_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_history_results {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:history_results';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_history_results_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_history_results_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_copy {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:copy';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_copy_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_copy_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_add {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:preview_on_add';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_add_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_add_args {
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_edit {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:preview_on_edit';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_edit_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_edit_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_view {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:revisions_view';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_view_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_view_args {
    pk: string;
    revision_id: number;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_revert {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:revisions_revert';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_revert_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_revert_args {
    pk: string;
    revision_id: number;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_unschedule {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:revisions_unschedule';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_unschedule_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_unschedule_args {
    pk: string;
    revision_id: number;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_unpublish {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:unpublish';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_unpublish_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_unpublish_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_lock {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:lock';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_lock_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_lock_args {
    pk: string;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_unlock {
    name: 'wagtailsnippets_thelabui_labuitoolboxsnippet:unlock';
    args: wagtailsnippets_thelabui_labuitoolboxsnippet_unlock_args;
}

interface wagtailsnippets_thelabui_labuitoolboxsnippet_unlock_args {
    pk: string;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose {
    name: 'wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:choose';
    args: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_args;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_args {
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_results {
    name: 'wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:choose_results';
    args: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_results_args;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_results_args {
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen {
    name: 'wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:chosen';
    args: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_args;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_args {
    pk: string;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_multiple {
    name: 'wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:chosen_multiple';
    args: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_multiple_args;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_multiple_args {
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_create {
    name: 'wagtailsnippetchoosers_thelabui_labuitoolboxsnippet:create';
    args: wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_create_args;
}

interface wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_create_args {
}

interface wagtailvideos_chooser_choose {
    name: 'wagtailvideos_chooser:choose';
    args: wagtailvideos_chooser_choose_args;
}

interface wagtailvideos_chooser_choose_args {
}

interface wagtailvideos_chooser_choose_results {
    name: 'wagtailvideos_chooser:choose_results';
    args: wagtailvideos_chooser_choose_results_args;
}

interface wagtailvideos_chooser_choose_results_args {
}

interface wagtailvideos_chooser_chosen {
    name: 'wagtailvideos_chooser:chosen';
    args: wagtailvideos_chooser_chosen_args;
}

interface wagtailvideos_chooser_chosen_args {
    pk: string;
}

interface wagtailvideos_chooser_chosen_multiple {
    name: 'wagtailvideos_chooser:chosen_multiple';
    args: wagtailvideos_chooser_chosen_multiple_args;
}

interface wagtailvideos_chooser_chosen_multiple_args {
}

interface wagtailvideos_chooser_create {
    name: 'wagtailvideos_chooser:create';
    args: wagtailvideos_chooser_create_args;
}

interface wagtailvideos_chooser_create_args {
}

interface wagtaildocs_chooser_choose {
    name: 'wagtaildocs_chooser:choose';
    args: wagtaildocs_chooser_choose_args;
}

interface wagtaildocs_chooser_choose_args {
}

interface wagtaildocs_chooser_choose_results {
    name: 'wagtaildocs_chooser:choose_results';
    args: wagtaildocs_chooser_choose_results_args;
}

interface wagtaildocs_chooser_choose_results_args {
}

interface wagtaildocs_chooser_chosen {
    name: 'wagtaildocs_chooser:chosen';
    args: wagtaildocs_chooser_chosen_args;
}

interface wagtaildocs_chooser_chosen_args {
    pk: string;
}

interface wagtaildocs_chooser_chosen_multiple {
    name: 'wagtaildocs_chooser:chosen_multiple';
    args: wagtaildocs_chooser_chosen_multiple_args;
}

interface wagtaildocs_chooser_chosen_multiple_args {
}

interface wagtaildocs_chooser_create {
    name: 'wagtaildocs_chooser:create';
    args: wagtaildocs_chooser_create_args;
}

interface wagtaildocs_chooser_create_args {
}

interface wagtailsites_index {
    name: 'wagtailsites:index';
    args: wagtailsites_index_args;
}

interface wagtailsites_index_args {
}

interface wagtailsites_index_results {
    name: 'wagtailsites:index_results';
    args: wagtailsites_index_results_args;
}

interface wagtailsites_index_results_args {
}

interface wagtailsites_add {
    name: 'wagtailsites:add';
    args: wagtailsites_add_args;
}

interface wagtailsites_add_args {
}

interface wagtailsites_edit {
    name: 'wagtailsites:edit';
    args: wagtailsites_edit_args;
}

interface wagtailsites_edit_args {
    pk: string;
}

interface wagtailsites_delete {
    name: 'wagtailsites:delete';
    args: wagtailsites_delete_args;
}

interface wagtailsites_delete_args {
    pk: string;
}

interface wagtailsites_history {
    name: 'wagtailsites:history';
    args: wagtailsites_history_args;
}

interface wagtailsites_history_args {
    pk: string;
}

interface wagtailsites_history_results {
    name: 'wagtailsites:history_results';
    args: wagtailsites_history_results_args;
}

interface wagtailsites_history_results_args {
    pk: string;
}

interface wagtailsites_usage {
    name: 'wagtailsites:usage';
    args: wagtailsites_usage_args;
}

interface wagtailsites_usage_args {
    pk: string;
}

interface wagtailsites_copy {
    name: 'wagtailsites:copy';
    args: wagtailsites_copy_args;
}

interface wagtailsites_copy_args {
    pk: string;
}

interface wagtailusers_users_index {
    name: 'wagtailusers_users:index';
    args: wagtailusers_users_index_args;
}

interface wagtailusers_users_index_args {
}

interface wagtailusers_users_index_results {
    name: 'wagtailusers_users:index_results';
    args: wagtailusers_users_index_results_args;
}

interface wagtailusers_users_index_results_args {
}

interface wagtailusers_users_add {
    name: 'wagtailusers_users:add';
    args: wagtailusers_users_add_args;
}

interface wagtailusers_users_add_args {
}

interface wagtailusers_users_edit {
    name: 'wagtailusers_users:edit';
    args: wagtailusers_users_edit_args;
}

interface wagtailusers_users_edit_args {
    pk: string;
}

interface wagtailusers_users_delete {
    name: 'wagtailusers_users:delete';
    args: wagtailusers_users_delete_args;
}

interface wagtailusers_users_delete_args {
    pk: string;
}

interface wagtailusers_users_history {
    name: 'wagtailusers_users:history';
    args: wagtailusers_users_history_args;
}

interface wagtailusers_users_history_args {
    pk: string;
}

interface wagtailusers_users_history_results {
    name: 'wagtailusers_users:history_results';
    args: wagtailusers_users_history_results_args;
}

interface wagtailusers_users_history_results_args {
    pk: string;
}

interface wagtailusers_users_usage {
    name: 'wagtailusers_users:usage';
    args: wagtailusers_users_usage_args;
}

interface wagtailusers_users_usage_args {
    pk: string;
}

interface wagtailusers_users_copy {
    name: 'wagtailusers_users:copy';
    args: wagtailusers_users_copy_args;
}

interface wagtailusers_users_copy_args {
    pk: string;
}

interface wagtailusers_groups_index {
    name: 'wagtailusers_groups:index';
    args: wagtailusers_groups_index_args;
}

interface wagtailusers_groups_index_args {
}

interface wagtailusers_groups_index_results {
    name: 'wagtailusers_groups:index_results';
    args: wagtailusers_groups_index_results_args;
}

interface wagtailusers_groups_index_results_args {
}

interface wagtailusers_groups_add {
    name: 'wagtailusers_groups:add';
    args: wagtailusers_groups_add_args;
}

interface wagtailusers_groups_add_args {
}

interface wagtailusers_groups_edit {
    name: 'wagtailusers_groups:edit';
    args: wagtailusers_groups_edit_args;
}

interface wagtailusers_groups_edit_args {
    pk: string;
}

interface wagtailusers_groups_delete {
    name: 'wagtailusers_groups:delete';
    args: wagtailusers_groups_delete_args;
}

interface wagtailusers_groups_delete_args {
    pk: string;
}

interface wagtailusers_groups_history {
    name: 'wagtailusers_groups:history';
    args: wagtailusers_groups_history_args;
}

interface wagtailusers_groups_history_args {
    pk: string;
}

interface wagtailusers_groups_history_results {
    name: 'wagtailusers_groups:history_results';
    args: wagtailusers_groups_history_results_args;
}

interface wagtailusers_groups_history_results_args {
    pk: string;
}

interface wagtailusers_groups_usage {
    name: 'wagtailusers_groups:usage';
    args: wagtailusers_groups_usage_args;
}

interface wagtailusers_groups_usage_args {
    pk: string;
}

interface wagtaillocales_index {
    name: 'wagtaillocales:index';
    args: wagtaillocales_index_args;
}

interface wagtaillocales_index_args {
}

interface wagtaillocales_index_results {
    name: 'wagtaillocales:index_results';
    args: wagtaillocales_index_results_args;
}

interface wagtaillocales_index_results_args {
}

interface wagtaillocales_add {
    name: 'wagtaillocales:add';
    args: wagtaillocales_add_args;
}

interface wagtaillocales_add_args {
}

interface wagtaillocales_edit {
    name: 'wagtaillocales:edit';
    args: wagtaillocales_edit_args;
}

interface wagtaillocales_edit_args {
    pk: string;
}

interface wagtaillocales_delete {
    name: 'wagtaillocales:delete';
    args: wagtaillocales_delete_args;
}

interface wagtaillocales_delete_args {
    pk: string;
}

interface wagtaillocales_history {
    name: 'wagtaillocales:history';
    args: wagtaillocales_history_args;
}

interface wagtaillocales_history_args {
    pk: string;
}

interface wagtaillocales_history_results {
    name: 'wagtaillocales:history_results';
    args: wagtaillocales_history_results_args;
}

interface wagtaillocales_history_results_args {
    pk: string;
}

interface wagtaillocales_usage {
    name: 'wagtaillocales:usage';
    args: wagtaillocales_usage_args;
}

interface wagtaillocales_usage_args {
    pk: string;
}

interface wagtaillocales_copy {
    name: 'wagtaillocales:copy';
    args: wagtaillocales_copy_args;
}

interface wagtaillocales_copy_args {
    pk: string;
}

interface tsicommon_cms_product_chooser_choose {
    name: 'tsicommon_cms_product_chooser:choose';
    args: tsicommon_cms_product_chooser_choose_args;
}

interface tsicommon_cms_product_chooser_choose_args {
}

interface tsicommon_cms_product_chooser_choose_results {
    name: 'tsicommon_cms_product_chooser:choose_results';
    args: tsicommon_cms_product_chooser_choose_results_args;
}

interface tsicommon_cms_product_chooser_choose_results_args {
}

interface tsicommon_cms_product_chooser_chosen {
    name: 'tsicommon_cms_product_chooser:chosen';
    args: tsicommon_cms_product_chooser_chosen_args;
}

interface tsicommon_cms_product_chooser_chosen_args {
    pk: string;
}

interface tsicommon_cms_product_chooser_chosen_multiple {
    name: 'tsicommon_cms_product_chooser:chosen_multiple';
    args: tsicommon_cms_product_chooser_chosen_multiple_args;
}

interface tsicommon_cms_product_chooser_chosen_multiple_args {
}

interface tsicommon_cms_product_chooser_create {
    name: 'tsicommon_cms_product_chooser:create';
    args: tsicommon_cms_product_chooser_create_args;
}

interface tsicommon_cms_product_chooser_create_args {
}

interface tsicommon_cms_location_chooser_choose {
    name: 'tsicommon_cms_location_chooser:choose';
    args: tsicommon_cms_location_chooser_choose_args;
}

interface tsicommon_cms_location_chooser_choose_args {
}

interface tsicommon_cms_location_chooser_choose_results {
    name: 'tsicommon_cms_location_chooser:choose_results';
    args: tsicommon_cms_location_chooser_choose_results_args;
}

interface tsicommon_cms_location_chooser_choose_results_args {
}

interface tsicommon_cms_location_chooser_chosen {
    name: 'tsicommon_cms_location_chooser:chosen';
    args: tsicommon_cms_location_chooser_chosen_args;
}

interface tsicommon_cms_location_chooser_chosen_args {
    pk: string;
}

interface tsicommon_cms_location_chooser_chosen_multiple {
    name: 'tsicommon_cms_location_chooser:chosen_multiple';
    args: tsicommon_cms_location_chooser_chosen_multiple_args;
}

interface tsicommon_cms_location_chooser_chosen_multiple_args {
}

interface tsicommon_cms_location_chooser_create {
    name: 'tsicommon_cms_location_chooser:create';
    args: tsicommon_cms_location_chooser_create_args;
}

interface tsicommon_cms_location_chooser_create_args {
}

interface wagtailimages_chooser_choose {
    name: 'wagtailimages_chooser:choose';
    args: wagtailimages_chooser_choose_args;
}

interface wagtailimages_chooser_choose_args {
}

interface wagtailimages_chooser_choose_results {
    name: 'wagtailimages_chooser:choose_results';
    args: wagtailimages_chooser_choose_results_args;
}

interface wagtailimages_chooser_choose_results_args {
}

interface wagtailimages_chooser_chosen {
    name: 'wagtailimages_chooser:chosen';
    args: wagtailimages_chooser_chosen_args;
}

interface wagtailimages_chooser_chosen_args {
    pk: string;
}

interface wagtailimages_chooser_chosen_multiple {
    name: 'wagtailimages_chooser:chosen_multiple';
    args: wagtailimages_chooser_chosen_multiple_args;
}

interface wagtailimages_chooser_chosen_multiple_args {
}

interface wagtailimages_chooser_create {
    name: 'wagtailimages_chooser:create';
    args: wagtailimages_chooser_create_args;
}

interface wagtailimages_chooser_create_args {
}

interface wagtailimages_chooser_select_format {
    name: 'wagtailimages_chooser:select_format';
    args: wagtailimages_chooser_select_format_args;
}

interface wagtailimages_chooser_select_format_args {
    image_id: number;
}

interface wagtaildocs_index {
    name: 'wagtaildocs:index';
    args: wagtaildocs_index_args;
}

interface wagtaildocs_index_args {
}

interface wagtaildocs_index_results {
    name: 'wagtaildocs:index_results';
    args: wagtaildocs_index_results_args;
}

interface wagtaildocs_index_results_args {
}

interface wagtaildocs_add {
    name: 'wagtaildocs:add';
    args: wagtaildocs_add_args;
}

interface wagtaildocs_add_args {
}

interface wagtaildocs_edit {
    name: 'wagtaildocs:edit';
    args: wagtaildocs_edit_args;
}

interface wagtaildocs_edit_args {
    document_id: number;
}

interface wagtaildocs_delete {
    name: 'wagtaildocs:delete';
    args: wagtaildocs_delete_args;
}

interface wagtaildocs_delete_args {
    document_id: number;
}

interface wagtaildocs_add_multiple {
    name: 'wagtaildocs:add_multiple';
    args: wagtaildocs_add_multiple_args;
}

interface wagtaildocs_add_multiple_args {
}

interface wagtaildocs_edit_multiple {
    name: 'wagtaildocs:edit_multiple';
    args: wagtaildocs_edit_multiple_args;
}

interface wagtaildocs_edit_multiple_args {
    doc_id: number;
}

interface wagtaildocs_create_multiple_from_uploaded_document {
    name: 'wagtaildocs:create_multiple_from_uploaded_document';
    args: wagtaildocs_create_multiple_from_uploaded_document_args;
}

interface wagtaildocs_create_multiple_from_uploaded_document_args {
    uploaded_file_id: number;
}

interface wagtaildocs_delete_multiple {
    name: 'wagtaildocs:delete_multiple';
    args: wagtaildocs_delete_multiple_args;
}

interface wagtaildocs_delete_multiple_args {
    doc_id: number;
}

interface wagtaildocs_delete_upload_multiple {
    name: 'wagtaildocs:delete_upload_multiple';
    args: wagtaildocs_delete_upload_multiple_args;
}

interface wagtaildocs_delete_upload_multiple_args {
    uploaded_file_id: number;
}

interface wagtaildocs_document_usage {
    name: 'wagtaildocs:document_usage';
    args: wagtaildocs_document_usage_args;
}

interface wagtaildocs_document_usage_args {
    document_id: number;
}

interface wagtailembeds_chooser {
    name: 'wagtailembeds:chooser';
    args: wagtailembeds_chooser_args;
}

interface wagtailembeds_chooser_args {
}

interface wagtailembeds_chooser_upload {
    name: 'wagtailembeds:chooser_upload';
    args: wagtailembeds_chooser_upload_args;
}

interface wagtailembeds_chooser_upload_args {
}

interface wagtailsnippets_index {
    name: 'wagtailsnippets:index';
    args: wagtailsnippets_index_args;
}

interface wagtailsnippets_index_args {
}

interface wagtail_localize_javascript_catalog {
    name: 'wagtail_localize:javascript_catalog';
    args: wagtail_localize_javascript_catalog_args;
}

interface wagtail_localize_javascript_catalog_args {
}

interface wagtail_localize_submit_page_translation {
    name: 'wagtail_localize:submit_page_translation';
    args: wagtail_localize_submit_page_translation_args;
}

interface wagtail_localize_submit_page_translation_args {
    page_id: number;
}

interface wagtail_localize_submit_snippet_translation {
    name: 'wagtail_localize:submit_snippet_translation';
    args: wagtail_localize_submit_snippet_translation_args;
}

interface wagtail_localize_submit_snippet_translation_args {
    app_label: string;
    model_name: string;
    pk: string;
}

interface wagtail_localize_update_translations {
    name: 'wagtail_localize:update_translations';
    args: wagtail_localize_update_translations_args;
}

interface wagtail_localize_update_translations_args {
    translation_source_id: number;
}

interface wagtail_localize_edit_string_translation {
    name: 'wagtail_localize:edit_string_translation';
    args: wagtail_localize_edit_string_translation_args;
}

interface wagtail_localize_edit_string_translation_args {
    translation_id: number;
    string_segment_id: number;
}

interface wagtail_localize_edit_override {
    name: 'wagtail_localize:edit_override';
    args: wagtail_localize_edit_override_args;
}

interface wagtail_localize_edit_override_args {
    translation_id: number;
    overridable_segment_id: number;
}

interface wagtail_localize_download_pofile {
    name: 'wagtail_localize:download_pofile';
    args: wagtail_localize_download_pofile_args;
}

interface wagtail_localize_download_pofile_args {
    translation_id: number;
}

interface wagtail_localize_upload_pofile {
    name: 'wagtail_localize:upload_pofile';
    args: wagtail_localize_upload_pofile_args;
}

interface wagtail_localize_upload_pofile_args {
    translation_id: number;
}

interface wagtail_localize_machine_translate {
    name: 'wagtail_localize:machine_translate';
    args: wagtail_localize_machine_translate_args;
}

interface wagtail_localize_machine_translate_args {
    translation_id: number;
}

interface wagtail_localize_preview_translation {
    name: 'wagtail_localize:preview_translation';
    args: wagtail_localize_preview_translation_args;
}

interface wagtail_localize_preview_translation_args {
    translation_id: number;
    mode: string;
}

interface wagtail_localize_stop_translation {
    name: 'wagtail_localize:stop_translation';
    args: wagtail_localize_stop_translation_args;
}

interface wagtail_localize_stop_translation_args {
    translation_id: number;
}

interface wagtail_localize_convert_to_alias {
    name: 'wagtail_localize:convert_to_alias';
    args: wagtail_localize_convert_to_alias_args;
}

interface wagtail_localize_convert_to_alias_args {
    page_id: number;
}

interface wagtail_localize_translations_report {
    name: 'wagtail_localize:translations_report';
    args: wagtail_localize_translations_report_args;
}

interface wagtail_localize_translations_report_args {
}

interface wagtail_localize_snippets_api_listing {
    name: 'wagtail_localize:snippets_api_listing';
    args: wagtail_localize_snippets_api_listing_args;
}

interface wagtail_localize_snippets_api_listing_args {
    app_label: string;
    model_name: string;
}

interface wagtail_localize_snippets_api_detail {
    name: 'wagtail_localize:snippets_api_detail';
    args: wagtail_localize_snippets_api_detail_args;
}

interface wagtail_localize_snippets_api_detail_args {
    app_label: string;
    model_name: string;
    pk: string;
}

interface wagtail_localize_translations_report_results {
    name: 'wagtail_localize:translations_report_results';
    args: wagtail_localize_translations_report_results_args;
}

interface wagtail_localize_translations_report_results_args {
}

interface wagtailforms_index {
    name: 'wagtailforms:index';
    args: wagtailforms_index_args;
}

interface wagtailforms_index_args {
}

interface wagtailforms_index_results {
    name: 'wagtailforms:index_results';
    args: wagtailforms_index_results_args;
}

interface wagtailforms_index_results_args {
}

interface wagtailforms_list_submissions {
    name: 'wagtailforms:list_submissions';
    args: wagtailforms_list_submissions_args;
}

interface wagtailforms_list_submissions_args {
    page_id: number;
}

interface wagtailforms_list_submissions_results {
    name: 'wagtailforms:list_submissions_results';
    args: wagtailforms_list_submissions_results_args;
}

interface wagtailforms_list_submissions_results_args {
    page_id: number;
}

interface wagtailforms_delete_submissions {
    name: 'wagtailforms:delete_submissions';
    args: wagtailforms_delete_submissions_args;
}

interface wagtailforms_delete_submissions_args {
    page_id: number;
}

interface wagtailredirects_index {
    name: 'wagtailredirects:index';
    args: wagtailredirects_index_args;
}

interface wagtailredirects_index_args {
}

interface wagtailredirects_index_results {
    name: 'wagtailredirects:index_results';
    args: wagtailredirects_index_results_args;
}

interface wagtailredirects_index_results_args {
}

interface wagtailredirects_add {
    name: 'wagtailredirects:add';
    args: wagtailredirects_add_args;
}

interface wagtailredirects_add_args {
}

interface wagtailredirects_edit {
    name: 'wagtailredirects:edit';
    args: wagtailredirects_edit_args;
}

interface wagtailredirects_edit_args {
    redirect_id: number;
}

interface wagtailredirects_delete {
    name: 'wagtailredirects:delete';
    args: wagtailredirects_delete_args;
}

interface wagtailredirects_delete_args {
    redirect_id: number;
}

interface wagtailredirects_start_import {
    name: 'wagtailredirects:start_import';
    args: wagtailredirects_start_import_args;
}

interface wagtailredirects_start_import_args {
}

interface wagtailredirects_process_import {
    name: 'wagtailredirects:process_import';
    args: wagtailredirects_process_import_args;
}

interface wagtailredirects_process_import_args {
}

interface wagtailsearchpromotions_index {
    name: 'wagtailsearchpromotions:index';
    args: wagtailsearchpromotions_index_args;
}

interface wagtailsearchpromotions_index_args {
}

interface wagtailsearchpromotions_index_results {
    name: 'wagtailsearchpromotions:index_results';
    args: wagtailsearchpromotions_index_results_args;
}

interface wagtailsearchpromotions_index_results_args {
}

interface wagtailsearchpromotions_add {
    name: 'wagtailsearchpromotions:add';
    args: wagtailsearchpromotions_add_args;
}

interface wagtailsearchpromotions_add_args {
}

interface wagtailsearchpromotions_edit {
    name: 'wagtailsearchpromotions:edit';
    args: wagtailsearchpromotions_edit_args;
}

interface wagtailsearchpromotions_edit_args {
    query_id: number;
}

interface wagtailsearchpromotions_delete {
    name: 'wagtailsearchpromotions:delete';
    args: wagtailsearchpromotions_delete_args;
}

interface wagtailsearchpromotions_delete_args {
    query_id: number;
}

interface wagtailsearchpromotions_chooser {
    name: 'wagtailsearchpromotions:chooser';
    args: wagtailsearchpromotions_chooser_args;
}

interface wagtailsearchpromotions_chooser_args {
}

interface wagtailsearchpromotions_chooserresults {
    name: 'wagtailsearchpromotions:chooserresults';
    args: wagtailsearchpromotions_chooserresults_args;
}

interface wagtailsearchpromotions_chooserresults_args {
}

interface wagtailsearchpromotions_search_terms {
    name: 'wagtailsearchpromotions:search_terms';
    args: wagtailsearchpromotions_search_terms_args;
}

interface wagtailsearchpromotions_search_terms_args {
}

interface wagtailsearchpromotions_search_terms_results {
    name: 'wagtailsearchpromotions:search_terms_results';
    args: wagtailsearchpromotions_search_terms_results_args;
}

interface wagtailsearchpromotions_search_terms_results_args {
}

interface wagtailstyleguide {
    name: 'wagtailstyleguide';
    args: wagtailstyleguide_args;
}

interface wagtailstyleguide_args {
}

interface wagtail_modeladmin_javascript_catalog {
    name: 'wagtail_modeladmin:javascript_catalog';
    args: wagtail_modeladmin_javascript_catalog_args;
}

interface wagtail_modeladmin_javascript_catalog_args {
}

interface cms_flagship_page_bulk_update {
    name: 'cms:flagship_page_bulk_update';
    args: cms_flagship_page_bulk_update_args;
}

interface cms_flagship_page_bulk_update_args {
}

interface cms_flagship_page_bulk_update_apply {
    name: 'cms:flagship_page_bulk_update_apply';
    args: cms_flagship_page_bulk_update_apply_args;
}

interface cms_flagship_page_bulk_update_apply_args {
}

interface cms_mattress_match_bulk_import {
    name: 'cms:mattress-match-bulk-import';
    args: cms_mattress_match_bulk_import_args;
}

interface cms_mattress_match_bulk_import_args {
}

interface cms_mattress_match_bulk_import_apply {
    name: 'cms:mattress-match-bulk-import-apply';
    args: cms_mattress_match_bulk_import_apply_args;
}

interface cms_mattress_match_bulk_import_apply_args {
}

interface tsicommon_cms_admin_tooltip_content_modal {
    name: 'tsicommon-cms-admin:tooltip-content-modal';
    args: tsicommon_cms_admin_tooltip_content_modal_args;
}

interface tsicommon_cms_admin_tooltip_content_modal_args {
}

interface tsicommon_cms_admin_wistia_link_content_modal {
    name: 'tsicommon-cms-admin:wistia-link-content-modal';
    args: tsicommon_cms_admin_wistia_link_content_modal_args;
}

interface tsicommon_cms_admin_wistia_link_content_modal_args {
}

interface wagtailimages_index {
    name: 'wagtailimages:index';
    args: wagtailimages_index_args;
}

interface wagtailimages_index_args {
}

interface wagtailimages_index_results {
    name: 'wagtailimages:index_results';
    args: wagtailimages_index_results_args;
}

interface wagtailimages_index_results_args {
}

interface wagtailimages_edit {
    name: 'wagtailimages:edit';
    args: wagtailimages_edit_args;
}

interface wagtailimages_edit_args {
    image_id: number;
}

interface wagtailimages_delete {
    name: 'wagtailimages:delete';
    args: wagtailimages_delete_args;
}

interface wagtailimages_delete_args {
    image_id: number;
}

interface wagtailimages_url_generator {
    name: 'wagtailimages:url_generator';
    args: wagtailimages_url_generator_args;
}

interface wagtailimages_url_generator_args {
    image_id: number;
}

interface wagtailimages_generate_url {
    name: 'wagtailimages:generate_url';
    args: wagtailimages_generate_url_args;
}

interface wagtailimages_generate_url_args {
    image_id: number;
    filter_spec: string;
}

interface wagtailimages_preview {
    name: 'wagtailimages:preview';
    args: wagtailimages_preview_args;
}

interface wagtailimages_preview_args {
    image_id: number;
    filter_spec: string;
}

interface wagtailimages_add {
    name: 'wagtailimages:add';
    args: wagtailimages_add_args;
}

interface wagtailimages_add_args {
}

interface wagtailimages_image_usage {
    name: 'wagtailimages:image_usage';
    args: wagtailimages_image_usage_args;
}

interface wagtailimages_image_usage_args {
    image_id: number;
}

interface wagtailimages_add_multiple {
    name: 'wagtailimages:add_multiple';
    args: wagtailimages_add_multiple_args;
}

interface wagtailimages_add_multiple_args {
}

interface wagtailimages_edit_multiple {
    name: 'wagtailimages:edit_multiple';
    args: wagtailimages_edit_multiple_args;
}

interface wagtailimages_edit_multiple_args {
    image_id: number;
}

interface wagtailimages_create_multiple_from_uploaded_image {
    name: 'wagtailimages:create_multiple_from_uploaded_image';
    args: wagtailimages_create_multiple_from_uploaded_image_args;
}

interface wagtailimages_create_multiple_from_uploaded_image_args {
    uploaded_file_id: number;
}

interface wagtailimages_delete_multiple {
    name: 'wagtailimages:delete_multiple';
    args: wagtailimages_delete_multiple_args;
}

interface wagtailimages_delete_multiple_args {
    image_id: number;
}

interface wagtailimages_delete_upload_multiple {
    name: 'wagtailimages:delete_upload_multiple';
    args: wagtailimages_delete_upload_multiple_args;
}

interface wagtailimages_delete_upload_multiple_args {
    uploaded_file_id: number;
}

interface wagtailadmin_sprite {
    name: 'wagtailadmin_sprite';
    args: wagtailadmin_sprite_args;
}

interface wagtailadmin_sprite_args {
}

interface wagtailadmin_login {
    name: 'wagtailadmin_login';
    args: wagtailadmin_login_args;
}

interface wagtailadmin_login_args {
}

interface wagtailadmin_password_reset {
    name: 'wagtailadmin_password_reset';
    args: wagtailadmin_password_reset_args;
}

interface wagtailadmin_password_reset_args {
}

interface wagtailadmin_password_reset_done {
    name: 'wagtailadmin_password_reset_done';
    args: wagtailadmin_password_reset_done_args;
}

interface wagtailadmin_password_reset_done_args {
}

interface wagtailadmin_password_reset_confirm {
    name: 'wagtailadmin_password_reset_confirm';
    args: wagtailadmin_password_reset_confirm_args;
}

interface wagtailadmin_password_reset_confirm_args {
    uidb64: string;
    token: string;
}

interface wagtailadmin_password_reset_complete {
    name: 'wagtailadmin_password_reset_complete';
    args: wagtailadmin_password_reset_complete_args;
}

interface wagtailadmin_password_reset_complete_args {
}

interface wagtailadmin_javascript_catalog {
    name: 'wagtailadmin_javascript_catalog';
    args: wagtailadmin_javascript_catalog_args;
}

interface wagtailadmin_javascript_catalog_args {
}

interface django_admindocs_docroot {
    name: 'django-admindocs-docroot';
    args: django_admindocs_docroot_args;
}

interface django_admindocs_docroot_args {
}

interface django_admindocs_bookmarklets {
    name: 'django-admindocs-bookmarklets';
    args: django_admindocs_bookmarklets_args;
}

interface django_admindocs_bookmarklets_args {
}

interface django_admindocs_tags {
    name: 'django-admindocs-tags';
    args: django_admindocs_tags_args;
}

interface django_admindocs_tags_args {
}

interface django_admindocs_filters {
    name: 'django-admindocs-filters';
    args: django_admindocs_filters_args;
}

interface django_admindocs_filters_args {
}

interface django_admindocs_views_index {
    name: 'django-admindocs-views-index';
    args: django_admindocs_views_index_args;
}

interface django_admindocs_views_index_args {
}

interface django_admindocs_views_detail {
    name: 'django-admindocs-views-detail';
    args: django_admindocs_views_detail_args;
}

interface django_admindocs_views_detail_args {
    view: string;
}

interface django_admindocs_models_index {
    name: 'django-admindocs-models-index';
    args: django_admindocs_models_index_args;
}

interface django_admindocs_models_index_args {
}

interface django_admindocs_templates {
    name: 'django-admindocs-templates';
    args: django_admindocs_templates_args;
}

interface django_admindocs_templates_args {
    template: string;
}

interface thelabui_load_balancer_health_check {
    name: 'thelabui:load-balancer-health-check';
    args: thelabui_load_balancer_health_check_args;
}

interface thelabui_load_balancer_health_check_args {
}

interface thelabui_csrftoken_get {
    name: 'thelabui:csrftoken-get';
    args: thelabui_csrftoken_get_args;
}

interface thelabui_csrftoken_get_args {
}

interface thelabui_robots_txt {
    name: 'thelabui:robots-txt';
    args: thelabui_robots_txt_args;
}

interface thelabui_robots_txt_args {
}

interface thelabui_security_txt {
    name: 'thelabui:security-txt';
    args: thelabui_security_txt_args;
}

interface thelabui_security_txt_args {
}

interface thelabui_sitemap {
    name: 'thelabui:sitemap';
    args: thelabui_sitemap_args;
}

interface thelabui_sitemap_args {
}

interface asymmetric_jwt_auth_jwks {
    name: 'asymmetric_jwt_auth:jwks';
    args: asymmetric_jwt_auth_jwks_args;
}

interface asymmetric_jwt_auth_jwks_args {
}

interface cybersource_reply {
    name: 'cybersource-reply';
    args: cybersource_reply_args;
}

interface cybersource_reply_args {
}

interface cybersource_review_notification {
    name: 'cybersource-review-notification';
    args: cybersource_review_notification_args;
}

interface cybersource_review_notification_args {
}

interface cybersource_fingerprint_redirect {
    name: 'cybersource-fingerprint-redirect';
    args: cybersource_fingerprint_redirect_args;
}

interface cybersource_fingerprint_redirect_args {
    url_type: string;
}

interface financingapi_apply {
    name: 'financingapi:apply';
    args: financingapi_apply_args;
}

interface financingapi_apply_args {
}

interface financingapi_update_inquiry {
    name: 'financingapi:update-inquiry';
    args: financingapi_update_inquiry_args;
}

interface financingapi_update_inquiry_args {
}

interface financingapi_plan_list {
    name: 'financingapi:plan-list';
    args: financingapi_plan_list_args;
}

interface financingapi_plan_list_args {
}

interface financingapi_estimated_payment {
    name: 'financingapi:estimated-payment';
    args: financingapi_estimated_payment_args;
}

interface financingapi_estimated_payment_args {
}

interface financingapi_acct_inquiry {
    name: 'financingapi:acct-inquiry';
    args: financingapi_acct_inquiry_args;
}

interface financingapi_acct_inquiry_args {
}

interface financingapi_prequal {
    name: 'financingapi:prequal';
    args: financingapi_prequal_args;
}

interface financingapi_prequal_args {
}

interface financingapi_prequal_customer_response {
    name: 'financingapi:prequal-customer-response';
    args: financingapi_prequal_customer_response_args;
}

interface financingapi_prequal_customer_response_args {
}

interface financingapi_document_content_view {
    name: 'financingapi:document-content-view';
    args: financingapi_document_content_view_args;
}

interface financingapi_document_content_view_args {
    signed_idobj: string;
}

interface financingapi_syf_dpos_token {
    name: 'financingapi:syf-dpos-token';
    args: financingapi_syf_dpos_token_args;
}

interface financingapi_syf_dpos_token_args {
}

interface financingapi_syf_transaction_lookup {
    name: 'financingapi:syf-transaction-lookup';
    args: financingapi_syf_transaction_lookup_args;
}

interface financingapi_syf_transaction_lookup_args {
    dpos_token: string;
}

interface api_root {
    name: 'api-root';
    args: api_root_args;
}

interface api_root_args {
}

interface tsi_auth_current_user {
    name: 'tsi-auth-current-user';
    args: tsi_auth_current_user_args;
}

interface tsi_auth_current_user_args {
}

interface tsi_auth_keep_alive {
    name: 'tsi-auth-keep-alive';
    args: tsi_auth_keep_alive_args;
}

interface tsi_auth_keep_alive_args {
}

interface tsi_auth_expired_token {
    name: 'tsi-auth-expired-token';
    args: tsi_auth_expired_token_args;
}

interface tsi_auth_expired_token_args {
}

interface tsi_auth_login {
    name: 'tsi-auth-login';
    args: tsi_auth_login_args;
}

interface tsi_auth_login_args {
}

interface tsi_auth_login_token {
    name: 'tsi-auth-login-token';
    args: tsi_auth_login_token_args;
}

interface tsi_auth_login_token_args {
    token: string;
}

interface tsi_auth_change_password {
    name: 'tsi-auth-change-password';
    args: tsi_auth_change_password_args;
}

interface tsi_auth_change_password_args {
}

interface tsi_yext_entity_webhook {
    name: 'tsi-yext-entity-webhook';
    args: tsi_yext_entity_webhook_args;
}

interface tsi_yext_entity_webhook_args {
    token: string;
}

interface product_bundle_list {
    name: 'product-bundle-list';
    args: product_bundle_list_args;
}

interface product_bundle_list_args {
    pk: number;
}

interface product_concretebundle_list {
    name: 'product-concretebundle-list';
    args: product_concretebundle_list_args;
}

interface product_concretebundle_list_args {
    pk: number;
}

interface product_userconfigurablebundle_list {
    name: 'product-userconfigurablebundle-list';
    args: product_userconfigurablebundle_list_args;
}

interface product_userconfigurablebundle_list_args {
    pk: number;
}

interface oscarbundles_i18n_js {
    name: 'oscarbundles-i18n-js';
    args: oscarbundles_i18n_js_args;
}

interface oscarbundles_i18n_js_args {
}

interface bundlegrouptype_list {
    name: 'bundlegrouptype-list';
    args: bundlegrouptype_list_args;
}

interface bundlegrouptype_list_args {
}

interface bundlegroup_list {
    name: 'bundlegroup-list';
    args: bundlegroup_list_args;
}

interface bundlegroup_list_args {
}

interface bundlegroup_detail {
    name: 'bundlegroup-detail';
    args: bundlegroup_detail_args;
}

interface bundlegroup_detail_args {
    pk: number;
}

interface concretebundle_list {
    name: 'concretebundle-list';
    args: concretebundle_list_args;
}

interface concretebundle_list_args {
}

interface concretebundle_detail {
    name: 'concretebundle-detail';
    args: concretebundle_detail_args;
}

interface concretebundle_detail_args {
    pk: number;
}

interface concretebundle_product_choice_list {
    name: 'concretebundle-product-choice-list';
    args: concretebundle_product_choice_list_args;
}

interface concretebundle_product_choice_list_args {
}

interface userconfigurablebundle_list {
    name: 'userconfigurablebundle-list';
    args: userconfigurablebundle_list_args;
}

interface userconfigurablebundle_list_args {
}

interface userconfigurablebundle_detail {
    name: 'userconfigurablebundle-detail';
    args: userconfigurablebundle_detail_args;
}

interface userconfigurablebundle_detail_args {
    pk: number;
}

interface userconfigurablebundle_range_choice_list {
    name: 'userconfigurablebundle-range-choice-list';
    args: userconfigurablebundle_range_choice_list_args;
}

interface userconfigurablebundle_range_choice_list_args {
}

interface api_checkout_payment_methods {
    name: 'api-checkout-payment-methods';
    args: api_checkout_payment_methods_args;
}

interface api_checkout_payment_methods_args {
}

interface api_payment {
    name: 'api-payment';
    args: api_payment_args;
}

interface api_payment_args {
    pk: number;
}

interface api_complete_deferred_payment {
    name: 'api-complete-deferred-payment';
    args: api_complete_deferred_payment_args;
}

interface api_complete_deferred_payment_args {
}

interface api_checkout {
    name: 'api-checkout';
    args: api_checkout_args;
}

interface api_checkout_args {
}

interface api_get_csrf_token {
    name: 'api-get-csrf-token';
    args: api_get_csrf_token_args;
}

interface api_get_csrf_token_args {
}

interface api_user_data_layer {
    name: 'api-user-data-layer';
    args: api_user_data_layer_args;
}

interface api_user_data_layer_args {
}

interface api_register {
    name: 'api-register';
    args: api_register_args;
}

interface api_register_args {
}

interface api_login {
    name: 'api-login';
    args: api_login_args;
}

interface api_login_args {
}

interface product_list {
    name: 'product-list';
    args: product_list_args;
}

interface product_list_args {
}

interface product_detail {
    name: 'product-detail';
    args: product_detail_args;
}

interface product_detail_args {
    pk: number;
}

interface product_price {
    name: 'product-price';
    args: product_price_args;
}

interface product_price_args {
    pk: number;
}

interface product_financing_plans {
    name: 'product-financing-plans';
    args: product_financing_plans_args;
}

interface product_financing_plans_args {
    pk: number;
}

interface product_stockrecords {
    name: 'product-stockrecords';
    args: product_stockrecords_args;
}

interface product_stockrecords_args {
    pk: number;
}

interface product_stockrecord_detail {
    name: 'product-stockrecord-detail';
    args: product_stockrecord_detail_args;
}

interface product_stockrecord_detail_args {
    product_pk: number;
    pk: number;
}

interface product_shipping_methods {
    name: 'product-shipping-methods';
    args: product_shipping_methods_args;
}

interface product_shipping_methods_args {
    pk: number;
}

interface product_shipping_methods_by_location {
    name: 'product-shipping-methods-by-location';
    args: product_shipping_methods_by_location_args;
}

interface product_shipping_methods_by_location_args {
    pk: number;
}

interface product_upsellinfomodals {
    name: 'product-upsellinfomodals';
    args: product_upsellinfomodals_args;
}

interface product_upsellinfomodals_args {
    pk: number;
}

interface product_promocards {
    name: 'product-promocards';
    args: product_promocards_args;
}

interface product_promocards_args {
    pk: number;
}

interface option_list {
    name: 'option-list';
    args: option_list_args;
}

interface option_list_args {
}

interface option_detail {
    name: 'option-detail';
    args: option_detail_args;
}

interface option_detail_args {
    pk: number;
}

interface user_detail {
    name: 'user-detail';
    args: user_detail_args;
}

interface user_detail_args {
    pk: number;
}

interface order_list {
    name: 'order-list';
    args: order_list_args;
}

interface order_list_args {
}

interface order_detail {
    name: 'order-detail';
    args: order_detail_args;
}

interface order_detail_args {
    pk: number;
}

interface order_cancel_detail {
    name: 'order-cancel-detail';
    args: order_cancel_detail_args;
}

interface order_cancel_detail_args {
    pk: number;
}

interface order_lines_list {
    name: 'order-lines-list';
    args: order_lines_list_args;
}

interface order_lines_list_args {
    pk: number;
}

interface api_basket {
    name: 'api-basket';
    args: api_basket_args;
}

interface api_basket_args {
}

interface api_basket_add_product {
    name: 'api-basket-add-product';
    args: api_basket_add_product_args;
}

interface api_basket_add_product_args {
}

interface api_basket_add_voucher {
    name: 'api-basket-add-voucher';
    args: api_basket_add_voucher_args;
}

interface api_basket_add_voucher_args {
}

interface api_basket_apply_voucher_code {
    name: 'api-basket-apply-voucher-code';
    args: api_basket_apply_voucher_code_args;
}

interface api_basket_apply_voucher_code_args {
}

interface api_basket_email {
    name: 'api-basket-email';
    args: api_basket_email_args;
}

interface api_basket_email_args {
}

interface api_basket_remove_voucher {
    name: 'api-basket-remove-voucher';
    args: api_basket_remove_voucher_args;
}

interface api_basket_remove_voucher_args {
}

interface api_basket_last_modified {
    name: 'api-basket-last-modified';
    args: api_basket_last_modified_args;
}

interface api_basket_last_modified_args {
}

interface api_basket_predicted_delivery_date {
    name: 'api-basket-predicted-delivery-date';
    args: api_basket_predicted_delivery_date_args;
}

interface api_basket_predicted_delivery_date_args {
}

interface basket_list {
    name: 'basket-list';
    args: basket_list_args;
}

interface basket_list_args {
}

interface basket_detail {
    name: 'basket-detail';
    args: basket_detail_args;
}

interface basket_detail_args {
    pk: number;
}

interface basket_lines_list {
    name: 'basket-lines-list';
    args: basket_lines_list_args;
}

interface basket_lines_list_args {
    pk: number;
}

interface basket_line_detail {
    name: 'basket-line-detail';
    args: basket_line_detail_args;
}

interface basket_line_detail_args {
    basket_pk: number;
    pk: number;
}

interface lineattribute_detail {
    name: 'lineattribute-detail';
    args: lineattribute_detail_args;
}

interface lineattribute_detail_args {
    basket_pk: number;
    line_pk: number;
    pk: number;
}

interface category_list {
    name: 'category-list';
    args: category_list_args;
}

interface category_list_args {
}

interface category_detail {
    name: 'category-detail';
    args: category_detail_args;
}

interface category_detail_args {
    pk: number;
}

interface category_products {
    name: 'category-products';
    args: category_products_args;
}

interface category_products_args {
    pk: number;
}

interface mattress_match {
    name: 'mattress-match';
    args: mattress_match_args;
}

interface mattress_match_args {
}

interface productclass_list {
    name: 'productclass-list';
    args: productclass_list_args;
}

interface productclass_list_args {
}

interface productclass_detail {
    name: 'productclass-detail';
    args: productclass_detail_args;
}

interface productclass_detail_args {
    slug: string;
}

interface productclass_members {
    name: 'productclass-members';
    args: productclass_members_args;
}

interface productclass_members_args {
    product_class__slug: string;
}

interface checkout_shipping_address {
    name: 'checkout-shipping-address';
    args: checkout_shipping_address_args;
}

interface checkout_shipping_address_args {
}

interface checkout_billing_address {
    name: 'checkout-billing-address';
    args: checkout_billing_address_args;
}

interface checkout_billing_address_args {
}

interface checkout_shipping_methods {
    name: 'checkout-shipping-methods';
    args: checkout_shipping_methods_args;
}

interface checkout_shipping_methods_args {
}

interface country_list {
    name: 'country-list';
    args: country_list_args;
}

interface country_list_args {
}

interface country_detail {
    name: 'country-detail';
    args: country_detail_args;
}

interface country_detail_args {
    pk: string;
}

interface country_state_list {
    name: 'country-state-list';
    args: country_state_list_args;
}

interface country_state_list_args {
    country_code: string;
}

interface api_validate_phone_number {
    name: 'api-validate-phone-number';
    args: api_validate_phone_number_args;
}

interface api_validate_phone_number_args {
}

interface useraddress_list {
    name: 'useraddress-list';
    args: useraddress_list_args;
}

interface useraddress_list_args {
}

interface useraddress_detail {
    name: 'useraddress-detail';
    args: useraddress_detail_args;
}

interface useraddress_detail_args {
    pk: number;
}

interface email_offers_signup {
    name: 'email-offers-signup';
    args: email_offers_signup_args;
}

interface email_offers_signup_args {
}

interface email_retail_locator_results {
    name: 'email-retail-locator-results';
    args: email_retail_locator_results_args;
}

interface email_retail_locator_results_args {
}

interface wishlisttype_list {
    name: 'wishlisttype-list';
    args: wishlisttype_list_args;
}

interface wishlisttype_list_args {
}

interface wishlisttype_detail {
    name: 'wishlisttype-detail';
    args: wishlisttype_detail_args;
}

interface wishlisttype_detail_args {
    code: string;
}

interface wishlisttype_line_list {
    name: 'wishlisttype-line-list';
    args: wishlisttype_line_list_args;
}

interface wishlisttype_line_list_args {
    code: string;
}

interface wishlisttype_line_detail {
    name: 'wishlisttype-line-detail';
    args: wishlisttype_line_detail_args;
}

interface wishlisttype_line_detail_args {
    code: string;
    pk: number;
}

interface api_basket_estimate_tax {
    name: 'api-basket-estimate-tax';
    args: api_basket_estimate_tax_args;
}

interface api_basket_estimate_tax_args {
}

interface api_basket_shipping_methods {
    name: 'api-basket-shipping-methods';
    args: api_basket_shipping_methods_args;
}

interface api_basket_shipping_methods_args {
}

interface financing_plan_list {
    name: 'financing-plan-list';
    args: financing_plan_list_args;
}

interface financing_plan_list_args {
}

interface financing_plan_create {
    name: 'financing-plan-create';
    args: financing_plan_create_args;
}

interface financing_plan_create_args {
}

interface financing_plan_edit {
    name: 'financing-plan-edit';
    args: financing_plan_edit_args;
}

interface financing_plan_edit_args {
    pk: number;
}

interface financing_plan_delete {
    name: 'financing-plan-delete';
    args: financing_plan_delete_args;
}

interface financing_plan_delete_args {
    pk: number;
}

interface financing_benefit_list {
    name: 'financing-benefit-list';
    args: financing_benefit_list_args;
}

interface financing_benefit_list_args {
}

interface financing_benefit_create {
    name: 'financing-benefit-create';
    args: financing_benefit_create_args;
}

interface financing_benefit_create_args {
}

interface financing_benefit_edit {
    name: 'financing-benefit-edit';
    args: financing_benefit_edit_args;
}

interface financing_benefit_edit_args {
    pk: number;
}

interface financing_benefit_delete {
    name: 'financing-benefit-delete';
    args: financing_benefit_delete_args;
}

interface financing_benefit_delete_args {
    pk: number;
}

interface financing_application_list {
    name: 'financing-application-list';
    args: financing_application_list_args;
}

interface financing_application_list_args {
}

interface financing_application_detail {
    name: 'financing-application-detail';
    args: financing_application_detail_args;
}

interface financing_application_detail_args {
    pk: number;
}

interface financing_transfer_list {
    name: 'financing-transfer-list';
    args: financing_transfer_list_args;
}

interface financing_transfer_list_args {
}

interface financing_transfer_detail {
    name: 'financing-transfer-detail';
    args: financing_transfer_detail_args;
}

interface financing_transfer_detail_args {
    pk: number;
}

interface financing_prequal_list {
    name: 'financing-prequal-list';
    args: financing_prequal_list_args;
}

interface financing_prequal_list_args {
}

interface financing_prequal_detail {
    name: 'financing-prequal-detail';
    args: financing_prequal_detail_args;
}

interface financing_prequal_detail_args {
    uuid: string;
}

interface dashboard_bundle_group_list {
    name: 'dashboard-bundle-group-list';
    args: dashboard_bundle_group_list_args;
}

interface dashboard_bundle_group_list_args {
}

interface benefit_bundle_list {
    name: 'benefit-bundle-list';
    args: benefit_bundle_list_args;
}

interface benefit_bundle_list_args {
}

interface benefit_bundle_create {
    name: 'benefit-bundle-create';
    args: benefit_bundle_create_args;
}

interface benefit_bundle_create_args {
}

interface benefit_bundle_update {
    name: 'benefit-bundle-update';
    args: benefit_bundle_update_args;
}

interface benefit_bundle_update_args {
    pk: number;
}

interface benefit_bundle_delete {
    name: 'benefit-bundle-delete';
    args: benefit_bundle_delete_args;
}

interface benefit_bundle_delete_args {
    pk: number;
}

interface rma_vouchers_import {
    name: 'rma-vouchers-import';
    args: rma_vouchers_import_args;
}

interface rma_vouchers_import_args {
}

interface dashboard_index {
    name: 'dashboard:index';
    args: dashboard_index_args;
}

interface dashboard_index_args {
}

interface dashboard_catalogue_product {
    name: 'dashboard:catalogue-product';
    args: dashboard_catalogue_product_args;
}

interface dashboard_catalogue_product_args {
    pk: number;
}

interface dashboard_catalogue_product_create {
    name: 'dashboard:catalogue-product-create';
    args: dashboard_catalogue_product_create_args;
}

interface dashboard_catalogue_product_create_args {
}

interface dashboard_catalogue_product_create_child {
    name: 'dashboard:catalogue-product-create-child';
    args: dashboard_catalogue_product_create_child_args;
}

interface dashboard_catalogue_product_create_child_args {
    parent_pk: number;
}

interface dashboard_catalogue_product_delete {
    name: 'dashboard:catalogue-product-delete';
    args: dashboard_catalogue_product_delete_args;
}

interface dashboard_catalogue_product_delete_args {
    pk: number;
}

interface dashboard_catalogue_product_list {
    name: 'dashboard:catalogue-product-list';
    args: dashboard_catalogue_product_list_args;
}

interface dashboard_catalogue_product_list_args {
}

interface dashboard_stock_alert_list {
    name: 'dashboard:stock-alert-list';
    args: dashboard_stock_alert_list_args;
}

interface dashboard_stock_alert_list_args {
}

interface dashboard_catalogue_product_lookup {
    name: 'dashboard:catalogue-product-lookup';
    args: dashboard_catalogue_product_lookup_args;
}

interface dashboard_catalogue_product_lookup_args {
}

interface dashboard_catalogue_category_list {
    name: 'dashboard:catalogue-category-list';
    args: dashboard_catalogue_category_list_args;
}

interface dashboard_catalogue_category_list_args {
}

interface dashboard_catalogue_category_detail_list {
    name: 'dashboard:catalogue-category-detail-list';
    args: dashboard_catalogue_category_detail_list_args;
}

interface dashboard_catalogue_category_detail_list_args {
    pk: number;
}

interface dashboard_catalogue_category_create {
    name: 'dashboard:catalogue-category-create';
    args: dashboard_catalogue_category_create_args;
}

interface dashboard_catalogue_category_create_args {
}

interface dashboard_catalogue_category_create_child {
    name: 'dashboard:catalogue-category-create-child';
    args: dashboard_catalogue_category_create_child_args;
}

interface dashboard_catalogue_category_create_child_args {
    parent: number;
}

interface dashboard_catalogue_category_update {
    name: 'dashboard:catalogue-category-update';
    args: dashboard_catalogue_category_update_args;
}

interface dashboard_catalogue_category_update_args {
    pk: number;
}

interface dashboard_catalogue_category_delete {
    name: 'dashboard:catalogue-category-delete';
    args: dashboard_catalogue_category_delete_args;
}

interface dashboard_catalogue_category_delete_args {
    pk: number;
}

interface dashboard_catalogue_class_create {
    name: 'dashboard:catalogue-class-create';
    args: dashboard_catalogue_class_create_args;
}

interface dashboard_catalogue_class_create_args {
}

interface dashboard_catalogue_class_list {
    name: 'dashboard:catalogue-class-list';
    args: dashboard_catalogue_class_list_args;
}

interface dashboard_catalogue_class_list_args {
}

interface dashboard_catalogue_class_update {
    name: 'dashboard:catalogue-class-update';
    args: dashboard_catalogue_class_update_args;
}

interface dashboard_catalogue_class_update_args {
    pk: number;
}

interface dashboard_catalogue_class_delete {
    name: 'dashboard:catalogue-class-delete';
    args: dashboard_catalogue_class_delete_args;
}

interface dashboard_catalogue_class_delete_args {
    pk: number;
}

interface dashboard_catalogue_attribute_option_group_create {
    name: 'dashboard:catalogue-attribute-option-group-create';
    args: dashboard_catalogue_attribute_option_group_create_args;
}

interface dashboard_catalogue_attribute_option_group_create_args {
}

interface dashboard_catalogue_attribute_option_group_list {
    name: 'dashboard:catalogue-attribute-option-group-list';
    args: dashboard_catalogue_attribute_option_group_list_args;
}

interface dashboard_catalogue_attribute_option_group_list_args {
}

interface dashboard_catalogue_attribute_option_group_update {
    name: 'dashboard:catalogue-attribute-option-group-update';
    args: dashboard_catalogue_attribute_option_group_update_args;
}

interface dashboard_catalogue_attribute_option_group_update_args {
    pk: string;
}

interface dashboard_catalogue_attribute_option_group_delete {
    name: 'dashboard:catalogue-attribute-option-group-delete';
    args: dashboard_catalogue_attribute_option_group_delete_args;
}

interface dashboard_catalogue_attribute_option_group_delete_args {
    pk: string;
}

interface dashboard_catalogue_option_list {
    name: 'dashboard:catalogue-option-list';
    args: dashboard_catalogue_option_list_args;
}

interface dashboard_catalogue_option_list_args {
}

interface dashboard_catalogue_option_create {
    name: 'dashboard:catalogue-option-create';
    args: dashboard_catalogue_option_create_args;
}

interface dashboard_catalogue_option_create_args {
}

interface dashboard_catalogue_option_update {
    name: 'dashboard:catalogue-option-update';
    args: dashboard_catalogue_option_update_args;
}

interface dashboard_catalogue_option_update_args {
    pk: string;
}

interface dashboard_catalogue_option_delete {
    name: 'dashboard:catalogue-option-delete';
    args: dashboard_catalogue_option_delete_args;
}

interface dashboard_catalogue_option_delete_args {
    pk: string;
}

interface dashboard_product_price_import {
    name: 'dashboard:product-price-import';
    args: dashboard_product_price_import_args;
}

interface dashboard_product_price_import_args {
}

interface dashboard_product_price_import_apply {
    name: 'dashboard:product-price-import-apply';
    args: dashboard_product_price_import_apply_args;
}

interface dashboard_product_price_import_apply_args {
}

interface dashboard_value_prop_list {
    name: 'dashboard:value-prop-list';
    args: dashboard_value_prop_list_args;
}

interface dashboard_value_prop_list_args {
}

interface dashboard_value_prop_create {
    name: 'dashboard:value-prop-create';
    args: dashboard_value_prop_create_args;
}

interface dashboard_value_prop_create_args {
}

interface dashboard_value_prop_edit {
    name: 'dashboard:value-prop-edit';
    args: dashboard_value_prop_edit_args;
}

interface dashboard_value_prop_edit_args {
    pk: number;
}

interface dashboard_value_prop_delete {
    name: 'dashboard:value-prop-delete';
    args: dashboard_value_prop_delete_args;
}

interface dashboard_value_prop_delete_args {
    pk: number;
}

interface dashboard_reports_index {
    name: 'dashboard:reports-index';
    args: dashboard_reports_index_args;
}

interface dashboard_reports_index_args {
}

interface dashboard_reports_download {
    name: 'dashboard:reports-download';
    args: dashboard_reports_download_args;
}

interface dashboard_reports_download_args {
    uuid: string;
}

interface dashboard_reports_delete {
    name: 'dashboard:reports-delete';
    args: dashboard_reports_delete_args;
}

interface dashboard_reports_delete_args {
    uuid: string;
}

interface dashboard_orderconfirmation_resend {
    name: 'dashboard:orderconfirmation-resend';
    args: dashboard_orderconfirmation_resend_args;
}

interface dashboard_orderconfirmation_resend_args {
}

interface dashboard_order_billing_verification_send {
    name: 'dashboard:order-billing-verification-send';
    args: dashboard_order_billing_verification_send_args;
}

interface dashboard_order_billing_verification_send_args {
}

interface dashboard_order_send_deferred_payment_email {
    name: 'dashboard:order-send-deferred-payment-email';
    args: dashboard_order_send_deferred_payment_email_args;
}

interface dashboard_order_send_deferred_payment_email_args {
}

interface dashboard_order_request_pnp_resend {
    name: 'dashboard:order-request-pnp-resend';
    args: dashboard_order_request_pnp_resend_args;
}

interface dashboard_order_request_pnp_resend_args {
}

interface dashboard_order_list {
    name: 'dashboard:order-list';
    args: dashboard_order_list_args;
}

interface dashboard_order_list_args {
}

interface dashboard_order_stats {
    name: 'dashboard:order-stats';
    args: dashboard_order_stats_args;
}

interface dashboard_order_stats_args {
}

interface dashboard_order_detail {
    name: 'dashboard:order-detail';
    args: dashboard_order_detail_args;
}

interface dashboard_order_detail_args {
    number: string;
}

interface dashboard_order_detail_note {
    name: 'dashboard:order-detail-note';
    args: dashboard_order_detail_note_args;
}

interface dashboard_order_detail_note_args {
    number: string;
    note_id: number;
}

interface dashboard_order_line_detail {
    name: 'dashboard:order-line-detail';
    args: dashboard_order_line_detail_args;
}

interface dashboard_order_line_detail_args {
    number: string;
    line_id: number;
}

interface dashboard_order_shipping_address {
    name: 'dashboard:order-shipping-address';
    args: dashboard_order_shipping_address_args;
}

interface dashboard_order_shipping_address_args {
    number: string;
}

interface dashboard_users_index {
    name: 'dashboard:users-index';
    args: dashboard_users_index_args;
}

interface dashboard_users_index_args {
}

interface dashboard_user_alert_list {
    name: 'dashboard:user-alert-list';
    args: dashboard_user_alert_list_args;
}

interface dashboard_user_alert_list_args {
}

interface dashboard_deletion_request_list {
    name: 'dashboard:deletion-request-list';
    args: dashboard_deletion_request_list_args;
}

interface dashboard_deletion_request_list_args {
}

interface dashboard_deletion_request_create {
    name: 'dashboard:deletion-request-create';
    args: dashboard_deletion_request_create_args;
}

interface dashboard_deletion_request_create_args {
}

interface dashboard_deletion_request_details {
    name: 'dashboard:deletion-request-details';
    args: dashboard_deletion_request_details_args;
}

interface dashboard_deletion_request_details_args {
    pk: string;
}

interface dashboard_data_inquiry_list {
    name: 'dashboard:data-inquiry-list';
    args: dashboard_data_inquiry_list_args;
}

interface dashboard_data_inquiry_list_args {
}

interface dashboard_data_inquiry_create {
    name: 'dashboard:data-inquiry-create';
    args: dashboard_data_inquiry_create_args;
}

interface dashboard_data_inquiry_create_args {
}

interface dashboard_data_inquiry_details {
    name: 'dashboard:data-inquiry-details';
    args: dashboard_data_inquiry_details_args;
}

interface dashboard_data_inquiry_details_args {
    pk: string;
}

interface dashboard_data_inquiry_download {
    name: 'dashboard:data-inquiry-download';
    args: dashboard_data_inquiry_download_args;
}

interface dashboard_data_inquiry_download_args {
    pk: string;
    file_format: string;
}

interface dashboard_page_list {
    name: 'dashboard:page-list';
    args: dashboard_page_list_args;
}

interface dashboard_page_list_args {
}

interface dashboard_page_create {
    name: 'dashboard:page-create';
    args: dashboard_page_create_args;
}

interface dashboard_page_create_args {
}

interface dashboard_page_update {
    name: 'dashboard:page-update';
    args: dashboard_page_update_args;
}

interface dashboard_page_update_args {
    pk: string;
}

interface dashboard_page_delete {
    name: 'dashboard:page-delete';
    args: dashboard_page_delete_args;
}

interface dashboard_page_delete_args {
    pk: string;
}

interface dashboard_partner_list {
    name: 'dashboard:partner-list';
    args: dashboard_partner_list_args;
}

interface dashboard_partner_list_args {
}

interface dashboard_partner_create {
    name: 'dashboard:partner-create';
    args: dashboard_partner_create_args;
}

interface dashboard_partner_create_args {
}

interface dashboard_partner_manage {
    name: 'dashboard:partner-manage';
    args: dashboard_partner_manage_args;
}

interface dashboard_partner_manage_args {
    pk: number;
}

interface dashboard_partner_delete {
    name: 'dashboard:partner-delete';
    args: dashboard_partner_delete_args;
}

interface dashboard_partner_delete_args {
    pk: number;
}

interface dashboard_partner_user_create {
    name: 'dashboard:partner-user-create';
    args: dashboard_partner_user_create_args;
}

interface dashboard_partner_user_create_args {
    partner_pk: number;
}

interface dashboard_partner_user_select {
    name: 'dashboard:partner-user-select';
    args: dashboard_partner_user_select_args;
}

interface dashboard_partner_user_select_args {
    partner_pk: number;
}

interface dashboard_partner_user_link {
    name: 'dashboard:partner-user-link';
    args: dashboard_partner_user_link_args;
}

interface dashboard_partner_user_link_args {
    partner_pk: number;
    user_pk: number;
}

interface dashboard_partner_user_unlink {
    name: 'dashboard:partner-user-unlink';
    args: dashboard_partner_user_unlink_args;
}

interface dashboard_partner_user_unlink_args {
    partner_pk: number;
    user_pk: number;
}

interface dashboard_partner_user_update {
    name: 'dashboard:partner-user-update';
    args: dashboard_partner_user_update_args;
}

interface dashboard_partner_user_update_args {
    partner_pk: number;
    user_pk: number;
}

interface dashboard_offer_list {
    name: 'dashboard:offer-list';
    args: dashboard_offer_list_args;
}

interface dashboard_offer_list_args {
}

interface dashboard_offer_metadata {
    name: 'dashboard:offer-metadata';
    args: dashboard_offer_metadata_args;
}

interface dashboard_offer_metadata_args {
    pk: number;
}

interface dashboard_offer_condition {
    name: 'dashboard:offer-condition';
    args: dashboard_offer_condition_args;
}

interface dashboard_offer_condition_args {
    pk: number;
}

interface dashboard_offer_benefit {
    name: 'dashboard:offer-benefit';
    args: dashboard_offer_benefit_args;
}

interface dashboard_offer_benefit_args {
    pk: number;
}

interface dashboard_offer_restrictions {
    name: 'dashboard:offer-restrictions';
    args: dashboard_offer_restrictions_args;
}

interface dashboard_offer_restrictions_args {
    pk: number;
}

interface dashboard_offer_delete {
    name: 'dashboard:offer-delete';
    args: dashboard_offer_delete_args;
}

interface dashboard_offer_delete_args {
    pk: number;
}

interface dashboard_offer_detail {
    name: 'dashboard:offer-detail';
    args: dashboard_offer_detail_args;
}

interface dashboard_offer_detail_args {
    pk: number;
}

interface dashboard_api_root {
    name: 'dashboard:api-root';
    args: dashboard_api_root_args;
}

interface dashboard_api_root_args {
    format: string;
}

interface dashboard_oscarbluelight_i18n_js {
    name: 'dashboard:oscarbluelight-i18n-js';
    args: dashboard_oscarbluelight_i18n_js_args;
}

interface dashboard_oscarbluelight_i18n_js_args {
}

interface dashboard_offer_images {
    name: 'dashboard:offer-images';
    args: dashboard_offer_images_args;
}

interface dashboard_offer_images_args {
    pk: number;
}

interface dashboard_offer_api_list {
    name: 'dashboard:offer-api-list';
    args: dashboard_offer_api_list_args;
}

interface dashboard_offer_api_list_args {
}

interface dashboard_benefit_list {
    name: 'dashboard:benefit-list';
    args: dashboard_benefit_list_args;
}

interface dashboard_benefit_list_args {
}

interface dashboard_benefit_create {
    name: 'dashboard:benefit-create';
    args: dashboard_benefit_create_args;
}

interface dashboard_benefit_create_args {
}

interface dashboard_benefit_create_compound {
    name: 'dashboard:benefit-create-compound';
    args: dashboard_benefit_create_compound_args;
}

interface dashboard_benefit_create_compound_args {
}

interface dashboard_benefit_update {
    name: 'dashboard:benefit-update';
    args: dashboard_benefit_update_args;
}

interface dashboard_benefit_update_args {
    pk: number;
}

interface dashboard_benefit_delete {
    name: 'dashboard:benefit-delete';
    args: dashboard_benefit_delete_args;
}

interface dashboard_benefit_delete_args {
    pk: number;
}

interface dashboard_condition_list {
    name: 'dashboard:condition-list';
    args: dashboard_condition_list_args;
}

interface dashboard_condition_list_args {
}

interface dashboard_condition_create {
    name: 'dashboard:condition-create';
    args: dashboard_condition_create_args;
}

interface dashboard_condition_create_args {
}

interface dashboard_condition_create_compound {
    name: 'dashboard:condition-create-compound';
    args: dashboard_condition_create_compound_args;
}

interface dashboard_condition_create_compound_args {
}

interface dashboard_condition_update {
    name: 'dashboard:condition-update';
    args: dashboard_condition_update_args;
}

interface dashboard_condition_update_args {
    pk: number;
}

interface dashboard_condition_delete {
    name: 'dashboard:condition-delete';
    args: dashboard_condition_delete_args;
}

interface dashboard_condition_delete_args {
    pk: number;
}

interface dashboard_offergroup_list {
    name: 'dashboard:offergroup-list';
    args: dashboard_offergroup_list_args;
}

interface dashboard_offergroup_list_args {
}

interface dashboard_offergroup_create {
    name: 'dashboard:offergroup-create';
    args: dashboard_offergroup_create_args;
}

interface dashboard_offergroup_create_args {
}

interface dashboard_offergroup_update {
    name: 'dashboard:offergroup-update';
    args: dashboard_offergroup_update_args;
}

interface dashboard_offergroup_update_args {
    pk: number;
}

interface dashboard_offergroup_delete {
    name: 'dashboard:offergroup-delete';
    args: dashboard_offergroup_delete_args;
}

interface dashboard_offergroup_delete_args {
    pk: number;
}

interface dashboard_range_list {
    name: 'dashboard:range-list';
    args: dashboard_range_list_args;
}

interface dashboard_range_list_args {
}

interface dashboard_range_create {
    name: 'dashboard:range-create';
    args: dashboard_range_create_args;
}

interface dashboard_range_create_args {
}

interface dashboard_range_update {
    name: 'dashboard:range-update';
    args: dashboard_range_update_args;
}

interface dashboard_range_update_args {
    pk: number;
}

interface dashboard_range_delete {
    name: 'dashboard:range-delete';
    args: dashboard_range_delete_args;
}

interface dashboard_range_delete_args {
    pk: number;
}

interface dashboard_range_products {
    name: 'dashboard:range-products';
    args: dashboard_range_products_args;
}

interface dashboard_range_products_args {
    pk: number;
}

interface dashboard_range_reorder {
    name: 'dashboard:range-reorder';
    args: dashboard_range_reorder_args;
}

interface dashboard_range_reorder_args {
    pk: number;
}

interface dashboard_range_prices {
    name: 'dashboard:range-prices';
    args: dashboard_range_prices_args;
}

interface dashboard_range_prices_args {
    pk: number;
}

interface dashboard_range_excluded_products {
    name: 'dashboard:range-excluded-products';
    args: dashboard_range_excluded_products_args;
}

interface dashboard_range_excluded_products_args {
    pk: number;
}

interface dashboard_reviews_list {
    name: 'dashboard:reviews-list';
    args: dashboard_reviews_list_args;
}

interface dashboard_reviews_list_args {
}

interface dashboard_reviews_update {
    name: 'dashboard:reviews-update';
    args: dashboard_reviews_update_args;
}

interface dashboard_reviews_update_args {
    pk: number;
}

interface dashboard_reviews_delete {
    name: 'dashboard:reviews-delete';
    args: dashboard_reviews_delete_args;
}

interface dashboard_reviews_delete_args {
    pk: number;
}

interface dashboard_voucher_list {
    name: 'dashboard:voucher-list';
    args: dashboard_voucher_list_args;
}

interface dashboard_voucher_list_args {
}

interface dashboard_voucher_create {
    name: 'dashboard:voucher-create';
    args: dashboard_voucher_create_args;
}

interface dashboard_voucher_create_args {
}

interface dashboard_voucher_update {
    name: 'dashboard:voucher-update';
    args: dashboard_voucher_update_args;
}

interface dashboard_voucher_update_args {
    pk: number;
}

interface dashboard_voucher_delete {
    name: 'dashboard:voucher-delete';
    args: dashboard_voucher_delete_args;
}

interface dashboard_voucher_delete_args {
    pk: number;
}

interface dashboard_voucher_stats {
    name: 'dashboard:voucher-stats';
    args: dashboard_voucher_stats_args;
}

interface dashboard_voucher_stats_args {
    pk: number;
}

interface dashboard_voucher_set_list {
    name: 'dashboard:voucher-set-list';
    args: dashboard_voucher_set_list_args;
}

interface dashboard_voucher_set_list_args {
}

interface dashboard_voucher_set_create {
    name: 'dashboard:voucher-set-create';
    args: dashboard_voucher_set_create_args;
}

interface dashboard_voucher_set_create_args {
}

interface dashboard_voucher_set_update {
    name: 'dashboard:voucher-set-update';
    args: dashboard_voucher_set_update_args;
}

interface dashboard_voucher_set_update_args {
    pk: number;
}

interface dashboard_voucher_set_detail {
    name: 'dashboard:voucher-set-detail';
    args: dashboard_voucher_set_detail_args;
}

interface dashboard_voucher_set_detail_args {
    pk: number;
}

interface dashboard_voucher_set_download {
    name: 'dashboard:voucher-set-download';
    args: dashboard_voucher_set_download_args;
}

interface dashboard_voucher_set_download_args {
    pk: number;
}

interface dashboard_voucher_set_delete {
    name: 'dashboard:voucher-set-delete';
    args: dashboard_voucher_set_delete_args;
}

interface dashboard_voucher_set_delete_args {
    pk: number;
}

interface dashboard_voucher_list_children {
    name: 'dashboard:voucher-list-children';
    args: dashboard_voucher_list_children_args;
}

interface dashboard_voucher_list_children_args {
    parent_pk: number;
}

interface dashboard_voucher_add_children {
    name: 'dashboard:voucher-add-children';
    args: dashboard_voucher_add_children_args;
}

interface dashboard_voucher_add_children_args {
    pk: number;
}

interface dashboard_voucher_export_children {
    name: 'dashboard:voucher-export-children';
    args: dashboard_voucher_export_children_args;
}

interface dashboard_voucher_export_children_args {
    pk: number;
}

interface dashboard_voucher_export_children_file {
    name: 'dashboard:voucher-export-children-file';
    args: dashboard_voucher_export_children_file_args;
}

interface dashboard_voucher_export_children_file_args {
    pk: number;
    file_format: string;
}

interface dashboard_voucher_update_suspension_status {
    name: 'dashboard:voucher-update-suspension-status';
    args: dashboard_voucher_update_suspension_status_args;
}

interface dashboard_voucher_update_suspension_status_args {
    pk: number;
}

interface dashboard_comms_list {
    name: 'dashboard:comms-list';
    args: dashboard_comms_list_args;
}

interface dashboard_comms_list_args {
}

interface dashboard_country_list {
    name: 'dashboard:country-list';
    args: dashboard_country_list_args;
}

interface dashboard_country_list_args {
}

interface dashboard_country_create {
    name: 'dashboard:country-create';
    args: dashboard_country_create_args;
}

interface dashboard_country_create_args {
}

interface dashboard_country_edit {
    name: 'dashboard:country-edit';
    args: dashboard_country_edit_args;
}

interface dashboard_country_edit_args {
    pk: string;
}

interface dashboard_country_delete {
    name: 'dashboard:country-delete';
    args: dashboard_country_delete_args;
}

interface dashboard_country_delete_args {
    pk: string;
}

interface dashboard_delivery_region_list {
    name: 'dashboard:delivery-region-list';
    args: dashboard_delivery_region_list_args;
}

interface dashboard_delivery_region_list_args {
}

interface dashboard_delivery_region_create {
    name: 'dashboard:delivery-region-create';
    args: dashboard_delivery_region_create_args;
}

interface dashboard_delivery_region_create_args {
}

interface dashboard_delivery_region_edit {
    name: 'dashboard:delivery-region-edit';
    args: dashboard_delivery_region_edit_args;
}

interface dashboard_delivery_region_edit_args {
    pk: number;
}

interface dashboard_delivery_region_delete {
    name: 'dashboard:delivery-region-delete';
    args: dashboard_delivery_region_delete_args;
}

interface dashboard_delivery_region_delete_args {
    pk: number;
}

interface dashboard_delivery_region_group_list {
    name: 'dashboard:delivery-region-group-list';
    args: dashboard_delivery_region_group_list_args;
}

interface dashboard_delivery_region_group_list_args {
}

interface dashboard_delivery_region_group_create {
    name: 'dashboard:delivery-region-group-create';
    args: dashboard_delivery_region_group_create_args;
}

interface dashboard_delivery_region_group_create_args {
}

interface dashboard_delivery_region_group_edit {
    name: 'dashboard:delivery-region-group-edit';
    args: dashboard_delivery_region_group_edit_args;
}

interface dashboard_delivery_region_group_edit_args {
    pk: number;
}

interface dashboard_delivery_region_group_delete {
    name: 'dashboard:delivery-region-group-delete';
    args: dashboard_delivery_region_group_delete_args;
}

interface dashboard_delivery_region_group_delete_args {
    pk: number;
}

interface dashboard_shipping_product_class_list {
    name: 'dashboard:shipping-product-class-list';
    args: dashboard_shipping_product_class_list_args;
}

interface dashboard_shipping_product_class_list_args {
}

interface dashboard_shipping_product_class_create {
    name: 'dashboard:shipping-product-class-create';
    args: dashboard_shipping_product_class_create_args;
}

interface dashboard_shipping_product_class_create_args {
}

interface dashboard_shipping_product_class_edit {
    name: 'dashboard:shipping-product-class-edit';
    args: dashboard_shipping_product_class_edit_args;
}

interface dashboard_shipping_product_class_edit_args {
    pk: number;
}

interface dashboard_shipping_product_class_delete {
    name: 'dashboard:shipping-product-class-delete';
    args: dashboard_shipping_product_class_delete_args;
}

interface dashboard_shipping_product_class_delete_args {
    pk: number;
}

interface dashboard_shipping_method_list {
    name: 'dashboard:shipping-method-list';
    args: dashboard_shipping_method_list_args;
}

interface dashboard_shipping_method_list_args {
}

interface dashboard_shipping_method_create {
    name: 'dashboard:shipping-method-create';
    args: dashboard_shipping_method_create_args;
}

interface dashboard_shipping_method_create_args {
}

interface dashboard_shipping_method_detail {
    name: 'dashboard:shipping-method-detail';
    args: dashboard_shipping_method_detail_args;
}

interface dashboard_shipping_method_detail_args {
    pk: number;
}

interface dashboard_shipping_method_edit {
    name: 'dashboard:shipping-method-edit';
    args: dashboard_shipping_method_edit_args;
}

interface dashboard_shipping_method_edit_args {
    pk: number;
}

interface dashboard_shipping_method_delete {
    name: 'dashboard:shipping-method-delete';
    args: dashboard_shipping_method_delete_args;
}

interface dashboard_shipping_method_delete_args {
    pk: number;
}

interface dashboard_shipping_method_description_list {
    name: 'dashboard:shipping-method-description-list';
    args: dashboard_shipping_method_description_list_args;
}

interface dashboard_shipping_method_description_list_args {
}

interface dashboard_shipping_method_description_create {
    name: 'dashboard:shipping-method-description-create';
    args: dashboard_shipping_method_description_create_args;
}

interface dashboard_shipping_method_description_create_args {
}

interface dashboard_shipping_method_description_edit {
    name: 'dashboard:shipping-method-description-edit';
    args: dashboard_shipping_method_description_edit_args;
}

interface dashboard_shipping_method_description_edit_args {
    pk: number;
}

interface dashboard_shipping_method_description_delete {
    name: 'dashboard:shipping-method-description-delete';
    args: dashboard_shipping_method_description_delete_args;
}

interface dashboard_shipping_method_description_delete_args {
    pk: number;
}

interface dashboard_shipping_price_create {
    name: 'dashboard:shipping-price-create';
    args: dashboard_shipping_price_create_args;
}

interface dashboard_shipping_price_create_args {
    method_pk: number;
    region_group_pk: number;
}

interface dashboard_shipping_price_edit {
    name: 'dashboard:shipping-price-edit';
    args: dashboard_shipping_price_edit_args;
}

interface dashboard_shipping_price_edit_args {
    method_pk: number;
    region_group_pk: number;
    pk: number;
}

interface dashboard_shipping_price_delete {
    name: 'dashboard:shipping-price-delete';
    args: dashboard_shipping_price_delete_args;
}

interface dashboard_shipping_price_delete_args {
    method_pk: number;
    region_group_pk: number;
    pk: number;
}

interface dashboard_shipping_option_list {
    name: 'dashboard:shipping-option-list';
    args: dashboard_shipping_option_list_args;
}

interface dashboard_shipping_option_list_args {
}

interface dashboard_shipping_option_create {
    name: 'dashboard:shipping-option-create';
    args: dashboard_shipping_option_create_args;
}

interface dashboard_shipping_option_create_args {
}

interface dashboard_shipping_option_edit {
    name: 'dashboard:shipping-option-edit';
    args: dashboard_shipping_option_edit_args;
}

interface dashboard_shipping_option_edit_args {
    pk: number;
}

interface dashboard_shipping_option_delete {
    name: 'dashboard:shipping-option-delete';
    args: dashboard_shipping_option_delete_args;
}

interface dashboard_shipping_option_delete_args {
    pk: number;
}

interface dashboard_login {
    name: 'dashboard:login';
    args: dashboard_login_args;
}

interface dashboard_login_args {
}

interface dashboard_logout {
    name: 'dashboard:logout';
    args: dashboard_logout_args;
}

interface dashboard_logout_args {
}

interface basket_summary {
    name: 'basket:summary';
    args: basket_summary_args;
}

interface basket_summary_args {
}

interface basket_add {
    name: 'basket:add';
    args: basket_add_args;
}

interface basket_add_args {
    pk: number;
}

interface basket_vouchers_add {
    name: 'basket:vouchers-add';
    args: basket_vouchers_add_args;
}

interface basket_vouchers_add_args {
}

interface basket_vouchers_remove {
    name: 'basket:vouchers-remove';
    args: basket_vouchers_remove_args;
}

interface basket_vouchers_remove_args {
    pk: number;
}

interface basket_saved {
    name: 'basket:saved';
    args: basket_saved_args;
}

interface basket_saved_args {
}

interface basket_configure_gifts {
    name: 'basket:configure-gifts';
    args: basket_configure_gifts_args;
}

interface basket_configure_gifts_args {
}

interface checkout_index {
    name: 'checkout:index';
    args: checkout_index_args;
}

interface checkout_index_args {
}

interface checkout_payment_submit {
    name: 'checkout:payment-submit';
    args: checkout_payment_submit_args;
}

interface checkout_payment_submit_args {
}

interface checkout_payment_redirect {
    name: 'checkout:payment-redirect';
    args: checkout_payment_redirect_args;
}

interface checkout_payment_redirect_args {
}

interface checkout_order_pending {
    name: 'checkout:order-pending';
    args: checkout_order_pending_args;
}

interface checkout_order_pending_args {
}

interface checkout_complete_deferred_payment {
    name: 'checkout:complete-deferred-payment';
    args: checkout_complete_deferred_payment_args;
}

interface checkout_complete_deferred_payment_args {
    order_number: string;
}

interface checkout_thank_you {
    name: 'checkout:thank-you';
    args: checkout_thank_you_args;
}

interface checkout_thank_you_args {
}

interface customer_login {
    name: 'customer:login';
    args: customer_login_args;
}

interface customer_login_args {
}

interface customer_logout {
    name: 'customer:logout';
    args: customer_logout_args;
}

interface customer_logout_args {
}

interface customer_lookup_orders_by_email {
    name: 'customer:lookup-orders-by-email';
    args: customer_lookup_orders_by_email_args;
}

interface customer_lookup_orders_by_email_args {
}

interface customer_lookup_orders_by_email_confirmation {
    name: 'customer:lookup-orders-by-email-confirmation';
    args: customer_lookup_orders_by_email_confirmation_args;
}

interface customer_lookup_orders_by_email_confirmation_args {
}

interface customer_unified_order_lookup {
    name: 'customer:unified-order-lookup';
    args: customer_unified_order_lookup_args;
}

interface customer_unified_order_lookup_args {
}

interface customer_unified_order_status {
    name: 'customer:unified-order-status';
    args: customer_unified_order_status_args;
}

interface customer_unified_order_status_args {
    order_number_token: string;
}

interface customer_unified_order_shipment_status {
    name: 'customer:unified-order-shipment-status';
    args: customer_unified_order_shipment_status_args;
}

interface customer_unified_order_shipment_status_args {
    order_number_token: string;
    tracking_number: string;
}

interface customer_register {
    name: 'customer:register';
    args: customer_register_args;
}

interface customer_register_args {
}

interface customer_summary {
    name: 'customer:summary';
    args: customer_summary_args;
}

interface customer_summary_args {
}

interface customer_change_password {
    name: 'customer:change-password';
    args: customer_change_password_args;
}

interface customer_change_password_args {
}

interface customer_profile_view {
    name: 'customer:profile-view';
    args: customer_profile_view_args;
}

interface customer_profile_view_args {
}

interface customer_profile_update {
    name: 'customer:profile-update';
    args: customer_profile_update_args;
}

interface customer_profile_update_args {
}

interface customer_profile_delete {
    name: 'customer:profile-delete';
    args: customer_profile_delete_args;
}

interface customer_profile_delete_args {
}

interface customer_order_list {
    name: 'customer:order-list';
    args: customer_order_list_args;
}

interface customer_order_list_args {
}

interface customer_trs_order_history {
    name: 'customer:trs-order-history';
    args: customer_trs_order_history_args;
}

interface customer_trs_order_history_args {
}

interface customer_anon_order {
    name: 'customer:anon-order';
    args: customer_anon_order_args;
}

interface customer_anon_order_args {
    order_number: string;
    hash: string;
}

interface customer_order {
    name: 'customer:order';
    args: customer_order_args;
}

interface customer_order_args {
    order_number: string;
}

interface customer_review_order_products {
    name: 'customer:review-order-products';
    args: customer_review_order_products_args;
}

interface customer_review_order_products_args {
    order_number: string;
}

interface customer_order_shipment_tracking {
    name: 'customer:order-shipment-tracking';
    args: customer_order_shipment_tracking_args;
}

interface customer_order_shipment_tracking_args {
    order_number: string;
    tracking_number: string;
}

interface customer_order_line {
    name: 'customer:order-line';
    args: customer_order_line_args;
}

interface customer_order_line_args {
    order_number: string;
    line_id: number;
}

interface customer_address_list {
    name: 'customer:address-list';
    args: customer_address_list_args;
}

interface customer_address_list_args {
}

interface customer_address_create {
    name: 'customer:address-create';
    args: customer_address_create_args;
}

interface customer_address_create_args {
}

interface customer_address_detail {
    name: 'customer:address-detail';
    args: customer_address_detail_args;
}

interface customer_address_detail_args {
    pk: number;
}

interface customer_address_delete {
    name: 'customer:address-delete';
    args: customer_address_delete_args;
}

interface customer_address_delete_args {
    pk: number;
}

interface customer_email_list {
    name: 'customer:email-list';
    args: customer_email_list_args;
}

interface customer_email_list_args {
}

interface customer_email_detail {
    name: 'customer:email-detail';
    args: customer_email_detail_args;
}

interface customer_email_detail_args {
    email_id: number;
}

interface customer_notifications_inbox {
    name: 'customer:notifications-inbox';
    args: customer_notifications_inbox_args;
}

interface customer_notifications_inbox_args {
}

interface customer_notifications_archive {
    name: 'customer:notifications-archive';
    args: customer_notifications_archive_args;
}

interface customer_notifications_archive_args {
}

interface customer_notifications_update {
    name: 'customer:notifications-update';
    args: customer_notifications_update_args;
}

interface customer_notifications_update_args {
}

interface customer_notifications_detail {
    name: 'customer:notifications-detail';
    args: customer_notifications_detail_args;
}

interface customer_notifications_detail_args {
    pk: number;
}

interface customer_alerts_list {
    name: 'customer:alerts-list';
    args: customer_alerts_list_args;
}

interface customer_alerts_list_args {
}

interface customer_alert_create {
    name: 'customer:alert-create';
    args: customer_alert_create_args;
}

interface customer_alert_create_args {
    pk: number;
}

interface customer_alerts_confirm {
    name: 'customer:alerts-confirm';
    args: customer_alerts_confirm_args;
}

interface customer_alerts_confirm_args {
    key: string;
}

interface customer_alerts_cancel_by_key {
    name: 'customer:alerts-cancel-by-key';
    args: customer_alerts_cancel_by_key_args;
}

interface customer_alerts_cancel_by_key_args {
    key: string;
}

interface customer_alerts_cancel_by_pk {
    name: 'customer:alerts-cancel-by-pk';
    args: customer_alerts_cancel_by_pk_args;
}

interface customer_alerts_cancel_by_pk_args {
    pk: number;
}

interface customer_wishlists_list {
    name: 'customer:wishlists-list';
    args: customer_wishlists_list_args;
}

interface customer_wishlists_list_args {
}

interface customer_wishlists_add_product {
    name: 'customer:wishlists-add-product';
    args: customer_wishlists_add_product_args;
}

interface customer_wishlists_add_product_args {
    key: string;
    product_pk: number;
}

interface customer_wishlists_create {
    name: 'customer:wishlists-create';
    args: customer_wishlists_create_args;
}

interface customer_wishlists_create_args {
}

interface customer_wishlists_create_with_product {
    name: 'customer:wishlists-create-with-product';
    args: customer_wishlists_create_with_product_args;
}

interface customer_wishlists_create_with_product_args {
    product_pk: number;
}

interface customer_wishlists_detail {
    name: 'customer:wishlists-detail';
    args: customer_wishlists_detail_args;
}

interface customer_wishlists_detail_args {
    key: string;
}

interface customer_wishlists_update {
    name: 'customer:wishlists-update';
    args: customer_wishlists_update_args;
}

interface customer_wishlists_update_args {
    key: string;
}

interface customer_wishlists_delete {
    name: 'customer:wishlists-delete';
    args: customer_wishlists_delete_args;
}

interface customer_wishlists_delete_args {
    key: string;
}

interface customer_wishlists_remove_product {
    name: 'customer:wishlists-remove-product';
    args: customer_wishlists_remove_product_args;
}

interface customer_wishlists_remove_product_args {
    key: string;
    product_pk: number;
}

interface customer_wishlists_move_product_to_another {
    name: 'customer:wishlists-move-product-to-another';
    args: customer_wishlists_move_product_to_another_args;
}

interface customer_wishlists_move_product_to_another_args {
    key: string;
    line_pk: number;
    to_key: string;
}

interface catalogue_reviews_detail {
    name: 'catalogue:reviews-detail';
    args: catalogue_reviews_detail_args;
}

interface catalogue_reviews_detail_args {
    pk: number;
}

interface catalogue_reviews_add {
    name: 'catalogue:reviews-add';
    args: catalogue_reviews_add_args;
}

interface catalogue_reviews_add_args {
}

interface catalogue_reviews_vote {
    name: 'catalogue:reviews-vote';
    args: catalogue_reviews_vote_args;
}

interface catalogue_reviews_vote_args {
    pk: number;
}

interface catalogue_reviews_list {
    name: 'catalogue:reviews-list';
    args: catalogue_reviews_list_args;
}

interface catalogue_reviews_list_args {
}

interface catalogue_index {
    name: 'catalogue:index';
    args: catalogue_index_args;
}

interface catalogue_index_args {
}

interface search_search {
    name: 'search:search';
    args: search_search_args;
}

interface search_search_args {
}

interface offer_list {
    name: 'offer:list';
    args: offer_list_args;
}

interface offer_list_args {
}

interface loadup_submit_request {
    name: 'loadup-submit-request';
    args: loadup_submit_request_args;
}

interface loadup_submit_request_args {
    pk: number;
    token: string;
}

interface loadup_request_confirmation {
    name: 'loadup-request-confirmation';
    args: loadup_request_confirmation_args;
}

interface loadup_request_confirmation_args {
    pk: number;
    token: string;
}

interface password_reset {
    name: 'password-reset';
    args: password_reset_args;
}

interface password_reset_args {
}

interface password_reset_done {
    name: 'password-reset-done';
    args: password_reset_done_args;
}

interface password_reset_done_args {
}

interface password_reset_confirm {
    name: 'password-reset-confirm';
    args: password_reset_confirm_args;
}

interface password_reset_confirm_args {
    uidb64: string;
    token: string;
}

interface password_reset_complete {
    name: 'password-reset-complete';
    args: password_reset_complete_args;
}

interface password_reset_complete_args {
}

interface wagtaildocs_authenticate_with_password {
    name: 'wagtaildocs_authenticate_with_password';
    args: wagtaildocs_authenticate_with_password_args;
}

interface wagtaildocs_authenticate_with_password_args {
    restriction_id: number;
}

interface search {
    name: 'search';
    args: search_args;
}

interface search_args {
}

interface location_directory_state_list {
    name: 'location-directory:state-list';
    args: location_directory_state_list_args;
}

interface location_directory_state_list_args {
}

interface location_directory_city_list {
    name: 'location-directory:city-list';
    args: location_directory_city_list_args;
}

interface location_directory_city_list_args {
    state: string;
}

interface location_directory_store_list {
    name: 'location-directory:store-list';
    args: location_directory_store_list_args;
}

interface location_directory_store_list_args {
    state: string;
    city_slug: string;
}

interface location_directory_store_detail {
    name: 'location-directory:store-detail';
    args: location_directory_store_detail_args;
}

interface location_directory_store_detail_args {
    state: string;
    city_slug: string;
    pk: number;
}

interface cms_nav_iframe {
    name: 'cms-nav-iframe';
    args: cms_nav_iframe_args;
}

interface cms_nav_iframe_args {
}

interface cms_footer_iframe {
    name: 'cms-footer-iframe';
    args: cms_footer_iframe_args;
}

interface cms_footer_iframe_args {
}

interface cms_iframe_test {
    name: 'cms-iframe-test';
    args: cms_iframe_test_args;
}

interface cms_iframe_test_args {
}

interface shop_tile {
    name: 'shop-tile';
    args: shop_tile_args;
}

interface shop_tile_args {
    shop_tile_pk: number;
}

interface html_sitemap {
    name: 'html_sitemap';
    args: html_sitemap_args;
}

interface html_sitemap_args {
}

interface wagtailcore_authenticate_with_password {
    name: 'wagtailcore_authenticate_with_password';
    args: wagtailcore_authenticate_with_password_args;
}

interface wagtailcore_authenticate_with_password_args {
    page_view_restriction_id: number;
    page_id: number;
}

interface wagtailcore_login {
    name: 'wagtailcore_login';
    args: wagtailcore_login_args;
}

interface wagtailcore_login_args {
}

interface __reactivated_do_not_use {
    name: '__reactivated_do_not_use';
    args: __reactivated_do_not_use_args;
}

interface __reactivated_do_not_use_args {
}

interface __reactivated_do_not_use_args {
    name: '__reactivated_do_not_use_args';
    args: __reactivated_do_not_use_args_args;
}

interface __reactivated_do_not_use_args_args {
    _: string;
}

type WithArguments = |wagtailapi_pages_detail|wagtailapi_images_detail|wagtailapi_documents_detail|wagtailapi_flagship_pages_detail|wagtailapi_social_detail|health_check_health_check_subset|download_periodic_report|wagtailadmin_api_pages_detail|wagtailadmin_api_pages_action|wagtailadmin_api_documents_detail|wagtailadmin_api_images_detail|wagtailadmin_explore|wagtailadmin_explore_results|wagtail_bulk_action|wagtailadmin_pages_add|wagtailadmin_pages_preview_on_add|wagtailadmin_pages_type_use|wagtailadmin_pages_type_use_results|wagtailadmin_pages_usage|wagtailadmin_pages_edit|wagtailadmin_pages_preview_on_edit|wagtailadmin_pages_view_draft|wagtailadmin_pages_add_subpage|wagtailadmin_pages_delete|wagtailadmin_pages_unpublish|wagtailadmin_pages_convert_alias|wagtailadmin_pages_move|wagtailadmin_pages_move_confirm|wagtailadmin_pages_set_page_position|wagtailadmin_pages_copy|wagtailadmin_pages_workflow_action|wagtailadmin_pages_collect_workflow_action_data|wagtailadmin_pages_confirm_workflow_cancellation|wagtailadmin_pages_workflow_preview|wagtailadmin_pages_set_privacy|wagtailadmin_pages_lock|wagtailadmin_pages_unlock|wagtailadmin_pages_revisions_index|wagtailadmin_pages_revisions_view|wagtailadmin_pages_revisions_revert|wagtailadmin_pages_revisions_unschedule|wagtailadmin_pages_workflow_history|wagtailadmin_pages_workflow_history_detail|wagtailadmin_pages_history|wagtailadmin_pages_history_results|wagtailadmin_choose_page_child|wagtailadmin_tag_model_autocomplete|wagtailadmin_collections_edit|wagtailadmin_collections_delete|wagtailadmin_collections_set_privacy|wagtailadmin_workflows_enable|wagtailadmin_workflows_disable|wagtailadmin_workflows_edit|wagtailadmin_workflows_usage|wagtailadmin_workflows_usage_results|wagtailadmin_workflows_remove|wagtailadmin_workflows_add_task|wagtailadmin_workflows_edit_task|wagtailadmin_workflows_disable_task|wagtailadmin_workflows_enable_task|wagtailadmin_workflows_task_chosen|wagtailadmin_editing_sessions_ping|wagtailadmin_editing_sessions_release|wagtailvideos_edit_multiple|wagtailvideos_create_multiple_from_uploaded_image|wagtailvideos_delete_multiple|wagtailvideos_delete_upload_multiple|wagtailsettings_edit|wagtailsnippets_wagtail_links_link_edit|wagtailsnippets_wagtail_links_link_delete|wagtailsnippets_wagtail_links_link_usage|wagtailsnippets_wagtail_links_link_history|wagtailsnippets_wagtail_links_link_history_results|wagtailsnippets_wagtail_links_link_copy|wagtailsnippetchoosers_wagtail_links_link_chosen|wagtailsnippets_tsicommon_cms_mattressmatchcondition_edit|wagtailsnippets_tsicommon_cms_mattressmatchcondition_delete|wagtailsnippets_tsicommon_cms_mattressmatchcondition_usage|wagtailsnippets_tsicommon_cms_mattressmatchcondition_history|wagtailsnippets_tsicommon_cms_mattressmatchcondition_history_results|wagtailsnippets_tsicommon_cms_mattressmatchcondition_copy|wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_chosen|wagtailsnippets_tsicommon_cms_promoperiod_edit|wagtailsnippets_tsicommon_cms_promoperiod_delete|wagtailsnippets_tsicommon_cms_promoperiod_usage|wagtailsnippets_tsicommon_cms_promoperiod_history|wagtailsnippets_tsicommon_cms_promoperiod_history_results|wagtailsnippets_tsicommon_cms_promoperiod_copy|wagtailsnippetchoosers_tsicommon_cms_promoperiod_chosen|wagtailsnippets_tsicommon_cms_mattressmatchresult_edit|wagtailsnippets_tsicommon_cms_mattressmatchresult_delete|wagtailsnippets_tsicommon_cms_mattressmatchresult_usage|wagtailsnippets_tsicommon_cms_mattressmatchresult_history|wagtailsnippets_tsicommon_cms_mattressmatchresult_history_results|wagtailsnippets_tsicommon_cms_mattressmatchresult_copy|wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_chosen|wagtailsnippets_tsicommon_cms_mattressfeel_edit|wagtailsnippets_tsicommon_cms_mattressfeel_delete|wagtailsnippets_tsicommon_cms_mattressfeel_usage|wagtailsnippets_tsicommon_cms_mattressfeel_history|wagtailsnippets_tsicommon_cms_mattressfeel_history_results|wagtailsnippets_tsicommon_cms_mattressfeel_copy|wagtailsnippetchoosers_tsicommon_cms_mattressfeel_chosen|wagtailsnippets_tsicommon_cms_featuredofferscard_edit|wagtailsnippets_tsicommon_cms_featuredofferscard_delete|wagtailsnippets_tsicommon_cms_featuredofferscard_usage|wagtailsnippets_tsicommon_cms_featuredofferscard_history|wagtailsnippets_tsicommon_cms_featuredofferscard_history_results|wagtailsnippets_tsicommon_cms_featuredofferscard_copy|wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_chosen|wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_edit|wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_delete|wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_usage|wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_history|wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_history_results|wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_copy|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_chosen|wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_edit|wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_delete|wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_usage|wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_history|wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_history_results|wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_copy|wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_chosen|wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_edit|wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_delete|wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_usage|wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_history|wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_history_results|wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_copy|wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_chosen|wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_edit|wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_delete|wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_usage|wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_history|wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_history_results|wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_copy|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_chosen|wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_edit|wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_delete|wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_usage|wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_history|wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_history_results|wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_copy|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_chosen|wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_edit|wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_delete|wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_usage|wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_history|wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_history_results|wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_copy|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_chosen|wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_edit|wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_delete|wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_usage|wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_history|wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_history_results|wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_copy|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_chosen|wagtailsnippets_tsicommon_cms_offeradvertisingcontent_edit|wagtailsnippets_tsicommon_cms_offeradvertisingcontent_delete|wagtailsnippets_tsicommon_cms_offeradvertisingcontent_usage|wagtailsnippets_tsicommon_cms_offeradvertisingcontent_history|wagtailsnippets_tsicommon_cms_offeradvertisingcontent_history_results|wagtailsnippets_tsicommon_cms_offeradvertisingcontent_copy|wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_chosen|wagtailsnippets_tsicommon_cms_countdowntimerqueue_edit|wagtailsnippets_tsicommon_cms_countdowntimerqueue_delete|wagtailsnippets_tsicommon_cms_countdowntimerqueue_usage|wagtailsnippets_tsicommon_cms_countdowntimerqueue_history|wagtailsnippets_tsicommon_cms_countdowntimerqueue_history_results|wagtailsnippets_tsicommon_cms_countdowntimerqueue_copy|wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_chosen|wagtailsnippets_tsicommon_cms_faq_edit|wagtailsnippets_tsicommon_cms_faq_delete|wagtailsnippets_tsicommon_cms_faq_usage|wagtailsnippets_tsicommon_cms_faq_history|wagtailsnippets_tsicommon_cms_faq_history_results|wagtailsnippets_tsicommon_cms_faq_copy|wagtailsnippetchoosers_tsicommon_cms_faq_chosen|wagtailsnippets_tsicommon_cms_slidecollection_edit|wagtailsnippets_tsicommon_cms_slidecollection_delete|wagtailsnippets_tsicommon_cms_slidecollection_usage|wagtailsnippets_tsicommon_cms_slidecollection_history|wagtailsnippets_tsicommon_cms_slidecollection_history_results|wagtailsnippets_tsicommon_cms_slidecollection_copy|wagtailsnippetchoosers_tsicommon_cms_slidecollection_chosen|wagtailsnippets_tsicommon_cms_link_edit|wagtailsnippets_tsicommon_cms_link_delete|wagtailsnippets_tsicommon_cms_link_usage|wagtailsnippets_tsicommon_cms_link_history|wagtailsnippets_tsicommon_cms_link_history_results|wagtailsnippets_tsicommon_cms_link_copy|wagtailsnippetchoosers_tsicommon_cms_link_chosen|wagtailsnippets_tsicommon_cms_plainnavigation_edit|wagtailsnippets_tsicommon_cms_plainnavigation_delete|wagtailsnippets_tsicommon_cms_plainnavigation_usage|wagtailsnippets_tsicommon_cms_plainnavigation_history|wagtailsnippets_tsicommon_cms_plainnavigation_history_results|wagtailsnippets_tsicommon_cms_plainnavigation_copy|wagtailsnippetchoosers_tsicommon_cms_plainnavigation_chosen|wagtailsnippets_tsicommon_cms_productcomparetile_edit|wagtailsnippets_tsicommon_cms_productcomparetile_delete|wagtailsnippets_tsicommon_cms_productcomparetile_usage|wagtailsnippets_tsicommon_cms_productcomparetile_history|wagtailsnippets_tsicommon_cms_productcomparetile_history_results|wagtailsnippets_tsicommon_cms_productcomparetile_copy|wagtailsnippetchoosers_tsicommon_cms_productcomparetile_chosen|wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_edit|wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_delete|wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_usage|wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_history|wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_history_results|wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_copy|wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_chosen|wagtailsnippets_tsicommon_cms_productcomparerowtype_edit|wagtailsnippets_tsicommon_cms_productcomparerowtype_delete|wagtailsnippets_tsicommon_cms_productcomparerowtype_usage|wagtailsnippets_tsicommon_cms_productcomparerowtype_history|wagtailsnippets_tsicommon_cms_productcomparerowtype_history_results|wagtailsnippets_tsicommon_cms_productcomparerowtype_copy|wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_chosen|wagtailsnippets_tsicommon_cms_productcomparerowcontent_edit|wagtailsnippets_tsicommon_cms_productcomparerowcontent_delete|wagtailsnippets_tsicommon_cms_productcomparerowcontent_usage|wagtailsnippets_tsicommon_cms_productcomparerowcontent_history|wagtailsnippets_tsicommon_cms_productcomparerowcontent_history_results|wagtailsnippets_tsicommon_cms_productcomparerowcontent_copy|wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_chosen|wagtailsnippets_tsicommon_cms_productgrid_edit|wagtailsnippets_tsicommon_cms_productgrid_delete|wagtailsnippets_tsicommon_cms_productgrid_usage|wagtailsnippets_tsicommon_cms_productgrid_history|wagtailsnippets_tsicommon_cms_productgrid_history_results|wagtailsnippets_tsicommon_cms_productgrid_copy|wagtailsnippetchoosers_tsicommon_cms_productgrid_chosen|wagtailsnippets_tsicommon_cms_plcconfigurator_edit|wagtailsnippets_tsicommon_cms_plcconfigurator_delete|wagtailsnippets_tsicommon_cms_plcconfigurator_usage|wagtailsnippets_tsicommon_cms_plcconfigurator_history|wagtailsnippets_tsicommon_cms_plcconfigurator_history_results|wagtailsnippets_tsicommon_cms_plcconfigurator_copy|wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_chosen|wagtailsnippets_tsicommon_cms_promomessagingbanner_edit|wagtailsnippets_tsicommon_cms_promomessagingbanner_delete|wagtailsnippets_tsicommon_cms_promomessagingbanner_usage|wagtailsnippets_tsicommon_cms_promomessagingbanner_history|wagtailsnippets_tsicommon_cms_promomessagingbanner_history_results|wagtailsnippets_tsicommon_cms_promomessagingbanner_copy|wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_chosen|wagtailsnippets_tsicommon_cms_richnavigationlink_edit|wagtailsnippets_tsicommon_cms_richnavigationlink_delete|wagtailsnippets_tsicommon_cms_richnavigationlink_usage|wagtailsnippets_tsicommon_cms_richnavigationlink_history|wagtailsnippets_tsicommon_cms_richnavigationlink_history_results|wagtailsnippets_tsicommon_cms_richnavigationlink_copy|wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_chosen|wagtailsnippets_tsicommon_cms_richnavigation_edit|wagtailsnippets_tsicommon_cms_richnavigation_delete|wagtailsnippets_tsicommon_cms_richnavigation_usage|wagtailsnippets_tsicommon_cms_richnavigation_history|wagtailsnippets_tsicommon_cms_richnavigation_history_results|wagtailsnippets_tsicommon_cms_richnavigation_copy|wagtailsnippetchoosers_tsicommon_cms_richnavigation_chosen|wagtailsnippets_tsicommon_cms_emailmodal_edit|wagtailsnippets_tsicommon_cms_emailmodal_delete|wagtailsnippets_tsicommon_cms_emailmodal_usage|wagtailsnippets_tsicommon_cms_emailmodal_history|wagtailsnippets_tsicommon_cms_emailmodal_history_results|wagtailsnippets_tsicommon_cms_emailmodal_copy|wagtailsnippetchoosers_tsicommon_cms_emailmodal_chosen|wagtailsnippets_tsicommon_cms_servicefootersnippet_edit|wagtailsnippets_tsicommon_cms_servicefootersnippet_delete|wagtailsnippets_tsicommon_cms_servicefootersnippet_usage|wagtailsnippets_tsicommon_cms_servicefootersnippet_history|wagtailsnippets_tsicommon_cms_servicefootersnippet_history_results|wagtailsnippets_tsicommon_cms_servicefootersnippet_copy|wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_chosen|wagtailsnippets_tsicommon_cms_timedemailmodal_edit|wagtailsnippets_tsicommon_cms_timedemailmodal_delete|wagtailsnippets_tsicommon_cms_timedemailmodal_usage|wagtailsnippets_tsicommon_cms_timedemailmodal_history|wagtailsnippets_tsicommon_cms_timedemailmodal_history_results|wagtailsnippets_tsicommon_cms_timedemailmodal_copy|wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_chosen|wagtailsnippets_tsicommon_cms_comparefeature_edit|wagtailsnippets_tsicommon_cms_comparefeature_delete|wagtailsnippets_tsicommon_cms_comparefeature_usage|wagtailsnippets_tsicommon_cms_comparefeature_history|wagtailsnippets_tsicommon_cms_comparefeature_history_results|wagtailsnippets_tsicommon_cms_comparefeature_copy|wagtailsnippetchoosers_tsicommon_cms_comparefeature_chosen|wagtailsnippets_tsicommon_cms_comparetile_edit|wagtailsnippets_tsicommon_cms_comparetile_delete|wagtailsnippets_tsicommon_cms_comparetile_usage|wagtailsnippets_tsicommon_cms_comparetile_history|wagtailsnippets_tsicommon_cms_comparetile_history_results|wagtailsnippets_tsicommon_cms_comparetile_copy|wagtailsnippetchoosers_tsicommon_cms_comparetile_chosen|wagtailsnippets_tsicommon_cms_shoptile_edit|wagtailsnippets_tsicommon_cms_shoptile_delete|wagtailsnippets_tsicommon_cms_shoptile_usage|wagtailsnippets_tsicommon_cms_shoptile_history|wagtailsnippets_tsicommon_cms_shoptile_history_results|wagtailsnippets_tsicommon_cms_shoptile_copy|wagtailsnippetchoosers_tsicommon_cms_shoptile_chosen|wagtailsnippets_tsicommon_cms_shopcomparetileset_edit|wagtailsnippets_tsicommon_cms_shopcomparetileset_delete|wagtailsnippets_tsicommon_cms_shopcomparetileset_usage|wagtailsnippets_tsicommon_cms_shopcomparetileset_history|wagtailsnippets_tsicommon_cms_shopcomparetileset_history_results|wagtailsnippets_tsicommon_cms_shopcomparetileset_copy|wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_chosen|wagtailsnippets_tsicommon_cms_stickyemailbanner_edit|wagtailsnippets_tsicommon_cms_stickyemailbanner_delete|wagtailsnippets_tsicommon_cms_stickyemailbanner_usage|wagtailsnippets_tsicommon_cms_stickyemailbanner_history|wagtailsnippets_tsicommon_cms_stickyemailbanner_history_results|wagtailsnippets_tsicommon_cms_stickyemailbanner_copy|wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_chosen|wagtailsnippets_tsicommon_cms_valueprop_edit|wagtailsnippets_tsicommon_cms_valueprop_delete|wagtailsnippets_tsicommon_cms_valueprop_usage|wagtailsnippets_tsicommon_cms_valueprop_history|wagtailsnippets_tsicommon_cms_valueprop_history_results|wagtailsnippets_tsicommon_cms_valueprop_copy|wagtailsnippetchoosers_tsicommon_cms_valueprop_chosen|wagtailsnippets_cms_navbar_edit|wagtailsnippets_cms_navbar_delete|wagtailsnippets_cms_navbar_usage|wagtailsnippets_cms_navbar_history|wagtailsnippets_cms_navbar_history_results|wagtailsnippets_cms_navbar_copy|wagtailsnippetchoosers_cms_navbar_chosen|wagtailsnippets_cms_contentblock_edit|wagtailsnippets_cms_contentblock_delete|wagtailsnippets_cms_contentblock_usage|wagtailsnippets_cms_contentblock_history|wagtailsnippets_cms_contentblock_history_results|wagtailsnippets_cms_contentblock_copy|wagtailsnippetchoosers_cms_contentblock_chosen|wagtailsnippets_cms_promocopyheader_edit|wagtailsnippets_cms_promocopyheader_delete|wagtailsnippets_cms_promocopyheader_usage|wagtailsnippets_cms_promocopyheader_history|wagtailsnippets_cms_promocopyheader_history_results|wagtailsnippets_cms_promocopyheader_copy|wagtailsnippetchoosers_cms_promocopyheader_chosen|wagtailsnippets_cms_promocopy_edit|wagtailsnippets_cms_promocopy_delete|wagtailsnippets_cms_promocopy_usage|wagtailsnippets_cms_promocopy_history|wagtailsnippets_cms_promocopy_history_results|wagtailsnippets_cms_promocopy_copy|wagtailsnippetchoosers_cms_promocopy_chosen|wagtailsnippets_cms_navbadge_edit|wagtailsnippets_cms_navbadge_delete|wagtailsnippets_cms_navbadge_usage|wagtailsnippets_cms_navbadge_history|wagtailsnippets_cms_navbadge_history_results|wagtailsnippets_cms_navbadge_copy|wagtailsnippetchoosers_cms_navbadge_chosen|wagtailsnippets_cms_ownerspotlight_edit|wagtailsnippets_cms_ownerspotlight_delete|wagtailsnippets_cms_ownerspotlight_usage|wagtailsnippets_cms_ownerspotlight_history|wagtailsnippets_cms_ownerspotlight_history_results|wagtailsnippets_cms_ownerspotlight_copy|wagtailsnippetchoosers_cms_ownerspotlight_chosen|wagtailsnippets_cms_ugcpost_edit|wagtailsnippets_cms_ugcpost_delete|wagtailsnippets_cms_ugcpost_usage|wagtailsnippets_cms_ugcpost_history|wagtailsnippets_cms_ugcpost_history_results|wagtailsnippets_cms_ugcpost_copy|wagtailsnippetchoosers_cms_ugcpost_chosen|wagtailsnippets_cms_tempurlovestorycategory_edit|wagtailsnippets_cms_tempurlovestorycategory_delete|wagtailsnippets_cms_tempurlovestorycategory_usage|wagtailsnippets_cms_tempurlovestorycategory_history|wagtailsnippets_cms_tempurlovestorycategory_history_results|wagtailsnippets_cms_tempurlovestorycategory_copy|wagtailsnippetchoosers_cms_tempurlovestorycategory_chosen|wagtailsnippets_tempur_search_dynamicsearchsnippet_edit|wagtailsnippets_tempur_search_dynamicsearchsnippet_delete|wagtailsnippets_tempur_search_dynamicsearchsnippet_usage|wagtailsnippets_tempur_search_dynamicsearchsnippet_history|wagtailsnippets_tempur_search_dynamicsearchsnippet_history_results|wagtailsnippets_tempur_search_dynamicsearchsnippet_copy|wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_chosen|wagtailsnippets_tempur_search_dynamic404pagesnippet_edit|wagtailsnippets_tempur_search_dynamic404pagesnippet_delete|wagtailsnippets_tempur_search_dynamic404pagesnippet_usage|wagtailsnippets_tempur_search_dynamic404pagesnippet_history|wagtailsnippets_tempur_search_dynamic404pagesnippet_history_results|wagtailsnippets_tempur_search_dynamic404pagesnippet_copy|wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_chosen|wagtailsnippets_thelabui_labuitoolboxsnippet_edit|wagtailsnippets_thelabui_labuitoolboxsnippet_delete|wagtailsnippets_thelabui_labuitoolboxsnippet_usage|wagtailsnippets_thelabui_labuitoolboxsnippet_history|wagtailsnippets_thelabui_labuitoolboxsnippet_history_results|wagtailsnippets_thelabui_labuitoolboxsnippet_copy|wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_edit|wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_view|wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_revert|wagtailsnippets_thelabui_labuitoolboxsnippet_revisions_unschedule|wagtailsnippets_thelabui_labuitoolboxsnippet_unpublish|wagtailsnippets_thelabui_labuitoolboxsnippet_lock|wagtailsnippets_thelabui_labuitoolboxsnippet_unlock|wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen|wagtailvideos_chooser_chosen|wagtaildocs_chooser_chosen|wagtailsites_edit|wagtailsites_delete|wagtailsites_history|wagtailsites_history_results|wagtailsites_usage|wagtailsites_copy|wagtailusers_users_edit|wagtailusers_users_delete|wagtailusers_users_history|wagtailusers_users_history_results|wagtailusers_users_usage|wagtailusers_users_copy|wagtailusers_groups_edit|wagtailusers_groups_delete|wagtailusers_groups_history|wagtailusers_groups_history_results|wagtailusers_groups_usage|wagtaillocales_edit|wagtaillocales_delete|wagtaillocales_history|wagtaillocales_history_results|wagtaillocales_usage|wagtaillocales_copy|tsicommon_cms_product_chooser_chosen|tsicommon_cms_location_chooser_chosen|wagtailimages_chooser_chosen|wagtailimages_chooser_select_format|wagtaildocs_edit|wagtaildocs_delete|wagtaildocs_edit_multiple|wagtaildocs_create_multiple_from_uploaded_document|wagtaildocs_delete_multiple|wagtaildocs_delete_upload_multiple|wagtaildocs_document_usage|wagtail_localize_submit_page_translation|wagtail_localize_submit_snippet_translation|wagtail_localize_update_translations|wagtail_localize_edit_string_translation|wagtail_localize_edit_override|wagtail_localize_download_pofile|wagtail_localize_upload_pofile|wagtail_localize_machine_translate|wagtail_localize_preview_translation|wagtail_localize_stop_translation|wagtail_localize_convert_to_alias|wagtail_localize_snippets_api_listing|wagtail_localize_snippets_api_detail|wagtailforms_list_submissions|wagtailforms_list_submissions_results|wagtailforms_delete_submissions|wagtailredirects_edit|wagtailredirects_delete|wagtailsearchpromotions_edit|wagtailsearchpromotions_delete|wagtailimages_edit|wagtailimages_delete|wagtailimages_url_generator|wagtailimages_generate_url|wagtailimages_preview|wagtailimages_image_usage|wagtailimages_edit_multiple|wagtailimages_create_multiple_from_uploaded_image|wagtailimages_delete_multiple|wagtailimages_delete_upload_multiple|wagtailadmin_password_reset_confirm|django_admindocs_views_detail|django_admindocs_templates|cybersource_fingerprint_redirect|financingapi_document_content_view|financingapi_syf_transaction_lookup|tsi_auth_login_token|tsi_yext_entity_webhook|product_bundle_list|product_concretebundle_list|product_userconfigurablebundle_list|bundlegroup_detail|concretebundle_detail|userconfigurablebundle_detail|api_payment|product_detail|product_price|product_financing_plans|product_stockrecords|product_stockrecord_detail|product_shipping_methods|product_shipping_methods_by_location|product_upsellinfomodals|product_promocards|option_detail|user_detail|order_detail|order_cancel_detail|order_lines_list|basket_detail|basket_lines_list|basket_line_detail|lineattribute_detail|category_detail|category_products|productclass_detail|productclass_members|country_detail|country_state_list|useraddress_detail|wishlisttype_detail|wishlisttype_line_list|wishlisttype_line_detail|financing_plan_edit|financing_plan_delete|financing_benefit_edit|financing_benefit_delete|financing_application_detail|financing_transfer_detail|financing_prequal_detail|benefit_bundle_update|benefit_bundle_delete|dashboard_catalogue_product|dashboard_catalogue_product_create_child|dashboard_catalogue_product_delete|dashboard_catalogue_category_detail_list|dashboard_catalogue_category_create_child|dashboard_catalogue_category_update|dashboard_catalogue_category_delete|dashboard_catalogue_class_update|dashboard_catalogue_class_delete|dashboard_catalogue_attribute_option_group_update|dashboard_catalogue_attribute_option_group_delete|dashboard_catalogue_option_update|dashboard_catalogue_option_delete|dashboard_value_prop_edit|dashboard_value_prop_delete|dashboard_reports_download|dashboard_reports_delete|dashboard_order_detail|dashboard_order_detail_note|dashboard_order_line_detail|dashboard_order_shipping_address|dashboard_deletion_request_details|dashboard_data_inquiry_details|dashboard_data_inquiry_download|dashboard_page_update|dashboard_page_delete|dashboard_partner_manage|dashboard_partner_delete|dashboard_partner_user_create|dashboard_partner_user_select|dashboard_partner_user_link|dashboard_partner_user_unlink|dashboard_partner_user_update|dashboard_offer_metadata|dashboard_offer_condition|dashboard_offer_benefit|dashboard_offer_restrictions|dashboard_offer_delete|dashboard_offer_detail|dashboard_api_root|dashboard_offer_images|dashboard_benefit_update|dashboard_benefit_delete|dashboard_condition_update|dashboard_condition_delete|dashboard_offergroup_update|dashboard_offergroup_delete|dashboard_range_update|dashboard_range_delete|dashboard_range_products|dashboard_range_reorder|dashboard_range_prices|dashboard_range_excluded_products|dashboard_reviews_update|dashboard_reviews_delete|dashboard_voucher_update|dashboard_voucher_delete|dashboard_voucher_stats|dashboard_voucher_set_update|dashboard_voucher_set_detail|dashboard_voucher_set_download|dashboard_voucher_set_delete|dashboard_voucher_list_children|dashboard_voucher_add_children|dashboard_voucher_export_children|dashboard_voucher_export_children_file|dashboard_voucher_update_suspension_status|dashboard_country_edit|dashboard_country_delete|dashboard_delivery_region_edit|dashboard_delivery_region_delete|dashboard_delivery_region_group_edit|dashboard_delivery_region_group_delete|dashboard_shipping_product_class_edit|dashboard_shipping_product_class_delete|dashboard_shipping_method_detail|dashboard_shipping_method_edit|dashboard_shipping_method_delete|dashboard_shipping_method_description_edit|dashboard_shipping_method_description_delete|dashboard_shipping_price_create|dashboard_shipping_price_edit|dashboard_shipping_price_delete|dashboard_shipping_option_edit|dashboard_shipping_option_delete|basket_add|basket_vouchers_remove|checkout_complete_deferred_payment|customer_unified_order_status|customer_unified_order_shipment_status|customer_anon_order|customer_order|customer_review_order_products|customer_order_shipment_tracking|customer_order_line|customer_address_detail|customer_address_delete|customer_email_detail|customer_notifications_detail|customer_alert_create|customer_alerts_confirm|customer_alerts_cancel_by_key|customer_alerts_cancel_by_pk|customer_wishlists_add_product|customer_wishlists_create_with_product|customer_wishlists_detail|customer_wishlists_update|customer_wishlists_delete|customer_wishlists_remove_product|customer_wishlists_move_product_to_another|catalogue_reviews_detail|catalogue_reviews_vote|loadup_submit_request|loadup_request_confirmation|password_reset_confirm|wagtaildocs_authenticate_with_password|location_directory_city_list|location_directory_store_list|location_directory_store_detail|shop_tile|wagtailcore_authenticate_with_password|__reactivated_do_not_use_args;
type WithoutArguments = |wagtailapi_pages_listing|wagtailapi_pages_find|wagtailapi_images_listing|wagtailapi_images_find|wagtailapi_documents_listing|wagtailapi_documents_find|wagtailapi_flagship_pages_listing|wagtailapi_flagship_pages_find|wagtailapi_social_listing|wagtailapi_social_find|oidc_authentication_callback|oidc_authentication_init|oidc_logout|health_check_health_check_home|wagtailadmin_home|wagtailadmin_api_pages_listing|wagtailadmin_api_pages_find|wagtailadmin_api_documents_listing|wagtailadmin_api_documents_find|wagtailadmin_api_images_listing|wagtailadmin_api_images_find|wagtailadmin_error_test|wagtailadmin_explore_root|wagtailadmin_pages_search|wagtailadmin_pages_search_results|wagtailadmin_choose_page|wagtailadmin_choose_page_search|wagtailadmin_choose_page_chosen_multiple|wagtailadmin_choose_page_external_link|wagtailadmin_choose_page_email_link|wagtailadmin_choose_page_phone_link|wagtailadmin_choose_page_anchor_link|wagtailadmin_tag_autocomplete|wagtailadmin_collections_index|wagtailadmin_collections_add|wagtailadmin_workflows_index|wagtailadmin_workflows_index_results|wagtailadmin_workflows_add|wagtailadmin_workflows_select_task_type|wagtailadmin_workflows_task_index|wagtailadmin_workflows_task_index_results|wagtailadmin_workflows_task_chooser|wagtailadmin_workflows_task_chooser_results|wagtailadmin_workflows_task_chooser_create|wagtailadmin_reports_locked_pages|wagtailadmin_reports_locked_pages_results|wagtailadmin_reports_workflow|wagtailadmin_reports_workflow_results|wagtailadmin_reports_workflow_tasks|wagtailadmin_reports_workflow_tasks_results|wagtailadmin_reports_site_history|wagtailadmin_reports_site_history_results|wagtailadmin_reports_aging_pages|wagtailadmin_reports_aging_pages_results|wagtailadmin_reports_page_types_usage|wagtailadmin_reports_page_types_usage_results|wagtailadmin_account|wagtailadmin_logout|wagtailadmin_dismissibles|wagtailadmin_block_preview|wagtailvideos_add|wagtailvideos_add_multiple|wagtailvideos_index|wagtailvideos_index_results|wagtailsnippets_wagtail_links_link_list|wagtailsnippets_wagtail_links_link_list_results|wagtailsnippets_wagtail_links_link_add|wagtailsnippetchoosers_wagtail_links_link_choose|wagtailsnippetchoosers_wagtail_links_link_choose_results|wagtailsnippetchoosers_wagtail_links_link_chosen_multiple|wagtailsnippetchoosers_wagtail_links_link_create|wagtailsnippets_tsicommon_cms_mattressmatchcondition_list|wagtailsnippets_tsicommon_cms_mattressmatchcondition_list_results|wagtailsnippets_tsicommon_cms_mattressmatchcondition_add|wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_choose|wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_choose_results|wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_mattressmatchcondition_create|wagtailsnippets_tsicommon_cms_promoperiod_list|wagtailsnippets_tsicommon_cms_promoperiod_list_results|wagtailsnippets_tsicommon_cms_promoperiod_add|wagtailsnippetchoosers_tsicommon_cms_promoperiod_choose|wagtailsnippetchoosers_tsicommon_cms_promoperiod_choose_results|wagtailsnippetchoosers_tsicommon_cms_promoperiod_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_promoperiod_create|wagtailsnippets_tsicommon_cms_mattressmatchresult_list|wagtailsnippets_tsicommon_cms_mattressmatchresult_list_results|wagtailsnippets_tsicommon_cms_mattressmatchresult_add|wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_choose|wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_choose_results|wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_mattressmatchresult_create|wagtailsnippets_tsicommon_cms_mattressfeel_list|wagtailsnippets_tsicommon_cms_mattressfeel_list_results|wagtailsnippets_tsicommon_cms_mattressfeel_add|wagtailsnippetchoosers_tsicommon_cms_mattressfeel_choose|wagtailsnippetchoosers_tsicommon_cms_mattressfeel_choose_results|wagtailsnippetchoosers_tsicommon_cms_mattressfeel_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_mattressfeel_create|wagtailsnippets_tsicommon_cms_featuredofferscard_list|wagtailsnippets_tsicommon_cms_featuredofferscard_list_results|wagtailsnippets_tsicommon_cms_featuredofferscard_add|wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_choose|wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_choose_results|wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_featuredofferscard_create|wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_list|wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_list_results|wagtailsnippets_tsicommon_cms_modularconfiguratoroptionset_add|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_choose|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_choose_results|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratoroptionset_create|wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_list|wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_list_results|wagtailsnippets_tsicommon_cms_modularconfigurator_promocard_add|wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_choose|wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_choose_results|wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_promocard_create|wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_list|wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_list_results|wagtailsnippets_tsicommon_cms_modularconfigurator_upsellinfomodal_add|wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_choose|wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_choose_results|wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_modularconfigurator_upsellinfomodal_create|wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_list|wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_list_results|wagtailsnippets_tsicommon_cms_modularconfiguratorshippingmessage_add|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_choose|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_choose_results|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorshippingmessage_create|wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_list|wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_list_results|wagtailsnippets_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_add|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_choose|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_choose_results|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratordynamicshippingtimemessaging_create|wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_list|wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_list_results|wagtailsnippets_tsicommon_cms_modularconfiguratorreviewaggregation_add|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_choose|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_choose_results|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorreviewaggregation_create|wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_list|wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_list_results|wagtailsnippets_tsicommon_cms_modularconfiguratorpromocardinfomodal_add|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_choose|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_choose_results|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_modularconfiguratorpromocardinfomodal_create|wagtailsnippets_tsicommon_cms_offeradvertisingcontent_list|wagtailsnippets_tsicommon_cms_offeradvertisingcontent_list_results|wagtailsnippets_tsicommon_cms_offeradvertisingcontent_add|wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_choose|wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_choose_results|wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_offeradvertisingcontent_create|wagtailsnippets_tsicommon_cms_countdowntimerqueue_list|wagtailsnippets_tsicommon_cms_countdowntimerqueue_list_results|wagtailsnippets_tsicommon_cms_countdowntimerqueue_add|wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_choose|wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_choose_results|wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_countdowntimerqueue_create|wagtailsnippets_tsicommon_cms_faq_list|wagtailsnippets_tsicommon_cms_faq_list_results|wagtailsnippets_tsicommon_cms_faq_add|wagtailsnippetchoosers_tsicommon_cms_faq_choose|wagtailsnippetchoosers_tsicommon_cms_faq_choose_results|wagtailsnippetchoosers_tsicommon_cms_faq_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_faq_create|wagtailsnippets_tsicommon_cms_slidecollection_list|wagtailsnippets_tsicommon_cms_slidecollection_list_results|wagtailsnippets_tsicommon_cms_slidecollection_add|wagtailsnippetchoosers_tsicommon_cms_slidecollection_choose|wagtailsnippetchoosers_tsicommon_cms_slidecollection_choose_results|wagtailsnippetchoosers_tsicommon_cms_slidecollection_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_slidecollection_create|wagtailsnippets_tsicommon_cms_link_list|wagtailsnippets_tsicommon_cms_link_list_results|wagtailsnippets_tsicommon_cms_link_add|wagtailsnippetchoosers_tsicommon_cms_link_choose|wagtailsnippetchoosers_tsicommon_cms_link_choose_results|wagtailsnippetchoosers_tsicommon_cms_link_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_link_create|wagtailsnippets_tsicommon_cms_plainnavigation_list|wagtailsnippets_tsicommon_cms_plainnavigation_list_results|wagtailsnippets_tsicommon_cms_plainnavigation_add|wagtailsnippetchoosers_tsicommon_cms_plainnavigation_choose|wagtailsnippetchoosers_tsicommon_cms_plainnavigation_choose_results|wagtailsnippetchoosers_tsicommon_cms_plainnavigation_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_plainnavigation_create|wagtailsnippets_tsicommon_cms_productcomparetile_list|wagtailsnippets_tsicommon_cms_productcomparetile_list_results|wagtailsnippets_tsicommon_cms_productcomparetile_add|wagtailsnippetchoosers_tsicommon_cms_productcomparetile_choose|wagtailsnippetchoosers_tsicommon_cms_productcomparetile_choose_results|wagtailsnippetchoosers_tsicommon_cms_productcomparetile_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_productcomparetile_create|wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_list|wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_list_results|wagtailsnippets_tsicommon_cms_attributeoptiongroupdescription_add|wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_choose|wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_choose_results|wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_attributeoptiongroupdescription_create|wagtailsnippets_tsicommon_cms_productcomparerowtype_list|wagtailsnippets_tsicommon_cms_productcomparerowtype_list_results|wagtailsnippets_tsicommon_cms_productcomparerowtype_add|wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_choose|wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_choose_results|wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_productcomparerowtype_create|wagtailsnippets_tsicommon_cms_productcomparerowcontent_list|wagtailsnippets_tsicommon_cms_productcomparerowcontent_list_results|wagtailsnippets_tsicommon_cms_productcomparerowcontent_add|wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_choose|wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_choose_results|wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_productcomparerowcontent_create|wagtailsnippets_tsicommon_cms_productgrid_list|wagtailsnippets_tsicommon_cms_productgrid_list_results|wagtailsnippets_tsicommon_cms_productgrid_add|wagtailsnippetchoosers_tsicommon_cms_productgrid_choose|wagtailsnippetchoosers_tsicommon_cms_productgrid_choose_results|wagtailsnippetchoosers_tsicommon_cms_productgrid_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_productgrid_create|wagtailsnippets_tsicommon_cms_plcconfigurator_list|wagtailsnippets_tsicommon_cms_plcconfigurator_list_results|wagtailsnippets_tsicommon_cms_plcconfigurator_add|wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_choose|wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_choose_results|wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_plcconfigurator_create|wagtailsnippets_tsicommon_cms_promomessagingbanner_list|wagtailsnippets_tsicommon_cms_promomessagingbanner_list_results|wagtailsnippets_tsicommon_cms_promomessagingbanner_add|wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_choose|wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_choose_results|wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_promomessagingbanner_create|wagtailsnippets_tsicommon_cms_richnavigationlink_list|wagtailsnippets_tsicommon_cms_richnavigationlink_list_results|wagtailsnippets_tsicommon_cms_richnavigationlink_add|wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_choose|wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_choose_results|wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_richnavigationlink_create|wagtailsnippets_tsicommon_cms_richnavigation_list|wagtailsnippets_tsicommon_cms_richnavigation_list_results|wagtailsnippets_tsicommon_cms_richnavigation_add|wagtailsnippetchoosers_tsicommon_cms_richnavigation_choose|wagtailsnippetchoosers_tsicommon_cms_richnavigation_choose_results|wagtailsnippetchoosers_tsicommon_cms_richnavigation_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_richnavigation_create|wagtailsnippets_tsicommon_cms_emailmodal_list|wagtailsnippets_tsicommon_cms_emailmodal_list_results|wagtailsnippets_tsicommon_cms_emailmodal_add|wagtailsnippetchoosers_tsicommon_cms_emailmodal_choose|wagtailsnippetchoosers_tsicommon_cms_emailmodal_choose_results|wagtailsnippetchoosers_tsicommon_cms_emailmodal_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_emailmodal_create|wagtailsnippets_tsicommon_cms_servicefootersnippet_list|wagtailsnippets_tsicommon_cms_servicefootersnippet_list_results|wagtailsnippets_tsicommon_cms_servicefootersnippet_add|wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_choose|wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_choose_results|wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_servicefootersnippet_create|wagtailsnippets_tsicommon_cms_timedemailmodal_list|wagtailsnippets_tsicommon_cms_timedemailmodal_list_results|wagtailsnippets_tsicommon_cms_timedemailmodal_add|wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_choose|wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_choose_results|wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_timedemailmodal_create|wagtailsnippets_tsicommon_cms_comparefeature_list|wagtailsnippets_tsicommon_cms_comparefeature_list_results|wagtailsnippets_tsicommon_cms_comparefeature_add|wagtailsnippetchoosers_tsicommon_cms_comparefeature_choose|wagtailsnippetchoosers_tsicommon_cms_comparefeature_choose_results|wagtailsnippetchoosers_tsicommon_cms_comparefeature_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_comparefeature_create|wagtailsnippets_tsicommon_cms_comparetile_list|wagtailsnippets_tsicommon_cms_comparetile_list_results|wagtailsnippets_tsicommon_cms_comparetile_add|wagtailsnippetchoosers_tsicommon_cms_comparetile_choose|wagtailsnippetchoosers_tsicommon_cms_comparetile_choose_results|wagtailsnippetchoosers_tsicommon_cms_comparetile_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_comparetile_create|wagtailsnippets_tsicommon_cms_shoptile_list|wagtailsnippets_tsicommon_cms_shoptile_list_results|wagtailsnippets_tsicommon_cms_shoptile_add|wagtailsnippetchoosers_tsicommon_cms_shoptile_choose|wagtailsnippetchoosers_tsicommon_cms_shoptile_choose_results|wagtailsnippetchoosers_tsicommon_cms_shoptile_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_shoptile_create|wagtailsnippets_tsicommon_cms_shopcomparetileset_list|wagtailsnippets_tsicommon_cms_shopcomparetileset_list_results|wagtailsnippets_tsicommon_cms_shopcomparetileset_add|wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_choose|wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_choose_results|wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_shopcomparetileset_create|wagtailsnippets_tsicommon_cms_stickyemailbanner_list|wagtailsnippets_tsicommon_cms_stickyemailbanner_list_results|wagtailsnippets_tsicommon_cms_stickyemailbanner_add|wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_choose|wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_choose_results|wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_stickyemailbanner_create|wagtailsnippets_tsicommon_cms_valueprop_list|wagtailsnippets_tsicommon_cms_valueprop_list_results|wagtailsnippets_tsicommon_cms_valueprop_add|wagtailsnippetchoosers_tsicommon_cms_valueprop_choose|wagtailsnippetchoosers_tsicommon_cms_valueprop_choose_results|wagtailsnippetchoosers_tsicommon_cms_valueprop_chosen_multiple|wagtailsnippetchoosers_tsicommon_cms_valueprop_create|wagtailsnippets_cms_navbar_list|wagtailsnippets_cms_navbar_list_results|wagtailsnippets_cms_navbar_add|wagtailsnippetchoosers_cms_navbar_choose|wagtailsnippetchoosers_cms_navbar_choose_results|wagtailsnippetchoosers_cms_navbar_chosen_multiple|wagtailsnippetchoosers_cms_navbar_create|wagtailsnippets_cms_contentblock_list|wagtailsnippets_cms_contentblock_list_results|wagtailsnippets_cms_contentblock_add|wagtailsnippetchoosers_cms_contentblock_choose|wagtailsnippetchoosers_cms_contentblock_choose_results|wagtailsnippetchoosers_cms_contentblock_chosen_multiple|wagtailsnippetchoosers_cms_contentblock_create|wagtailsnippets_cms_promocopyheader_list|wagtailsnippets_cms_promocopyheader_list_results|wagtailsnippets_cms_promocopyheader_add|wagtailsnippetchoosers_cms_promocopyheader_choose|wagtailsnippetchoosers_cms_promocopyheader_choose_results|wagtailsnippetchoosers_cms_promocopyheader_chosen_multiple|wagtailsnippetchoosers_cms_promocopyheader_create|wagtailsnippets_cms_promocopy_list|wagtailsnippets_cms_promocopy_list_results|wagtailsnippets_cms_promocopy_add|wagtailsnippetchoosers_cms_promocopy_choose|wagtailsnippetchoosers_cms_promocopy_choose_results|wagtailsnippetchoosers_cms_promocopy_chosen_multiple|wagtailsnippetchoosers_cms_promocopy_create|wagtailsnippets_cms_navbadge_list|wagtailsnippets_cms_navbadge_list_results|wagtailsnippets_cms_navbadge_add|wagtailsnippetchoosers_cms_navbadge_choose|wagtailsnippetchoosers_cms_navbadge_choose_results|wagtailsnippetchoosers_cms_navbadge_chosen_multiple|wagtailsnippetchoosers_cms_navbadge_create|wagtailsnippets_cms_ownerspotlight_list|wagtailsnippets_cms_ownerspotlight_list_results|wagtailsnippets_cms_ownerspotlight_add|wagtailsnippetchoosers_cms_ownerspotlight_choose|wagtailsnippetchoosers_cms_ownerspotlight_choose_results|wagtailsnippetchoosers_cms_ownerspotlight_chosen_multiple|wagtailsnippetchoosers_cms_ownerspotlight_create|wagtailsnippets_cms_ugcpost_list|wagtailsnippets_cms_ugcpost_list_results|wagtailsnippets_cms_ugcpost_add|wagtailsnippetchoosers_cms_ugcpost_choose|wagtailsnippetchoosers_cms_ugcpost_choose_results|wagtailsnippetchoosers_cms_ugcpost_chosen_multiple|wagtailsnippetchoosers_cms_ugcpost_create|wagtailsnippets_cms_tempurlovestorycategory_list|wagtailsnippets_cms_tempurlovestorycategory_list_results|wagtailsnippets_cms_tempurlovestorycategory_add|wagtailsnippetchoosers_cms_tempurlovestorycategory_choose|wagtailsnippetchoosers_cms_tempurlovestorycategory_choose_results|wagtailsnippetchoosers_cms_tempurlovestorycategory_chosen_multiple|wagtailsnippetchoosers_cms_tempurlovestorycategory_create|wagtailsnippets_tempur_search_dynamicsearchsnippet_list|wagtailsnippets_tempur_search_dynamicsearchsnippet_list_results|wagtailsnippets_tempur_search_dynamicsearchsnippet_add|wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_choose|wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_choose_results|wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_chosen_multiple|wagtailsnippetchoosers_tempur_search_dynamicsearchsnippet_create|wagtailsnippets_tempur_search_dynamic404pagesnippet_list|wagtailsnippets_tempur_search_dynamic404pagesnippet_list_results|wagtailsnippets_tempur_search_dynamic404pagesnippet_add|wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_choose|wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_choose_results|wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_chosen_multiple|wagtailsnippetchoosers_tempur_search_dynamic404pagesnippet_create|wagtailsnippets_thelabui_labuitoolboxsnippet_list|wagtailsnippets_thelabui_labuitoolboxsnippet_list_results|wagtailsnippets_thelabui_labuitoolboxsnippet_add|wagtailsnippets_thelabui_labuitoolboxsnippet_preview_on_add|wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose|wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_choose_results|wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_chosen_multiple|wagtailsnippetchoosers_thelabui_labuitoolboxsnippet_create|wagtailvideos_chooser_choose|wagtailvideos_chooser_choose_results|wagtailvideos_chooser_chosen_multiple|wagtailvideos_chooser_create|wagtaildocs_chooser_choose|wagtaildocs_chooser_choose_results|wagtaildocs_chooser_chosen_multiple|wagtaildocs_chooser_create|wagtailsites_index|wagtailsites_index_results|wagtailsites_add|wagtailusers_users_index|wagtailusers_users_index_results|wagtailusers_users_add|wagtailusers_groups_index|wagtailusers_groups_index_results|wagtailusers_groups_add|wagtaillocales_index|wagtaillocales_index_results|wagtaillocales_add|tsicommon_cms_product_chooser_choose|tsicommon_cms_product_chooser_choose_results|tsicommon_cms_product_chooser_chosen_multiple|tsicommon_cms_product_chooser_create|tsicommon_cms_location_chooser_choose|tsicommon_cms_location_chooser_choose_results|tsicommon_cms_location_chooser_chosen_multiple|tsicommon_cms_location_chooser_create|wagtailimages_chooser_choose|wagtailimages_chooser_choose_results|wagtailimages_chooser_chosen_multiple|wagtailimages_chooser_create|wagtaildocs_index|wagtaildocs_index_results|wagtaildocs_add|wagtaildocs_add_multiple|wagtailembeds_chooser|wagtailembeds_chooser_upload|wagtailsnippets_index|wagtail_localize_javascript_catalog|wagtail_localize_translations_report|wagtail_localize_translations_report_results|wagtailforms_index|wagtailforms_index_results|wagtailredirects_index|wagtailredirects_index_results|wagtailredirects_add|wagtailredirects_start_import|wagtailredirects_process_import|wagtailsearchpromotions_index|wagtailsearchpromotions_index_results|wagtailsearchpromotions_add|wagtailsearchpromotions_chooser|wagtailsearchpromotions_chooserresults|wagtailsearchpromotions_search_terms|wagtailsearchpromotions_search_terms_results|wagtailstyleguide|wagtail_modeladmin_javascript_catalog|cms_flagship_page_bulk_update|cms_flagship_page_bulk_update_apply|cms_mattress_match_bulk_import|cms_mattress_match_bulk_import_apply|tsicommon_cms_admin_tooltip_content_modal|tsicommon_cms_admin_wistia_link_content_modal|wagtailimages_index|wagtailimages_index_results|wagtailimages_add|wagtailimages_add_multiple|wagtailadmin_sprite|wagtailadmin_login|wagtailadmin_password_reset|wagtailadmin_password_reset_done|wagtailadmin_password_reset_complete|wagtailadmin_javascript_catalog|django_admindocs_docroot|django_admindocs_bookmarklets|django_admindocs_tags|django_admindocs_filters|django_admindocs_views_index|django_admindocs_models_index|thelabui_load_balancer_health_check|thelabui_csrftoken_get|thelabui_robots_txt|thelabui_security_txt|thelabui_sitemap|asymmetric_jwt_auth_jwks|cybersource_reply|cybersource_review_notification|financingapi_apply|financingapi_update_inquiry|financingapi_plan_list|financingapi_estimated_payment|financingapi_acct_inquiry|financingapi_prequal|financingapi_prequal_customer_response|financingapi_syf_dpos_token|api_root|tsi_auth_current_user|tsi_auth_keep_alive|tsi_auth_expired_token|tsi_auth_login|tsi_auth_change_password|oscarbundles_i18n_js|bundlegrouptype_list|bundlegroup_list|concretebundle_list|concretebundle_product_choice_list|userconfigurablebundle_list|userconfigurablebundle_range_choice_list|api_checkout_payment_methods|api_complete_deferred_payment|api_checkout|api_get_csrf_token|api_user_data_layer|api_register|api_login|product_list|option_list|order_list|api_basket|api_basket_add_product|api_basket_add_voucher|api_basket_apply_voucher_code|api_basket_email|api_basket_remove_voucher|api_basket_last_modified|api_basket_predicted_delivery_date|basket_list|category_list|mattress_match|productclass_list|checkout_shipping_address|checkout_billing_address|checkout_shipping_methods|country_list|api_validate_phone_number|useraddress_list|email_offers_signup|email_retail_locator_results|wishlisttype_list|api_basket_estimate_tax|api_basket_shipping_methods|financing_plan_list|financing_plan_create|financing_benefit_list|financing_benefit_create|financing_application_list|financing_transfer_list|financing_prequal_list|dashboard_bundle_group_list|benefit_bundle_list|benefit_bundle_create|rma_vouchers_import|dashboard_index|dashboard_catalogue_product_create|dashboard_catalogue_product_list|dashboard_stock_alert_list|dashboard_catalogue_product_lookup|dashboard_catalogue_category_list|dashboard_catalogue_category_create|dashboard_catalogue_class_create|dashboard_catalogue_class_list|dashboard_catalogue_attribute_option_group_create|dashboard_catalogue_attribute_option_group_list|dashboard_catalogue_option_list|dashboard_catalogue_option_create|dashboard_product_price_import|dashboard_product_price_import_apply|dashboard_value_prop_list|dashboard_value_prop_create|dashboard_reports_index|dashboard_orderconfirmation_resend|dashboard_order_billing_verification_send|dashboard_order_send_deferred_payment_email|dashboard_order_request_pnp_resend|dashboard_order_list|dashboard_order_stats|dashboard_users_index|dashboard_user_alert_list|dashboard_deletion_request_list|dashboard_deletion_request_create|dashboard_data_inquiry_list|dashboard_data_inquiry_create|dashboard_page_list|dashboard_page_create|dashboard_partner_list|dashboard_partner_create|dashboard_offer_list|dashboard_oscarbluelight_i18n_js|dashboard_offer_api_list|dashboard_benefit_list|dashboard_benefit_create|dashboard_benefit_create_compound|dashboard_condition_list|dashboard_condition_create|dashboard_condition_create_compound|dashboard_offergroup_list|dashboard_offergroup_create|dashboard_range_list|dashboard_range_create|dashboard_reviews_list|dashboard_voucher_list|dashboard_voucher_create|dashboard_voucher_set_list|dashboard_voucher_set_create|dashboard_comms_list|dashboard_country_list|dashboard_country_create|dashboard_delivery_region_list|dashboard_delivery_region_create|dashboard_delivery_region_group_list|dashboard_delivery_region_group_create|dashboard_shipping_product_class_list|dashboard_shipping_product_class_create|dashboard_shipping_method_list|dashboard_shipping_method_create|dashboard_shipping_method_description_list|dashboard_shipping_method_description_create|dashboard_shipping_option_list|dashboard_shipping_option_create|dashboard_login|dashboard_logout|basket_summary|basket_vouchers_add|basket_saved|basket_configure_gifts|checkout_index|checkout_payment_submit|checkout_payment_redirect|checkout_order_pending|checkout_thank_you|customer_login|customer_logout|customer_lookup_orders_by_email|customer_lookup_orders_by_email_confirmation|customer_unified_order_lookup|customer_register|customer_summary|customer_change_password|customer_profile_view|customer_profile_update|customer_profile_delete|customer_order_list|customer_trs_order_history|customer_address_list|customer_address_create|customer_email_list|customer_notifications_inbox|customer_notifications_archive|customer_notifications_update|customer_alerts_list|customer_wishlists_list|customer_wishlists_create|catalogue_reviews_add|catalogue_reviews_list|catalogue_index|search_search|offer_list|password_reset|password_reset_done|password_reset_complete|search|location_directory_state_list|cms_nav_iframe|cms_footer_iframe|cms_iframe_test|html_sitemap|wagtailcore_login|__reactivated_do_not_use;


    type All = WithArguments|WithoutArguments;
    export function reverse<T extends WithoutArguments['name']>(name: T): string;
    export function reverse<T extends WithArguments['name']>(name: T, args: Extract<WithArguments, {name: T}>['args']): string;
    export function reverse<T extends All['name']>(name: T, args?: Extract<WithArguments, {name: T}>['args']): string {
        let route = urls[name].route;

        if (args != null) {
            for (const token of Object.keys(args)) {
                route = route.replace(new RegExp('<(.+?:)' + token + '>'), (args as any)[token]);
            }
        }
        return route;
    }
